import * as React from "react";
import wrapIcon from "../utils/wrapIcon";

const SlideMultipleSearchRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M15 6h.5A2.5 2.5 0 0118 8.5v6a2.5 2.5 0 01-2.5 2.5h-5.38l-1-1h6.38c.83 0 1.5-.67 1.5-1.5v-6c0-.83-.67-1.5-1.5-1.5h-8C6.67 7 6 7.67 6 8.5v.76a4.47 4.47 0 00-1-.23V8.5A2.5 2.5 0 017.5 6H14v-.5c0-.83-.67-1.5-1.5-1.5h-8C3.67 4 3 4.67 3 5.5v3.76c-.36.12-.7.3-1 .5V5.5A2.5 2.5 0 014.5 3h8A2.5 2.5 0 0115 5.5V6zM4.5 17c.79 0 1.51-.26 2.1-.7l2.55 2.55a.5.5 0 00.7-.7L7.3 15.6A3.5 3.5 0 104.5 17zm0-1a2.5 2.5 0 110-5 2.5 2.5 0 010 5z",
    fill: primaryFill
  }));
};

export const SlideMultipleSearchRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/SlideMultipleSearchRegularIcon({}), 'SlideMultipleSearchRegular');

const SlideSettingsFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M4.75 4A2.75 2.75 0 002 6.75v6.5A2.75 2.75 0 004.75 16h4.46A5.5 5.5 0 0118 10.26V6.75A2.75 2.75 0 0015.25 4H4.75zm7.32 7.44a2 2 0 01-1.44 2.48l-.46.12a4.73 4.73 0 00.01 1.01l.35.09A2 2 0 0112 17.66l-.13.42c.26.2.54.38.84.52l.32-.35a2 2 0 012.91 0l.34.36c.3-.13.57-.3.82-.5l-.15-.55a2 2 0 011.43-2.48l.46-.12a4.73 4.73 0 00-.01-1.01l-.35-.09A2 2 0 0117 11.34l.13-.42c-.26-.2-.54-.38-.84-.52l-.32.35a2 2 0 01-2.91 0l-.34-.36c-.3.13-.57.3-.82.5l.16.55zm2.43 4.06a1 1 0 110-2 1 1 0 010 2z",
    fill: primaryFill
  }));
};

export const SlideSettingsFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/SlideSettingsFilledIcon({}), 'SlideSettingsFilled');

const SlideSettingsRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M2 6.75A2.75 2.75 0 014.75 4h10.5A2.75 2.75 0 0118 6.75v3.5a5.5 5.5 0 00-1-.65V6.75C17 5.78 16.22 5 15.25 5H4.75C3.78 5 3 5.78 3 6.75v6.5c0 .97.78 1.75 1.75 1.75h4.27c.03.34.1.68.19 1H4.75A2.75 2.75 0 012 13.25v-6.5zm10.07 4.7a2 2 0 01-1.44 2.47l-.46.12a4.73 4.73 0 00.01 1.01l.35.09A2 2 0 0112 17.66l-.13.42c.26.2.54.38.84.52l.32-.35a2 2 0 012.91 0l.34.36c.3-.13.57-.3.82-.5l-.15-.55a2 2 0 011.43-2.48l.46-.12a4.73 4.73 0 00-.01-1.01l-.35-.09A2 2 0 0117 11.34l.13-.42c-.26-.2-.54-.38-.84-.52l-.32.35a2 2 0 01-2.91 0l-.34-.36c-.3.13-.57.3-.82.5l.16.55zm2.43 4.05a1 1 0 110-2 1 1 0 010 2z",
    fill: primaryFill
  }));
};

export const SlideSettingsRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/SlideSettingsRegularIcon({}), 'SlideSettingsRegular');

const SlideSizeFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M2 6.75A2.75 2.75 0 014.75 4h10.5A2.75 2.75 0 0118 6.75v6.5A2.75 2.75 0 0115.25 16H4.75A2.75 2.75 0 012 13.25v-6.5zm9-.25c0 .28.22.5.5.5h.8l-1.65 1.65a.5.5 0 00.7.7L13 7.71v.79a.5.5 0 001 0v-2a.5.5 0 00-.5-.5h-2a.5.5 0 00-.5.5zm-1.65 4.15a.5.5 0 00-.7 0L7 12.29v-.79a.5.5 0 00-1 0v2a.5.5 0 00.5.5h2a.5.5 0 000-1h-.8l1.65-1.65a.5.5 0 000-.7z",
    fill: primaryFill
  }));
};

export const SlideSizeFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/SlideSizeFilledIcon({}), 'SlideSizeFilled');

const SlideSizeRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M2 6.75A2.75 2.75 0 014.75 4h10.5A2.75 2.75 0 0118 6.75v6.5A2.75 2.75 0 0115.25 16H4.75A2.75 2.75 0 012 13.25v-6.5zM4.75 5C3.78 5 3 5.78 3 6.75v6.5c0 .97.78 1.75 1.75 1.75h10.5c.97 0 1.75-.78 1.75-1.75v-6.5C17 5.78 16.22 5 15.25 5H4.75zM11 6.5c0-.28.22-.5.5-.5h2c.28 0 .5.22.5.5v2a.5.5 0 01-1 0v-.8l-1.65 1.65a.5.5 0 01-.7-.7L12.29 7h-.79a.5.5 0 01-.5-.5zm-2.35 4.15a.5.5 0 01.7.7L7.71 13h.79a.5.5 0 010 1h-2a.5.5 0 01-.5-.5v-2a.5.5 0 011 0v.8l1.65-1.65z",
    fill: primaryFill
  }));
};

export const SlideSizeRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/SlideSizeRegularIcon({}), 'SlideSizeRegular');

const SlideTextFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M2 6.5A2.5 2.5 0 014.5 4h11A2.5 2.5 0 0118 6.5v7a2.5 2.5 0 01-2.5 2.5h-11A2.5 2.5 0 012 13.5v-7zm3.5.5a.5.5 0 000 1h4a.5.5 0 000-1h-4zM5 10c0 .28.22.5.5.5h7a.5.5 0 000-1h-7a.5.5 0 00-.5.5zm.5 2a.5.5 0 000 1h5a.5.5 0 000-1h-5z",
    fill: primaryFill
  }));
};

export const SlideTextFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/SlideTextFilledIcon({}), 'SlideTextFilled');

const SlideTextRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M5.5 7a.5.5 0 000 1h4a.5.5 0 000-1h-4zm0 2.5a.5.5 0 000 1h7a.5.5 0 000-1h-7zm-.5 3c0-.28.22-.5.5-.5h5a.5.5 0 010 1h-5a.5.5 0 01-.5-.5zM4.5 4A2.5 2.5 0 002 6.5v7A2.5 2.5 0 004.5 16h11a2.5 2.5 0 002.5-2.5v-7A2.5 2.5 0 0015.5 4h-11zM3 6.5C3 5.67 3.67 5 4.5 5h11c.83 0 1.5.67 1.5 1.5v7c0 .83-.67 1.5-1.5 1.5h-11A1.5 1.5 0 013 13.5v-7z",
    fill: primaryFill
  }));
};

export const SlideTextRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/SlideTextRegularIcon({}), 'SlideTextRegular');

const SlideTransitionFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M2 6.75A2.75 2.75 0 014.75 4h10.5A2.75 2.75 0 0118 6.75v6.5A2.75 2.75 0 0115.25 16H4.75A2.75 2.75 0 012 13.25v-6.5zM6 5H5v10h1V5zm3 0H8v10h1V5zm3 0v10h1V5h-1z",
    fill: primaryFill
  }));
};

export const SlideTransitionFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/SlideTransitionFilledIcon({}), 'SlideTransitionFilled');

const SlideTransitionRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M4.75 4A2.75 2.75 0 002 6.75v6.5A2.75 2.75 0 004.75 16h10.5A2.75 2.75 0 0018 13.25v-6.5A2.75 2.75 0 0015.25 4H4.75zM12 5v10H9V5h3zm1 10V5h2.25c.97 0 1.75.78 1.75 1.75v6.5c0 .97-.78 1.75-1.75 1.75H13zm-5 0H6V5h2v10zM5 5v10h-.25C3.78 15 3 14.22 3 13.25v-6.5C3 5.78 3.78 5 4.75 5H5z",
    fill: primaryFill
  }));
};

export const SlideTransitionRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/SlideTransitionRegularIcon({}), 'SlideTransitionRegular');

const SmartwatchFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M8 2a2 2 0 00-2 2v.17A3 3 0 017 4h6a3 3 0 011 .17V4a2 2 0 00-2-2H8zM7 5a2 2 0 00-2 2v6c0 1.1.9 2 2 2h6a2 2 0 002-2v-2a1 1 0 001-1V9a1 1 0 00-1-1V7a2 2 0 00-2-2H7zm0 11a3 3 0 01-1-.17V16c0 1.1.9 2 2 2h4a2 2 0 002-2v-.17a3 3 0 01-1 .17H7z",
    fill: primaryFill
  }));
};

export const SmartwatchFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/SmartwatchFilledIcon({}), 'SmartwatchFilled');

const SmartwatchRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M6 5.27V4c0-1.1.9-2 2-2h4a2 2 0 012 2v1.27c.6.34 1 .99 1 1.73v1a1 1 0 011 1v1a1 1 0 01-1 1v2a2 2 0 01-1 1.73V16a2 2 0 01-2 2H8a2 2 0 01-2-2v-1.27A2 2 0 015 13V7a2 2 0 011-1.73zM8 3a1 1 0 00-1 1v1h6V4a1 1 0 00-1-1H8zm6 10V7a1 1 0 00-1-1H7a1 1 0 00-1 1v6a1 1 0 001 1h6a1 1 0 001-1zm-7 3a1 1 0 001 1h4a1 1 0 001-1v-1H7v1z",
    fill: primaryFill
  }));
};

export const SmartwatchRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/SmartwatchRegularIcon({}), 'SmartwatchRegular');

const SmartwatchDotFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M13.5 2.68A2 2 0 0012 2H8a2 2 0 00-2 2v.17A3 3 0 017 4h6.04c.06-.48.23-.92.47-1.32zM13.05 5H7a2 2 0 00-2 2v6c0 1.1.9 2 2 2h6a2 2 0 002-2v-2a1 1 0 001-1V9a1 1 0 00-1-1v-.34A3.5 3.5 0 0113.04 5zM7 16a3 3 0 01-1-.17V16c0 1.1.9 2 2 2h4a2 2 0 002-2v-.17a3 3 0 01-1 .17H7zM19 4.5a2.5 2.5 0 10-5 0 2.5 2.5 0 005 0z",
    fill: primaryFill
  }));
};

export const SmartwatchDotFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/SmartwatchDotFilledIcon({}), 'SmartwatchDotFilled');

const SmartwatchDotRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M16.5 2a2.5 2.5 0 110 5 2.5 2.5 0 010-5zm-3 .68A2 2 0 0012 2H8a2 2 0 00-2 2v1.27A2 2 0 005 7v6a2 2 0 001 1.73V16c0 1.1.9 2 2 2h4a2 2 0 002-2v-1.27A2 2 0 0015 13v-2a1 1 0 001-1V9a1 1 0 00-1-1v-.34a3.5 3.5 0 01-1-.71A1 1 0 0114 7v6a1 1 0 01-1 1H7a1 1 0 01-1-1V7a1 1 0 011-1h6a1 1 0 01.37.07 3.49 3.49 0 01.14-3.39zM13 4.5V5H7V4a1 1 0 011-1h4a1 1 0 011 1v.5zM7 15h6v1a1 1 0 01-1 1H8a1 1 0 01-1-1v-1z",
    fill: primaryFill
  }));
};

export const SmartwatchDotRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/SmartwatchDotRegularIcon({}), 'SmartwatchDotRegular');

const SnoozeFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M10.75 4a.75.75 0 000 1.5h3.88l-4.45 5.27a.75.75 0 00.57 1.23h5.5a.75.75 0 000-1.5h-3.88l4.45-5.27A.75.75 0 0016.25 4h-5.5zm-7 6a.75.75 0 000 1.5h1.97l-2.56 3.29A.75.75 0 003.75 16h3.5a.75.75 0 000-1.5H5.28l2.56-3.29A.75.75 0 007.25 10h-3.5z",
    fill: primaryFill
  }));
};

export const SnoozeFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/SnoozeFilledIcon({}), 'SnoozeFilled');

const SnoozeRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M10.5 4a.5.5 0 000 1h4.03l-4.44 6.2a.5.5 0 00.41.8h5a.5.5 0 000-1h-4.03l4.44-6.2a.5.5 0 00-.41-.8h-5zm-6 6a.5.5 0 000 1h2.96l-3.35 4.19a.5.5 0 00.39.81h4a.5.5 0 000-1H5.54l3.35-4.19A.5.5 0 008.5 10h-4z",
    fill: primaryFill
  }));
};

export const SnoozeRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/SnoozeRegularIcon({}), 'SnoozeRegular');

const SoundSourceFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M3 10a7 7 0 1112.14 4.75l.65.77a8 8 0 10-11.58 0l.65-.77A6.97 6.97 0 013 10zm11.16 3.6a5.5 5.5 0 10-8.32 0l.65-.78a4.5 4.5 0 117.01 0l.66.78zm-1.65-1.96a3 3 0 10-5.02 0l.69-.81a2 2 0 113.64 0l.69.81zm-2.13-.96a.5.5 0 00-.76 0l-5.5 6.5a.5.5 0 00.38.82h11a.5.5 0 00.38-.82l-5.5-6.5z",
    fill: primaryFill
  }));
};

export const SoundSourceFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/SoundSourceFilledIcon({}), 'SoundSourceFilled');

const SoundSourceRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M3 10a7 7 0 1112.14 4.75l.65.77a8 8 0 10-11.58 0l.65-.77A6.97 6.97 0 013 10zm11.16 3.6a5.5 5.5 0 10-8.32 0l.65-.78a4.5 4.5 0 117.01 0l.66.78zm-1.65-1.96a3 3 0 10-5.02 0l.69-.81a2 2 0 113.64 0l.69.81zm-2.13-.96a.5.5 0 00-.76 0l-5.5 6.5a.5.5 0 00.38.82h11a.5.5 0 00.38-.82l-5.5-6.5zM14.42 17H5.58L10 11.77 14.42 17z",
    fill: primaryFill
  }));
};

export const SoundSourceRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/SoundSourceRegularIcon({}), 'SoundSourceRegular');

const SoundWaveCircleFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M2 10a8 8 0 1116 0 8 8 0 01-16 0zm7-2.5a.5.5 0 00-1 0v5a.5.5 0 001 0v-5zM6 8a.5.5 0 00-.5.5v2a.5.5 0 001 0v-2A.5.5 0 006 8zm5 0a.5.5 0 00-.5.5v2a.5.5 0 001 0v-2A.5.5 0 0011 8zm2.5-1a.5.5 0 00-.5.5v5a.5.5 0 001 0v-5a.5.5 0 00-.5-.5z",
    fill: primaryFill
  }));
};

export const SoundWaveCircleFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/SoundWaveCircleFilledIcon({}), 'SoundWaveCircleFilled');

const SoundWaveCircleRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M9 7.5a.5.5 0 00-1 0v5a.5.5 0 001 0v-5zM6 8c.28 0 .5.22.5.5v2a.5.5 0 01-1 0v-2c0-.28.22-.5.5-.5zm5 0c.28 0 .5.22.5.5v2a.5.5 0 01-1 0v-2c0-.28.22-.5.5-.5zm2.5-1c.28 0 .5.22.5.5v5a.5.5 0 01-1 0v-5c0-.28.22-.5.5-.5zM10 2a8 8 0 100 16 8 8 0 000-16zm-7 8a7 7 0 1114 0 7 7 0 01-14 0z",
    fill: primaryFill
  }));
};

export const SoundWaveCircleRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/SoundWaveCircleRegularIcon({}), 'SoundWaveCircleRegular');

const SpacebarFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M2.75 7.75c.41 0 .75.34.75.75v2h13v-2a.75.75 0 011.5 0v2c0 .83-.67 1.5-1.5 1.5h-13A1.5 1.5 0 012 10.5v-2c0-.41.34-.75.75-.75z",
    fill: primaryFill
  }));
};

export const SpacebarFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/SpacebarFilledIcon({}), 'SpacebarFilled');

const SpacebarRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M2.5 8c.28 0 .5.22.5.5v2c0 .28.22.5.5.5h13a.5.5 0 00.5-.5v-2a.5.5 0 011 0v2c0 .83-.67 1.5-1.5 1.5h-13A1.5 1.5 0 012 10.5v-2c0-.28.22-.5.5-.5z",
    fill: primaryFill
  }));
};

export const SpacebarRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/SpacebarRegularIcon({}), 'SpacebarRegular');

const SparkleFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M7.4 12.8a1.04 1.04 0 001.59-.51l.45-1.37a2.34 2.34 0 011.47-1.48l1.4-.45A1.04 1.04 0 0012.25 7l-1.37-.45A2.34 2.34 0 019.4 5.08L8.95 3.7a1.03 1.03 0 00-.82-.68 1.04 1.04 0 00-1.15.7l-.46 1.4a2.34 2.34 0 01-1.44 1.45L3.7 7a1.04 1.04 0 00.02 1.97l1.37.45a2.33 2.33 0 011.48 1.48l.46 1.4c.07.2.2.37.38.5zm6.14 4.05a.8.8 0 001.22-.4l.25-.76a1.09 1.09 0 01.68-.68l.77-.25a.8.8 0 00-.02-1.52l-.77-.25a1.08 1.08 0 01-.68-.68l-.25-.77a.8.8 0 00-1.52.01l-.24.76a1.1 1.1 0 01-.67.68l-.77.25a.8.8 0 000 1.52l.77.25a1.09 1.09 0 01.68.68l.25.77c.06.16.16.3.3.4z",
    fill: primaryFill
  }));
};

export const SparkleFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/SparkleFilledIcon({}), 'SparkleFilled');

const SparkleRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M7.4 12.8a1.04 1.04 0 001.59-.51l.45-1.37a2.34 2.34 0 011.47-1.48l1.4-.45A1.04 1.04 0 0012.25 7l-1.37-.45A2.34 2.34 0 019.4 5.08L8.95 3.7a1.03 1.03 0 00-.82-.68 1.04 1.04 0 00-1.15.7l-.46 1.4a2.34 2.34 0 01-1.44 1.45L3.7 7a1.04 1.04 0 00.02 1.97l1.37.45a2.33 2.33 0 011.48 1.48l.46 1.4c.07.2.2.37.38.5zm.08-7.4l.53-1.38.44 1.37a3.33 3.33 0 002.12 2.12l1.4.53-1.38.45a3.34 3.34 0 00-2.11 2.11l-.53 1.38-.45-1.38a3.34 3.34 0 00-2.1-2.12L4 7.96 5.4 7.5a3.36 3.36 0 002.08-2.12zm6.06 11.45a.8.8 0 001.22-.4l.25-.76a1.09 1.09 0 01.68-.68l.77-.25a.8.8 0 00-.02-1.52l-.77-.25a1.08 1.08 0 01-.68-.68l-.25-.77a.8.8 0 00-1.52.01l-.24.76a1.1 1.1 0 01-.67.68l-.77.25a.8.8 0 000 1.52l.77.25a1.09 1.09 0 01.68.68l.25.77c.06.16.16.3.3.4zm-.92-2.8l-.18-.05.19-.06a2.09 2.09 0 001.3-1.32l.06-.18.05.18a2.08 2.08 0 001.32 1.32l.2.06-.18.06a2.08 2.08 0 00-1.32 1.32l-.06.18-.06-.18a2.07 2.07 0 00-1.32-1.32z",
    fill: primaryFill
  }));
};

export const SparkleRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/SparkleRegularIcon({}), 'SparkleRegular');

const Speaker0FilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M12 3a1 1 0 00-1.68-.73l-3.87 3.6A.5.5 0 016.1 6H3.5C2.67 6 2 6.67 2 7.5v5c0 .83.67 1.5 1.5 1.5h2.6a.5.5 0 01.35.13l3.87 3.6a1 1 0 001.68-.74V3.01z",
    fill: primaryFill
  }));
};

export const Speaker0Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/Speaker0FilledIcon({}), 'Speaker0Filled');

const Speaker0RegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M12 3a1 1 0 00-1.68-.73l-3.88 3.6A.5.5 0 016.1 6H3.5C2.67 6 2 6.67 2 7.5v5c0 .83.67 1.5 1.5 1.5h2.6a.5.5 0 01.34.13l3.88 3.6a1 1 0 001.68-.74V3.01zM7.12 6.6L11 3v14l-3.88-3.6A1.5 1.5 0 006.1 13H3.5a.5.5 0 01-.5-.5v-5c0-.28.22-.5.5-.5h2.6c.38 0 .75-.14 1.02-.4z",
    fill: primaryFill
  }));
};

export const Speaker0Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/Speaker0RegularIcon({}), 'Speaker0Regular');

const Speaker1FilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M12 3a1 1 0 00-1.68-.73l-3.87 3.6A.5.5 0 016.1 6H3.5C2.67 6 2 6.67 2 7.5v5c0 .83.67 1.5 1.5 1.5h2.6a.5.5 0 01.35.13l3.87 3.6a1 1 0 001.68-.74V3.01zm2.08 9.93a.5.5 0 01-.19-.68 4.5 4.5 0 000-4.5.5.5 0 11.87-.5 5.5 5.5 0 010 5.5.5.5 0 01-.68.18z",
    fill: primaryFill
  }));
};

export const Speaker1Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/Speaker1FilledIcon({}), 'Speaker1Filled');

const Speaker1RegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M12 3a1 1 0 00-1.68-.73l-3.88 3.6A.5.5 0 016.1 6H3.5C2.67 6 2 6.67 2 7.5v5c0 .83.67 1.5 1.5 1.5h2.6a.5.5 0 01.34.13l3.88 3.6a1 1 0 001.68-.74V3.01zM7.12 6.6L11 3v14l-3.88-3.6A1.5 1.5 0 006.1 13H3.5a.5.5 0 01-.5-.5v-5c0-.28.22-.5.5-.5h2.6c.38 0 .75-.14 1.02-.4zm6.96 6.33a.5.5 0 01-.18-.68 4.5 4.5 0 000-4.5.5.5 0 01.86-.5 5.5 5.5 0 010 5.5.5.5 0 01-.68.18z",
    fill: primaryFill
  }));
};

export const Speaker1Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/Speaker1RegularIcon({}), 'Speaker1Regular');

const Speaker2FilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M12 3a1 1 0 00-1.68-.73l-3.87 3.6A.5.5 0 016.1 6H3.5C2.67 6 2 6.67 2 7.5v5c0 .83.67 1.5 1.5 1.5h2.6a.5.5 0 01.35.13l3.87 3.6a1 1 0 001.68-.74V3.01zm3.25 1.63a.5.5 0 01.71.04 8 8 0 010 10.66.5.5 0 11-.75-.66 7 7 0 000-9.34.5.5 0 01.04-.7zm-1.17 8.3a.5.5 0 01-.19-.68 4.5 4.5 0 000-4.5.5.5 0 11.87-.5 5.5 5.5 0 010 5.5.5.5 0 01-.68.18z",
    fill: primaryFill
  }));
};

export const Speaker2Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/Speaker2FilledIcon({}), 'Speaker2Filled');

const Speaker2RegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M12 3a1 1 0 00-1.68-.73l-3.88 3.6A.5.5 0 016.1 6H3.5C2.67 6 2 6.67 2 7.5v5c0 .83.67 1.5 1.5 1.5h2.6a.5.5 0 01.34.13l3.88 3.6a1 1 0 001.68-.74V3.01zM7.12 6.6L11 3v14l-3.88-3.6A1.5 1.5 0 006.1 13H3.5a.5.5 0 01-.5-.5v-5c0-.28.22-.5.5-.5h2.6c.38 0 .75-.14 1.02-.4zm8.14-1.97a.5.5 0 01.7.04 8 8 0 010 10.66.5.5 0 01-.74-.66 7 7 0 000-9.34.5.5 0 01.04-.7zm-1.18 8.3a.5.5 0 01-.18-.68 4.5 4.5 0 000-4.5.5.5 0 01.86-.5 5.5 5.5 0 010 5.5.5.5 0 01-.68.18z",
    fill: primaryFill
  }));
};

export const Speaker2Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/Speaker2RegularIcon({}), 'Speaker2Regular');

const SpeakerEditFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M12 3a1 1 0 00-1.68-.73l-3.87 3.6A.5.5 0 016.1 6H3.5C2.67 6 2 6.67 2 7.5v5c0 .83.67 1.5 1.5 1.5h2.6a.5.5 0 01.35.13l2.83 2.63.15-.6a3.2 3.2 0 01.84-1.5L12 12.95V3zm3.96 1.66a7.97 7.97 0 011.99 4.46c-.34-.1-.68-.14-1.02-.12a6.97 6.97 0 00-1.72-3.67.5.5 0 01.75-.67zm-1.2 2.59c.41.72.65 1.5.72 2.27-.14.1-.26.2-.38.32l-.63.63c.1-.92-.08-1.87-.58-2.72a.5.5 0 01.87-.5zm-3.78 8.12l4.83-4.83a1.87 1.87 0 112.64 2.65l-4.83 4.83a2.2 2.2 0 01-1.02.58l-1.5.37a.89.89 0 01-1.07-1.08l.37-1.5c.1-.38.3-.73.58-1.02z",
    fill: primaryFill
  }));
};

export const SpeakerEditFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/SpeakerEditFilledIcon({}), 'SpeakerEditFilled');

const SpeakerEditRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M12 3a1 1 0 00-1.68-.73l-3.87 3.6A.5.5 0 016.1 6H3.5C2.67 6 2 6.67 2 7.5v5c0 .83.67 1.5 1.5 1.5h2.6a.5.5 0 01.35.13l2.83 2.63.15-.6c.04-.17.1-.32.16-.48L7.13 13.4A1.5 1.5 0 006.1 13H3.5a.5.5 0 01-.5-.5v-5c0-.28.22-.5.5-.5h2.6c.38 0 .75-.15 1.03-.4L11 3v10.94l1-1V3zm3.96 1.66a7.97 7.97 0 011.99 4.46c-.33-.1-.68-.14-1.02-.12a6.97 6.97 0 00-1.71-3.67.5.5 0 01.74-.67zm-1.2 2.59c.42.72.65 1.5.72 2.27-.13.1-.26.2-.38.32l-.62.62c.1-.9-.09-1.86-.58-2.71a.5.5 0 01.86-.5zm-3.78 8.12l4.83-4.83a1.87 1.87 0 112.64 2.65l-4.83 4.83a2.2 2.2 0 01-1.02.58l-1.5.37a.89.89 0 01-1.07-1.08l.37-1.5c.1-.38.3-.73.58-1.02z",
    fill: primaryFill
  }));
};

export const SpeakerEditRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/SpeakerEditRegularIcon({}), 'SpeakerEditRegular');

const SpeakerMuteFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M12 3a1 1 0 00-1.68-.73l-3.88 3.6A.5.5 0 016.1 6H3.5C2.67 6 2 6.67 2 7.5v5c0 .83.67 1.5 1.5 1.5h2.6a.5.5 0 01.34.13l3.88 3.6a1 1 0 001.68-.74V3.01zm1.14 4.65c.2-.2.52-.2.71 0l1.65 1.64 1.64-1.64a.5.5 0 11.71.7L16.2 10l1.65 1.65a.5.5 0 11-.7.7l-1.65-1.64-1.65 1.64a.5.5 0 11-.7-.7L14.78 10l-1.65-1.65a.5.5 0 010-.7z",
    fill: primaryFill
  }));
};

export const SpeakerMuteFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/SpeakerMuteFilledIcon({}), 'SpeakerMuteFilled');

const SpeakerMuteRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M12 3a1 1 0 00-1.68-.73l-3.88 3.6A.5.5 0 016.1 6H3.5C2.67 6 2 6.67 2 7.5v5c0 .83.67 1.5 1.5 1.5h2.6a.5.5 0 01.34.13l3.88 3.6a1 1 0 001.68-.74V3.01zM7.12 6.6L11 3v14l-3.88-3.6A1.5 1.5 0 006.1 13H3.5a.5.5 0 01-.5-.5v-5c0-.28.22-.5.5-.5h2.6c.38 0 .75-.14 1.02-.4zm6.02 1.05c.2-.2.52-.2.71 0l1.65 1.64 1.64-1.64a.5.5 0 11.71.7L16.2 10l1.65 1.65a.5.5 0 11-.7.7l-1.65-1.64-1.65 1.64a.5.5 0 11-.7-.7L14.78 10l-1.65-1.65a.5.5 0 010-.7z",
    fill: primaryFill
  }));
};

export const SpeakerMuteRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/SpeakerMuteRegularIcon({}), 'SpeakerMuteRegular');

const SpeakerOffFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M2.85 2.15a.5.5 0 10-.7.7L5.29 6H3.5C2.67 6 2 6.67 2 7.5v5c0 .83.67 1.5 1.5 1.5h2.6a.5.5 0 01.35.13l3.87 3.6a1 1 0 001.68-.74v-4.28l5.15 5.14a.5.5 0 00.7-.7l-2.56-2.57L2.85 2.15zm13.11 2.52a8 8 0 01.66 9.83l-.73-.73a7 7 0 00-.68-8.44.5.5 0 11.75-.66zm-1.2 2.58c1 1.74.95 3.8.04 5.43l-.74-.74a4.5 4.5 0 00-.17-4.19.5.5 0 11.87-.5zM12 3.01v6.87L7.25 5.13l3.07-2.86a1 1 0 011.68.74z",
    fill: primaryFill
  }));
};

export const SpeakerOffFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/SpeakerOffFilledIcon({}), 'SpeakerOffFilled');

const SpeakerOffRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M2.85 2.15a.5.5 0 10-.7.7L5.29 6H3.5C2.68 6 2 6.67 2 7.5v5c0 .83.68 1.5 1.5 1.5H6.1a.5.5 0 01.34.13l3.88 3.6a1 1 0 001.68-.74V12.7l5.15 5.15a.5.5 0 00.7-.7l-2.56-2.57L2.85 2.15zM11 11.7V17l-3.88-3.6A1.5 1.5 0 006.1 13H3.5a.5.5 0 01-.5-.5v-5c0-.28.22-.5.5-.5h2.6l.18-.01L11 11.7zM11 3v5.88l1 1V3a1 1 0 00-1.68-.74L7.25 5.12l.7.71L11 3.01zm3.06 8.94l.74.74a5.5 5.5 0 00-.04-5.43.5.5 0 00-.86.5 4.5 4.5 0 01.16 4.19zm1.84 1.84l.72.72a8 8 0 00-.66-9.83.5.5 0 10-.74.66 7 7 0 01.68 8.45z",
    fill: primaryFill
  }));
};

export const SpeakerOffRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/SpeakerOffRegularIcon({}), 'SpeakerOffRegular');

const SpeakerSettingsFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M12 3a1 1 0 00-1.68-.73l-3.87 3.6A.5.5 0 016.1 6H3.5C2.67 6 2 6.67 2 7.5v5c0 .83.67 1.5 1.5 1.5h2.6a.5.5 0 01.35.13l3.21 2.98A5.48 5.48 0 0112 9.6V3zm.07 8.44l-.16-.55c.25-.2.53-.37.82-.5l.34.36a2 2 0 002.9 0l.33-.35c.3.14.58.32.84.52l-.13.42a2 2 0 001.46 2.52l.35.09a4.7 4.7 0 010 1.01l-.45.12a2 2 0 00-1.43 2.48l.15.55c-.25.2-.53.37-.82.5l-.34-.36a2 2 0 00-2.9 0l-.33.35c-.3-.14-.58-.32-.84-.52l.13-.42a2 2 0 00-1.46-2.52l-.35-.09a4.71 4.71 0 010-1.01l.45-.12a2 2 0 001.44-2.48zm2.43 4.06a1 1 0 100-2 1 1 0 000 2z",
    fill: primaryFill
  }));
};

export const SpeakerSettingsFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/SpeakerSettingsFilledIcon({}), 'SpeakerSettingsFilled');

const SpeakerSettingsRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M12 3a1 1 0 00-1.68-.73l-3.88 3.6A.5.5 0 016.1 6H3.5C2.67 6 2 6.67 2 7.5v5c0 .83.67 1.5 1.5 1.5h2.6a.5.5 0 01.34.13l3.22 2.99a5.46 5.46 0 01-.62-1.94L7.12 13.4A1.5 1.5 0 006.1 13H3.5a.5.5 0 01-.5-.5v-5c0-.28.22-.5.5-.5h2.6c.38 0 .75-.14 1.02-.4L11 3v7.26c.3-.25.64-.48 1-.66V3zm.07 8.44a2 2 0 01-1.44 2.48l-.46.12a4.74 4.74 0 00.01 1.01l.35.09A2 2 0 0112 17.66l-.13.42c.26.2.54.38.84.52l.32-.35a2 2 0 012.91 0l.34.36c.3-.13.57-.3.82-.5l-.15-.55a2 2 0 011.43-2.48l.46-.12a4.73 4.73 0 00-.01-1.01l-.35-.09A2 2 0 0117 11.34l.13-.42c-.26-.2-.54-.38-.84-.52l-.32.35a2 2 0 01-2.91 0l-.34-.36c-.3.13-.57.3-.82.5l.16.55zm2.43 4.06a1 1 0 110-2 1 1 0 010 2z",
    fill: primaryFill
  }));
};

export const SpeakerSettingsRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/SpeakerSettingsRegularIcon({}), 'SpeakerSettingsRegular');

const SpinnerIosFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M10 3.5A6.5 6.5 0 003.5 10 .75.75 0 012 10a8 8 0 118 8 .75.75 0 010-1.5 6.5 6.5 0 100-13z",
    fill: primaryFill
  }));
};

export const SpinnerIosFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/SpinnerIosFilledIcon({}), 'SpinnerIosFilled');

const SpinnerIosRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M10 3a7 7 0 00-7 7 .5.5 0 01-1 0 8 8 0 118 8 .5.5 0 010-1 7 7 0 100-14z",
    fill: primaryFill
  }));
};

export const SpinnerIosRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/SpinnerIosRegularIcon({}), 'SpinnerIosRegular');

const SplitHintFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M9.5 2c.28 0 .5.22.5.5v15a.5.5 0 01-1 0v-15c0-.28.22-.5.5-.5zM4 4a2 2 0 00-2 2v8c0 1.1.9 2 2 2h4V4H4zm11 1a1 1 0 011 1v.5a.5.5 0 001 0V6a2 2 0 00-2-2h-.5a.5.5 0 000 1h.5zm0 10a1 1 0 001-1v-.5a.5.5 0 011 0v.5a2 2 0 01-2 2h-.5a.5.5 0 010-1h.5zm1.5-7a.5.5 0 00-.5.5v3a.5.5 0 001 0v-3a.5.5 0 00-.5-.5zm-4-4a.5.5 0 010 1h-1a.5.5 0 010-1h1zm.5 11.5a.5.5 0 00-.5-.5h-1a.5.5 0 000 1h1a.5.5 0 00.5-.5z",
    fill: primaryFill
  }));
};

export const SplitHintFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/SplitHintFilledIcon({}), 'SplitHintFilled');

const SplitHintRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M9.5 2c.28 0 .5.22.5.5v15a.5.5 0 01-1 0v-15c0-.28.22-.5.5-.5zM2 6c0-1.1.9-2 2-2h4v1H4a1 1 0 00-1 1v8a1 1 0 001 1h4v1H4a2 2 0 01-2-2V6zm13-1a1 1 0 011 1v.5a.5.5 0 001 0V6a2 2 0 00-2-2h-.5a.5.5 0 000 1h.5zm0 10a1 1 0 001-1v-.5a.5.5 0 011 0v.5a2 2 0 01-2 2h-.5a.5.5 0 010-1h.5zm1.5-7a.5.5 0 00-.5.5v3a.5.5 0 001 0v-3a.5.5 0 00-.5-.5zm-4-4a.5.5 0 010 1h-1a.5.5 0 010-1h1zm.5 11.5a.5.5 0 00-.5-.5h-1a.5.5 0 000 1h1a.5.5 0 00.5-.5z",
    fill: primaryFill
  }));
};

export const SplitHintRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/SplitHintRegularIcon({}), 'SplitHintRegular');

const SplitHorizontalFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M17.5 10a.5.5 0 000-1h-15a.5.5 0 000 1h15zM14 2a2 2 0 012 2v4H4V4c0-1.1.9-2 2-2h8zM4 11v4c0 1.1.9 2 2 2h8a2 2 0 002-2v-4H4z",
    fill: primaryFill
  }));
};

export const SplitHorizontalFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/SplitHorizontalFilledIcon({}), 'SplitHorizontalFilled');

const SplitHorizontalRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M17.5 10a.5.5 0 000-1h-15a.5.5 0 000 1h15zM16 4a2 2 0 00-2-2H6a2 2 0 00-2 2v4h1V4a1 1 0 011-1h8a1 1 0 011 1v4h1V4zm0 7h-1v4a1 1 0 01-1 1H6a1 1 0 01-1-1v-4H4v4c0 1.1.9 2 2 2h8a2 2 0 002-2v-4z",
    fill: primaryFill
  }));
};

export const SplitHorizontalRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/SplitHorizontalRegularIcon({}), 'SplitHorizontalRegular');

const SplitVerticalFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M10 2.5a.5.5 0 00-1 0v15a.5.5 0 001 0v-15zM2 6c0-1.1.9-2 2-2h4v12H4a2 2 0 01-2-2V6zm9 10h4a2 2 0 002-2V6a2 2 0 00-2-2h-4v12z",
    fill: primaryFill
  }));
};

export const SplitVerticalFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/SplitVerticalFilledIcon({}), 'SplitVerticalFilled');

const SplitVerticalRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M10 2.5a.5.5 0 00-1 0v15a.5.5 0 001 0v-15zM4 4a2 2 0 00-2 2v8c0 1.1.9 2 2 2h4v-1H4a1 1 0 01-1-1V6a1 1 0 011-1h4V4H4zm7 0v1h4a1 1 0 011 1v8a1 1 0 01-1 1h-4v1h4a2 2 0 002-2V6a2 2 0 00-2-2h-4z",
    fill: primaryFill
  }));
};

export const SplitVerticalRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/SplitVerticalRegularIcon({}), 'SplitVerticalRegular');

const SportFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M16.58 4.13c.34.4.62.83.84 1.28a2 2 0 01-2.44.31l1.6-1.6zm-.7-.71l-1.6 1.6a2 2 0 01.3-2.43c.46.21.9.49 1.3.83zm1.04 8.02a6 6 0 00.87-5.03 3 3 0 01-3.53.04L13.1 7.6l3.82 3.83zm-3.37-5.7a3 3 0 01.04-3.53 6 6 0 00-5.03.87L12.4 6.9l1.16-1.16zM7.8 3.72l-.03.04a5.97 5.97 0 00-1.52 2.57c.46.14.93.3 1.4.5 1.04.41 2.15.98 3.06 1.77l.98-.99L7.8 3.72zm5.9 10.04a5.97 5.97 0 002.55-1.52l.04-.03-3.9-3.9-.97.99c.8.92 1.39 2.05 1.8 3.1.19.46.34.91.48 1.36zm-.44 2.57a1.7 1.7 0 01-2.1 1.65c-1.76-.4-4.54-1.23-6.2-2.89-1.65-1.65-2.5-4.44-2.9-6.2A1.7 1.7 0 014.08 6.8c.9.19 2.06.49 3.19.94a9.3 9.3 0 013.1 1.91 9.2 9.2 0 011.9 3.1c.45 1.14.75 2.29.93 3.2.03.12.04.25.04.37zm-6.4-5.18a.5.5 0 00-.7.7l2 2a.5.5 0 10.7-.7l-2-2z",
    fill: primaryFill
  }));
};

export const SportFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/SportFilledIcon({}), 'SportFilled');

const SportRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M6.44 5.75c-.08.2-.15.38-.2.58.3.1.63.2.95.32.18-.65.5-1.27.94-1.81L11.29 8l-.6.6a7.16 7.16 0 01.72.7l.59-.6 3.16 3.17c-.54.44-1.15.76-1.79.94.12.32.22.64.32.95a5.97 5.97 0 004.1-7.32 6.01 6.01 0 00-11.35-.69zm10.2.38a2 2 0 01-2.12.06l1.35-1.35c.33.4.58.83.77 1.3zm-2.84.78a3 3 0 003.12.21 5 5 0 01-1.05 4.04L12.71 8l1.09-1.09zm-.71-.7L12 7.28 8.84 4.13a5 5 0 014.04-1.05 3 3 0 00.21 3.12zm.72-.73a2 2 0 01.06-2.12c.46.19.9.44 1.3.77L13.8 5.48zm-7.66 5.67c.2-.2.5-.2.7 0l2 2a.5.5 0 01-.7.7l-2-2a.5.5 0 010-.7zm-4.1-2.27a1.7 1.7 0 012.03-2.07c.91.19 2.07.49 3.2.94a9.3 9.3 0 013.1 1.91 9.2 9.2 0 011.9 3.1c.45 1.14.75 2.29.93 3.2a1.7 1.7 0 01-2.07 2.02c-1.75-.4-4.53-1.23-6.19-2.89-1.65-1.65-2.5-4.44-2.9-6.2zm1.82-1.1a.7.7 0 00-.85.88c.4 1.76 1.2 4.29 2.64 5.72 1.44 1.44 3.96 2.23 5.7 2.63a.7.7 0 00.87-.85c-.18-.88-.45-1.97-.87-3.02a8.21 8.21 0 00-1.69-2.77c-.7-.7-1.7-1.26-2.77-1.69a18.53 18.53 0 00-3.03-.9z",
    fill: primaryFill
  }));
};

export const SportRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/SportRegularIcon({}), 'SportRegular');

const SportAmericanFootballFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M10.94 2.64A11.63 11.63 0 002.6 10.9l6.6 6.6a10.9 10.9 0 006.08-4.08 13.32 13.32 0 002.07-4.35l-6.42-6.43zm.91 5.5c.2.2.2.52 0 .71l-3 3a.5.5 0 01-.7-.7l3-3c.2-.2.5-.2.7 0zm5.8-.2c.26-1.3.36-2.56.35-3.71A2.25 2.25 0 0015.7 2c-1.32.02-2.53.15-3.62.37l5.56 5.56zm-9.6 9.81l-5.72-5.72A16.1 16.1 0 002 15.84c.04 1.18 1 2.09 2.15 2.14 1.43.07 2.72-.02 3.89-.23z",
    fill: primaryFill
  }));
};

export const SportAmericanFootballFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/SportAmericanFootballFilledIcon({}), 'SportAmericanFootballFilled');

const SportAmericanFootballRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M11.85 8.85a.5.5 0 10-.7-.7l-3 3a.5.5 0 10.7.7l3-3zM18 4.23A2.25 2.25 0 0015.7 2c-5.62.07-9.12 2.15-11.18 4.96-2.04 2.78-2.6 6.2-2.51 8.88.04 1.18 1 2.09 2.15 2.14 5.53.26 9.03-1.73 11.13-4.56 2.07-2.8 2.73-6.36 2.71-9.2zM15.71 3c.72 0 1.29.54 1.3 1.23 0 .9-.07 1.86-.23 2.84l-3.84-3.84C13.79 3.09 14.7 3 15.7 3zm-3.95.46l4.79 4.8c-.39 1.6-1.04 3.19-2.07 4.56a10.01 10.01 0 01-6.1 3.85.5.5 0 00-.03-.02l-4.93-4.93a11.8 11.8 0 011.9-4.17 10.8 10.8 0 016.44-4.09zM3.19 12.9l3.98 3.99c-.9.11-1.89.15-2.96.1A1.24 1.24 0 013 15.81c-.03-.91.02-1.9.18-2.92z",
    fill: primaryFill
  }));
};

export const SportAmericanFootballRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/SportAmericanFootballRegularIcon({}), 'SportAmericanFootballRegular');

const SportBaseballFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M18 10c0 1.55-.44 3-1.2 4.22-.95-.7-2-1.24-3.14-1.63a.5.5 0 10-.32.95c1.04.35 2 .86 2.88 1.5a7.98 7.98 0 01-12.44 0c.87-.64 1.84-1.15 2.88-1.5a.5.5 0 00-.32-.95c-1.13.39-2.2.94-3.14 1.63a7.96 7.96 0 010-8.43c.94.7 2 1.25 3.14 1.63a.5.5 0 10.32-.95 10.47 10.47 0 01-2.88-1.5 7.98 7.98 0 0112.44 0c-.87.64-1.84 1.15-2.88 1.5a.5.5 0 10.32.95c1.14-.38 2.2-.94 3.14-1.63A7.96 7.96 0 0118 10zm-8 3c.49 0 .96.03 1.43.1a.5.5 0 10.14-1 11.6 11.6 0 00-3.14 0 .5.5 0 00.14 1c.47-.07.94-.1 1.43-.1zM8.57 6.92a.5.5 0 00-.14.99 11.6 11.6 0 003.14 0 .5.5 0 10-.14-1 10.6 10.6 0 01-2.86 0z",
    fill: primaryFill
  }));
};

export const SportBaseballFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/SportBaseballFilledIcon({}), 'SportBaseballFilled');

const SportBaseballRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M4.61 5.53a6.99 6.99 0 0110.78 0c-.64.38-1.33.7-2.05.94a.5.5 0 00.32.95c.81-.27 1.59-.64 2.31-1.08a6.97 6.97 0 010 7.33c-.73-.44-1.5-.8-2.31-1.08a.5.5 0 00-.32.95c.72.24 1.4.56 2.04.94a6.99 6.99 0 01-10.76 0c.64-.38 1.32-.7 2.04-.94a.5.5 0 10-.32-.95c-.81.28-1.58.64-2.3 1.08a6.97 6.97 0 01-.01-7.33c.72.44 1.5.8 2.31 1.08a.5.5 0 00.32-.95c-.72-.24-1.4-.56-2.05-.94zM10 2a8 8 0 100 16 8 8 0 000-16zM8.57 6.92a10.6 10.6 0 002.86 0 .5.5 0 01.14.99 11.6 11.6 0 01-3.14 0 .5.5 0 01.14-1zm0 6.18a10.6 10.6 0 012.86 0 .5.5 0 00.14-1 11.6 11.6 0 00-3.14 0 .5.5 0 10.14 1z",
    fill: primaryFill
  }));
};

export const SportBaseballRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/SportBaseballRegularIcon({}), 'SportBaseballRegular');

const SportHockeyFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M11.97 2.06a3.7 3.7 0 013.45 1.3l1.71 1.93c.75.84 1.08 2.02.73 3.13-2.1 6.7-7.03 9.08-10.19 9.55-.9.14-1.76-.22-2.39-.78l-1.8-1.6A4.07 4.07 0 012.2 11.2c2.12-5.99 6.46-8.47 9.76-9.15zm2.52 3.52a.5.5 0 10-.98-.16 10.9 10.9 0 01-3.05 5.9 10.32 10.32 0 01-4.1 2.7.5.5 0 10.28.96c1.25-.36 3-1.38 4.53-2.96a11.89 11.89 0 003.32-6.44z",
    fill: primaryFill
  }));
};

export const SportHockeyFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/SportHockeyFilledIcon({}), 'SportHockeyFilled');

const SportHockeyRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M11.97 2.06a3.7 3.7 0 013.45 1.3l1.71 1.93c.75.84 1.08 2.02.73 3.13-2.1 6.7-7.03 9.08-10.19 9.55-.9.14-1.76-.22-2.39-.78l-1.8-1.6A4.07 4.07 0 012.2 11.2c2.12-5.99 6.46-8.47 9.76-9.15zm2.7 1.97c-.68-.76-1.6-1.17-2.5-.99-3 .61-7.03 2.89-9.02 8.5-.4 1.15.02 2.44.98 3.3l1.82 1.6c.46.41 1.03.63 1.57.54 2.85-.42 7.41-2.57 9.39-8.86.23-.73.02-1.55-.53-2.16l-1.71-1.93zm-.6.98c.28.04.47.3.42.57a11.89 11.89 0 01-3.32 6.44 11.28 11.28 0 01-4.53 2.96.5.5 0 01-.28-.96c1.05-.3 2.66-1.22 4.1-2.7a10.9 10.9 0 003.05-5.9.5.5 0 01.57-.41z",
    fill: primaryFill
  }));
};

export const SportHockeyRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/SportHockeyRegularIcon({}), 'SportHockeyRegular');

const SportSoccerFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M10 2a8 8 0 100 16 8 8 0 000-16zM7.1 3.63l2.4 1.4v1.7L6.73 8.7l-1.56-.57-.62-2.51a7.02 7.02 0 012.54-1.98zM3.02 10.7l1.83-1.62 1.55.56 1.04 3.3L6.73 14H4.25a6.96 6.96 0 01-1.22-3.3zm5.34 6.12l-.81-2.25.7-1.06h3.47l.72 1.06-.82 2.25a7.02 7.02 0 01-3.26 0zM15.75 14h-2.48l-.72-1.08 1.02-3.29 1.57-.56 1.83 1.62a6.96 6.96 0 01-1.22 3.3zm-.3-8.38l-.62 2.5-1.58.57-2.75-1.95v-1.7l2.4-1.4c1 .45 1.88 1.13 2.56 1.98z",
    fill: primaryFill
  }));
};

export const SportSoccerFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/SportSoccerFilledIcon({}), 'SportSoccerFilled');

const SportSoccerRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M10 2a8 8 0 100 16 8 8 0 000-16zM8.34 3.2a7.02 7.02 0 013.33 0L10 4.17 8.34 3.2zm-1.25.43l2.41 1.4v1.7L6.73 8.7l-1.56-.57-.62-2.51a7.02 7.02 0 012.54-1.98zM3.8 6.75l.4 1.58-1.17 1.03c.08-.94.35-1.82.77-2.61zm-.77 3.94l1.83-1.62 1.55.56 1.04 3.3L6.73 14H4.25a6.96 6.96 0 01-1.22-3.3zM5.1 15h1.55l.51 1.41A7.01 7.01 0 015.1 15zm3.27 1.82l-.81-2.25.7-1.06h3.47l.72 1.06-.82 2.25a7.02 7.02 0 01-3.26 0zm4.47-.41l.51-1.4h1.55a7.02 7.02 0 01-2.06 1.4zm2.9-2.4h-2.47l-.72-1.08 1.02-3.29 1.57-.56 1.83 1.62a6.96 6.96 0 01-1.22 3.3zm1.23-4.64l-1.16-1.03.4-1.58c.4.8.68 1.68.76 2.6zm-1.51-3.74l-.63 2.5-1.58.57-2.75-1.95v-1.7l2.4-1.4c1 .45 1.88 1.13 2.56 1.98zM7.4 9.45L10 7.6l2.59 1.84-.96 3.05H8.37L7.4 9.45z",
    fill: primaryFill
  }));
};

export const SportSoccerRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/SportSoccerRegularIcon({}), 'SportSoccerRegular');

const SquareFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M3 6a3 3 0 013-3h8a3 3 0 013 3v8a3 3 0 01-3 3H6a3 3 0 01-3-3V6z",
    fill: primaryFill
  }));
};

export const SquareFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/SquareFilledIcon({}), 'SquareFilled');

const SquareRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M3 6a3 3 0 013-3h8a3 3 0 013 3v8a3 3 0 01-3 3H6a3 3 0 01-3-3V6zm3-2a2 2 0 00-2 2v8c0 1.1.9 2 2 2h8a2 2 0 002-2V6a2 2 0 00-2-2H6z",
    fill: primaryFill
  }));
};

export const SquareRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/SquareRegularIcon({}), 'SquareRegular');

const SquareAddFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M6 3a3 3 0 00-3 3v8a3 3 0 003 3h3.6A5.5 5.5 0 0117 9.6V6a3 3 0 00-3-3H6zm8.5 16a4.5 4.5 0 100-9 4.5 4.5 0 000 9zm0-7c.28 0 .5.22.5.5V14h1.5a.5.5 0 010 1H15v1.5a.5.5 0 01-1 0V15h-1.5a.5.5 0 010-1H14v-1.5c0-.28.22-.5.5-.5z",
    fill: primaryFill
  }));
};

export const SquareAddFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/SquareAddFilledIcon({}), 'SquareAddFilled');

const SquareAddRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M6 3a3 3 0 00-3 3v8a3 3 0 003 3h3.6c-.16-.32-.3-.65-.4-1H6a2 2 0 01-2-2V6c0-1.1.9-2 2-2h8a2 2 0 012 2v3.2c.35.1.68.24 1 .4V6a3 3 0 00-3-3H6zm8.5 16a4.5 4.5 0 100-9 4.5 4.5 0 000 9zm0-7c.28 0 .5.22.5.5V14h1.5a.5.5 0 010 1H15v1.5a.5.5 0 01-1 0V15h-1.5a.5.5 0 010-1H14v-1.5c0-.28.22-.5.5-.5z",
    fill: primaryFill
  }));
};

export const SquareAddRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/SquareAddRegularIcon({}), 'SquareAddRegular');

const SquareArrowForwardFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M6 3a3 3 0 00-3 3v8a3 3 0 003 3h3.6A5.5 5.5 0 0117 9.6V6a3 3 0 00-3-3H6zm8.5 16a4.5 4.5 0 110-9 4.5 4.5 0 010 9zm.9-6.4l.9.9h-1.55A2.75 2.75 0 0012 16.25v.25a.5.5 0 001 0v-.25c0-.97.78-1.75 1.75-1.75h1.54l-.9.9a.5.5 0 00.71.7l1.76-1.75a.5.5 0 000-.7L16.1 11.9a.5.5 0 00-.7.7z",
    fill: primaryFill
  }));
};

export const SquareArrowForwardFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/SquareArrowForwardFilledIcon({}), 'SquareArrowForwardFilled');

const SquareArrowForwardRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M3 6a3 3 0 013-3h8a3 3 0 013 3v3.6c-.32-.16-.65-.3-1-.4V6a2 2 0 00-2-2H6a2 2 0 00-2 2v8c0 1.1.9 2 2 2h3.2c.1.35.24.68.4 1H6a3 3 0 01-3-3V6zm11.5 13a4.5 4.5 0 110-9 4.5 4.5 0 010 9zm.9-6.4l.9.9h-1.55A2.75 2.75 0 0012 16.25v.25a.5.5 0 001 0v-.25c0-.97.78-1.75 1.75-1.75h1.54l-.9.9a.5.5 0 00.71.7l1.76-1.75a.5.5 0 000-.7L16.1 11.9a.5.5 0 00-.7.7z",
    fill: primaryFill
  }));
};

export const SquareArrowForwardRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/SquareArrowForwardRegularIcon({}), 'SquareArrowForwardRegular');

const SquareDismissFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M6 3a3 3 0 00-3 3v8a3 3 0 003 3h3.6A5.5 5.5 0 0117 9.6V6a3 3 0 00-3-3H6zm8.5 16a4.5 4.5 0 100-9 4.5 4.5 0 000 9zm1.85-6.35c.2.2.2.5 0 .7l-1.14 1.15 1.14 1.15a.5.5 0 01-.7.7l-1.15-1.14-1.15 1.14a.5.5 0 01-.7-.7l1.14-1.15-1.14-1.15a.5.5 0 01.7-.7l1.15 1.14 1.15-1.14c.2-.2.5-.2.7 0z",
    fill: primaryFill
  }));
};

export const SquareDismissFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/SquareDismissFilledIcon({}), 'SquareDismissFilled');

const SquareDismissRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M6 3a3 3 0 00-3 3v8a3 3 0 003 3h3.6c-.16-.32-.3-.65-.4-1H6a2 2 0 01-2-2V6c0-1.1.9-2 2-2h8a2 2 0 012 2v3.2c.35.1.68.24 1 .4V6a3 3 0 00-3-3H6zm8.5 16a4.5 4.5 0 100-9 4.5 4.5 0 000 9zm1.85-6.35c.2.2.2.5 0 .7l-1.14 1.15 1.14 1.15a.5.5 0 01-.7.7l-1.15-1.14-1.15 1.14a.5.5 0 01-.7-.7l1.14-1.15-1.14-1.15a.5.5 0 01.7-.7l1.15 1.14 1.15-1.14c.2-.2.5-.2.7 0z",
    fill: primaryFill
  }));
};

export const SquareDismissRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/SquareDismissRegularIcon({}), 'SquareDismissRegular');

const SquareEraserFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M8.73 13.64l4.9-4.9A2.48 2.48 0 0117 8.59V6a3 3 0 00-3-3H6a3 3 0 00-3 3v8a3 3 0 003 3h2.6a2.5 2.5 0 01.13-3.36zm7.74-4.2l2.1 2.1a1.5 1.5 0 010 2.12l-3.6 3.6-4.22-4.22 3.6-3.6a1.5 1.5 0 012.12 0zm-2.21 8.52l-4.22-4.22-.6.6a1.5 1.5 0 000 2.13l2.1 2.1a1.5 1.5 0 001.12.43h4.09a.5.5 0 000-1h-2.53l.04-.04z",
    fill: primaryFill
  }));
};

export const SquareEraserFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/SquareEraserFilledIcon({}), 'SquareEraserFilled');

const SquareEraserRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M8.08 16H6a2 2 0 01-2-2V6a2 2 0 012-2h8a2 2 0 012 2v2.08c.37.09.71.26 1 .5V6a3 3 0 00-3-3H6a3 3 0 00-3 3v8a3 3 0 003 3h2.6a2.47 2.47 0 01-.52-1zm1.36.47a1.5 1.5 0 010-2.13l4.9-4.9a1.5 1.5 0 012.12 0l2.1 2.1a1.5 1.5 0 010 2.13L14.22 18h2.53a.5.5 0 010 1h-4.1a1.5 1.5 0 01-1.12-.44l-2.1-2.1zm5.61-6.32l-3.6 3.6 2.8 2.8 3.6-3.6a.5.5 0 000-.71l-2.1-2.1a.5.5 0 00-.7 0zm-1.5 7.1l-2.8-2.8-.6.6a.5.5 0 000 .71l2.1 2.1a.5.5 0 00.7 0l.6-.6z",
    fill: primaryFill
  }));
};

export const SquareEraserRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/SquareEraserRegularIcon({}), 'SquareEraserRegular');

const SquareHintFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M9.25 3a.75.75 0 000 1.5h1.5a.75.75 0 000-1.5h-1.5zM3 10.75a.75.75 0 001.5 0v-1.5a.75.75 0 00-1.5 0v1.5zm5.5 5.5c0-.41.34-.75.75-.75h1.5a.75.75 0 010 1.5h-1.5a.75.75 0 01-.75-.75zm7-5.5a.75.75 0 001.5 0v-1.5a.75.75 0 00-1.5 0v1.5zm-9.5-7A.75.75 0 005.25 3C4.01 3 3 4 3 5.25a.75.75 0 001.5 0c0-.41.34-.75.75-.75S6 4.16 6 3.75zM5.25 17a.75.75 0 000-1.5.75.75 0 01-.75-.75.75.75 0 00-1.5 0C3 15.99 4 17 5.25 17zM14 3.75c0-.41.34-.75.75-.75C15.99 3 17 4 17 5.25a.75.75 0 01-1.5 0 .75.75 0 00-.75-.75.75.75 0 01-.75-.75zM14.75 17a.75.75 0 010-1.5c.41 0 .75-.34.75-.75a.75.75 0 011.5 0c0 1.24-1 2.25-2.25 2.25z",
    fill: primaryFill
  }));
};

export const SquareHintFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/SquareHintFilledIcon({}), 'SquareHintFilled');

const SquareHintRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M6 3.5a.5.5 0 00-.5-.5A2.5 2.5 0 003 5.5a.5.5 0 001 0C4 4.67 4.67 4 5.5 4a.5.5 0 00.5-.5zM16.5 6a.5.5 0 00.5-.5A2.5 2.5 0 0014.5 3a.5.5 0 000 1c.83 0 1.5.67 1.5 1.5 0 .28.22.5.5.5zm-2 11a.5.5 0 010-1c.83 0 1.5-.67 1.5-1.5a.5.5 0 011 0 2.5 2.5 0 01-2.5 2.5zm-11-3a.5.5 0 00-.5.5A2.5 2.5 0 005.5 17a.5.5 0 000-1A1.5 1.5 0 014 14.5a.5.5 0 00-.5-.5zM3 9a.5.5 0 011 0v2a.5.5 0 01-1 0V9zm13.5-.5a.5.5 0 00-.5.5v2a.5.5 0 001 0V9a.5.5 0 00-.5-.5zm-8-5c0-.28.22-.5.5-.5h2a.5.5 0 010 1H9a.5.5 0 01-.5-.5zM9 16a.5.5 0 000 1h2a.5.5 0 000-1H9z",
    fill: primaryFill
  }));
};

export const SquareHintRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/SquareHintRegularIcon({}), 'SquareHintRegular');

const SquareHintAppsFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M8.5 3a.5.5 0 000 1h3a.5.5 0 000-1h-3zM4.05 5.54a2 2 0 011.55-1.5.5.5 0 00.4-.59.5.5 0 00-.66-.38 3 3 0 00-2.29 2.34.5.5 0 00.4.6.5.5 0 00.6-.47zm0 8.92a2 2 0 001.55 1.5.5.5 0 01.4.59.5.5 0 01-.66.38 3 3 0 01-2.29-2.34.5.5 0 01.4-.6.5.5 0 01.6.47zM14.66 3.07a.5.5 0 00-.66.38.5.5 0 00.46.6 2 2 0 011.5 1.55.5.5 0 00.59.4.5.5 0 00.38-.66 3 3 0 00-2.27-2.27zM3 11.5a.5.5 0 001 0v-3a.5.5 0 00-1 0v3zM6.5 5C5.67 5 5 5.67 5 6.5v7c0 .83.67 1.5 1.5 1.5H7v-.25A2.75 2.75 0 019.75 12H12V9.75A2.75 2.75 0 0114.75 7H15v-.5c0-.83-.67-1.5-1.5-1.5h-7zM19 9.75C19 8.78 18.22 8 17.25 8h-2.5C13.78 8 13 8.78 13 9.75V13H9.75C8.78 13 8 13.78 8 14.75v2.5c0 .97.78 1.75 1.75 1.75h6.75a2.5 2.5 0 002.5-2.5V9.75zM14 13V9.75c0-.41.34-.75.75-.75h2.5c.41 0 .75.34.75.75V13h-4zm2.5 5H14v-4h4v2.5c0 .83-.67 1.5-1.5 1.5zm-6.75-4H13v4H9.75a.75.75 0 01-.75-.75v-2.5c0-.41.34-.75.75-.75z",
    fill: primaryFill
  }));
};

export const SquareHintAppsFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/SquareHintAppsFilledIcon({}), 'SquareHintAppsFilled');

const SquareHintAppsRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M8.5 3a.5.5 0 000 1h3a.5.5 0 000-1h-3zM4.05 5.54a2 2 0 011.55-1.5.5.5 0 00.4-.59.5.5 0 00-.66-.38 3 3 0 00-2.29 2.34.5.5 0 00.4.6.5.5 0 00.6-.47zm0 8.92a2 2 0 001.55 1.5.5.5 0 01.4.59.5.5 0 01-.66.38 3 3 0 01-2.29-2.34.5.5 0 01.4-.6.5.5 0 01.6.47zM14.66 3.07a.5.5 0 00-.66.38.5.5 0 00.46.6 2 2 0 011.5 1.55.5.5 0 00.59.4.5.5 0 00.38-.66 3 3 0 00-2.27-2.27zM3 11.5a.5.5 0 001 0v-3a.5.5 0 00-1 0v3zm16-1.75C19 8.78 18.22 8 17.25 8h-2.5C13.78 8 13 8.78 13 9.75V13H9.75C8.78 13 8 13.78 8 14.75v2.5c0 .97.78 1.75 1.75 1.75h6.75a2.5 2.5 0 002.5-2.5V9.75zM14 13V9.75c0-.41.34-.75.75-.75h2.5c.41 0 .75.34.75.75V13h-4zm2.5 5H14v-4h4v2.5c0 .83-.67 1.5-1.5 1.5zm-6.75-4H13v4H9.75a.75.75 0 01-.75-.75v-2.5c0-.41.34-.75.75-.75z",
    fill: primaryFill
  }));
};

export const SquareHintAppsRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/SquareHintAppsRegularIcon({}), 'SquareHintAppsRegular');

const SquareHintArrowBackFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M9.25 3a.75.75 0 000 1.5h1.5a.75.75 0 000-1.5h-1.5zM3 10.75a.75.75 0 001.5 0v-1.5a.75.75 0 00-1.5 0v1.5zm4.5 5.5c0-.41.34-.75.75-.75h.84c.1.53.27 1.03.51 1.5H8.25a.75.75 0 01-.75-.75zm8-7.16c.53.1 1.03.27 1.5.51V8.25a.75.75 0 00-1.5 0v.84zM6 3.75A.75.75 0 005.25 3C4.01 3 3 4 3 5.25a.75.75 0 001.5 0c0-.41.34-.75.75-.75S6 4.16 6 3.75zM5.25 17a.75.75 0 000-1.5.75.75 0 01-.75-.75.75.75 0 00-1.5 0C3 15.99 4 17 5.25 17zM14 3.75c0-.41.34-.75.75-.75C15.99 3 17 4 17 5.25a.75.75 0 01-1.5 0 .75.75 0 00-.75-.75.75.75 0 01-.75-.75zM14.5 19a4.5 4.5 0 100-9 4.5 4.5 0 000 9zm-.9-6.4l-.9.9h1.55A2.75 2.75 0 0117 16.25v.25a.5.5 0 01-1 0v-.25c0-.97-.78-1.75-1.75-1.75h-1.54l.9.9a.5.5 0 01-.71.7l-1.76-1.75a.5.5 0 010-.7l1.76-1.75a.5.5 0 01.7.7z",
    fill: primaryFill
  }));
};

export const SquareHintArrowBackFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/SquareHintArrowBackFilledIcon({}), 'SquareHintArrowBackFilled');

const SquareHintArrowBackRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M6 3.5a.5.5 0 00-.5-.5A2.5 2.5 0 003 5.5a.5.5 0 001 0C4 4.67 4.67 4 5.5 4a.5.5 0 00.5-.5zM16.5 6a.5.5 0 00.5-.5A2.5 2.5 0 0014.5 3a.5.5 0 000 1c.83 0 1.5.67 1.5 1.5 0 .28.22.5.5.5zm-13 8a.5.5 0 00-.5.5A2.5 2.5 0 005.5 17a.5.5 0 000-1A1.5 1.5 0 014 14.5a.5.5 0 00-.5-.5zM3 9a.5.5 0 011 0v2a.5.5 0 01-1 0V9zm13.5-1.5a.5.5 0 00-.5.5v1.2c.35.1.68.24 1 .4V8a.5.5 0 00-.5-.5zM9.6 17c-.16-.32-.3-.65-.4-1H8a.5.5 0 000 1h1.6zM8.5 3.5c0-.28.22-.5.5-.5h2a.5.5 0 010 1H9a.5.5 0 01-.5-.5zm6 15.5a4.5 4.5 0 100-9 4.5 4.5 0 000 9zm-.9-6.4l-.9.9h1.55A2.75 2.75 0 0117 16.25v.25a.5.5 0 01-1 0v-.25c0-.97-.78-1.75-1.75-1.75h-1.54l.9.9a.5.5 0 01-.71.7l-1.76-1.75a.5.5 0 010-.7l1.76-1.75a.5.5 0 01.7.7z",
    fill: primaryFill
  }));
};

export const SquareHintArrowBackRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/SquareHintArrowBackRegularIcon({}), 'SquareHintArrowBackRegular');

const SquareHintSparklesFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M14.88.28l.35 1.07a2.2 2.2 0 001.4 1.4l1.07.35h.02a.42.42 0 010 .8l-1.07.35a2.2 2.2 0 00-1.4 1.4l-.35 1.07a.42.42 0 01-.8 0l-.35-1.07a2.23 2.23 0 00-1.4-1.4l-1.07-.35a.42.42 0 010-.8l1.07-.35a2.2 2.2 0 001.38-1.4l.35-1.07a.42.42 0 01.8 0zm4.9 7.93l-.76-.25a1.58 1.58 0 01-1-1l-.25-.76a.3.3 0 00-.57 0l-.25.77a1.58 1.58 0 01-.98 1l-.77.24a.3.3 0 000 .57l.77.25a1.58 1.58 0 011 1l.24.77a.3.3 0 00.58 0l.24-.77a1.58 1.58 0 011-1l.77-.24a.3.3 0 000-.57h-.02zM10 3.5c0-.17.04-.34.1-.5h-.85a.75.75 0 000 1.5h1.18a1.43 1.43 0 01-.43-1zm-6.25 8a.75.75 0 01-.75-.75v-1.5a.75.75 0 011.5 0v1.5c0 .41-.34.75-.75.75zm5.5 4a.75.75 0 000 1.5h1.5a.75.75 0 000-1.5h-1.5zM5.25 3a.75.75 0 010 1.5.75.75 0 00-.75.75.75.75 0 01-1.5 0C3 4.01 4 3 5.25 3zM6 16.25c0 .41-.34.75-.75.75C4.01 17 3 16 3 14.75a.75.75 0 011.5 0c0 .41.34.75.75.75s.75.34.75.75zm8 0c0 .41.34.75.75.75 1.24 0 2.25-1 2.25-2.25a.75.75 0 00-1.5 0c0 .41-.34.75-.75.75a.75.75 0 00-.75.75z",
    fill: primaryFill
  }));
};

export const SquareHintSparklesFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/SquareHintSparklesFilledIcon({}), 'SquareHintSparklesFilled');

const SquareHintSparklesRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M14.88.28l.35 1.07a2.2 2.2 0 001.4 1.4l1.07.35h.02a.42.42 0 010 .8l-1.07.35a2.2 2.2 0 00-1.4 1.4l-.35 1.07a.42.42 0 01-.8 0l-.35-1.07a2.23 2.23 0 00-1.4-1.4l-1.07-.35a.42.42 0 010-.8l1.07-.35a2.2 2.2 0 001.38-1.4l.35-1.07a.42.42 0 01.8 0zm4.9 7.93l-.76-.25a1.58 1.58 0 01-1-1l-.25-.76a.3.3 0 00-.57 0l-.25.77a1.58 1.58 0 01-.98 1l-.77.24a.3.3 0 000 .57l.77.25a1.58 1.58 0 011 1l.24.77a.3.3 0 00.58 0l.24-.77a1.58 1.58 0 011-1l.77-.24a.3.3 0 000-.57h-.02zM10 3.5c0-.17.04-.34.1-.5H9a.5.5 0 000 1h1.1c-.06-.16-.1-.33-.1-.5zM5.5 3a.5.5 0 010 1C4.67 4 4 4.67 4 5.5a.5.5 0 01-1 0A2.5 2.5 0 015.5 3zM14 16.5c0 .28.22.5.5.5a2.5 2.5 0 002.5-2.5.5.5 0 00-1 0c0 .83-.67 1.5-1.5 1.5a.5.5 0 00-.5.5zm-11-2a.5.5 0 011 0c0 .83.67 1.5 1.5 1.5a.5.5 0 010 1A2.5 2.5 0 013 14.5zm.5-6A.5.5 0 003 9v2a.5.5 0 001 0V9a.5.5 0 00-.5-.5zm5 8c0-.28.22-.5.5-.5h2a.5.5 0 010 1H9a.5.5 0 01-.5-.5z",
    fill: primaryFill
  }));
};

export const SquareHintSparklesRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/SquareHintSparklesRegularIcon({}), 'SquareHintSparklesRegular');

const SquareMultipleFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M6.09 4H5.05A2.5 2.5 0 017.5 2H14a4 4 0 014 4v6.5a2.5 2.5 0 01-2 2.45v-1.04c.58-.2 1-.76 1-1.41V6a3 3 0 00-3-3H7.5c-.65 0-1.2.42-1.41 1zM2 7.5A2.5 2.5 0 014.5 5h8A2.5 2.5 0 0115 7.5v8a2.5 2.5 0 01-2.5 2.5h-8A2.5 2.5 0 012 15.5v-8z",
    fill: primaryFill
  }));
};

export const SquareMultipleFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/SquareMultipleFilledIcon({}), 'SquareMultipleFilled');

const SquareMultipleRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M6.09 4H5.05A2.5 2.5 0 017.5 2H14a4 4 0 014 4v6.5a2.5 2.5 0 01-2 2.45v-1.04c.58-.2 1-.76 1-1.41V6a3 3 0 00-3-3H7.5c-.65 0-1.2.42-1.41 1zM4.5 5A2.5 2.5 0 002 7.5v8A2.5 2.5 0 004.5 18h8a2.5 2.5 0 002.5-2.5v-8A2.5 2.5 0 0012.5 5h-8zM3 7.5C3 6.67 3.67 6 4.5 6h8c.83 0 1.5.67 1.5 1.5v8c0 .83-.67 1.5-1.5 1.5h-8A1.5 1.5 0 013 15.5v-8z",
    fill: primaryFill
  }));
};

export const SquareMultipleRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/SquareMultipleRegularIcon({}), 'SquareMultipleRegular');

const SquareShadowFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M4.5 2A2.5 2.5 0 002 4.5v7A2.5 2.5 0 004.5 14H6v1.5A2.5 2.5 0 008.5 18h7a2.5 2.5 0 002.5-2.5v-7A2.5 2.5 0 0015.5 6H14V4.5A2.5 2.5 0 0011.5 2h-7zm-1 2.5a1 1 0 011-1h7a1 1 0 011 1v7a1 1 0 01-1 1h-7a1 1 0 01-1-1v-7z",
    fill: primaryFill
  }));
};

export const SquareShadowFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/SquareShadowFilledIcon({}), 'SquareShadowFilled');

const SquareShadowRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M4.5 2A2.5 2.5 0 002 4.5v7A2.5 2.5 0 004.5 14H6v1.5A2.5 2.5 0 008.5 18h7a2.5 2.5 0 002.5-2.5v-7A2.5 2.5 0 0015.5 6H14V4.5A2.5 2.5 0 0011.5 2h-7zM3 4.5C3 3.67 3.67 3 4.5 3h7c.83 0 1.5.67 1.5 1.5v7c0 .83-.67 1.5-1.5 1.5h-7A1.5 1.5 0 013 11.5v-7z",
    fill: primaryFill
  }));
};

export const SquareShadowRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/SquareShadowRegularIcon({}), 'SquareShadowRegular');

const SquaresNestedFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M3 6a3 3 0 013-3h8a3 3 0 013 3v1.76A2.99 2.99 0 0015 7h-5a3 3 0 00-3 3v5c0 .77.29 1.47.76 2H6a3 3 0 01-3-3V6zm7 11h4a3 3 0 003-3v-4a2 2 0 00-2-2h-5a2 2 0 00-2 2v5c0 1.1.9 2 2 2z",
    fill: primaryFill
  }));
};

export const SquaresNestedFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/SquaresNestedFilledIcon({}), 'SquaresNestedFilled');

const SquaresNestedRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M6 3a3 3 0 00-3 3v8a3 3 0 003 3h8a3 3 0 003-3V6a3 3 0 00-3-3H6zm10 4.76A2.99 2.99 0 0014 7h-4a3 3 0 00-3 3v4c0 .77.29 1.47.76 2H6a2 2 0 01-2-2V6c0-1.1.9-2 2-2h8a2 2 0 012 2v1.76zM10 16a2 2 0 01-2-2v-4c0-1.1.9-2 2-2h4a2 2 0 012 2v4a2 2 0 01-2 2h-4z",
    fill: primaryFill
  }));
};

export const SquaresNestedRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/SquaresNestedRegularIcon({}), 'SquaresNestedRegular');

const StackFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M4 3a2 2 0 00-2 2v6c0 1.1.9 2 2 2h8a2 2 0 002-2V5a2 2 0 00-2-2H4zm.27 11c.34.6.99 1 1.73 1h6a4 4 0 004-4V7a2 2 0 00-1-1.73V11a3 3 0 01-3 3H4.27zm2 2c.34.6.99 1 1.73 1h4a6 6 0 006-6V9a2 2 0 00-1-1.73V11a5 5 0 01-5 5H6.27z",
    fill: primaryFill
  }));
};

export const StackFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/StackFilledIcon({}), 'StackFilled');

const StackRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M2 5c0-1.1.9-2 2-2h8a2 2 0 012 2v6a2 2 0 01-2 2H4a2 2 0 01-2-2V5zm2-1a1 1 0 00-1 1v6a1 1 0 001 1h8a1 1 0 001-1V5a1 1 0 00-1-1H4zm2 11a2 2 0 01-1.73-1H12a3 3 0 003-3V5.27c.6.34 1 .99 1 1.73v4a4 4 0 01-4 4H6zm2 2a2 2 0 01-1.73-1H12a5 5 0 005-5V7.27c.6.34 1 .99 1 1.73v2a6 6 0 01-6 6H8z",
    fill: primaryFill
  }));
};

export const StackRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/StackRegularIcon({}), 'StackRegular');

const StackArrowForwardFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M14.5 10a4.5 4.5 0 110-9 4.5 4.5 0 010 9zm1.6-7.1a.5.5 0 00-.7.7l.9.9h-1.55A2.75 2.75 0 0012 7.25v.25a.5.5 0 001 0v-.25c0-.97.78-1.75 1.75-1.75h1.54l-.9.9a.5.5 0 00.71.7l1.76-1.75a.5.5 0 000-.7L16.1 2.9zM4 3h5.6a5.5 5.5 0 004.4 7.98V11a2 2 0 01-2 2H4a2 2 0 01-2-2V5c0-1.1.9-2 2-2zm11 7.98c.34-.03.68-.1 1-.19V11a4 4 0 01-4 4H6a2 2 0 01-1.73-1H12a3 3 0 003-3v-.02zm3-1.24c-.3.26-.64.48-1 .66v.6a5 5 0 01-5 5H6.27c.34.6.99 1 1.73 1h4a6 6 0 006-6V9.74z",
    fill: primaryFill
  }));
};

export const StackArrowForwardFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/StackArrowForwardFilledIcon({}), 'StackArrowForwardFilled');

const StackArrowForwardRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M14.5 10a4.5 4.5 0 110-9 4.5 4.5 0 010 9zm1.6-7.1a.5.5 0 00-.7.7l.9.9h-1.55A2.75 2.75 0 0012 7.25v.25a.5.5 0 001 0v-.25c0-.97.78-1.75 1.75-1.75h1.54l-.9.9a.5.5 0 00.71.7l1.76-1.75a.5.5 0 000-.7L16.1 2.9zM14 11v-.02c-.34-.03-.68-.1-1-.19V11a1 1 0 01-1 1H4a1 1 0 01-1-1V5a1 1 0 011-1h5.2c.1-.35.24-.68.4-1H4a2 2 0 00-2 2v6c0 1.1.9 2 2 2h8a2 2 0 002-2zm1-.02c.34-.03.68-.1 1-.19V11a4 4 0 01-4 4H6a2 2 0 01-1.73-1H12a3 3 0 003-3v-.02zm3-1.24c-.3.26-.64.48-1 .66v.6a5 5 0 01-5 5H6.27c.34.6.99 1 1.73 1h4a6 6 0 006-6V9.74z",
    fill: primaryFill
  }));
};

export const StackArrowForwardRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/StackArrowForwardRegularIcon({}), 'StackArrowForwardRegular');

const StackStarFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M4 3a2 2 0 00-2 2v6c0 1.1.9 2 2 2h8a2 2 0 002-2V5a2 2 0 00-2-2H4zm4.33 2.08l.91 1.73 1.8.22a.38.38 0 01.2.67L9.91 8.74l.45 1.93a.38.38 0 01-.56.4L8 10l-1.8 1.08a.38.38 0 01-.57-.4l.45-1.93L4.77 7.7a.38.38 0 01.19-.67l1.8-.22.9-1.73a.38.38 0 01.67 0zM4.27 14c.34.6.99 1 1.73 1h6a4 4 0 004-4V7a2 2 0 00-1-1.73V11a3 3 0 01-3 3H4.27zm2 2c.34.6.99 1 1.73 1h4a6 6 0 006-6V9a2 2 0 00-1-1.73V11a5 5 0 01-5 5H6.27z",
    fill: primaryFill
  }));
};

export const StackStarFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/StackStarFilledIcon({}), 'StackStarFilled');

const StackStarRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M8 4.75c.19 0 .36.1.44.27l.88 1.68 1.74.2a.5.5 0 01.25.9l-1.25 1 .43 1.84a.5.5 0 01-.75.54L8 10.14l-1.74 1.04a.5.5 0 01-.75-.54l.43-1.85-1.25-1a.5.5 0 01.25-.88l1.74-.21.88-1.68A.5.5 0 018 4.75zM2 5c0-1.1.9-2 2-2h8a2 2 0 012 2v6a2 2 0 01-2 2H4a2 2 0 01-2-2V5zm2-1a1 1 0 00-1 1v6a1 1 0 001 1h8a1 1 0 001-1V5a1 1 0 00-1-1H4zm2 11a2 2 0 01-1.73-1H12a3 3 0 003-3V5.27c.6.34 1 .99 1 1.73v4a4 4 0 01-4 4H6zm2 2a2 2 0 01-1.73-1H12a5 5 0 005-5V7.27c.6.34 1 .99 1 1.73v2a6 6 0 01-6 6H8z",
    fill: primaryFill
  }));
};

export const StackStarRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/StackStarRegularIcon({}), 'StackStarRegular');

const StarFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M9.1 2.9a1 1 0 011.8 0l1.93 3.91 4.31.63a1 1 0 01.56 1.7l-3.12 3.05.73 4.3a1 1 0 01-1.45 1.05L10 15.51l-3.86 2.03a1 1 0 01-1.45-1.05l.74-4.3L2.3 9.14a1 1 0 01.56-1.7l4.31-.63L9.1 2.9z",
    fill: primaryFill
  }));
};

export const StarFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/StarFilledIcon({}), 'StarFilled');

const StarRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M9.1 2.9a1 1 0 011.8 0l1.93 3.91 4.31.63a1 1 0 01.56 1.7l-3.12 3.05.73 4.3a1 1 0 01-1.45 1.05L10 15.51l-3.86 2.03a1 1 0 01-1.45-1.05l.74-4.3L2.3 9.14a1 1 0 01.56-1.7l4.31-.63L9.1 2.9zm.9.44L8.07 7.25a1 1 0 01-.75.55L3 8.43l3.12 3.04a1 1 0 01.3.89l-.75 4.3 3.87-2.03a1 1 0 01.93 0l3.86 2.03-.74-4.3a1 1 0 01.29-.89L17 8.43l-4.32-.63a1 1 0 01-.75-.55L10 3.35z",
    fill: primaryFill
  }));
};

export const StarRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/StarRegularIcon({}), 'StarRegular');

const StarAddFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M9.1 2.9a1 1 0 011.8 0l1.93 3.91 4.31.63a1 1 0 01.56 1.7l-.55.54a5.5 5.5 0 00-7.96 6.26l-3.05 1.6a1 1 0 01-1.45-1.05l.74-4.3L2.3 9.14a1 1 0 01.56-1.7l4.31-.63L9.1 2.9zM19 14.5a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0zm-4-2a.5.5 0 00-1 0V14h-1.5a.5.5 0 100 1H14v1.5a.5.5 0 101 0V15h1.5a.5.5 0 100-1H15v-1.5z",
    fill: primaryFill
  }));
};

export const StarAddFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/StarAddFilledIcon({}), 'StarAddFilled');

const StarAddRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M9.1 2.9a1 1 0 011.8 0l1.93 3.91 4.31.63a1 1 0 01.56 1.7l-.55.54a5.46 5.46 0 00-1-.43l.85-.82-4.32-.63a1 1 0 01-.75-.55L10 3.35l-1.93 3.9a1 1 0 01-.75.55L3 8.43l3.12 3.04a1 1 0 01.3.89l-.75 4.3 3.35-1.76c.02.36.08.7.17 1.04l-3.05 1.6a1 1 0 01-1.45-1.05l.74-4.3L2.3 9.14a1 1 0 01.56-1.7l4.31-.63L9.1 2.9zM19 14.5a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0zm-4-2a.5.5 0 00-1 0V14h-1.5a.5.5 0 100 1H14v1.5a.5.5 0 101 0V15h1.5a.5.5 0 100-1H15v-1.5z",
    fill: primaryFill
  }));
};

export const StarAddRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/StarAddRegularIcon({}), 'StarAddRegular');

const StarArrowRightEndFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M10.9 2.56a1 1 0 00-1.8 0L7.17 6.45l-4.31.62a1 1 0 00-.56 1.7l3.13 3.03-.74 4.28a1 1 0 001.45 1.05l3.05-1.6a5.46 5.46 0 015.31-6.9c.96 0 1.86.24 2.65.67l.55-.53a1 1 0 00-.56-1.7l-4.31-.62-1.93-3.9zM19 14.5a4.5 4.5 0 10-9 0 4.5 4.5 0 009 0zm-4.15 2.35a.5.5 0 01-.7-.7L15.29 15H12.5a.5.5 0 010-1h2.8l-1.15-1.15a.5.5 0 01.7-.7l2 2a.5.5 0 01.15.35.5.5 0 01-.14.35l-2 2z",
    fill: primaryFill
  }));
};

export const StarArrowRightEndFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/StarArrowRightEndFilledIcon({}), 'StarArrowRightEndFilled');

const StarArrowRightEndRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M10.9 2.56a1 1 0 00-1.8 0L7.17 6.45l-4.31.62a1 1 0 00-.56 1.7l3.13 3.03-.74 4.28a1 1 0 001.45 1.05l3.05-1.6a5.44 5.44 0 01-.17-1.03l-3.35 1.75.74-4.28a1 1 0 00-.29-.88L3 8.06l4.32-.63a1 1 0 00.75-.54L10 2.99l1.93 3.9c.15.3.43.5.75.54l4.32.63-.85.82c.35.11.69.25 1 .42l.55-.53a1 1 0 00-.56-1.7l-4.31-.62-1.93-3.9zM19 14.5a4.5 4.5 0 10-9 0 4.5 4.5 0 009 0zm-4.15 2.35a.5.5 0 01-.7-.7L15.29 15H12.5a.5.5 0 010-1h2.8l-1.15-1.15a.5.5 0 01.7-.7l2 2a.5.5 0 01.15.35.5.5 0 01-.14.35l-2 2z",
    fill: primaryFill
  }));
};

export const StarArrowRightEndRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/StarArrowRightEndRegularIcon({}), 'StarArrowRightEndRegular');

const StarArrowRightStartFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M9.1 2.56a1 1 0 011.8 0l1.93 3.9 4.31.64a1 1 0 01.56 1.7l-3.13 3.05.74 4.3a1 1 0 01-1.45 1.05l-2.98-1.57a5.52 5.52 0 00-7.8-6.07L2.3 8.8a1 1 0 01.56-1.7l4.31-.63L9.1 2.56zM5.5 10a4.5 4.5 0 110 9 4.5 4.5 0 010-9zm2.35 4.85A.5.5 0 008 14.5a.5.5 0 00-.15-.35l-2-2a.5.5 0 00-.7.7L6.29 14H3.5a.5.5 0 000 1h2.8l-1.15 1.15a.5.5 0 00.7.7l2-2z",
    fill: primaryFill
  }));
};

export const StarArrowRightStartFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/StarArrowRightStartFilledIcon({}), 'StarArrowRightStartFilled');

const StarArrowRightStartRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M9.1 2.56a1 1 0 011.8 0l1.93 3.89 4.31.62a1 1 0 01.56 1.7l-3.13 3.03.74 4.28a1 1 0 01-1.45 1.05l-2.97-1.55c.07-.35.1-.7.11-1.07l3.33 1.74-.74-4.28a1 1 0 01.29-.88L17 8.06l-4.32-.63a1 1 0 01-.75-.54L10 2.99 8.07 6.9a1 1 0 01-.75.54L3 8.06l1.14 1.1c-.36.1-.7.23-1.04.39l-.8-.78a1 1 0 01.56-1.7l4.31-.62 1.93-3.9zM5.5 10a4.5 4.5 0 110 9 4.5 4.5 0 010-9zm2.35 4.85A.5.5 0 008 14.5a.5.5 0 00-.15-.35l-2-2a.5.5 0 00-.7.7L6.29 14H3.5a.5.5 0 000 1h2.8l-1.15 1.15a.5.5 0 00.7.7l2-2z",
    fill: primaryFill
  }));
};

export const StarArrowRightStartRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/StarArrowRightStartRegularIcon({}), 'StarArrowRightStartRegular');

const StarDismissFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M9.1 2.9a1 1 0 011.8 0l1.93 3.91 4.31.63a1 1 0 01.56 1.7l-.55.54a5.5 5.5 0 00-7.96 6.26l-3.05 1.6a1 1 0 01-1.45-1.05l.74-4.3L2.3 9.14a1 1 0 01.56-1.7l4.31-.63L9.1 2.9zM19 14.5a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0zm-2.65-1.15a.5.5 0 00-.7-.7l-1.15 1.14-1.15-1.14a.5.5 0 00-.7.7l1.14 1.15-1.14 1.15a.5.5 0 00.7.7l1.15-1.14 1.15 1.14a.5.5 0 00.7-.7l-1.14-1.15 1.14-1.15z",
    fill: primaryFill
  }));
};

export const StarDismissFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/StarDismissFilledIcon({}), 'StarDismissFilled');

const StarDismissRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M9.1 2.9a1 1 0 011.8 0l1.93 3.91 4.31.63a1 1 0 01.56 1.7l-.55.54a5.47 5.47 0 00-1-.43l.85-.82-4.32-.63a1 1 0 01-.75-.55L10 3.35l-1.93 3.9a1 1 0 01-.75.55L3 8.43l3.12 3.04a1 1 0 01.3.89l-.75 4.3 3.34-1.76c.03.36.09.7.18 1.04l-3.05 1.6a1 1 0 01-1.45-1.05l.74-4.3L2.3 9.14a1 1 0 01.56-1.7l4.31-.63L9.1 2.9zM19 14.5a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0zm-2.65-1.15a.5.5 0 00-.7-.7l-1.15 1.14-1.15-1.14a.5.5 0 00-.7.7l1.14 1.15-1.14 1.15a.5.5 0 00.7.7l1.15-1.14 1.15 1.14a.5.5 0 00.7-.7l-1.14-1.15 1.14-1.15z",
    fill: primaryFill
  }));
};

export const StarDismissRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/StarDismissRegularIcon({}), 'StarDismissRegular');

const StarEditFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M10.9 2.9a1 1 0 00-1.8 0L7.17 6.8l-4.31.63a1 1 0 00-.56 1.7l3.13 3.05-.74 4.3a1 1 0 001.45 1.05l3.43-1.8c.16-.4.4-.76.7-1.07l4.83-4.83a2.87 2.87 0 012.67-.77 1 1 0 00-.63-1.63l-4.31-.63L10.9 2.9zm4.9 7.65l-4.82 4.83a2.2 2.2 0 00-.58 1.02l-.37 1.5a.89.89 0 001.08 1.07l1.5-.37c.38-.1.73-.3 1.01-.58l4.83-4.83a1.87 1.87 0 00-2.64-2.64z",
    fill: primaryFill
  }));
};

export const StarEditFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/StarEditFilledIcon({}), 'StarEditFilled');

const StarEditRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M10.9 2.9a1 1 0 00-1.8 0L7.17 6.8l-4.31.63a1 1 0 00-.56 1.7l3.13 3.05-.74 4.3a1 1 0 001.45 1.05l3.43-1.8c.16-.4.4-.76.7-1.07l.1-.09a1 1 0 00-.83.05l-3.87 2.03.74-4.3a1 1 0 00-.29-.89L3 8.43l4.32-.63a1 1 0 00.75-.55L10 3.35l1.93 3.9c.15.3.43.5.75.55l4.32.63-.72.7c.48-.15 1-.17 1.49-.06a1 1 0 00-.63-1.63l-4.31-.63L10.9 2.9zm4.9 7.65l-4.82 4.83a2.2 2.2 0 00-.58 1.02l-.37 1.5a.89.89 0 001.08 1.07l1.5-.37c.38-.1.73-.3 1.01-.58l4.83-4.83a1.87 1.87 0 00-2.64-2.64z",
    fill: primaryFill
  }));
};

export const StarEditRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/StarEditRegularIcon({}), 'StarEditRegular');

const StarEmphasisFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M9.1 2.9a1 1 0 011.8 0l1.93 3.91 4.31.63a1 1 0 01.56 1.7l-3.12 3.05.73 4.3a1 1 0 01-1.45 1.05L10 15.51l-3.86 2.03a1 1 0 01-1.45-1.05l.74-4.3L2.3 9.14a1 1 0 01.56-1.7l4.31-.63L9.1 2.9zM4.4 12.69a.5.5 0 01-.08.7l-2.5 2a.5.5 0 11-.62-.78l2.5-2a.5.5 0 01.7.08zM4.31 5.1a.5.5 0 11-.62.78l-2.5-2a.5.5 0 11.62-.78l2.5 2zm11.3 7.58a.5.5 0 00.08.7l2.5 2a.5.5 0 10.62-.78l-2.5-2a.5.5 0 00-.7.08zm.08-7.58a.5.5 0 00.62.78l2.5-2a.5.5 0 10-.62-.78l-2.5 2z",
    fill: primaryFill
  }));
};

export const StarEmphasisFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/StarEmphasisFilledIcon({}), 'StarEmphasisFilled');

const StarEmphasisRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M9.1 2.9a1 1 0 011.8 0l1.93 3.91 4.31.63a1 1 0 01.56 1.7l-3.12 3.05.73 4.3a1 1 0 01-1.45 1.05L10 15.51l-3.86 2.03a1 1 0 01-1.45-1.05l.74-4.3L2.3 9.14a1 1 0 01.56-1.7l4.31-.63L9.1 2.9zm.9.44L8.07 7.25a1 1 0 01-.75.55L3 8.43l3.12 3.04a1 1 0 01.3.89l-.75 4.3 3.87-2.03a1 1 0 01.93 0l3.86 2.03-.74-4.3a1 1 0 01.29-.89L17 8.43l-4.32-.63a1 1 0 01-.75-.55L10 3.35zM4.4 12.7a.5.5 0 01-.08.7l-2.5 2a.5.5 0 11-.62-.78l2.5-2a.5.5 0 01.7.08zM4.31 5.1a.5.5 0 11-.62.78l-2.5-2a.5.5 0 11.62-.78l2.5 2zm11.3 7.58a.5.5 0 00.08.7l2.5 2a.5.5 0 10.62-.78l-2.5-2a.5.5 0 00-.7.08zm.08-7.58a.5.5 0 00.62.78l2.5-2a.5.5 0 10-.62-.78l-2.5 2z",
    fill: primaryFill
  }));
};

export const StarEmphasisRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/StarEmphasisRegularIcon({}), 'StarEmphasisRegular');

const StarHalfFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M10 2.34a.99.99 0 00-.9.56L7.17 6.8l-4.31.63a1 1 0 00-.56 1.7l3.13 3.05-.74 4.3a1 1 0 001.45 1.05L10 15.51V2.34z",
    fill: primaryFill
  }));
};

export const StarHalfFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/StarHalfFilledIcon({}), 'StarHalfFilled');

const StarHalfRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M9.1 2.9a.99.99 0 01.9-.56c.36 0 .71.19.9.56l1.93 3.91 4.31.63a1 1 0 01.56 1.7l-3.12 3.05.73 4.3a1 1 0 01-1.45 1.05L10 15.51l-3.86 2.03a1 1 0 01-1.45-1.05l.74-4.3L2.3 9.14a1 1 0 01.56-1.7l4.31-.63L9.1 2.9zM10 14.5a1 1 0 01.47.12l3.86 2.03-.74-4.3a1 1 0 01.29-.89L17 8.43l-4.32-.63a1 1 0 01-.75-.55L10 3.35V14.5z",
    fill: primaryFill
  }));
};

export const StarHalfRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/StarHalfRegularIcon({}), 'StarHalfRegular');

const StarLineHorizontal3FilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M10.9 2.9a1 1 0 00-1.8 0L7.17 6.8l-4.31.63a1 1 0 00-.56 1.7l3.12 3.05-.73 4.3a1 1 0 001.45 1.05L11 14.98V13.5c0-.83.67-1.5 1.5-1.5a1.5 1.5 0 110-3 1.5 1.5 0 01-.07-3L10.9 2.9zm1.6 7.1a.5.5 0 000 1h5a.5.5 0 100-1h-5zM12 7.5c0-.28.22-.5.5-.5h5a.5.5 0 010 1h-5a.5.5 0 01-.5-.5zm.5 5.5a.5.5 0 000 1h5a.5.5 0 100-1h-5z",
    fill: primaryFill
  }));
};

export const StarLineHorizontal3Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/StarLineHorizontal3FilledIcon({}), 'StarLineHorizontal3Filled');

const StarLineHorizontal3RegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M9.1 2.9a1 1 0 011.8 0L12.92 7h4.58a.5.5 0 110 1h-4.58a1 1 0 01-.9-.56L10 3.34 8.07 7.25a1 1 0 01-.75.55L3 8.43l3.12 3.04a1 1 0 01.3.89l-.75 4.3 4.1-2.16a.5.5 0 01.46.89l-4.09 2.15a1 1 0 01-1.45-1.05l.74-4.3L2.3 9.14a1 1 0 01.56-1.7l4.31-.63L9.1 2.9zm2.9 7.6c0-.28.22-.5.5-.5h5a.5.5 0 110 1h-5a.5.5 0 01-.5-.5zm.5 2.5a.5.5 0 100 1h5a.5.5 0 000-1h-5z",
    fill: primaryFill
  }));
};

export const StarLineHorizontal3Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/StarLineHorizontal3RegularIcon({}), 'StarLineHorizontal3Regular');

const StarOffFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M2.86 2.15a.5.5 0 10-.71.7l4.1 4.1-3.4.49a1 1 0 00-.55 1.7l3.13 3.05-.74 4.3a1 1 0 001.45 1.05L10 15.51l3.86 2.03a1 1 0 001.45-1.05l-.1-.57 1.94 1.93a.5.5 0 00.7-.7l-15-15zm11.72 10.04l.05.32-6.87-6.88L9.1 2.9a1 1 0 011.8 0l1.93 3.91 4.31.63a1 1 0 01.56 1.7l-3.12 3.05z",
    fill: primaryFill
  }));
};

export const StarOffFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/StarOffFilledIcon({}), 'StarOffFilled');

const StarOffRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M2.86 2.15a.5.5 0 10-.71.7l4.1 4.1-3.4.49a1 1 0 00-.55 1.7l3.13 3.05-.74 4.3a1 1 0 001.45 1.05L10 15.51l3.86 2.03a1 1 0 001.45-1.05l-.1-.57 1.94 1.93a.5.5 0 00.7-.7l-15-15zM13.99 14.7l.34 1.96-3.86-2.03a1 1 0 00-.93 0l-3.87 2.03.74-4.3a1 1 0 00-.29-.89L3 8.43l4.12-.6L14 14.7zm-.11-3.23a1 1 0 00-.13.16l.88.88-.05-.32 3.12-3.05a1 1 0 00-.56-1.7l-4.31-.63L10.9 2.9a1 1 0 00-1.8 0L7.76 5.63l.74.75L10 3.34l1.93 3.91c.15.3.43.5.75.55l4.32.63-3.12 3.04z",
    fill: primaryFill
  }));
};

export const StarOffRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/StarOffRegularIcon({}), 'StarOffRegular');

const StarOneQuarterFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M8 5.14L7.17 6.8l-4.31.63a1 1 0 00-.56 1.7l3.13 3.05-.74 4.3a1 1 0 001.45 1.05L8 16.56V5.14z",
    fill: primaryFill
  }));
};

export const StarOneQuarterFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/StarOneQuarterFilledIcon({}), 'StarOneQuarterFilled');

const StarOneQuarterRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M10.9 2.9a1 1 0 00-1.8 0L8 5.13l-.83 1.68-4.31.63a1 1 0 00-.56 1.7l3.13 3.05-.74 4.3a1 1 0 001.45 1.05L10 15.51l3.86 2.03a1 1 0 001.45-1.05l-.73-4.3 3.12-3.05a1 1 0 00-.55-1.7l-4.32-.63L10.9 2.9zM8 15.43V7.37a1 1 0 00.07-.12L10 3.35l1.93 3.9c.15.3.43.5.76.55l4.31.63-3.12 3.04a1 1 0 00-.29.89l.74 4.3-3.86-2.03a1 1 0 00-.93 0l-1.54.8z",
    fill: primaryFill
  }));
};

export const StarOneQuarterRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/StarOneQuarterRegularIcon({}), 'StarOneQuarterRegular');

const StarProhibitedFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M9.1 2.9a1 1 0 011.8 0l1.93 3.91 4.31.63a1 1 0 01.56 1.7l-.55.54a5.5 5.5 0 00-7.96 6.26l-3.05 1.6a1 1 0 01-1.45-1.05l.74-4.3L2.3 9.14a1 1 0 01.56-1.7l4.31-.63L9.1 2.9zm.9 11.6a4.5 4.5 0 109 0 4.5 4.5 0 00-9 0zm1 0a3.5 3.5 0 015.6-2.8l-4.9 4.9a3.48 3.48 0 01-.7-2.1zm3.5 3.5c-.78 0-1.51-.26-2.1-.7l4.9-4.9a3.5 3.5 0 01-2.8 5.6z",
    fill: primaryFill
  }));
};

export const StarProhibitedFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/StarProhibitedFilledIcon({}), 'StarProhibitedFilled');

const StarProhibitedRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M9.1 2.9a1 1 0 011.8 0l1.93 3.91 4.31.63a1 1 0 01.56 1.7l-.55.54a5.46 5.46 0 00-1-.43l.85-.82-4.32-.63a1 1 0 01-.75-.55L10 3.35l-1.93 3.9a1 1 0 01-.75.55L3 8.43l3.12 3.04a1 1 0 01.3.89l-.75 4.3 3.35-1.76c.02.36.08.7.17 1.04l-3.05 1.6a1 1 0 01-1.45-1.05l.74-4.3L2.3 9.14a1 1 0 01.56-1.7l4.31-.63L9.1 2.9zm.9 11.6a4.5 4.5 0 109 0 4.5 4.5 0 00-9 0zm1 0a3.5 3.5 0 015.6-2.8l-4.9 4.9a3.48 3.48 0 01-.7-2.1zm3.5 3.5c-.78 0-1.51-.26-2.1-.7l4.9-4.9a3.5 3.5 0 01-2.8 5.6z",
    fill: primaryFill
  }));
};

export const StarProhibitedRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/StarProhibitedRegularIcon({}), 'StarProhibitedRegular');

const StarSettingsFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M10.9 2.9a1 1 0 00-1.8 0L7.17 6.8l-4.31.63a1 1 0 00-.56 1.7l3.13 3.05-.74 4.3a1 1 0 001.45 1.05l3.05-1.6a5.5 5.5 0 017.96-6.26l.55-.54a1 1 0 00-.56-1.7l-4.31-.63L10.9 2.9zm-.27 11.02l-.46.12a4.74 4.74 0 00.01 1.01l.35.09A2 2 0 0112 17.66l-.13.42c.26.2.54.38.84.52l.32-.35a2 2 0 012.91 0l.34.36c.3-.13.57-.3.82-.5l-.15-.55a2 2 0 011.43-2.48l.46-.12a4.73 4.73 0 00-.01-1.01l-.35-.09A2 2 0 0117 11.34l.13-.42c-.26-.2-.54-.38-.84-.52l-.32.35a2 2 0 01-2.91 0l-.34-.36c-.3.13-.57.3-.82.5l.16.55a2 2 0 01-1.44 2.48zm4.87.58a1 1 0 11-2 0 1 1 0 012 0z",
    fill: primaryFill
  }));
};

export const StarSettingsFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/StarSettingsFilledIcon({}), 'StarSettingsFilled');

const StarSettingsRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M10.9 2.9a1 1 0 00-1.8 0L7.17 6.8l-4.31.63a1 1 0 00-.56 1.7l3.13 3.05-.74 4.3a1 1 0 001.45 1.05l3.05-1.6a5.49 5.49 0 01-.18-1.04l-3.34 1.76.74-4.3a1 1 0 00-.29-.89L3 8.43l4.32-.63a1 1 0 00.75-.55L10 3.35l1.93 3.9c.15.3.43.5.75.55l4.32.63-.85.82c.35.11.69.26 1 .43l.55-.54a1 1 0 00-.56-1.7l-4.31-.63L10.9 2.9zm-.27 11.02a2 2 0 001.44-2.48l-.16-.55c.25-.2.53-.37.82-.5l.34.36a2 2 0 002.9 0l.33-.35c.3.14.58.32.84.52l-.13.42a2 2 0 001.46 2.52l.35.09a4.7 4.7 0 010 1.01l-.45.12a2 2 0 00-1.43 2.48l.15.55c-.25.2-.53.37-.82.5l-.34-.36a2 2 0 00-2.9 0l-.33.35c-.3-.14-.58-.32-.84-.52l.13-.42a2 2 0 00-1.46-2.52l-.35-.09a4.71 4.71 0 010-1.01l.45-.12zm4.87.58a1 1 0 10-2 0 1 1 0 002 0z",
    fill: primaryFill
  }));
};

export const StarSettingsRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/StarSettingsRegularIcon({}), 'StarSettingsRegular');

const StarThreeQuarterFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M12 5.13L10.9 2.9a1 1 0 00-1.8 0L7.17 6.8l-4.31.63a1 1 0 00-.56 1.7l3.13 3.05-.74 4.3a1 1 0 001.45 1.05L10 15.51l2 1.05V5.13z",
    fill: primaryFill
  }));
};

export const StarThreeQuarterFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/StarThreeQuarterFilledIcon({}), 'StarThreeQuarterFilled');

const StarThreeQuarterRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M10.9 2.9l1.93 3.91 4.31.63a1 1 0 01.56 1.7l-3.12 3.05.73 4.3a1 1 0 01-1.45 1.05L10 15.51l-3.86 2.03a1 1 0 01-1.45-1.05l.74-4.3L2.3 9.14a1 1 0 01.56-1.7l4.31-.63L9.1 2.9a1 1 0 011.8 0zM12 7.37v8.06l2.33 1.23-.74-4.3a1 1 0 01.29-.89L17 8.43l-4.32-.63a1 1 0 01-.68-.43z",
    fill: primaryFill
  }));
};

export const StarThreeQuarterRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/StarThreeQuarterRegularIcon({}), 'StarThreeQuarterRegular');

const StatusFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M17.35 2.65a2.62 2.62 0 00-3.7 0l-5.5 5.5a.5.5 0 00-.14.23l-1 4a.5.5 0 00.61.6l4-1a.5.5 0 00.23-.13l5.5-5.5a2.62 2.62 0 000-3.7zm-1.4 6.53a6 6 0 11-5.12-5.12l.85-.86A7.02 7.02 0 003 10a7 7 0 1013.8-1.68l-.86.86z",
    fill: primaryFill
  }));
};

export const StatusFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/StatusFilledIcon({}), 'StatusFilled');

const StatusRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M17.35 2.65a2.62 2.62 0 00-3.7 0l-5.5 5.5a.5.5 0 00-.14.23l-1 4a.5.5 0 00.61.6l4-1a.5.5 0 00.23-.13l5.5-5.5a2.62 2.62 0 000-3.7zm-3 .7a1.62 1.62 0 012.3 2.3l-5.4 5.4-3.06.76.76-3.05 5.4-5.4zM10 4c.28 0 .55.02.82.06l.86-.86A7.02 7.02 0 003 10a7 7 0 1013.8-1.68l-.86.86A6 6 0 1110 4z",
    fill: primaryFill
  }));
};

export const StatusRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/StatusRegularIcon({}), 'StatusRegular');

const StepsFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M11 3a1 1 0 011-1h3a1 1 0 011 1v4h-1V3h-3v3a1 1 0 01-1 1H8v3a1 1 0 01-1 1H4v3h4v1H4a1 1 0 01-1-1v-3a1 1 0 011-1h3V7a1 1 0 011-1h3V3zm2 6a1 1 0 011-1h3a1 1 0 011 1v5.5a2.5 2.5 0 01-2.5 2.5H10a1 1 0 01-1-1v-3a1 1 0 011-1h3V9z",
    fill: primaryFill
  }));
};

export const StepsFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/StepsFilledIcon({}), 'StepsFilled');

const StepsRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M11 3a1 1 0 011-1h3a1 1 0 011 1v4h-1V3h-3v3a1 1 0 01-1 1H8v3a1 1 0 01-1 1H4v3h4v1H4a1 1 0 01-1-1v-3a1 1 0 011-1h3V7a1 1 0 011-1h3V3zm3 5a1 1 0 00-1 1v3h-3a1 1 0 00-1 1v3a1 1 0 001 1h5.5a2.5 2.5 0 002.5-2.5V9a1 1 0 00-1-1h-3zm0 1h3v5.5c0 .83-.67 1.5-1.5 1.5H10v-3h3a1 1 0 001-1V9z",
    fill: primaryFill
  }));
};

export const StepsRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/StepsRegularIcon({}), 'StepsRegular');

const StethoscopeFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M2.75 2a.75.75 0 00-.75.75v5a4.5 4.5 0 003.75 4.44v1.06a5.25 5.25 0 1010.5 0v-1.1a2.75 2.75 0 10-1.5 0v1.1a3.75 3.75 0 11-7.5 0v-1.06A4.5 4.5 0 0011 7.75v-5a.75.75 0 00-.75-.75h-1.5a.75.75 0 000 1.5h.75v4.25a3 3 0 11-6 0V3.5h.75a.75.75 0 000-1.5h-1.5zM15.5 8.25a1.25 1.25 0 110 2.5 1.25 1.25 0 010-2.5z",
    fill: primaryFill
  }));
};

export const StethoscopeFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/StethoscopeFilledIcon({}), 'StethoscopeFilled');

const StethoscopeRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M2.5 2a.5.5 0 00-.5.5v5a4.5 4.5 0 004 4.47V13a5 5 0 0010 0v-1.05a2.5 2.5 0 10-1 0V13a4 4 0 11-8 0v-1.03a4.5 4.5 0 004-4.47v-5a.5.5 0 00-.5-.5h-2a.5.5 0 000 1H10v4.5a3.5 3.5 0 01-7 0V3h1.5a.5.5 0 000-1h-2zm13 6a1.5 1.5 0 110 3 1.5 1.5 0 010-3z",
    fill: primaryFill
  }));
};

export const StethoscopeRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/StethoscopeRegularIcon({}), 'StethoscopeRegular');

const StickerFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M6 3a3 3 0 00-3 3v8a3 3 0 003 3h5v-3.08a5.87 5.87 0 01-3.47-.47 4.2 4.2 0 01-.86-.57l-.01-.02h-.01a.5.5 0 01.7-.72 1 1 0 00.14.12c.1.07.26.18.48.3A4.5 4.5 0 0010 13c.43 0 .81-.05 1.15-.14a2.75 2.75 0 012.6-1.86H17V6a3 3 0 00-3-3H6zm1.5 6a1 1 0 110-2 1 1 0 010 2zm6-1a1 1 0 11-2 0 1 1 0 012 0zm-.7 8.41a2 2 0 01-.8.5v-3.16c0-.97.78-1.75 1.75-1.75h3.15a2 2 0 01-.49.8L12.8 16.4z",
    fill: primaryFill
  }));
};

export const StickerFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/StickerFilledIcon({}), 'StickerFilled');

const StickerRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M7.5 9a1 1 0 100-2 1 1 0 000 2zm6-1a1 1 0 11-2 0 1 1 0 012 0zM3 6v8a3 3 0 003 3h5.38a1.97 1.97 0 001.41-.59l3.62-3.62a2 2 0 00.59-1.41V6a3 3 0 00-3-3H6a3 3 0 00-3 3zm13 0v5h-2.25c-1.2 0-2.24.78-2.6 1.86-.34.09-.72.14-1.15.14a4.5 4.5 0 01-2.51-.74 1.97 1.97 0 01-.14-.11.5.5 0 00-.7.7v.01l.02.02a2 2 0 00.22.18 5.5 5.5 0 004.11.86V16H6a2 2 0 01-2-2V6c0-1.1.9-2 2-2h8a2 2 0 012 2zm-3.91 9.7a1 1 0 01-.09.08v-2.03c0-.97.78-1.75 1.75-1.75h2.03l-.07.09-3.62 3.62z",
    fill: primaryFill
  }));
};

export const StickerRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/StickerRegularIcon({}), 'StickerRegular');

const StickerAddFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M3 6a3 3 0 013-3h8a3 3 0 013 3v3.6a5.5 5.5 0 00-7.78 3.34 4.23 4.23 0 01-1.73-.68 1.97 1.97 0 01-.14-.11.5.5 0 00-.7.7v.01l.02.02a2 2 0 00.22.18 5.22 5.22 0 002.14.87A5.56 5.56 0 009.6 17H6a3 3 0 01-3-3V6zm4.5 3a1 1 0 100-2 1 1 0 000 2zm6-1a1 1 0 10-2 0 1 1 0 002 0zm5.5 6.5a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0zm-4-2a.5.5 0 00-1 0V14h-1.5a.5.5 0 000 1H14v1.5a.5.5 0 001 0V15h1.5a.5.5 0 000-1H15v-1.5z",
    fill: primaryFill
  }));
};

export const StickerAddFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/StickerAddFilledIcon({}), 'StickerAddFilled');

const StickerAddRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M3 6a3 3 0 013-3h8a3 3 0 013 3v3.6c-.32-.16-.65-.3-1-.4V6a2 2 0 00-2-2H6a2 2 0 00-2 2v8c0 1.1.9 2 2 2h3.2c.1.35.24.68.4 1H6a3 3 0 01-3-3V6zm4.97 6.55c.3.15.72.31 1.25.4-.09.3-.16.64-.19.97a5.22 5.22 0 01-2.14-.86 2.93 2.93 0 01-.22-.18l-.01-.02h-.01a.5.5 0 01.7-.72 1 1 0 00.14.12c.1.07.26.18.48.3zM7.5 9a1 1 0 100-2 1 1 0 000 2zm6-1a1 1 0 11-2 0 1 1 0 012 0zm5.5 6.5a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0zm-4-2a.5.5 0 00-1 0V14h-1.5a.5.5 0 000 1H14v1.5a.5.5 0 001 0V15h1.5a.5.5 0 000-1H15v-1.5z",
    fill: primaryFill
  }));
};

export const StickerAddRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/StickerAddRegularIcon({}), 'StickerAddRegular');

const StopFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M4.5 3C3.67 3 3 3.67 3 4.5v11c0 .83.67 1.5 1.5 1.5h11c.83 0 1.5-.67 1.5-1.5v-11c0-.83-.67-1.5-1.5-1.5h-11z",
    fill: primaryFill
  }));
};

export const StopFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/StopFilledIcon({}), 'StopFilled');

const StopRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M15.5 4c.28 0 .5.22.5.5v11a.5.5 0 01-.5.5h-11a.5.5 0 01-.5-.5v-11c0-.28.22-.5.5-.5h11zm-11-1C3.67 3 3 3.67 3 4.5v11c0 .83.67 1.5 1.5 1.5h11c.83 0 1.5-.67 1.5-1.5v-11c0-.83-.67-1.5-1.5-1.5h-11z",
    fill: primaryFill
  }));
};

export const StopRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/StopRegularIcon({}), 'StopRegular');

const StorageFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M2 8.5A2.5 2.5 0 014.5 6h11A2.5 2.5 0 0118 8.5v3a2.5 2.5 0 01-2.5 2.5h-11A2.5 2.5 0 012 11.5v-3zM13 9a1 1 0 10-2 0 1 1 0 002 0zm3 0a1 1 0 10-2 0 1 1 0 002 0z",
    fill: primaryFill
  }));
};

export const StorageFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/StorageFilledIcon({}), 'StorageFilled');

const StorageRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M13 9a1 1 0 11-2 0 1 1 0 012 0zm2 1a1 1 0 100-2 1 1 0 000 2zM2 8.5A2.5 2.5 0 014.5 6h11A2.5 2.5 0 0118 8.5v3a2.5 2.5 0 01-2.5 2.5h-11A2.5 2.5 0 012 11.5v-3zM4.5 7C3.67 7 3 7.67 3 8.5v3c0 .83.67 1.5 1.5 1.5h11c.83 0 1.5-.67 1.5-1.5v-3c0-.83-.67-1.5-1.5-1.5h-11z",
    fill: primaryFill
  }));
};

export const StorageRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/StorageRegularIcon({}), 'StorageRegular');

const StoreMicrosoftFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M7 2.5V4H2.5a.5.5 0 00-.5.5v10A2.5 2.5 0 004.5 17h11a2.5 2.5 0 002.5-2.5v-10a.5.5 0 00-.5-.5H13V2.5c0-.83-.67-1.5-1.5-1.5h-3C7.67 1 7 1.67 7 2.5zM8.5 2h3c.28 0 .5.22.5.5V4H8V2.5c0-.28.22-.5.5-.5zm-2 8V7h3v3h-3zm0 4v-3h3v3h-3zm7-4h-3V7h3v3zm-3 4v-3h3v3h-3z",
    fill: primaryFill
  }));
};

export const StoreMicrosoftFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/StoreMicrosoftFilledIcon({}), 'StoreMicrosoftFilled');

const StoreMicrosoftRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M9.5 7v3h-3V7h3zm0 7v-3h-3v3h3zm4-7v3h-3V7h3zm0 7v-3h-3v3h3zM7 4V2.5C7 1.67 7.67 1 8.5 1h3c.83 0 1.5.67 1.5 1.5V4h4.5c.28 0 .5.22.5.5v10a2.5 2.5 0 01-2.5 2.5h-11A2.5 2.5 0 012 14.5v-10c0-.28.22-.5.5-.5H7zm1-1.5V4h4V2.5a.5.5 0 00-.5-.5h-3a.5.5 0 00-.5.5zm-5 12c0 .83.67 1.5 1.5 1.5h11c.83 0 1.5-.67 1.5-1.5V5H3v9.5z",
    fill: primaryFill
  }));
};

export const StoreMicrosoftRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/StoreMicrosoftRegularIcon({}), 'StoreMicrosoftRegular');

const StreamFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M7.5 9.25a5.75 5.75 0 015.75-5.75h.5a.75.75 0 000-1.5h-.5C9.25 2 6 5.25 6 9.25v1c0 .41-.34.75-.75.75h-2.5a.75.75 0 000 1.5h2.5c1.24 0 2.25-1 2.25-2.25v-1zm6.25-3A3.25 3.25 0 0010.5 9.5v1a4.75 4.75 0 01-4.75 4.75h-3a.75.75 0 010-1.5h3c1.8 0 3.25-1.46 3.25-3.25v-1a4.75 4.75 0 014.75-4.75h3.5a.75.75 0 010 1.5h-3.5zm.5 2.75a.75.75 0 00-.75.75v1c0 4-3.25 7.25-7.25 7.25h-.5a.75.75 0 010-1.5h.5A5.75 5.75 0 0012 10.75v-1c0-1.24 1-2.25 2.25-2.25h3a.75.75 0 010 1.5h-3z",
    fill: primaryFill
  }));
};

export const StreamFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/StreamFilledIcon({}), 'StreamFilled');

const StreamRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M7 9a6 6 0 016-6h.5a.5.5 0 000-1H13a7 7 0 00-7 7v1a1 1 0 01-1 1H2.5a.5.5 0 000 1H5a2 2 0 002-2V9zm6.5-3A3.5 3.5 0 0010 9.5v1A4.5 4.5 0 015.5 15h-3a.5.5 0 010-1h3A3.5 3.5 0 009 10.5v-1A4.5 4.5 0 0113.5 5h4a.5.5 0 010 1h-4zm.5 3a1 1 0 00-1 1v1a7 7 0 01-7 7h-.5a.5.5 0 010-1H6a6 6 0 006-6v-1c0-1.1.9-2 2-2h3.5a.5.5 0 010 1H14z",
    fill: primaryFill
  }));
};

export const StreamRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/StreamRegularIcon({}), 'StreamRegular');

const StreamInputFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M7.5 9.25a5.75 5.75 0 015.75-5.75h.5a.75.75 0 000-1.5h-.5C9.25 2 6 5.25 6 9.25v1c0 .41-.34.75-.75.75H4.9l1.3 1.3a2.25 2.25 0 001.3-2.05v-1zM6.4 16.5l-1.23 1.23c.14.16.35.27.58.27h.5c4 0 7.25-3.25 7.25-7.25v-1c0-.41.34-.75.75-.75h3a.75.75 0 000-1.5h-3c-1.24 0-2.25 1-2.25 2.25v1c0 3.12-2.5 5.67-5.6 5.75zm.8-3.09c.26.48.34 1.02.23 1.53a4.75 4.75 0 003.07-4.44v-1c0-1.8 1.46-3.25 3.25-3.25h3.5a.75.75 0 000-1.5h-3.5A4.75 4.75 0 009 9.5v1c0 1.28-.74 2.38-1.8 2.91zm-5.48-2.44c.3-.3.77-.3 1.06 0l3 3c.3.3.3.77 0 1.06l-3 3a.75.75 0 01-1.06-1.06l1.72-1.72H.75a.75.75 0 010-1.5h2.69l-1.72-1.72a.75.75 0 010-1.06z",
    fill: primaryFill
  }));
};

export const StreamInputFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/StreamInputFilledIcon({}), 'StreamInputFilled');

const StreamInputRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M7 9a6 6 0 016-6h.5a.5.5 0 000-1H13a7 7 0 00-7 7v1a1 1 0 01-1 1h-.9l1 1A2 2 0 007 10V9zM.5 14a.5.5 0 000 1h3.68l-2.14 2.15a.5.5 0 00.7.7l3-2.99a.5.5 0 000-.72l-3-3a.5.5 0 00-.7.71L4.18 14H.5zm9.5-3.5a4.5 4.5 0 01-3.15 4.3c.06-.35.01-.7-.12-1.02A3.5 3.5 0 009 10.5v-1A4.5 4.5 0 0113.5 5h4a.5.5 0 010 1h-4A3.5 3.5 0 0010 9.5v1zM14 9a1 1 0 00-1 1v1a7 7 0 01-7 7h-.5a.5.5 0 010-1H6a6 6 0 006-6v-1c0-1.1.9-2 2-2h3.5a.5.5 0 010 1H14z",
    fill: primaryFill
  }));
};

export const StreamInputRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/StreamInputRegularIcon({}), 'StreamInputRegular');

const StreamInputOutputFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M13.25 3.5A5.75 5.75 0 007.5 9.25v1c0 1.24-1 2.25-2.25 2.25h-2.5a.75.75 0 010-1.5h2.5c.41 0 .75-.34.75-.75v-1C6 5.25 9.25 2 13.25 2h.5a.75.75 0 010 1.5h-.5zm-2.75 6c0-1.8 1.46-3.25 3.25-3.25h3.5a.75.75 0 000-1.5h-3.5A4.75 4.75 0 009 9.5v1c0 1.8-1.46 3.25-3.25 3.25h-3a.75.75 0 000 1.5h3a4.75 4.75 0 004.75-4.75v-1zm3.75-.5a.75.75 0 00-.75.75v1c0 .66-.09 1.3-.25 1.9a1.9 1.9 0 00-1.59.05c.22-.61.34-1.27.34-1.95v-1c0-1.24 1-2.25 2.25-2.25h3a.75.75 0 010 1.5h-3zm-1.4 9.16a.5.5 0 01-.7.7l-2-2a.5.5 0 010-.7l2-2a.5.5 0 01.7.7l-1.14 1.16h5.58l-1.14-1.15a.5.5 0 01.7-.7l2 2c.2.19.2.5 0 .7l-2 2a.5.5 0 01-.7-.7l1.14-1.15h-5.58l1.14 1.14z",
    fill: primaryFill
  }));
};

export const StreamInputOutputFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/StreamInputOutputFilledIcon({}), 'StreamInputOutputFilled');

const StreamInputOutputRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M13 3a6 6 0 00-6 6v1a2 2 0 01-2 2H2.5a.5.5 0 010-1H5a1 1 0 001-1V9a7 7 0 017-7h.5a.5.5 0 010 1H13zm-3 6.5A3.5 3.5 0 0113.5 6h4a.5.5 0 000-1h-4A4.5 4.5 0 009 9.5v1A3.5 3.5 0 015.5 14h-3a.5.5 0 000 1h3a4.5 4.5 0 004.5-4.5v-1zm3 .5c0-.6.4-1 1-1h3.5c.3 0 .5-.2.5-.5s-.2-.5-.5-.5H14a2 2 0 00-2 2v1c0 .9-.2 1.7-.5 2.4.3-.2.6-.4 1-.4h.2c.2-.6.3-1.3.3-2v-1zm-.15 8.16a.5.5 0 01-.7.7l-2-2a.5.5 0 010-.7l2-2a.5.5 0 01.7.7l-1.14 1.16h5.58l-1.14-1.15a.5.5 0 01.7-.7l2 2c.2.19.2.5 0 .7l-2 2a.5.5 0 01-.7-.7l1.14-1.15h-5.58l1.14 1.14z",
    fill: primaryFill
  }));
};

export const StreamInputOutputRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/StreamInputOutputRegularIcon({}), 'StreamInputOutputRegular');

const StreamOutputFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M16.78 1.97a.75.75 0 10-1.06 1.06l1.72 1.72h-3.69A4.75 4.75 0 009 9.5v1c0 1.8-1.46 3.25-3.25 3.25h-3a.75.75 0 000 1.5h3a4.75 4.75 0 004.75-4.75v-1c0-1.8 1.46-3.25 3.25-3.25h3.69l-1.72 1.72a.75.75 0 001.06 1.06l3-3c.3-.3.3-.77 0-1.06l-3-3zM13.25 3.5A5.75 5.75 0 007.5 9.25v1c0 1.24-1 2.25-2.25 2.25h-2.5a.75.75 0 010-1.5h2.5c.41 0 .75-.34.75-.75v-1C6 5.25 9.25 2 13.25 2h.5a.75.75 0 010 1.5h-.5zm.91 4c-.24.49-.3 1.03-.17 1.54-.28.1-.49.39-.49.71v1c0 4-3.25 7.25-7.25 7.25h-.5a.75.75 0 010-1.5h.5A5.75 5.75 0 0012 10.75v-1c0-1.21.96-2.2 2.16-2.25z",
    fill: primaryFill
  }));
};

export const StreamOutputFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/StreamOutputFilledIcon({}), 'StreamOutputFilled');

const StreamOutputRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M16.15 2.15c.2-.2.5-.2.7 0l3 2.99a.5.5 0 010 .72l-3 3a.5.5 0 01-.7-.71L18.29 6H13.5C11.6 6 10 7.6 10 9.5v1C10 13 8 15 5.5 15h-3c-.3 0-.5-.2-.5-.5s.2-.5.5-.5h3C7.4 14 9 12.4 9 10.5v-1C9 7 11 5 13.5 5h4.8l-2.15-2.15a.5.5 0 010-.7zM2.5 12H5a2 2 0 002-2V9c0-3.3 2.7-6 6-6h.5c.3 0 .5-.2.5-.5s-.2-.5-.5-.5H13C9.1 2 6 5.1 6 9v1c0 .6-.4 1-1 1H2.5c-.3 0-.5.2-.5.5s.2.5.5.5zm12.6-4H14a2 2 0 00-2 2v1c0 3.3-2.7 6-6 6h-.5c-.3 0-.5.2-.5.5s.2.5.5.5H6c3.9 0 7-3.1 7-7v-1c0-.6.4-1 1-1h1.1c-.1-.3-.1-.7 0-1z",
    fill: primaryFill
  }));
};

export const StreamOutputRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/StreamOutputRegularIcon({}), 'StreamOutputRegular');

const StyleGuideFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M5.07 6a2 2 0 011.41-2.46l5.46-1.47a2 2 0 012.45 1.41l2.54 9.53a2 2 0 01-1.41 2.45l-5.46 1.47a2 2 0 01-2.45-1.41L5.07 5.99zM9 6.24a.75.75 0 10-1.5 0 .75.75 0 001.5 0zM5 15V9.62l1.77 6.64c.07.27.19.52.34.74H7a2 2 0 01-2-2zm-2.33-1.5L4 8.53V15a3 3 0 00.16.97l-.08-.02a2 2 0 01-1.41-2.45z",
    fill: primaryFill
  }));
};

export const StyleGuideFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/StyleGuideFilledIcon({}), 'StyleGuideFilled');

const StyleGuideRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M5.07 6a2 2 0 011.41-2.46l5.46-1.47a2 2 0 012.45 1.41l2.54 9.53a2 2 0 01-1.41 2.45l-5.46 1.47a2 2 0 01-2.45-1.41L5.07 5.99zm1.67-1.5a1 1 0 00-.7 1.23l2.53 9.53a1 1 0 001.23.7l5.46-1.47a1 1 0 00.7-1.22l-2.53-9.53a1 1 0 00-1.23-.7L6.74 4.5zM4 8.54L2.67 13.5a2 2 0 001.41 2.45l.08.02A3 3 0 014 15v-.19a1 1 0 01-.36-1.06L4 12.4V8.53zm1 1.09V15c0 1.1.9 2 2 2h.1a2.5 2.5 0 01-.33-.74l-.08-.3A1 1 0 016 15v-1.63L5 9.62zM8.25 7a.75.75 0 100-1.5.75.75 0 000 1.5z",
    fill: primaryFill
  }));
};

export const StyleGuideRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/StyleGuideRegularIcon({}), 'StyleGuideRegular');

const SubGridFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M6 10.5v2c0 .83.67 1.5 1.5 1.5h2v-3.5H6zm0-1v-2C6 6.67 6.67 6 7.5 6h2v3.5H6zM10.5 6v3.5H14v-2c0-.83-.67-1.5-1.5-1.5h-2zm3.5 4.5h-3.5V14h2c.83 0 1.5-.67 1.5-1.5v-2zM6 3a3 3 0 00-3 3v8a3 3 0 003 3h8a3 3 0 003-3V6a3 3 0 00-3-3H6zm-2 7.5h2v-1H4V6c0-1.1.9-2 2-2h3.5v2h1V4H14a2 2 0 012 2v3.5h-2v1h2V14a2 2 0 01-2 2h-3.5v-2h-1v2H6a2 2 0 01-2-2v-3.5z",
    fill: primaryFill
  }));
};

export const SubGridFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/SubGridFilledIcon({}), 'SubGridFilled');

const SubGridRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M6 3a3 3 0 00-3 3v8a3 3 0 003 3h8a3 3 0 003-3V6a3 3 0 00-3-3H6zM4 14v-3.5h2v2c0 .83.67 1.5 1.5 1.5h2v2H6a2 2 0 01-2-2zm6.5 0h2c.83 0 1.5-.67 1.5-1.5v-2h2V14a2 2 0 01-2 2h-3.5v-2zm2.5-3.5v2a.5.5 0 01-.5.5h-2v-2.5H13zm1-1v-2c0-.83-.67-1.5-1.5-1.5h-2V4H14a2 2 0 012 2v3.5h-2zM10.5 7h2c.28 0 .5.22.5.5v2h-2.5V7zm-1-1h-2C6.67 6 6 6.67 6 7.5v2H4V6c0-1.1.9-2 2-2h3.5v2zM7 9.5v-2c0-.28.22-.5.5-.5h2v2.5H7zm0 1h2.5V13h-2a.5.5 0 01-.5-.5v-2z",
    fill: primaryFill
  }));
};

export const SubGridRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/SubGridRegularIcon({}), 'SubGridRegular');

const SubtitlesFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M2 6.75A2.75 2.75 0 014.75 4h10.5A2.75 2.75 0 0118 6.75v6.5A2.75 2.75 0 0115.25 16H4.75A2.75 2.75 0 012 13.25v-6.5zm2 4.75c0 .28.22.5.5.5h7a.5.5 0 000-1h-7a.5.5 0 00-.5.5zm.5 1.5a.5.5 0 000 1h3a.5.5 0 000-1h-3zm8.5-1.5c0 .28.22.5.5.5h2a.5.5 0 000-1h-2a.5.5 0 00-.5.5zM9.5 13a.5.5 0 000 1h6a.5.5 0 000-1h-6z",
    fill: primaryFill
  }));
};

export const SubtitlesFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/SubtitlesFilledIcon({}), 'SubtitlesFilled');

const SubtitlesRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M2 6.75A2.75 2.75 0 014.75 4h10.5A2.75 2.75 0 0118 6.75v6.5A2.75 2.75 0 0115.25 16H4.75A2.75 2.75 0 012 13.25v-6.5zM4.75 5C3.78 5 3 5.78 3 6.75v6.5c0 .97.78 1.75 1.75 1.75h10.5c.97 0 1.75-.78 1.75-1.75v-6.5C17 5.78 16.22 5 15.25 5H4.75zM4 11.5c0-.28.22-.5.5-.5h7a.5.5 0 010 1h-7a.5.5 0 01-.5-.5zm.5 1.5a.5.5 0 000 1h3a.5.5 0 000-1h-3zm8.5-1.5c0-.28.22-.5.5-.5h2a.5.5 0 010 1h-2a.5.5 0 01-.5-.5zM9.5 13a.5.5 0 000 1h6a.5.5 0 000-1h-6z",
    fill: primaryFill
  }));
};

export const SubtitlesRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/SubtitlesRegularIcon({}), 'SubtitlesRegular');

const SubtractFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("rect", {
    x: 3,
    y: 9.25,
    width: 14,
    height: 1.5,
    rx: 0.75,
    fill: primaryFill
  }));
};

export const SubtractFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/SubtractFilledIcon({}), 'SubtractFilled');

const SubtractRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("rect", {
    x: 3,
    y: 9.5,
    width: 14,
    height: 1,
    rx: 0.5,
    fill: primaryFill
  }));
};

export const SubtractRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/SubtractRegularIcon({}), 'SubtractRegular');

const SubtractCircleFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M18 10a8 8 0 11-16 0 8 8 0 0116 0zM6 10c0 .28.22.5.5.5h7a.5.5 0 000-1h-7a.5.5 0 00-.5.5z",
    fill: primaryFill
  }));
};

export const SubtractCircleFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/SubtractCircleFilledIcon({}), 'SubtractCircleFilled');

const SubtractCircleRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M6 10c0-.28.22-.5.5-.5h7a.5.5 0 010 1h-7A.5.5 0 016 10zm4 8a8 8 0 100-16 8 8 0 000 16zm0-1a7 7 0 110-14 7 7 0 010 14z",
    fill: primaryFill
  }));
};

export const SubtractCircleRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/SubtractCircleRegularIcon({}), 'SubtractCircleRegular');

const SubtractCircleArrowBackFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M16.98 9.59L17 9a8 8 0 10-7.41 7.98A5.48 5.48 0 0112.2 9.5H5.5a.5.5 0 010-1h7a.5.5 0 01.45.72 5.5 5.5 0 014.03.37zM19 14.5a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0zm-5.4-2.6a.5.5 0 00-.7 0l-1.75 1.75a.5.5 0 000 .7l1.75 1.75a.5.5 0 00.7-.7l-.9-.9h1.55c.97 0 1.75.78 1.75 1.75v.25a.5.5 0 001 0v-.25a2.75 2.75 0 00-2.75-2.75h-1.54l.9-.9a.5.5 0 000-.7z",
    fill: primaryFill
  }));
};

export const SubtractCircleArrowBackFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/SubtractCircleArrowBackFilledIcon({}), 'SubtractCircleArrowBackFilled');

const SubtractCircleArrowBackRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M5.5 8.5a.5.5 0 000 1h6.7c.24-.11.5-.2.75-.28a.5.5 0 00-.45-.72h-7zm10.5.7V9a7 7 0 10-6.8 7c.1.34.23.67.39.98L9 17a8 8 0 117.98-7.41A5.46 5.46 0 0016 9.2zm3 5.3a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0zm-5.4-2.6a.5.5 0 00-.7 0l-1.75 1.75a.5.5 0 000 .7l1.75 1.75a.5.5 0 00.7-.7l-.9-.9h1.55c.97 0 1.75.78 1.75 1.75v.25a.5.5 0 001 0v-.25a2.75 2.75 0 00-2.75-2.75h-1.54l.9-.9a.5.5 0 000-.7z",
    fill: primaryFill
  }));
};

export const SubtractCircleArrowBackRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/SubtractCircleArrowBackRegularIcon({}), 'SubtractCircleArrowBackRegular');

const SubtractCircleArrowForwardFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M16.98 9.59L17 9a8 8 0 10-7.41 7.98A5.48 5.48 0 0112.2 9.5H5.5a.5.5 0 010-1h7a.5.5 0 01.45.72 5.5 5.5 0 014.03.37zM10 14.5a4.5 4.5 0 109 0 4.5 4.5 0 00-9 0zm5.4-2.6c.2-.2.5-.2.7 0l1.75 1.75a.5.5 0 010 .7L16.1 16.1a.5.5 0 01-.7-.7l.9-.9h-1.55c-.97 0-1.75.78-1.75 1.75v.25a.5.5 0 01-1 0v-.25a2.75 2.75 0 012.75-2.75h1.54l-.9-.9a.5.5 0 010-.7z",
    fill: primaryFill
  }));
};

export const SubtractCircleArrowForwardFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/SubtractCircleArrowForwardFilledIcon({}), 'SubtractCircleArrowForwardFilled');

const SubtractCircleArrowForwardRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M5.5 8.5a.5.5 0 000 1h6.7c.24-.11.5-.2.75-.28a.5.5 0 00-.45-.72h-7zm10.5.7V9a7 7 0 10-6.8 7c.1.34.23.67.39.98L9 17a8 8 0 117.98-7.41A5.46 5.46 0 0016 9.2zm-6 5.3a4.5 4.5 0 109 0 4.5 4.5 0 00-9 0zm5.4-2.6c.2-.2.5-.2.7 0l1.75 1.75a.5.5 0 010 .7L16.1 16.1a.5.5 0 01-.7-.7l.9-.9h-1.55c-.97 0-1.75.78-1.75 1.75v.25a.5.5 0 01-1 0v-.25a2.75 2.75 0 012.75-2.75h1.54l-.9-.9a.5.5 0 010-.7z",
    fill: primaryFill
  }));
};

export const SubtractCircleArrowForwardRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/SubtractCircleArrowForwardRegularIcon({}), 'SubtractCircleArrowForwardRegular');

const SubtractSquareFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M6 3a3 3 0 00-3 3v8a3 3 0 003 3h8a3 3 0 003-3V6a3 3 0 00-3-3H6zm.5 6.5h7a.5.5 0 010 1h-7a.5.5 0 010-1z",
    fill: primaryFill
  }));
};

export const SubtractSquareFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/SubtractSquareFilledIcon({}), 'SubtractSquareFilled');

const SubtractSquareRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M6.5 9.5a.5.5 0 000 1h7a.5.5 0 000-1h-7zM6 3a3 3 0 00-3 3v8a3 3 0 003 3h8a3 3 0 003-3V6a3 3 0 00-3-3H6zM4 6c0-1.1.9-2 2-2h8a2 2 0 012 2v8a2 2 0 01-2 2H6a2 2 0 01-2-2V6z",
    fill: primaryFill
  }));
};

export const SubtractSquareRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/SubtractSquareRegularIcon({}), 'SubtractSquareRegular');

const SubtractSquareMultipleFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M16 5.27c.6.34 1 .99 1 1.73v6a4 4 0 01-4 4H7a2 2 0 01-1.73-1H13a3 3 0 003-3V5.27zM15 5a2 2 0 00-2-2H5a2 2 0 00-2 2v8c0 1.1.9 2 2 2h8a2 2 0 002-2V5zm-3 4a.5.5 0 01-.5.5h-5a.5.5 0 110-1h5c.28 0 .5.22.5.5z",
    fill: primaryFill
  }));
};

export const SubtractSquareMultipleFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/SubtractSquareMultipleFilledIcon({}), 'SubtractSquareMultipleFilled');

const SubtractSquareMultipleRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M16 5.27V13a3 3 0 01-3 3H5.27c.34.6.99 1 1.73 1h6a4 4 0 004-4V7a2 2 0 00-1-1.73zM11.5 9.5a.5.5 0 000-1h-5a.5.5 0 100 1h5zM13 3a2 2 0 012 2v8a2 2 0 01-2 2H5a2 2 0 01-2-2V5c0-1.1.9-2 2-2h8zm1 2a1 1 0 00-1-1H5a1 1 0 00-1 1v8a1 1 0 001 1h8a1 1 0 001-1V5z",
    fill: primaryFill
  }));
};

export const SubtractSquareMultipleRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/SubtractSquareMultipleRegularIcon({}), 'SubtractSquareMultipleRegular');

const SurfaceEarbudsFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M8.55 14.03a5.75 5.75 0 002.9 4.24l-1.4.57a2 2 0 01-2.37-.66l-.27-.37a2 2 0 01.06-2.44l1.08-1.34zm5.7-5.53a4.75 4.75 0 110 9.5 4.75 4.75 0 010-9.5zM5.75 1c.2 0 .39.01.58.03l.28.05-.14.04A3.72 3.72 0 004.54 6.6a3.65 3.65 0 005.75.56A4.75 4.75 0 115.75 1zm5.37.46l.09.1.09.12.44.65a1.5 1.5 0 01-.03 1.72l-.09.12-1.88 2.18a2.65 2.65 0 01-4.26-.18 2.72 2.72 0 011.43-4.1l2.62-.97a1.5 1.5 0 011.59.36zm-1.14.68a.5.5 0 00-.2.61l.03.08.26.43.06.07a.5.5 0 00.84-.5l-.04-.09-.26-.43-.05-.07a.5.5 0 00-.64-.1z",
    fill: primaryFill
  }));
};

export const SurfaceEarbudsFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/SurfaceEarbudsFilledIcon({}), 'SurfaceEarbudsFilled');

const SurfaceEarbudsRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M14.13 8.25a4.87 4.87 0 11-1.1 9.63l-.1.03-2.21.9c-1 .41-2.15.13-2.85-.68l-.1-.15-.28-.36a2.5 2.5 0 01-.04-2.91l.1-.15 1.58-1.94.17-.2a4.87 4.87 0 014.83-4.17zm-4.8 5.72l-1 1.22a1.5 1.5 0 00-.12 1.71l.08.12.28.37a1.5 1.5 0 001.63.55l.14-.05 1.34-.55a4.88 4.88 0 01-2.36-3.37zm4.8-4.72a3.88 3.88 0 00-3.76 2.93l-.07.3-.03.25-.01.18v.21c0 1.78 1.18 3.28 2.81 3.74l.2.04.22.05.2.02.17.02H14.33a3.88 3.88 0 00-.2-7.74zM5.88 1c.66 0 1.29.13 1.86.37l.7-.23a2.5 2.5 0 012.66.73l.12.14.12.17.29.46c.53.84.5 1.91-.05 2.74l-.1.15-.13.14-.62.67A4.88 4.88 0 115.88 1zm-.04 1h.04A3.87 3.87 0 109.1 8.02l-.06.04-.2.13a3.44 3.44 0 01-4.77-1.05A3.5 3.5 0 015.61 2.1l.23-.1zm4.58.61a1.5 1.5 0 00-1.53-.56l-.14.04-2.36.78a2.5 2.5 0 00-1.46 3.74 2.44 2.44 0 003.75.46l.16-.16L10.6 5l.1-.11a1.5 1.5 0 00.15-1.6l-.07-.12-.28-.45-.08-.12zm-.8.53l.05.08.26.42a.5.5 0 01-.8.6l-.06-.08-.26-.43a.5.5 0 01.8-.59z",
    fill: primaryFill
  }));
};

export const SurfaceEarbudsRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/SurfaceEarbudsRegularIcon({}), 'SurfaceEarbudsRegular');

const SurfaceHubFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M5.26 2a.5.5 0 00-.5.45l-.76 8a.5.5 0 00.5.55h2.42l-.91 6.43a.5.5 0 00.98.14L7.36 15h3L10 17.43a.5.5 0 00.98.14l.37-2.57h2.28l.37 2.57a.5.5 0 00.98-.14L14.08 11h.66a.5.5 0 00.5-.45l.76-8a.5.5 0 00-.5-.55H5.26zm8.23 12h-1.98l.42-3h1.14l.42 3zm-3 0H7.51l.42-3h3l-.44 3z",
    fill: primaryFill
  }));
};

export const SurfaceHubFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/SurfaceHubFilledIcon({}), 'SurfaceHubFilled');

const SurfaceHubRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M4.76 2.45a.5.5 0 01.5-.45H15.5a.5.5 0 01.5.55l-.76 8a.5.5 0 01-.5.45h-.66l.91 6.43a.5.5 0 01-.98.14L13.64 15h-2.28L11 17.57a.5.5 0 01-.98-.14l.34-2.43H7.36L7 17.57a.5.5 0 01-.98-.14L6.92 11H4.5a.5.5 0 01-.5-.55l.76-8zM7.51 14h2.98l.43-3H7.93l-.42 3zm4 0h1.98l-.42-3h-1.14l-.42 3zm2.78-4l.66-7H5.71l-.66 7h9.24z",
    fill: primaryFill
  }));
};

export const SurfaceHubRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/SurfaceHubRegularIcon({}), 'SurfaceHubRegular');

const SymbolsFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M14.14 7.97c.2.2.51.2.7 0l2.56-2.55a2 2 0 10-2.83-2.83l-.07.08-.08-.08a2 2 0 00-2.83 2.83l2.55 2.55zM2 5.5a3.5 3.5 0 117 0 3.5 3.5 0 01-7 0zM5.5 3c-.5 0-.98.16-1.38.42L7.6 6.88A2.5 2.5 0 005.5 3zM3 5.5A2.5 2.5 0 006.88 7.6L3.4 4.12C3.15 4.52 3 5 3 5.5zm9.34 7.75A2.5 2.5 0 0116.5 13h-1a.5.5 0 100 1h2a.5.5 0 00.5-.5v-2a.5.5 0 00-1 0v.55a3.49 3.49 0 00-5.53.7.5.5 0 00.87.5zm-.34 3.7v.55a.5.5 0 01-1 0v-2c0-.28.22-.5.5-.5h2a.5.5 0 110 1h-1a2.5 2.5 0 004.17-.25.5.5 0 01.86.5 3.5 3.5 0 01-5.53.7zM5.5 11c.28 0 .5.23.5.5V14h2.5a.5.5 0 110 1H6v2.5a.5.5 0 01-1 0V15H2.5a.5.5 0 110-1H5v-2.5c0-.27.22-.5.5-.5z",
    fill: primaryFill
  }));
};

export const SymbolsFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/SymbolsFilledIcon({}), 'SymbolsFilled');

const SymbolsRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M14.14 7.97c.2.2.51.2.7 0l2.56-2.55a2 2 0 10-2.83-2.83l-.07.08-.08-.08a2 2 0 00-2.83 2.83l2.55 2.55zM12.3 4.71a1 1 0 111.42-1.41l.79.78.5-.5.28-.28a1 1 0 011.43 0 1 1 0 010 1.4L14.5 6.92l-2.2-2.2zM2 5.51a3.5 3.5 0 117 0 3.5 3.5 0 01-7 0zM5.5 3c-.5 0-.98.15-1.38.4L7.6 6.89A2.5 2.5 0 005.5 3zM3 5.5a2.5 2.5 0 003.88 2.08L3.4 4.12C3.15 4.52 3 5 3 5.5zm9.34 7.74A2.5 2.5 0 0116.5 13h-1a.5.5 0 100 1h2a.5.5 0 00.5-.5v-2a.5.5 0 00-1 0v.55a3.49 3.49 0 00-5.53.7.5.5 0 00.87.5zm-.34 3.7v.55a.5.5 0 01-1 0v-2c0-.28.22-.5.5-.5h2a.5.5 0 110 1h-1a2.5 2.5 0 004.17-.25.5.5 0 01.86.5 3.5 3.5 0 01-5.53.7zM5.5 11c.28 0 .5.23.5.5V14h2.5a.5.5 0 110 1H6v2.5a.5.5 0 01-1 0V15H2.5a.5.5 0 110-1H5v-2.5c0-.27.22-.5.5-.5z",
    fill: primaryFill
  }));
};

export const SymbolsRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/SymbolsRegularIcon({}), 'SymbolsRegular');

const SyncOffFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M17.94 9H12.3l.67-2.36a.5.5 0 00-.96-.28l-2 7a.5.5 0 00.96.28L12.02 10H18a8 8 0 01-16 0h5.98l-.96 3.36a.5.5 0 00.96.28l2-7a.5.5 0 00-.96-.28L8.27 9h-6.2a8 8 0 0115.87 0z",
    fill: primaryFill
  }));
};

export const SyncOffFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/SyncOffFilledIcon({}), 'SyncOffFilled');

const SyncOffRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M2 10a8 8 0 1116 0 8 8 0 01-16 0zm8-7a7 7 0 00-6.93 6h5.2l.75-2.64a.5.5 0 11.96.28l-2 7a.5.5 0 11-.96-.28L7.98 10H3a7 7 0 1014 0h-4.98l-1.04 3.64a.5.5 0 11-.96-.28l2-7a.5.5 0 11.96.28L12.31 9h4.62A7 7 0 0010 3z",
    fill: primaryFill
  }));
};

export const SyncOffRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/SyncOffRegularIcon({}), 'SyncOffRegular');

const SyringeFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M14.15 2.15c.2-.2.5-.2.7 0l3 3a.5.5 0 01-.7.7l-.4-.4-1.8 1.8 1.9 1.9a.5.5 0 01-.7.7L15 8.71l-5.56 5.56a2.5 2.5 0 01-1.77.73H5.71l-2.86 2.85a.5.5 0 01-.7-.7L5 14.29v-1.96c0-.66.26-1.3.73-1.77L6.3 10l.86.85a.5.5 0 00.7-.7L7 9.29l.8-.79.85.85a.5.5 0 10.7-.7l-.85-.86.8-.79.85.85a.5.5 0 00.7-.7L10 6.29 11.3 5l-1.15-1.15a.5.5 0 01.7-.7l1.9 1.9 1.8-1.8-.4-.4a.5.5 0 010-.7zm1.9 2.6l-.8-.8-1.8 1.8.8.8 1.8-1.8z",
    fill: primaryFill
  }));
};

export const SyringeFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/SyringeFilledIcon({}), 'SyringeFilled');

const SyringeRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M14.15 2.15c.2-.2.5-.2.7 0l3 3a.5.5 0 01-.7.7l-.4-.4-1.8 1.8 1.9 1.9a.5.5 0 01-.7.7L15 8.71l-5.56 5.56a2.5 2.5 0 01-1.77.73H5.71l-2.86 2.85a.5.5 0 01-.7-.7L5 14.29v-1.96c0-.66.26-1.3.73-1.77L11.3 5l-1.14-1.15a.5.5 0 01.7-.7l1.9 1.9 1.8-1.8-.4-.4a.5.5 0 010-.7zM10 7.7l-.8.79.65.65a.5.5 0 01-.7.7l-.65-.64-.8.79.65.65a.5.5 0 01-.7.7L7 10.71l-.56.56A1.5 1.5 0 006 12.33V14h1.67c.4 0 .78-.16 1.06-.44L14.3 8 12 5.7 10.7 7l.65.65a.5.5 0 01-.7.7L10 7.71zm6.04-2.96l-.79-.8-1.8 1.8.8.8 1.8-1.8z",
    fill: primaryFill
  }));
};

export const SyringeRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/SyringeRegularIcon({}), 'SyringeRegular');

const SystemFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M2 6.5A2.5 2.5 0 014.5 4h11A2.5 2.5 0 0118 6.5v7a2.5 2.5 0 01-2.5 2.5h-11A2.5 2.5 0 012 13.5v-7zm2.5-1a1 1 0 00-1 1v7a1 1 0 001 1h11a1 1 0 001-1v-7a1 1 0 00-1-1h-11z",
    fill: primaryFill
  }));
};

export const SystemFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/SystemFilledIcon({}), 'SystemFilled');

const SystemRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M2 6.5A2.5 2.5 0 014.5 4h11A2.5 2.5 0 0118 6.5v7a2.5 2.5 0 01-2.5 2.5h-11A2.5 2.5 0 012 13.5v-7zM4.5 5C3.67 5 3 5.67 3 6.5v7c0 .83.67 1.5 1.5 1.5h11c.83 0 1.5-.67 1.5-1.5v-7c0-.83-.67-1.5-1.5-1.5h-11z",
    fill: primaryFill
  }));
};

export const SystemRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/SystemRegularIcon({}), 'SystemRegular');

const TabFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M2.86 5.75A2.75 2.75 0 015.6 3h8.5a2.75 2.75 0 012.75 2.75v8.5A2.75 2.75 0 0114.1 17H5.6a2.75 2.75 0 01-2.75-2.75v-8.5zM5.6 4.5c-.7 0-1.25.56-1.25 1.25v8.5c0 .69.56 1.25 1.25 1.25h8.5c.69 0 1.25-.56 1.25-1.25v-8.5c0-.69-.56-1.25-1.25-1.25H5.6z",
    fill: primaryFill
  }));
};

export const TabFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/TabFilledIcon({}), 'TabFilled');

const TabRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M3 5.5A2.5 2.5 0 015.5 3h9A2.5 2.5 0 0117 5.5v9a2.5 2.5 0 01-2.5 2.5h-9A2.5 2.5 0 013 14.5v-9zM5.5 4C4.67 4 4 4.67 4 5.5v9c0 .83.67 1.5 1.5 1.5h9c.83 0 1.5-.67 1.5-1.5v-9c0-.83-.67-1.5-1.5-1.5h-9z",
    fill: primaryFill
  }));
};

export const TabRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/TabRegularIcon({}), 'TabRegular');

const TabAddFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M3 5.75A2.75 2.75 0 015.75 3h8.5A2.75 2.75 0 0117 5.75V9.6a5.46 5.46 0 00-1.5-.5V5.74c0-.69-.56-1.25-1.25-1.25h-8.5c-.69 0-1.25.56-1.25 1.25v8.5c0 .69.56 1.25 1.25 1.25h3.34c.1.53.27 1.03.51 1.5H5.75A2.75 2.75 0 013 14.25v-8.5zm16 8.75a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0zm-4-2a.5.5 0 00-1 0V14h-1.5a.5.5 0 000 1H14v1.5a.5.5 0 001 0V15h1.5a.5.5 0 000-1H15v-1.5z",
    fill: primaryFill
  }));
};

export const TabAddFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/TabAddFilledIcon({}), 'TabAddFilled');

const TabAddRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M3 5.5A2.5 2.5 0 015.5 3h9A2.5 2.5 0 0117 5.5v4.1c-.32-.16-.65-.3-1-.4V5.5c0-.83-.67-1.5-1.5-1.5h-9C4.67 4 4 4.67 4 5.5v9c0 .83.67 1.5 1.5 1.5h3.7c.1.35.24.68.4 1H5.5A2.5 2.5 0 013 14.5v-9zm16 9a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0zm-4-2a.5.5 0 00-1 0V14h-1.5a.5.5 0 000 1H14v1.5a.5.5 0 001 0V15h1.5a.5.5 0 000-1H15v-1.5z",
    fill: primaryFill
  }));
};

export const TabAddRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/TabAddRegularIcon({}), 'TabAddRegular');

const TabArrowLeftFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M3 5c0-1.1.9-2 2-2h10a2 2 0 012 2v4.6A5.5 5.5 0 009.6 17H5a2 2 0 01-2-2V5zm11.5 14a4.5 4.5 0 110-9 4.5 4.5 0 010 9zm-2.35-4.85a.5.5 0 00-.15.35.5.5 0 00.15.35l2 2a.5.5 0 00.7-.7L13.71 15h2.79a.5.5 0 000-1h-2.8l1.15-1.15a.5.5 0 00-.7-.7l-2 2z",
    fill: primaryFill
  }));
};

export const TabArrowLeftFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/TabArrowLeftFilledIcon({}), 'TabArrowLeftFilled');

const TabArrowLeftRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M3 5c0-1.1.9-2 2-2h10a2 2 0 012 2v4.6c-.32-.16-.65-.3-1-.4V5a1 1 0 00-1-1H5a1 1 0 00-1 1v10a1 1 0 001 1h4.2c.1.35.24.68.4 1H5a2 2 0 01-2-2V5zm11.5 14a4.5 4.5 0 110-9 4.5 4.5 0 010 9zm-2.35-4.85a.5.5 0 00-.15.35.5.5 0 00.15.35l2 2a.5.5 0 00.7-.7L13.71 15h2.79a.5.5 0 000-1h-2.8l1.15-1.15a.5.5 0 00-.7-.7l-2 2z",
    fill: primaryFill
  }));
};

export const TabArrowLeftRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/TabArrowLeftRegularIcon({}), 'TabArrowLeftRegular');

const TabDesktopFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M5.5 3A2.5 2.5 0 003 5.5v9A2.5 2.5 0 005.5 17h9a2.5 2.5 0 002.5-2.5V7H9.5A1.5 1.5 0 018 5.5V3H5.5zM9 3v2.5c0 .28.22.5.5.5H17v-.5A2.5 2.5 0 0014.5 3H9z",
    fill: primaryFill
  }));
};

export const TabDesktopFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/TabDesktopFilledIcon({}), 'TabDesktopFilled');

const TabDesktopRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M3 5.5A2.5 2.5 0 015.5 3h9A2.5 2.5 0 0117 5.5v9a2.5 2.5 0 01-2.5 2.5h-9A2.5 2.5 0 013 14.5v-9zM16 6v-.5c0-.83-.67-1.5-1.5-1.5H9v1.5c0 .28.22.5.5.5H16zM8 4H5.5C4.67 4 4 4.67 4 5.5v9c0 .83.67 1.5 1.5 1.5h9c.83 0 1.5-.67 1.5-1.5V7H9.5A1.5 1.5 0 018 5.5V4z",
    fill: primaryFill
  }));
};

export const TabDesktopRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/TabDesktopRegularIcon({}), 'TabDesktopRegular');

const TabDesktopArrowClockwiseFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M5.5 3A2.5 2.5 0 003 5.5v3.76a5.48 5.48 0 015.2-1A1.5 1.5 0 0111 9v1.34a5.48 5.48 0 01-.26 6.66h3.76a2.5 2.5 0 002.5-2.5V7H9.5A1.5 1.5 0 018 5.5V3H5.5zM9 3v2.5c0 .28.22.5.5.5H17v-.5A2.5 2.5 0 0014.5 3H9zm1 8a.5.5 0 01-.5.5h-2a.5.5 0 010-1h.8a3.5 3.5 0 101.7 3 .5.5 0 011 0 4.5 4.5 0 11-2-3.74V9a.5.5 0 01.5-.5c.28 0 .5.22.5.5v2z",
    fill: primaryFill
  }));
};

export const TabDesktopArrowClockwiseFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/TabDesktopArrowClockwiseFilledIcon({}), 'TabDesktopArrowClockwiseFilled');

const TabDesktopArrowClockwiseRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M3 5.5A2.5 2.5 0 015.5 3h9A2.5 2.5 0 0117 5.5v9a2.5 2.5 0 01-2.5 2.5h-3.76c.26-.3.48-.64.66-1h3.1c.83 0 1.5-.67 1.5-1.5V7H9.5A1.5 1.5 0 018 5.5V4H5.5C4.67 4 4 4.67 4 5.5v3.1c-.36.18-.7.4-1 .66V5.5zM16 6v-.5c0-.83-.67-1.5-1.5-1.5H9v1.5c0 .28.22.5.5.5H16zM9.5 8.5c.28 0 .5.22.5.5v2a.5.5 0 01-.5.5h-2a.5.5 0 010-1h.8a3.5 3.5 0 101.7 3 .5.5 0 011 0 4.5 4.5 0 11-2-3.74V9c0-.28.22-.5.5-.5z",
    fill: primaryFill
  }));
};

export const TabDesktopArrowClockwiseRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/TabDesktopArrowClockwiseRegularIcon({}), 'TabDesktopArrowClockwiseRegular');

const TabDesktopArrowLeftFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M5.5 3A2.5 2.5 0 003 5.5v4.1a5.5 5.5 0 017.4 7.4h4.1a2.5 2.5 0 002.5-2.5V7H9.5A1.5 1.5 0 018 5.5V3H5.5zM9 3v2.5c0 .28.22.5.5.5H17v-.5A2.5 2.5 0 0014.5 3H9zm1 11.5a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0zm-6.85-.35a.5.5 0 00-.15.35.5.5 0 00.15.35l2 2a.5.5 0 00.7-.7L4.71 15H7.5a.5.5 0 000-1H4.7l1.15-1.15a.5.5 0 00-.7-.7l-2 2z",
    fill: primaryFill
  }));
};

export const TabDesktopArrowLeftFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/TabDesktopArrowLeftFilledIcon({}), 'TabDesktopArrowLeftFilled');

const TabDesktopArrowLeftRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M3 5.5A2.5 2.5 0 015.5 3h9A2.5 2.5 0 0117 5.5v9a2.5 2.5 0 01-2.5 2.5h-4.1c.16-.32.3-.65.4-1h3.7c.82 0 1.5-.67 1.5-1.5V7H9.5A1.5 1.5 0 018 5.5V4H5.5C4.67 4 4 4.67 4 5.5v3.7c-.35.1-.69.24-1 .4V5.5zM16 6v-.5c0-.83-.68-1.5-1.5-1.5H9v1.5c0 .28.22.5.5.5H16zm-6 8.5a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0zm-6.85-.35a.5.5 0 00-.15.35.5.5 0 00.15.35l2 2a.5.5 0 00.7-.7L4.71 15H7.5a.5.5 0 000-1H4.7l1.15-1.15a.5.5 0 00-.7-.7l-2 2z",
    fill: primaryFill
  }));
};

export const TabDesktopArrowLeftRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/TabDesktopArrowLeftRegularIcon({}), 'TabDesktopArrowLeftRegular');

const TabDesktopBottomFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M14.5 17a2.5 2.5 0 002.5-2.5v-9A2.5 2.5 0 0014.5 3h-9A2.5 2.5 0 003 5.5V13h7.5c.83 0 1.5.67 1.5 1.5V17h2.5zM11 17v-2.5a.5.5 0 00-.5-.5H3v.5A2.5 2.5 0 005.5 17H11z",
    fill: primaryFill
  }));
};

export const TabDesktopBottomFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/TabDesktopBottomFilledIcon({}), 'TabDesktopBottomFilled');

const TabDesktopBottomRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M17 14.5a2.5 2.5 0 01-2.5 2.5h-9A2.5 2.5 0 013 14.5v-9A2.5 2.5 0 015.5 3h9A2.5 2.5 0 0117 5.5v9zM4 14v.5c0 .83.67 1.5 1.5 1.5H11v-1.5a.5.5 0 00-.5-.5H4zm8 2h2.5c.83 0 1.5-.67 1.5-1.5v-9c0-.83-.67-1.5-1.5-1.5h-9C4.67 4 4 4.67 4 5.5V13h6.5c.83 0 1.5.67 1.5 1.5V16z",
    fill: primaryFill
  }));
};

export const TabDesktopBottomRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/TabDesktopBottomRegularIcon({}), 'TabDesktopBottomRegular');

const TabDesktopClockFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M5.5 3A2.5 2.5 0 003 5.5v4.1a5.5 5.5 0 017.4 7.4h4.1a2.5 2.5 0 002.5-2.5V7H9.5A1.5 1.5 0 018 5.5V3H5.5zM9 3v2.5c0 .28.22.5.5.5H17v-.5A2.5 2.5 0 0014.5 3H9zM5.5 19a4.5 4.5 0 100-9 4.5 4.5 0 000 9zm0-7c.28 0 .5.22.5.5V14h1a.5.5 0 010 1H5.5a.5.5 0 01-.5-.5v-2c0-.28.22-.5.5-.5z",
    fill: primaryFill
  }));
};

export const TabDesktopClockFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/TabDesktopClockFilledIcon({}), 'TabDesktopClockFilled');

const TabDesktopClockRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M3 5.5A2.5 2.5 0 015.5 3h9A2.5 2.5 0 0117 5.5v9a2.5 2.5 0 01-2.5 2.5h-4.1c.16-.32.3-.65.4-1h3.7c.83 0 1.5-.67 1.5-1.5V7H9.5A1.5 1.5 0 018 5.5V4H5.5C4.67 4 4 4.67 4 5.5v3.7c-.35.1-.68.24-1 .4V5.5zM16 6v-.5c0-.83-.67-1.5-1.5-1.5H9v1.5c0 .28.22.5.5.5H16zm-6 8.5a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0zM5.5 12a.5.5 0 00-.5.5v2c0 .28.22.5.5.5H7a.5.5 0 000-1H6v-1.5a.5.5 0 00-.5-.5z",
    fill: primaryFill
  }));
};

export const TabDesktopClockRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/TabDesktopClockRegularIcon({}), 'TabDesktopClockRegular');

const TabDesktopCopyFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M5 4.5A2.5 2.5 0 017.5 2H9v2.5c0 .83.67 1.5 1.5 1.5H18v6.5a2.5 2.5 0 01-2.5 2.5h-8A2.5 2.5 0 015 12.5v-8zm5 0V2h5.5A2.5 2.5 0 0118 4.5V5h-7.5a.5.5 0 01-.5-.5zM12.5 18a2.5 2.5 0 002.45-2H7.5A3.5 3.5 0 014 12.5V5.05A2.5 2.5 0 002 7.5V14a4 4 0 004 4h6.5z",
    fill: primaryFill
  }));
};

export const TabDesktopCopyFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/TabDesktopCopyFilledIcon({}), 'TabDesktopCopyFilled');

const TabDesktopCopyRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M7.5 2A2.5 2.5 0 005 4.5v8A2.5 2.5 0 007.5 15h8a2.5 2.5 0 002.5-2.5v-8A2.5 2.5 0 0015.5 2h-8zM17 4.5V5h-6.5a.5.5 0 01-.5-.5V3h5.5c.83 0 1.5.67 1.5 1.5zm-8 0c0 .83.67 1.5 1.5 1.5H17v6.5c0 .83-.67 1.5-1.5 1.5h-8A1.5 1.5 0 016 12.5v-8C6 3.67 6.67 3 7.5 3H9v1.5zM12.5 18a2.5 2.5 0 002.45-2h-1.04c-.2.58-.76 1-1.41 1H6a3 3 0 01-3-3V7.5c0-.65.42-1.2 1-1.41V5.05A2.5 2.5 0 002 7.5V14a4 4 0 004 4h6.5z",
    fill: primaryFill
  }));
};

export const TabDesktopCopyRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/TabDesktopCopyRegularIcon({}), 'TabDesktopCopyRegular');

const TabDesktopImageFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M5.5 3A2.5 2.5 0 003 5.5v2.84c.45-.22.96-.34 1.5-.34h4a3.5 3.5 0 013.5 3.5v4c0 .54-.12 1.05-.34 1.5h2.84a2.5 2.5 0 002.5-2.5V7H9.5A1.5 1.5 0 018 5.5V3H5.5zM9 3v2.5c0 .28.22.5.5.5H17v-.5A2.5 2.5 0 0014.5 3H9zm-7 8.5A2.5 2.5 0 014.5 9h4a2.5 2.5 0 012.5 2.5v4c0 .5-.15.98-.41 1.38l-3.03-3.03a1.5 1.5 0 00-2.12 0L2.4 16.88C2.15 16.48 2 16 2 15.5v-4zm7 .25a.75.75 0 10-1.5 0 .75.75 0 001.5 0zm-5.88 5.84c.4.26.87.41 1.38.41h4c.51 0 .98-.15 1.38-.41l-3.03-3.03a.5.5 0 00-.7 0L3.12 17.6z",
    fill: primaryFill
  }));
};

export const TabDesktopImageFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/TabDesktopImageFilledIcon({}), 'TabDesktopImageFilled');

const TabDesktopImageRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M3 5.5A2.5 2.5 0 015.5 3h9A2.5 2.5 0 0117 5.5v9a2.5 2.5 0 01-2.5 2.5h-2.84c.15-.31.25-.65.3-1h2.54c.82 0 1.5-.67 1.5-1.5V7H9.5A1.5 1.5 0 018 5.5V4H5.5C4.67 4 4 4.67 4 5.5v2.54c-.36.05-.7.15-1 .3V5.5zM16 6v-.5c0-.83-.68-1.5-1.5-1.5H9v1.5c0 .28.22.5.5.5H16zM2 11.5A2.5 2.5 0 014.5 9h4a2.5 2.5 0 012.5 2.5v4c0 .5-.15.98-.41 1.38l-3.03-3.03a1.5 1.5 0 00-2.12 0L2.4 16.88C2.15 16.48 2 16 2 15.5v-4zm7 .25a.75.75 0 10-1.5 0 .75.75 0 001.5 0zm-5.88 5.84c.4.26.87.41 1.38.41h4c.51 0 .98-.15 1.38-.41l-3.03-3.03a.5.5 0 00-.7 0L3.12 17.6z",
    fill: primaryFill
  }));
};

export const TabDesktopImageRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/TabDesktopImageRegularIcon({}), 'TabDesktopImageRegular');

const TabDesktopMultipleFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M2 4.5A2.5 2.5 0 014.5 2H6v2.5C6 5.33 6.67 6 7.5 6H15v6.5a2.5 2.5 0 01-2.5 2.5h-8A2.5 2.5 0 012 12.5v-8zm5 0V2h5.5A2.5 2.5 0 0115 4.5V5H7.5a.5.5 0 01-.5-.5zM7.5 18a2.5 2.5 0 01-2.45-2h7.45a3.5 3.5 0 003.5-3.5V5.05a2.5 2.5 0 012 2.45V14a4 4 0 01-4 4H7.5z",
    fill: primaryFill
  }));
};

export const TabDesktopMultipleFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/TabDesktopMultipleFilledIcon({}), 'TabDesktopMultipleFilled');

const TabDesktopMultipleRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M4.5 2A2.5 2.5 0 002 4.5v8A2.5 2.5 0 004.5 15h8a2.5 2.5 0 002.5-2.5v-8A2.5 2.5 0 0012.5 2h-8zM14 4.5V5H7.5a.5.5 0 01-.5-.5V3h5.5c.83 0 1.5.67 1.5 1.5zm-8 0C6 5.33 6.67 6 7.5 6H14v6.5c0 .83-.67 1.5-1.5 1.5h-8A1.5 1.5 0 013 12.5v-8C3 3.67 3.67 3 4.5 3H6v1.5zM7.5 18a2.5 2.5 0 01-2.45-2h1.04c.2.58.76 1 1.41 1H14a3 3 0 003-3V7.5c0-.65-.42-1.2-1-1.41V5.05a2.5 2.5 0 012 2.45V14a4 4 0 01-4 4H7.5z",
    fill: primaryFill
  }));
};

export const TabDesktopMultipleRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/TabDesktopMultipleRegularIcon({}), 'TabDesktopMultipleRegular');

const TabDesktopMultipleBottomFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M5.05 4h7.45A3.5 3.5 0 0116 7.5v7.45a2.5 2.5 0 002-2.45V6a4 4 0 00-4-4H7.5a2.5 2.5 0 00-2.45 2zM2 7.5A2.5 2.5 0 014.5 5h8A2.5 2.5 0 0115 7.5v8a2.5 2.5 0 01-2.5 2.5H11v-2.5c0-.83-.67-1.5-1.5-1.5H2V7.5zm8 8V18H4.5A2.5 2.5 0 012 15.5V15h7.5c.28 0 .5.22.5.5z",
    fill: primaryFill
  }));
};

export const TabDesktopMultipleBottomFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/TabDesktopMultipleBottomFilledIcon({}), 'TabDesktopMultipleBottomFilled');

const TabDesktopMultipleBottomRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M6.09 4H5.05A2.5 2.5 0 017.5 2H14a4 4 0 014 4v6.5a2.5 2.5 0 01-2 2.45v-1.04c.58-.2 1-.76 1-1.41V6a3 3 0 00-3-3H7.5c-.65 0-1.2.42-1.41 1zM9.5 15H3v.5c0 .83.67 1.5 1.5 1.5H10v-1.5a.5.5 0 00-.5-.5zM3 14h6.5c.83 0 1.5.67 1.5 1.5V17h1.5c.83 0 1.5-.67 1.5-1.5v-8c0-.83-.67-1.5-1.5-1.5h-8C3.67 6 3 6.67 3 7.5V14zm1.5 4A2.5 2.5 0 012 15.5v-8A2.5 2.5 0 014.5 5h8A2.5 2.5 0 0115 7.5v8a2.5 2.5 0 01-2.5 2.5h-8z",
    fill: primaryFill
  }));
};

export const TabDesktopMultipleBottomRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/TabDesktopMultipleBottomRegularIcon({}), 'TabDesktopMultipleBottomRegular');

const TabDesktopNewPageFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M3 5.5A2.5 2.5 0 015.5 3H8v2.5C8 6.33 8.67 7 9.5 7H17v7.5a2.5 2.5 0 01-2.5 2.5h-9A2.5 2.5 0 013 14.5v-9zM8 11a1 1 0 10-2 0 1 1 0 002 0zm2 1a1 1 0 100-2 1 1 0 000 2zm4-1a1 1 0 10-2 0 1 1 0 002 0zm3-5v-.5A2.5 2.5 0 0014.5 3H9v2.5c0 .28.22.5.5.5H17z",
    fill: primaryFill
  }));
};

export const TabDesktopNewPageFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/TabDesktopNewPageFilledIcon({}), 'TabDesktopNewPageFilled');

const TabDesktopNewPageRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M7 12a1 1 0 100-2 1 1 0 000 2zm4-1a1 1 0 11-2 0 1 1 0 012 0zm2 1a1 1 0 100-2 1 1 0 000 2zM3 5.5A2.5 2.5 0 015.5 3h9A2.5 2.5 0 0117 5.5v9a2.5 2.5 0 01-2.5 2.5h-9A2.5 2.5 0 013 14.5v-9zM5.5 4C4.67 4 4 4.67 4 5.5v9c0 .83.67 1.5 1.5 1.5h9c.83 0 1.5-.67 1.5-1.5V7H9.5A1.5 1.5 0 018 5.5V4H5.5zM16 5.5c0-.83-.67-1.5-1.5-1.5H9v1.5c0 .28.22.5.5.5H16v-.5z",
    fill: primaryFill
  }));
};

export const TabDesktopNewPageRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/TabDesktopNewPageRegularIcon({}), 'TabDesktopNewPageRegular');

const TabInPrivateFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M5.75 3A2.75 2.75 0 003 5.75v8.5A2.75 2.75 0 005.75 17h8.5A2.75 2.75 0 0017 14.25v-8.5A2.75 2.75 0 0014.25 3h-8.5zM4.5 5.75c0-.69.56-1.25 1.25-1.25h.31L4.5 6.36v-.61zm0 2.16L7.36 4.5h1.85L4.5 10.12v-2.2zm6.02-3.41h1.85L4.5 13.88v-2.2l6.02-7.18zm3.15 0h.58c.37 0 .7.16.93.41L6.29 15.5h-.54c-.38 0-.72-.17-.94-.43L13.67 4.5zm1.83 1.58v2.2L9.45 15.5H7.6l7.9-9.42zm0 3.76v2.2l-2.9 3.46h-1.85l4.75-5.66zm0 3.76v.65c0 .69-.56 1.25-1.25 1.25h-.34l1.59-1.9z",
    fill: primaryFill
  }));
};

export const TabInPrivateFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/TabInPrivateFilledIcon({}), 'TabInPrivateFilled');

const TabInPrivateRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M5.5 3A2.5 2.5 0 003 5.5v9A2.5 2.5 0 005.5 17h9a2.5 2.5 0 002.5-2.5v-9A2.5 2.5 0 0014.5 3h-9zM4 5.5C4 4.67 4.67 4 5.5 4h.34L4 6.19V5.5zm0 2.24L7.14 4h2.1L4 10.25v-2.5zM10.55 4h2.1L4 14.32V11.8L10.55 4zm3.41 0h.54c.45 0 .86.2 1.13.52L6 16h-.5a1.5 1.5 0 01-1.15-.54L13.96 4zM16 5.64v2.5L9.41 16h-2.1L16 5.64zm0 4.06v2.51L12.82 16h-2.1L16 9.7zm0 4.07v.73c0 .83-.67 1.5-1.5 1.5h-.37L16 13.77z",
    fill: primaryFill
  }));
};

export const TabInPrivateRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/TabInPrivateRegularIcon({}), 'TabInPrivateRegular');

const TabInprivateAccountFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M5.5 3A2.5 2.5 0 003 5.5v9A2.5 2.5 0 005.5 17h4.66c-.1-.33-.16-.69-.16-1.06v-.32c0-.68.29-1.3.69-1.76.4-.44 1.02-.84 1.81-.86h.05A3.49 3.49 0 0115 7c.74 0 1.43.23 2 .63V5.5A2.5 2.5 0 0014.5 3h-9zm7.05 11h4.9c.46 0 .86.24 1.12.53.12.14.22.3.3.47H15v1h4c0 .35-.1.68-.24 1H15v1h2.99c-.71.6-1.75 1-2.99 1-2.37 0-4-1.43-4-3.06v-.32c0-.4.17-.8.43-1.1.27-.28.66-.52 1.12-.52zm-.05-3.5A2.5 2.5 0 0017 12h-2v-1h2.45a2.51 2.51 0 000-1H15V9h2a2.5 2.5 0 00-4.5 1.5z",
    fill: primaryFill
  }));
};

export const TabInprivateAccountFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/TabInprivateAccountFilledIcon({}), 'TabInprivateAccountFilled');

const TabInprivateAccountRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M5.5 3A2.5 2.5 0 003 5.5v9A2.5 2.5 0 005.5 17h4.66c-.1-.32-.15-.65-.16-1H5.5A1.5 1.5 0 014 14.5v-9C4 4.67 4.67 4 5.5 4h9c.83 0 1.5.67 1.5 1.5v1.64c.36.11.7.28 1 .49V5.5A2.5 2.5 0 0014.5 3h-9zm8 7.5c0 .83.67 1.5 1.5 1.5h2a2.5 2.5 0 110-3h-2c-.83 0-1.5.67-1.5 1.5zm-1.32 4.7c.12-.14.26-.2.37-.2h6.32a1.78 1.78 0 00-.3-.47 1.5 1.5 0 00-1.12-.53h-4.9c-.46 0-.86.24-1.12.53-.26.29-.43.69-.43 1.09v.32c0 1.63 1.63 3.06 4 3.06 1.24 0 2.28-.4 2.99-1H15c-2.03 0-3-1.17-3-2.06v-.32c0-.13.06-.3.18-.43zm5.32-4.7c0 .17-.02.34-.05.5H15v-1h2.45c.03.16.05.33.05.5zm1.26 6.5H15v-1h4c0 .35-.1.68-.24 1z",
    fill: primaryFill
  }));
};

export const TabInprivateAccountRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/TabInprivateAccountRegularIcon({}), 'TabInprivateAccountRegular');

const TabProhibitedFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M3 5c0-1.1.9-2 2-2h10a2 2 0 012 2v4.6A5.5 5.5 0 009.6 17H5a2 2 0 01-2-2V5zm7 9.5a4.5 4.5 0 109 0 4.5 4.5 0 00-9 0zm1 0a3.5 3.5 0 015.6-2.8l-4.9 4.9a3.48 3.48 0 01-.7-2.1zm3.5 3.5c-.79 0-1.51-.26-2.1-.7l4.9-4.9a3.5 3.5 0 01-2.8 5.6z",
    fill: primaryFill
  }));
};

export const TabProhibitedFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/TabProhibitedFilledIcon({}), 'TabProhibitedFilled');

const TabProhibitedRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M3 5c0-1.1.9-2 2-2h10a2 2 0 012 2v4.6c-.32-.16-.65-.3-1-.4V5a1 1 0 00-1-1H5a1 1 0 00-1 1v10a1 1 0 001 1h4.2c.1.35.24.68.4 1H5a2 2 0 01-2-2V5zm7 9.5a4.5 4.5 0 109 0 4.5 4.5 0 00-9 0zm1 0a3.5 3.5 0 015.6-2.8l-4.9 4.9a3.48 3.48 0 01-.7-2.1zm3.5 3.5c-.79 0-1.51-.26-2.1-.7l4.9-4.9a3.5 3.5 0 01-2.8 5.6z",
    fill: primaryFill
  }));
};

export const TabProhibitedRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/TabProhibitedRegularIcon({}), 'TabProhibitedRegular');

const TabShieldDismissFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M3 5.75A2.75 2.75 0 015.75 3h8.5A2.75 2.75 0 0117 5.75v2.48c-.34-.2-.67-.46-1-.8a1.4 1.4 0 00-.5-.34V5.75c0-.69-.56-1.25-1.25-1.25h-8.5c-.69 0-1.25.56-1.25 1.25v8.5c0 .69.56 1.25 1.25 1.25h4.82a5.8 5.8 0 00.96 1.5H5.75A2.75 2.75 0 013 14.25v-8.5zm15.6 3.92c-1.22 0-2.32-.51-3.32-1.55a.39.39 0 00-.56 0 4.5 4.5 0 01-3.32 1.55.4.4 0 00-.4.41v2.75c.08 2.55 1.4 4.29 3.87 5.15.09.03.17.03.26 0 2.56-.89 3.87-2.71 3.87-5.4v-2.57a.4.4 0 00-.4-.34zm-4.96 1.44L15 12.47l1.35-1.36a.38.38 0 01.54.54L15.53 13l1.36 1.35a.38.38 0 01-.54.54L15 13.53l-1.35 1.36a.38.38 0 01-.54-.54L14.47 13l-1.36-1.36a.38.38 0 01.53-.53z",
    fill: primaryFill
  }));
};

export const TabShieldDismissFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/TabShieldDismissFilledIcon({}), 'TabShieldDismissFilled');

const TabShieldDismissRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M3 5.5A2.5 2.5 0 015.5 3h9A2.5 2.5 0 0117 5.5v2.73c-.34-.2-.67-.46-1-.8V5.5c0-.83-.67-1.5-1.5-1.5h-9C4.67 4 4 4.67 4 5.5v9c0 .83.67 1.5 1.5 1.5h5.32a5.75 5.75 0 00.71 1H5.5A2.5 2.5 0 013 14.5v-9zm15.6 4.17c-1.22 0-2.32-.51-3.32-1.55a.39.39 0 00-.56 0 4.5 4.5 0 01-3.32 1.55.4.4 0 00-.4.41v2.75c.08 2.55 1.4 4.29 3.87 5.15.09.03.17.03.26 0 2.56-.89 3.87-2.71 3.87-5.4v-2.57a.4.4 0 00-.4-.34zm-4.96 1.44L15 12.47l1.35-1.36a.38.38 0 01.54.54L15.53 13l1.36 1.35a.38.38 0 01-.54.54L15 13.53l-1.35 1.36a.38.38 0 01-.54-.54L14.47 13l-1.36-1.36a.38.38 0 01.53-.53z",
    fill: primaryFill
  }));
};

export const TabShieldDismissRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/TabShieldDismissRegularIcon({}), 'TabShieldDismissRegular');

const TableFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M13 17h1.5a2.5 2.5 0 002.5-2.5V13h-4v4zm0-5V8h4v4h-4zm-1 0H8V8h4v4zm-4 1h4v4H8v-4zm-1-1V8H3v4h4zm-4 1h4v4H5.5A2.5 2.5 0 013 14.5V13zm10-6h4V5.5A2.5 2.5 0 0014.5 3H13v4zm-1-4v4H8V3h4zM7 3v4H3V5.5A2.5 2.5 0 015.5 3H7z",
    fill: primaryFill
  }));
};

export const TableFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/TableFilledIcon({}), 'TableFilled');

const TableRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M17 5.5A2.5 2.5 0 0014.5 3h-9A2.5 2.5 0 003 5.5v9A2.5 2.5 0 005.5 17h9a2.5 2.5 0 002.5-2.5v-9zm-13 9V13h3v3H5.36A1.5 1.5 0 014 14.5zm8-1.5v3H8v-3h4zm2.5 3H13v-3h3V14.64A1.5 1.5 0 0114.5 16zM12 8v4H8V8h4zm1 0h3v4h-3V8zm-1-4v3H8V4h4zm1 0H14.64A1.5 1.5 0 0116 5.5V7h-3V4zM7 4v3H4V5.36A1.5 1.5 0 015.5 4H7zm0 4v4H4V8h3z",
    fill: primaryFill
  }));
};

export const TableRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/TableRegularIcon({}), 'TableRegular');

const TableAddFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M13 7h4V5.5A2.5 2.5 0 0014.5 3H13v4zm-6 5V8H3v4h4zm2.6 0A5.52 5.52 0 0112 9.6V8H8v4h1.6zm4.9-3c.9 0 1.75.22 2.5.6V8h-4v1.2c.48-.13.98-.2 1.5-.2zM9 14.5c0-.52.07-1.02.2-1.5H8v4h1.6c-.38-.75-.6-1.6-.6-2.5zM7 13H3v1.5A2.5 2.5 0 005.5 17H7v-4zm5-6V3H8v4h4zM7 3v4H3V5.5A2.5 2.5 0 015.5 3H7zm12 11.5a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0zm-4-2a.5.5 0 00-1 0V14h-1.5a.5.5 0 000 1H14v1.5a.5.5 0 001 0V15h1.5a.5.5 0 000-1H15v-1.5z",
    fill: primaryFill
  }));
};

export const TableAddFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/TableAddFilledIcon({}), 'TableAddFilled');

const TableAddRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M17 5.5A2.5 2.5 0 0014.5 3h-9A2.5 2.5 0 003 5.5v9A2.5 2.5 0 005.5 17h4.1c-.16-.32-.3-.65-.4-1H8v-3h1.2c.1-.35.24-.68.4-1H8V8h4v1.6c.32-.16.65-.3 1-.4V8h3v1.2c.35.1.68.24 1 .4V5.5zm-13 9V13h3v3H5.36A1.5 1.5 0 014 14.5zM12 4v3H8V4h4zm1 0H14.64A1.5 1.5 0 0116 5.5V7h-3V4zM7 4v3H4V5.36A1.5 1.5 0 015.5 4H7zm0 4v4H4V8h3zm12 6.5a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0zm-4-2a.5.5 0 00-1 0V14h-1.5a.5.5 0 000 1H14v1.5a.5.5 0 001 0V15h1.5a.5.5 0 000-1H15v-1.5z",
    fill: primaryFill
  }));
};

export const TableAddRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/TableAddRegularIcon({}), 'TableAddRegular');

const TableBottomRowFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M14.5 3A2.5 2.5 0 0117 5.5V12h-1V5.5c0-.78-.6-1.42-1.36-1.5H5.5c-.78 0-1.42.6-1.5 1.36V12H3V5.5A2.5 2.5 0 015.5 3h9zM17 14.5a2.5 2.5 0 01-2.5 2.5H13v-4h4v1.5zm-13 2c.42.31.94.5 1.5.5H7v-4H3v1.5c0 .82.4 1.54 1 2zM8 13h4v4H8v-4z",
    fill: primaryFill
  }));
};

export const TableBottomRowFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/TableBottomRowFilledIcon({}), 'TableBottomRowFilled');

const TableBottomRowRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M14.5 3A2.5 2.5 0 0117 5.5v9a2.5 2.5 0 01-2.5 2.5h-9A2.5 2.5 0 013 14.5v-9A2.5 2.5 0 015.5 3h9zM4 13v1.5c0 .78.6 1.42 1.36 1.5H7v-3H4zm4 3h4v-3H8v3zm5 0h1.5c.78 0 1.42-.6 1.5-1.36V13h-3v3zm3-4V5.5c0-.78-.6-1.42-1.36-1.5H5.5c-.78 0-1.42.6-1.5 1.36V12h12z",
    fill: primaryFill
  }));
};

export const TableBottomRowRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/TableBottomRowRegularIcon({}), 'TableBottomRowRegular');

const TableCellEditFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M8 13h1.98c.1-.12.19-.23.3-.33L12 10.94V7H8v6zm7.1-5.16c.26-.26.55-.45.86-.6A2 2 0 0015 7h-2v2.94l2.1-2.1zM5 13a2 2 0 01-2-2V9c0-1.1.9-2 2-2h2v6H5zm10.8-4.45l-4.82 4.83a2.2 2.2 0 00-.58 1.02l-.37 1.5a.89.89 0 001.08 1.07l1.5-.37c.38-.1.73-.3 1.01-.58l4.83-4.83a1.87 1.87 0 00-2.64-2.64z",
    fill: primaryFill
  }));
};

export const TableCellEditFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/TableCellEditFilledIcon({}), 'TableCellEditFilled');

const TableCellEditRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M9.98 13c.1-.12.19-.23.3-.33l.66-.67H8V8h4v2.94l1-1V8h1.94l.16-.16c.26-.26.55-.45.86-.6A2 2 0 0015 7H5a2 2 0 00-2 2v2c0 1.1.9 2 2 2h4.98zM7 8v4H5a1 1 0 01-1-1V9a1 1 0 011-1h2zm8.8.55l-4.82 4.83a2.2 2.2 0 00-.58 1.02l-.37 1.5a.89.89 0 001.08 1.07l1.5-.37c.38-.1.73-.3 1.01-.58l4.83-4.83a1.87 1.87 0 00-2.64-2.64z",
    fill: primaryFill
  }));
};

export const TableCellEditRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/TableCellEditRegularIcon({}), 'TableCellEditRegular');

const TableCellsMergeFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M3 6a3 3 0 013-3h8a3 3 0 013 3H3zm0 1v6h14V7H3zm4.35 1.85l-.64.65h6.58l-.64-.65a.5.5 0 01.7-.7l1.5 1.5c.2.2.2.5 0 .7l-1.5 1.5a.5.5 0 01-.7-.7l.64-.65H6.71l.64.65a.5.5 0 01-.7.7l-1.5-1.5a.5.5 0 010-.7l1.5-1.5a.5.5 0 11.7.7zM3 14h14a3 3 0 01-3 3H6a3 3 0 01-3-3z",
    fill: primaryFill
  }));
};

export const TableCellsMergeFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/TableCellsMergeFilledIcon({}), 'TableCellsMergeFilled');

const TableCellsMergeRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M7.35 8.85a.5.5 0 10-.7-.7l-1.5 1.5a.5.5 0 000 .7l1.5 1.5a.5.5 0 00.7-.7l-.64-.65h6.58l-.64.65a.5.5 0 00.7.7l1.5-1.5a.5.5 0 000-.7l-1.5-1.5a.5.5 0 00-.7.7l.64.65H6.71l.64-.65zM6 3a3 3 0 00-3 3v8a3 3 0 003 3h8a3 3 0 003-3V6a3 3 0 00-3-3H6zM4 7h12v6H4V7zm10 9H6a2 2 0 01-2-2h12a2 2 0 01-2 2zm2-10H4c0-1.1.9-2 2-2h8a2 2 0 012 2z",
    fill: primaryFill
  }));
};

export const TableCellsMergeRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/TableCellsMergeRegularIcon({}), 'TableCellsMergeRegular');

const TableCellsSplitFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M10 6h7v-.5A2.5 2.5 0 0014.5 3H10v3zm7 7V7H3v6h14zm-7-5v4H9V8h1zm0 9h4.5a2.5 2.5 0 002.5-2.5V14h-7v3zm-1-3H3v.5A2.5 2.5 0 005.5 17H9v-3zm0-8V3H5.5A2.5 2.5 0 003 5.5V6h6z",
    fill: primaryFill
  }));
};

export const TableCellsSplitFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/TableCellsSplitFilledIcon({}), 'TableCellsSplitFilled');

const TableCellsSplitRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M10 8v4H9V8h1zm7-2.5A2.5 2.5 0 0014.5 3h-9A2.5 2.5 0 003 5.5v9A2.5 2.5 0 005.5 17h9a2.5 2.5 0 002.5-2.5v-9zm-13 9V14h5v2H5.36A1.5 1.5 0 014 14.5zM9 4v2H4v-.64A1.5 1.5 0 015.5 4H9zm1 2V4h4.64A1.5 1.5 0 0116 5.5V6h-6zm6 7H4V7h12v6zm0 1.5v.14A1.5 1.5 0 0114.5 16H10v-2h6v.5z",
    fill: primaryFill
  }));
};

export const TableCellsSplitRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/TableCellsSplitRegularIcon({}), 'TableCellsSplitRegular');

const TableCheckerFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M7 3v4H3V5.5A2.5 2.5 0 015.5 3H7zm5 5H8v4h4V8zm1 5h4v1.5a2.5 2.5 0 01-2.5 2.5H13v-4zM8 4h6.5c.83 0 1.5.67 1.5 1.5V12h1V5.5A2.5 2.5 0 0014.5 3H8v1zM5.5 16H12v1H5.5A2.5 2.5 0 013 14.5V8h1v6.5c0 .83.67 1.5 1.5 1.5z",
    fill: primaryFill
  }));
};

export const TableCheckerFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/TableCheckerFilledIcon({}), 'TableCheckerFilled');

const TableCheckerRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M16 5.5V11h1V5.5A2.5 2.5 0 0014.5 3H9v1h5.5c.83 0 1.5.67 1.5 1.5zM3 9v5.5A2.5 2.5 0 005.5 17H11v-1H5.5A1.5 1.5 0 014 14.5V9H3zm2.5-6H8v4h5v5h4v2.5a2.5 2.5 0 01-2.5 2.5H12v-4H7V8H3V5.5A2.5 2.5 0 015.5 3zm9 13c.78 0 1.42-.6 1.5-1.36V13h-3v3h1.5zM12 8H8v4h4V8zM4 7h3V4H5.5c-.78 0-1.42.6-1.5 1.36V7z",
    fill: primaryFill
  }));
};

export const TableCheckerRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/TableCheckerRegularIcon({}), 'TableCheckerRegular');

const TableCopyFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M3 13.5A3.5 3.5 0 006.5 17h7.83c-.77.63-1.76 1-2.83 1h-5A4.5 4.5 0 012 13.5v-5c0-1.07.37-2.06 1-2.83v7.83zM15.5 16H14v-4h4v1.5a2.5 2.5 0 01-2.5 2.5zM14 7v4h4V7h-4zm-5 4h4V7H9v4zm4 1H9v4h4v-4zM8 7v4H4V7h4zm0 5H4v1.5A2.5 2.5 0 006.5 16H8v-4zm10-6h-4V2h1.5A2.5 2.5 0 0118 4.5V6zm-5 0V2H9v4h4zM8 6V2H6.5A2.5 2.5 0 004 4.5V6h4z",
    fill: primaryFill
  }));
};

export const TableCopyFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/TableCopyFilledIcon({}), 'TableCopyFilled');

const TableCopyRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M3 13.5A3.5 3.5 0 006.5 17h7.83c-.77.63-1.76 1-2.83 1h-5A4.5 4.5 0 012 13.5v-5c0-1.07.37-2.06 1-2.83v7.83zm1.73 1.77A2.5 2.5 0 014 13.5v-9A2.5 2.5 0 016.5 2h9A2.5 2.5 0 0118 4.5v9a2.5 2.5 0 01-2.5 2.5h-9a2.5 2.5 0 01-1.77-.73zM17 6V4.5A1.5 1.5 0 0015.64 3H14v3h3zm-4-3H9v3h4V3zM8 3H6.5A1.5 1.5 0 005 4.36V6h3V3zm1 4v4h4V7H9zm-4 4h3V7H5v4zm4 1v3h4v-3H9zm-2.5 3H8v-3H5v1.5A1.5 1.5 0 006.36 15h.14zm7.5-3v3h1.5a1.5 1.5 0 001.5-1.36V12h-3zm0-5v4h3V7h-3z",
    fill: primaryFill
  }));
};

export const TableCopyRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/TableCopyRegularIcon({}), 'TableCopyRegular');

const TableDeleteColumnFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M10.5 2.5a.5.5 0 00-1 0v4.88c.13.1.24.22.36.34l.14.15.14-.15c.12-.12.23-.24.36-.34V2.5zm-1 15v-4.89c.13-.1.24-.23.36-.35l.14-.14.14.14c.12.12.23.24.36.35v4.89a.5.5 0 01-1 0zM2 3.5c0-.28.22-.5.5-.5H4a2 2 0 012 2v2H2V3.5zm0 13V13h4v2a2 2 0 01-2 2H2.5a.5.5 0 01-.5-.5zM6 8v4H2V8h4zm12-4.5a.5.5 0 00-.5-.5H16a2 2 0 00-2 2v2h4V3.5zM14 13v2c0 1.1.9 2 2 2h1.5a.5.5 0 00.5-.5V13h-4zm-2.15-4.85a.5.5 0 00-.7 0L10 9.29 8.85 8.15a.5.5 0 10-.7.7L9.29 10l-1.14 1.15a.5.5 0 00.7.7L10 10.71l1.15 1.14a.5.5 0 00.7-.7L10.71 10l1.14-1.15a.5.5 0 000-.7zM18 12V8h-4v4h4z",
    fill: primaryFill
  }));
};

export const TableDeleteColumnFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/TableDeleteColumnFilledIcon({}), 'TableDeleteColumnFilled');

const TableDeleteColumnRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M10.5 2.5a.5.5 0 00-1 0v4.88c.13.1.24.22.36.34l.14.15.14-.15c.12-.12.23-.24.36-.34V2.5zm-1 15v-4.89c.13-.1.24-.23.36-.35l.14-.14.14.14c.12.12.23.24.36.35v4.89a.5.5 0 01-1 0zM2 3.5c0-.28.22-.5.5-.5H4a2 2 0 012 2v10a2 2 0 01-2 2H2.5a.5.5 0 010-1H4a1 1 0 001-1v-2H2.5a.5.5 0 010-1H5V8H2.5a.5.5 0 010-1H5V5a1 1 0 00-1-1H2.5a.5.5 0 01-.5-.5zm16 0a.5.5 0 00-.5-.5H16a2 2 0 00-2 2v10c0 1.1.9 2 2 2h1.5a.5.5 0 000-1H16a1 1 0 01-1-1v-2h2.5a.5.5 0 000-1H15V8h2.5a.5.5 0 000-1H15V5a1 1 0 011-1h1.5a.5.5 0 00.5-.5zm-6.15 4.65a.5.5 0 00-.7 0L10 9.29 8.85 8.15a.5.5 0 10-.7.7L9.29 10l-1.14 1.15a.5.5 0 00.7.7L10 10.71l1.15 1.14a.5.5 0 00.7-.7L10.71 10l1.14-1.15a.5.5 0 000-.7z",
    fill: primaryFill
  }));
};

export const TableDeleteColumnRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/TableDeleteColumnRegularIcon({}), 'TableDeleteColumnRegular');

const TableDeleteRowFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M12 6H8V2h4v4zM3.5 2H7v4H5a2 2 0 01-2-2V2.5c0-.28.22-.5.5-.5zM15 6h-2V2h3.5c.28 0 .5.22.5.5V4a2 2 0 01-2 2zm1.5 12a.5.5 0 00.5-.5V16a2 2 0 00-2-2h-2v4h3.5zM12 18v-4H8v4h4zm-5 0H3.5a.5.5 0 01-.5-.5V16c0-1.1.9-2 2-2h2v4zm10.5-7.5a.5.5 0 000-1h-4.89a5 5 0 01-.48.5l.14.13c.12.12.25.24.35.37h4.88zm-15-1h4.89a5 5 0 00.34.35l.14.14-.14.14c-.12.12-.25.24-.35.37H2.5a.5.5 0 010-1zm9.35 2.35a.5.5 0 000-.7L10.71 10l1.14-1.15a.5.5 0 00-.7-.7L10 9.29 8.85 8.15a.5.5 0 10-.7.7L9.29 10l-1.14 1.15a.5.5 0 00.7.7L10 10.71l1.15 1.14c.2.2.5.2.7 0z",
    fill: primaryFill
  }));
};

export const TableDeleteRowFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/TableDeleteRowFilledIcon({}), 'TableDeleteRowFilled');

const TableDeleteRowRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M16.5 2c.28 0 .5.22.5.5V4a2 2 0 01-2 2H5a2 2 0 01-2-2V2.5a.5.5 0 011 0V4a1 1 0 001 1h2V2.5a.5.5 0 011 0V5h4V2.5a.5.5 0 011 0V5h2a1 1 0 001-1V2.5c0-.28.22-.5.5-.5zm0 16a.5.5 0 00.5-.5V16a2 2 0 00-2-2H5a2 2 0 00-2 2v1.5a.5.5 0 001 0V16a1 1 0 011-1h2v2.5a.5.5 0 001 0V15h4v2.5a.5.5 0 001 0V15h2a1 1 0 011 1v1.5c0 .28.22.5.5.5zm1-7.5a.5.5 0 000-1h-4.89a5 5 0 01-.48.5l.14.13c.12.12.25.24.35.37h4.88zm-15-1h4.89a5 5 0 00.34.35l.14.14-.14.14c-.12.12-.25.24-.35.37H2.5a.5.5 0 010-1zm9.35 2.35a.5.5 0 000-.7L10.71 10l1.14-1.15a.5.5 0 00-.7-.7L10 9.29 8.85 8.15a.5.5 0 10-.7.7L9.29 10l-1.14 1.15a.5.5 0 00.7.7L10 10.71l1.15 1.14c.2.2.5.2.7 0z",
    fill: primaryFill
  }));
};

export const TableDeleteRowRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/TableDeleteRowRegularIcon({}), 'TableDeleteRowRegular');

const TableDismissFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M13 7h4V5.5A2.5 2.5 0 0014.5 3H13v4zm-6 5V8H3v4h4zm2.6 0A5.52 5.52 0 0112 9.6V8H8v4h1.6zm4.9-3c.9 0 1.75.22 2.5.6V8h-4v1.2c.48-.13.98-.2 1.5-.2zM9 14.5c0-.52.07-1.02.2-1.5H8v4h1.6c-.38-.75-.6-1.6-.6-2.5zM7 13H3v1.5A2.5 2.5 0 005.5 17H7v-4zm5-6V3H8v4h4zM7 3v4H3V5.5A2.5 2.5 0 015.5 3H7zm12 11.5a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0zm-3.8 0l1.15-1.15a.5.5 0 00-.7-.7l-1.15 1.14-1.15-1.14a.5.5 0 00-.7.7l1.14 1.15-1.14 1.15a.5.5 0 00.7.7l1.15-1.14 1.15 1.14a.5.5 0 00.7-.7l-1.14-1.15z",
    fill: primaryFill
  }));
};

export const TableDismissFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/TableDismissFilledIcon({}), 'TableDismissFilled');

const TableDismissRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M17 5.5A2.5 2.5 0 0014.5 3h-9A2.5 2.5 0 003 5.5v9A2.5 2.5 0 005.5 17h4.1c-.16-.32-.3-.65-.4-1H8v-3h1.2c.1-.35.24-.68.4-1H8V8h4v1.6c.32-.16.65-.3 1-.4V8h3v1.2c.35.1.68.24 1 .4V5.5zm-13 9V13h3v3H5.36A1.5 1.5 0 014 14.5zM12 4v3H8V4h4zm1 0H14.64A1.5 1.5 0 0116 5.5V7h-3V4zM7 4v3H4V5.36A1.5 1.5 0 015.5 4H7zm0 4v4H4V8h3zm12 6.5a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0zm-3.8 0l1.15-1.15a.5.5 0 00-.7-.7l-1.15 1.14-1.15-1.14a.5.5 0 00-.7.7l1.14 1.15-1.14 1.15a.5.5 0 00.7.7l1.15-1.14 1.15 1.14a.5.5 0 00.7-.7l-1.14-1.15z",
    fill: primaryFill
  }));
};

export const TableDismissRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/TableDismissRegularIcon({}), 'TableDismissRegular');

const TableEditFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M18.45 13.2a1.87 1.87 0 00-2.64-2.65l-4.83 4.83a2.2 2.2 0 00-.58 1.02l-.37 1.5a.89.89 0 001.08 1.07l1.5-.37c.38-.1.73-.3 1.01-.58l4.83-4.83zM15.1 9.83c.53-.53 1.21-.8 1.9-.84V8h-4v3.94l2.1-2.1zm-4.83 4.83L11.94 13H8v4h1.22l.21-.85a3.2 3.2 0 01.84-1.48zM12 12H8V8h4v4zm-5 0V8H3v4h4zm-4 1h4v4H5.5A2.5 2.5 0 013 14.5V13zm10-6h4V5.5A2.5 2.5 0 0014.5 3H13v4zm-1-4v4H8V3h4zM7 3v4H3V5.5A2.5 2.5 0 015.5 3H7z",
    fill: primaryFill
  }));
};

export const TableEditFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/TableEditFilledIcon({}), 'TableEditFilled');

const TableEditRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M17 5.5A2.5 2.5 0 0014.5 3h-9A2.5 2.5 0 003 5.5v9A2.5 2.5 0 005.5 17h3.72l.21-.85.05-.15H8v-3h3.94L13 11.94V8h3v1.23c.32-.14.66-.21 1-.23V5.5zm-13 9V13h3v3H5.36A1.5 1.5 0 014 14.5zM12 8v4H8V8h4zm0-1H8V4h4v3zm1-3H14.64A1.5 1.5 0 0116 5.5V7h-3V4zM4 7V5.36A1.5 1.5 0 015.5 4H7v3H4zm3 1v4H4V8h3zm8.8 2.55l-4.82 4.83a2.2 2.2 0 00-.58 1.02l-.37 1.5a.89.89 0 001.08 1.07l1.5-.37c.38-.1.73-.3 1.01-.58l4.83-4.83a1.87 1.87 0 00-2.64-2.64zM14.66 17L17 14.65z",
    fill: primaryFill
  }));
};

export const TableEditRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/TableEditRegularIcon({}), 'TableEditRegular');

const TableFreezeColumnFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M4 5.5C4 4.67 4.67 4 5.5 4H8v3h4V3H5.5A2.5 2.5 0 003 5.5v9A2.5 2.5 0 005.5 17H12v-4H8v3H5.5A1.5 1.5 0 014 14.5v-9zM14.5 17H13v-4h4v1.5a2.5 2.5 0 01-2.5 2.5zM13 8v4h4V8h-4zm-5 4h4V8H8v4zm9-5h-4V3h1.5A2.5 2.5 0 0117 5.5V7z",
    fill: primaryFill
  }));
};

export const TableFreezeColumnFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/TableFreezeColumnFilledIcon({}), 'TableFreezeColumnFilled');

const TableFreezeColumnRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M14.5 3A2.5 2.5 0 0117 5.5v9a2.5 2.5 0 01-2.5 2.5h-9A2.5 2.5 0 013 14.5v-9A2.5 2.5 0 015.5 3h9zM8 16h4v-3H8v3zm5 0h1.5c.78 0 1.42-.6 1.5-1.36V13h-3v3zm-1-4V8H8v4h4zm4-4h-3v4h3V8zm-4-1V4H8v3h4zm2.5-3H13v3h3V5.5c0-.78-.6-1.42-1.36-1.5h-.14zm-9 12H7V4H5.5c-.78 0-1.42.6-1.5 1.36v9.14c0 .78.6 1.42 1.36 1.5h.14z",
    fill: primaryFill
  }));
};

export const TableFreezeColumnRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/TableFreezeColumnRegularIcon({}), 'TableFreezeColumnRegular');

const TableFreezeColumnAndRowFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M5.5 3A2.5 2.5 0 003 5.5v9A2.5 2.5 0 005.5 17H12v-4H8v3H5.5A1.5 1.5 0 014 14.5v-9C4 4.67 4.67 4 5.5 4h9c.83 0 1.5.67 1.5 1.5V8h-3v4h4V5.5A2.5 2.5 0 0014.5 3h-9zm9 14H13v-4h4v1.5a2.5 2.5 0 01-2.5 2.5zM8 12h4V8H8v4z",
    fill: primaryFill
  }));
};

export const TableFreezeColumnAndRowFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/TableFreezeColumnAndRowFilledIcon({}), 'TableFreezeColumnAndRowFilled');

const TableFreezeColumnAndRowRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M14.5 3A2.5 2.5 0 0117 5.5v9a2.5 2.5 0 01-2.5 2.5h-9A2.5 2.5 0 013 14.5v-9A2.5 2.5 0 015.5 3h9zM8 16h4v-3H8v3zm5 0h1.5c.78 0 1.42-.6 1.5-1.36V13h-3v3zm-1-4V8H8v4h4zm4-4h-3v4h3V8zM5.5 16H7V7h9V5.5c0-.78-.6-1.42-1.36-1.5H5.5c-.78 0-1.42.6-1.5 1.36v9.14c0 .78.6 1.42 1.36 1.5h.14z",
    fill: primaryFill
  }));
};

export const TableFreezeColumnAndRowRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/TableFreezeColumnAndRowRegularIcon({}), 'TableFreezeColumnAndRowRegular');

const TableFreezeRowFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M14.5 4c.83 0 1.5.67 1.5 1.5V8h-3v4h4V5.5A2.5 2.5 0 0014.5 3h-9A2.5 2.5 0 003 5.5V12h4V8H4V5.5C4 4.67 4.67 4 5.5 4h9zM3 14.5V13h4v4H5.5A2.5 2.5 0 013 14.5zm9-1.5H8v4h4v-4zM8 8v4h4V8H8zm5 9v-4h4v1.5a2.5 2.5 0 01-2.5 2.5H13z",
    fill: primaryFill
  }));
};

export const TableFreezeRowFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/TableFreezeRowFilledIcon({}), 'TableFreezeRowFilled');

const TableFreezeRowRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M14.5 17a2.5 2.5 0 002.5-2.5v-9A2.5 2.5 0 0014.5 3h-9A2.5 2.5 0 003 5.5v9A2.5 2.5 0 005.5 17h9zM4 12V8h3v4H4zm12-5H4V5.36A1.5 1.5 0 015.5 4h9.14A1.5 1.5 0 0116 5.5V7zM8 8h4v4H8V8zm-4 6.5V13h3v3H5.36A1.5 1.5 0 014 14.5zm8-1.5v3H8v-3h4zm4-5v4h-3V8h3zm0 5V14.64A1.5 1.5 0 0114.5 16H13v-3h3z",
    fill: primaryFill
  }));
};

export const TableFreezeRowRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/TableFreezeRowRegularIcon({}), 'TableFreezeRowRegular');

const TableImageFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M16.5 9c.17 0 .34.01.5.04V8h-4v1h3.5zM9 16.5V13H8v4h1.04a3.53 3.53 0 01-.04-.5zm.04-4.5A3.5 3.5 0 0112 9.04V8H8v4h1.04zM7 12V8H3v4h4zm-4 1h4v4H5.5A2.5 2.5 0 013 14.5V13zm10-6h4V5.5A2.5 2.5 0 0014.5 3H13v4zm-1-4v4H8V3h4zM7 3v4H3V5.5A2.5 2.5 0 015.5 3H7zm3 9.5a2.5 2.5 0 012.5-2.5h4a2.5 2.5 0 012.5 2.5v4c0 .5-.15.98-.41 1.38l-3.03-3.03a1.5 1.5 0 00-2.12 0l-3.03 3.03c-.26-.4-.41-.87-.41-1.38v-4zm7 .25a.75.75 0 10-1.5 0 .75.75 0 001.5 0zm-5.88 5.84c.4.26.87.41 1.38.41h4c.5 0 .98-.15 1.38-.41l-3.03-3.03a.5.5 0 00-.7 0l-3.03 3.03z",
    fill: primaryFill
  }));
};

export const TableImageFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/TableImageFilledIcon({}), 'TableImageFilled');

const TableImageRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M17 5.5A2.5 2.5 0 0014.5 3h-9A2.5 2.5 0 003 5.5v9A2.5 2.5 0 005.5 17h3.54a3.53 3.53 0 01-.04-.5V16H8v-3h1v-.5c0-.17.01-.34.04-.5H8V8h4v1.04c.16-.03.33-.04.5-.04h.5V8h3v1h.5c.17 0 .34.01.5.04V5.5zm-13 9V13h3v3H5.36A1.5 1.5 0 014 14.5zM12 7H8V4h4v3zm1-3H14.64A1.5 1.5 0 0116 5.5V7h-3V4zM4 7V5.36A1.5 1.5 0 015.5 4H7v3H4zm3 1v4H4V8h3zm3 4.5a2.5 2.5 0 012.5-2.5h4a2.5 2.5 0 012.5 2.5v4c0 .5-.15.98-.41 1.38l-3.03-3.03a1.5 1.5 0 00-2.12 0l-3.03 3.03c-.26-.4-.41-.87-.41-1.38v-4zm7 .25a.75.75 0 10-1.5 0 .75.75 0 001.5 0zm-5.88 5.84c.4.26.87.41 1.38.41h4c.5 0 .98-.15 1.38-.41l-3.03-3.03a.5.5 0 00-.7 0l-3.03 3.03z",
    fill: primaryFill
  }));
};

export const TableImageRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/TableImageRegularIcon({}), 'TableImageRegular');

const TableInsertColumnFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M4 3.5a.5.5 0 00-1 0v13a.5.5 0 001 0v-13zm13 0a.5.5 0 00-1 0v13a.5.5 0 001 0v-13zM9 3a2 2 0 00-2 2v2h6V5a2 2 0 00-2-2H9zm-2 9V8h6v4H7zm0 1h6v2a2 2 0 01-2 2H9a2 2 0 01-2-2v-2z",
    fill: primaryFill
  }));
};

export const TableInsertColumnFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/TableInsertColumnFilledIcon({}), 'TableInsertColumnFilled');

const TableInsertColumnRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M4 3.5a.5.5 0 00-1 0v13a.5.5 0 001 0v-13zm13 0a.5.5 0 00-1 0v13a.5.5 0 001 0v-13zM9 3a2 2 0 00-2 2v10c0 1.1.9 2 2 2h2a2 2 0 002-2V5a2 2 0 00-2-2H9zm-1 9V8h4v4H8zm4-7v2H8V5a1 1 0 011-1h2a1 1 0 011 1zm-4 8h4v2a1 1 0 01-1 1H9a1 1 0 01-1-1v-2z",
    fill: primaryFill
  }));
};

export const TableInsertColumnRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/TableInsertColumnRegularIcon({}), 'TableInsertColumnRegular');

const TableInsertRowFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M3.5 16a.5.5 0 000 1h13a.5.5 0 000-1h-13zm0-13a.5.5 0 000 1h13a.5.5 0 000-1h-13zM3 11c0 1.1.9 2 2 2h2V7H5a2 2 0 00-2 2v2zm9 2H8V7h4v6zm1 0V7h2a2 2 0 012 2v2a2 2 0 01-2 2h-2z",
    fill: primaryFill
  }));
};

export const TableInsertRowFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/TableInsertRowFilledIcon({}), 'TableInsertRowFilled');

const TableInsertRowRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M3.5 16a.5.5 0 000 1h13a.5.5 0 000-1h-13zm0-13a.5.5 0 000 1h13a.5.5 0 000-1h-13zM3 11c0 1.1.9 2 2 2h10a2 2 0 002-2V9a2 2 0 00-2-2H5a2 2 0 00-2 2v2zm9 1H8V8h4v4zM5 8h2v4H5a1 1 0 01-1-1V9a1 1 0 011-1zm8 4V8h2a1 1 0 011 1v2a1 1 0 01-1 1h-2z",
    fill: primaryFill
  }));
};

export const TableInsertRowRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/TableInsertRowRegularIcon({}), 'TableInsertRowRegular');

const TableLightningFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M14.5 9c.9 0 1.75.22 2.5.6V8h-4v1.2c.48-.13.98-.2 1.5-.2zM9 14.5c0-.52.07-1.02.2-1.5H8v4h1.6c-.38-.75-.6-1.6-.6-2.5zm.6-2.5A5.52 5.52 0 0112 9.6V8H8v4h1.6zM7 12V8H3v4h4zm-4 1h4v4H5.5A2.5 2.5 0 013 14.5V13zm10-6h4V5.5A2.5 2.5 0 0014.5 3H13v4zm-1-4v4H8V3h4zM7 3v4H3V5.5A2.5 2.5 0 015.5 3H7zm12 11.5a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0zm-5.12-3a.5.5 0 00-.47.33l-.88 2.5A.5.5 0 0013 15h.78l-.51 1.87a.5.5 0 00.9.4l2.25-3.5A.5.5 0 0016 13h-.75l.28-.84a.5.5 0 00-.47-.66h-1.18z",
    fill: primaryFill
  }));
};

export const TableLightningFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/TableLightningFilledIcon({}), 'TableLightningFilled');

const TableLightningRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M17 5.5A2.5 2.5 0 0014.5 3h-9A2.5 2.5 0 003 5.5v9A2.5 2.5 0 005.5 17h4.1c-.16-.32-.3-.65-.4-1H8v-3h1.2c.1-.35.24-.68.4-1H8V8h4v1.6c.32-.16.65-.3 1-.4V8h3v1.2c.35.1.68.24 1 .4V5.5zm-13 9V13h3v3H5.36A1.5 1.5 0 014 14.5zM12 7H8V4h4v3zm1-3H14.64A1.5 1.5 0 0116 5.5V7h-3V4zM4 7V5.36A1.5 1.5 0 015.5 4H7v3H4zm3 1v4H4V8h3zm12 6.5a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0zm-5.12-3a.5.5 0 00-.47.33l-.88 2.5A.5.5 0 0013 15h.78l-.51 1.87a.5.5 0 00.9.4l2.25-3.5A.5.5 0 0016 13h-.75l.28-.84a.5.5 0 00-.47-.66h-1.18z",
    fill: primaryFill
  }));
};

export const TableLightningRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/TableLightningRegularIcon({}), 'TableLightningRegular');

const TableLinkFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M9 15.5c0 .54.12 1.05.34 1.5H8v-4h2.05A3.49 3.49 0 009 15.5zM13 8v4h3.5c.17 0 .34.01.5.04V8h-4zm-1 4V8H8v4h4zm-5 0V8H3v4h4zm-4 1h4v4H5.5A2.5 2.5 0 013 14.5V13zm10-6h4V5.5A2.5 2.5 0 0014.5 3H13v4zm-1-4v4H8V3h4zM7 3v4H3V5.5A2.5 2.5 0 015.5 3H7zm3 12.5a2.5 2.5 0 012.5-2.5h.5a.5.5 0 010 1h-.5a1.5 1.5 0 000 3h.5a.5.5 0 010 1h-.5a2.5 2.5 0 01-2.5-2.5zm5.5-2c0-.28.22-.5.5-.5h.5a2.5 2.5 0 010 5H16a.5.5 0 010-1h.5a1.5 1.5 0 000-3H16a.5.5 0 01-.5-.5zm-3 1.5a.5.5 0 000 1h4a.5.5 0 000-1h-4z",
    fill: primaryFill
  }));
};

export const TableLinkFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/TableLinkFilledIcon({}), 'TableLinkFilled');

const TableLinkRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M17 5.5A2.5 2.5 0 0014.5 3h-9A2.5 2.5 0 003 5.5v9A2.5 2.5 0 005.5 17h3.84a3.48 3.48 0 01-.3-1H8v-3h2.05a3.49 3.49 0 012.45-1h.5V8h3v4h.5c.17 0 .34.01.5.04V5.5zM12 8v4H8V8h4zm-8 6.5V13h3v3H5.36A1.5 1.5 0 014 14.5zM12 7H8V4h4v3zm1-3H14.64A1.5 1.5 0 0116 5.5V7h-3V4zM4 7V5.36A1.5 1.5 0 015.5 4H7v3H4zm3 1v4H4V8h3zm3 7.5a2.5 2.5 0 012.5-2.5h.5a.5.5 0 010 1h-.5a1.5 1.5 0 000 3h.5a.5.5 0 010 1h-.5a2.5 2.5 0 01-2.5-2.5zm5.5-2c0-.28.22-.5.5-.5h.5a2.5 2.5 0 010 5H16a.5.5 0 010-1h.5a1.5 1.5 0 000-3H16a.5.5 0 01-.5-.5zm-3 1.5a.5.5 0 000 1h4a.5.5 0 000-1h-4z",
    fill: primaryFill
  }));
};

export const TableLinkRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/TableLinkRegularIcon({}), 'TableLinkRegular');

const TableMoveAboveFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M3.5 3a.5.5 0 000 1h13a.5.5 0 000-1h-13zM8 12V8.41c.16.06.33.09.5.09v1a1.5 1.5 0 003 0v-1c.17 0 .34-.03.5-.09V12H8zm7 5h-2v-4h4v2a2 2 0 01-2 2zm2-5h-4V8h3.5c.28 0 .5.22.5.5V12zm-9 5h4v-4H8v4zM7 8v4H3V8.5c0-.28.22-.5.5-.5H7zm0 9H5a2 2 0 01-2-2v-2h4v4zm4.15-9.65a.5.5 0 00.7-.7l-1.5-1.5a.5.5 0 00-.7 0l-1.5 1.5a.5.5 0 10.7.7l.65-.64V9.5a.5.5 0 001 0V6.7l.65.65z",
    fill: primaryFill
  }));
};

export const TableMoveAboveFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/TableMoveAboveFilledIcon({}), 'TableMoveAboveFilled');

const TableMoveAboveRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M3 3.5c0-.28.22-.5.5-.5h13a.5.5 0 010 1h-13a.5.5 0 01-.5-.5zM3.5 8h3.88a1.52 1.52 0 00.62.41V12h4V8.41a1.5 1.5 0 00.62-.41h3.88c.28 0 .5.22.5.5V15a2 2 0 01-2 2H5a2 2 0 01-2-2V8.5c0-.28.22-.5.5-.5zm.5 5v2a1 1 0 001 1h2v-3H4zm8 3v-3H8v3h4zm1 0h2a1 1 0 001-1v-2h-3v3zm0-4h3V9h-3v3zM4 9v3h3V9H4zm7.15-1.65a.5.5 0 00.7-.7l-1.5-1.5a.5.5 0 00-.7 0l-1.5 1.5a.5.5 0 10.7.7l.65-.64V9.5a.5.5 0 001 0V6.7l.65.65z",
    fill: primaryFill
  }));
};

export const TableMoveAboveRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/TableMoveAboveRegularIcon({}), 'TableMoveAboveRegular');

const TableMoveBelowFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M16.5 17a.5.5 0 000-1h-13a.5.5 0 000 1h13zM12 8v3.59a1.5 1.5 0 00-.5-.09v-1a1.5 1.5 0 00-3 0v1c-.17 0-.34.03-.5.09V8h4zM5 3h2v4H3V5c0-1.1.9-2 2-2zM3 8h4v4H3.5a.5.5 0 01-.5-.5V8zm9-5H8v4h4V3zm1 9V8h4v3.5a.5.5 0 01-.5.5H13zm0-9h2a2 2 0 012 2v2h-4V3zm-4.15 9.65a.5.5 0 00-.7.7l1.5 1.5c.2.2.5.2.7 0l1.5-1.5a.5.5 0 00-.7-.7l-.65.64V10.5a.5.5 0 00-1 0v2.8l-.65-.65z",
    fill: primaryFill
  }));
};

export const TableMoveBelowFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/TableMoveBelowFilledIcon({}), 'TableMoveBelowFilled');

const TableMoveBelowRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M17 16.5a.5.5 0 01-.5.5h-13a.5.5 0 010-1h13c.28 0 .5.22.5.5zm-.5-4.5h-3.88a1.5 1.5 0 00-.62-.41V8H8v3.59a1.5 1.5 0 00-.62.41H3.5a.5.5 0 01-.5-.5V5c0-1.1.9-2 2-2h10a2 2 0 012 2v6.5a.5.5 0 01-.5.5zM16 7V5a1 1 0 00-1-1h-2v3h3zM8 4v3h4V4H8zM7 4H5a1 1 0 00-1 1v2h3V4zm0 4H4v3h3V8zm9 3V8h-3v3h3zm-7.15 1.65a.5.5 0 00-.7.7l1.5 1.5c.2.2.5.2.7 0l1.5-1.5a.5.5 0 00-.7-.7l-.65.64V10.5a.5.5 0 00-1 0v2.8l-.65-.65z",
    fill: primaryFill
  }));
};

export const TableMoveBelowRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/TableMoveBelowRegularIcon({}), 'TableMoveBelowRegular');

const TableMoveLeftFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M3 16.5a.5.5 0 001 0v-13a.5.5 0 00-1 0v13zm9-4.5H8.41c.06-.16.09-.33.09-.5h1a1.5 1.5 0 000-3h-1c0-.17-.03-.34-.09-.5H12v4zm5-7v2h-4V3h2a2 2 0 012 2zm-5-2v4H8V3.5c0-.28.22-.5.5-.5H12zm5 9V8h-4v4h4zm-9 1h4v4H8.5a.5.5 0 01-.5-.5V13zm9 0v2a2 2 0 01-2 2h-2v-4h4zM7.35 8.85a.5.5 0 10-.7-.7l-1.5 1.5a.5.5 0 000 .7l1.5 1.5a.5.5 0 00.7-.7l-.64-.65H9.5a.5.5 0 000-1H6.7l.65-.65z",
    fill: primaryFill
  }));
};

export const TableMoveLeftFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/TableMoveLeftFilledIcon({}), 'TableMoveLeftFilled');

const TableMoveLeftRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M3.5 17a.5.5 0 01-.5-.5v-13a.5.5 0 011 0v13a.5.5 0 01-.5.5zm4.5-.5v-3.88a1.55 1.55 0 00.41-.62H12V8H8.41A1.5 1.5 0 008 7.38V3.5c0-.28.22-.5.5-.5H15a2 2 0 012 2v10a2 2 0 01-2 2H8.5a.5.5 0 01-.5-.5zm5-.5h2a1 1 0 001-1v-2h-3v3zm3-8h-3v4h3V8zm0-1V5a1 1 0 00-1-1h-2v3h3zm-4 0V4H9v3h3zm-3 9h3v-3H9v3zM7.35 8.85a.5.5 0 10-.7-.7l-1.5 1.5a.5.5 0 000 .7l1.5 1.5a.5.5 0 00.7-.7l-.64-.65H9.5a.5.5 0 000-1H6.7l.65-.65z",
    fill: primaryFill
  }));
};

export const TableMoveLeftRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/TableMoveLeftRegularIcon({}), 'TableMoveLeftRegular');

const TableMoveRightFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M17 3.5a.5.5 0 00-1 0v13a.5.5 0 001 0v-13zM8 8h3.59a1.5 1.5 0 00-.09.5h-1a1.5 1.5 0 100 3h1c0 .17.03.34.09.5H8V8zm-5 7v-2h4v4H5a2 2 0 01-2-2zm5 2v-4h4v3.5a.5.5 0 01-.5.5H8zM3 8v4h4V8H3zm9-1H8V3h3.5c.28 0 .5.22.5.5V7zM3 7V5c0-1.1.9-2 2-2h2v4H3zm9.65 4.15a.5.5 0 00.7.7l1.5-1.5a.5.5 0 000-.7l-1.5-1.5a.5.5 0 00-.7.7l.64.65H10.5a.5.5 0 000 1h2.8l-.65.65z",
    fill: primaryFill
  }));
};

export const TableMoveRightFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/TableMoveRightFilledIcon({}), 'TableMoveRightFilled');

const TableMoveRightRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M16.5 3c.28 0 .5.22.5.5v13a.5.5 0 01-1 0v-13c0-.28.22-.5.5-.5zm-4.5.5v3.88a1.5 1.5 0 00-.41.62H8v4h3.59a1.5 1.5 0 00.41.62v3.88a.5.5 0 01-.5.5H5a2 2 0 01-2-2V5c0-1.1.9-2 2-2h6.5c.28 0 .5.22.5.5zM7 4H5a1 1 0 00-1 1v2h3V4zm-3 8h3V8H4v4zm0 1v2a1 1 0 001 1h2v-3H4zm4 0v3h3v-3H8zm3-9H8v3h3V4zm1.65 7.15a.5.5 0 00.7.7l1.5-1.5a.5.5 0 000-.7l-1.5-1.5a.5.5 0 00-.7.7l.64.65H10.5a.5.5 0 000 1h2.8l-.65.65z",
    fill: primaryFill
  }));
};

export const TableMoveRightRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/TableMoveRightRegularIcon({}), 'TableMoveRightRegular');

const TableMultipleFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M17 13.5a3.5 3.5 0 01-3.5 3.5H5.67c.77.63 1.76 1 2.83 1h5a4.5 4.5 0 004.5-4.5v-5c0-1.07-.37-2.06-1-2.83v7.83zM4.5 16H6v-4H2v1.5A2.5 2.5 0 004.5 16zM6 7v4H2V7h4zm5 4H7V7h4v4zm-4 1h4v4H7v-4zm5-5v4h4V7h-4zm0 5h4v1.5a2.5 2.5 0 01-2.5 2.5H12v-4zM2 6h4V2H4.5A2.5 2.5 0 002 4.5V6zm5 0V2h4v4H7zm5 0V2h1.5A2.5 2.5 0 0116 4.5V6h-4z",
    fill: primaryFill
  }));
};

export const TableMultipleFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/TableMultipleFilledIcon({}), 'TableMultipleFilled');

const TableMultipleRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M5.67 17h7.84c.95 0 1.82-.39 2.45-1.01l.02-.02A3.49 3.49 0 0017 13.5V5.67c.63.77 1 1.76 1 2.83v5a4.5 4.5 0 01-4.5 4.5h-5a4.48 4.48 0 01-2.83-1zm9.6-14.27c.47.47.73 1.1.73 1.77v9a2.5 2.5 0 01-2.5 2.5h-9A2.5 2.5 0 012 13.5v-9A2.5 2.5 0 014.5 2h9c.66 0 1.3.26 1.77.73zM4.5 3h-.14A1.5 1.5 0 003 4.5V6h3V3H4.5zM11 3H7v3h4V3zm4 1.5v-.14A1.5 1.5 0 0013.5 3H12v3h3V4.5zM7 7v4h4V7H7zm8 0h-3v4h3V7zm-8 5v3h4v-3H7zm8 0h-3v3H13.64A1.5 1.5 0 0015 13.5V12zM3.5 14.61c.27.25.63.39 1 .39H6v-3H3V13.64c.04.38.22.72.5.97zM3 7v4h3V7H3z",
    fill: primaryFill
  }));
};

export const TableMultipleRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/TableMultipleRegularIcon({}), 'TableMultipleRegular');

const TableResizeColumnFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M14 3a3 3 0 013 3v8a3 3 0 01-3 3v-4.38l.06-.06 1.5-1.5a1.5 1.5 0 000-2.12l-1.5-1.5a1.6 1.6 0 00-.06-.06V3zm-1 0v4a1.5 1.5 0 00-1.5 1.5h-3A1.5 1.5 0 007 7V3h6zm-4.94 9.56c-.3.3-.68.44-1.06.44v4h6v-4a1.5 1.5 0 01-1.5-1.5h-3c0 .38-.15.77-.44 1.06zM6 17v-4.38a1.55 1.55 0 01-.06-.06l-1.5-1.5a1.5 1.5 0 010-2.12l1.5-1.5.06-.06V3a3 3 0 00-3 3v8a3 3 0 003 3zm1.35-8.85c.2.2.2.5 0 .7l-.64.65h6.58l-.64-.65a.5.5 0 01.7-.7l1.5 1.5c.2.2.2.5 0 .7l-1.5 1.5a.5.5 0 01-.7-.7l.64-.65H6.71l.64.65a.5.5 0 01-.7.7l-1.5-1.5a.5.5 0 010-.7l1.5-1.5c.2-.2.5-.2.7 0z",
    fill: primaryFill
  }));
};

export const TableResizeColumnFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/TableResizeColumnFilledIcon({}), 'TableResizeColumnFilled');

const TableResizeColumnRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M7.35 8.15c.2.2.2.5 0 .7l-.64.65h6.58l-.64-.65a.5.5 0 01.7-.7l1.5 1.5c.2.2.2.5 0 .7l-1.5 1.5a.5.5 0 01-.7-.7l.64-.65H6.71l.64.65a.5.5 0 01-.7.7l-1.5-1.5a.5.5 0 010-.7l1.5-1.5c.2-.2.5-.2.7 0zM17 6a3 3 0 00-3-3H6a3 3 0 00-3 3v8a3 3 0 003 3h8a3 3 0 003-3V6zm-4-2v3c.36 0 .72.13 1 .38V4a2 2 0 012 2v8a2 2 0 01-2 2v-3.38a1.5 1.5 0 01-1 .38v3H7v-3a1.5 1.5 0 01-1-.38V16a2 2 0 01-2-2V6c0-1.1.9-2 2-2v3.38A1.5 1.5 0 017 7V4h6z",
    fill: primaryFill
  }));
};

export const TableResizeColumnRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/TableResizeColumnRegularIcon({}), 'TableResizeColumnRegular');

const TableResizeRowFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M17 14a3 3 0 01-3 3H6a3 3 0 01-3-3h4.38l.06.06 1.5 1.5a1.5 1.5 0 002.12 0l1.5-1.5.06-.06H17zm0-1h-4a1.5 1.5 0 00-1.5-1.5v-3A1.5 1.5 0 0013 7h4v6zM7.44 8.06A1.5 1.5 0 017 7H3v6h4a1.5 1.5 0 011.5-1.5v-3a1.5 1.5 0 01-1.06-.44zM3 6h4.38l.06-.06 1.5-1.5a1.5 1.5 0 012.12 0l1.5 1.5.06.06H17a3 3 0 00-3-3H6a3 3 0 00-3 3zm8.85 1.35a.5.5 0 01-.7 0l-.65-.64v6.58l.65-.64a.5.5 0 01.7.7l-1.5 1.5a.5.5 0 01-.7 0l-1.5-1.5a.5.5 0 01.7-.7l.65.64V6.71l-.65.64a.5.5 0 11-.7-.7l1.5-1.5c.2-.2.5-.2.7 0l1.5 1.5c.2.2.2.5 0 .7z",
    fill: primaryFill
  }));
};

export const TableResizeRowFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/TableResizeRowFilledIcon({}), 'TableResizeRowFilled');

const TableResizeRowRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M11.85 7.35a.5.5 0 01-.7 0l-.65-.64v6.58l.65-.64a.5.5 0 01.7.7l-1.5 1.5a.5.5 0 01-.7 0l-1.5-1.5a.5.5 0 01.7-.7l.65.64V6.71l-.65.64a.5.5 0 11-.7-.7l1.5-1.5c.2-.2.5-.2.7 0l1.5 1.5c.2.2.2.5 0 .7zM14 17a3 3 0 003-3V6a3 3 0 00-3-3H6a3 3 0 00-3 3v8a3 3 0 003 3h8zm2-4h-3c0 .36-.13.72-.38 1H16a2 2 0 01-2 2H6a2 2 0 01-2-2h3.38A1.5 1.5 0 017 13H4V7h3c0-.36.13-.72.38-1H4c0-1.1.9-2 2-2h8a2 2 0 012 2h-3.38c.25.28.38.64.38 1h3v6z",
    fill: primaryFill
  }));
};

export const TableResizeRowRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/TableResizeRowRegularIcon({}), 'TableResizeRowRegular');

const TableSearchFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M13 17h1.5a2.5 2.5 0 002.5-2.5V13h-4v4z",
    fill: primaryFill
  }), React.createElement("path", {
    d: "M13 12V8h4v4h-4z",
    fill: primaryFill
  }), React.createElement("path", {
    d: "M12 12H8.74A4.5 4.5 0 008 10.67V8h4v4z",
    fill: primaryFill
  }), React.createElement("path", {
    d: "M8.56 15.44L10.12 17H12v-4H8.97a4.55 4.55 0 01-.4 2.44z",
    fill: primaryFill
  }), React.createElement("path", {
    d: "M4.5 9c.93 0 1.78.28 2.5.76V8H3v1.26A4.5 4.5 0 014.5 9z",
    fill: primaryFill
  }), React.createElement("path", {
    d: "M13 7h4V5.5A2.5 2.5 0 0014.5 3H13v4z",
    fill: primaryFill
  }), React.createElement("path", {
    d: "M12 3v4H8V3h4z",
    fill: primaryFill
  }), React.createElement("path", {
    d: "M7 3v4H3V5.5A2.5 2.5 0 015.5 3H7z",
    fill: primaryFill
  }), React.createElement("path", {
    d: "M4.5 17c.79 0 1.51-.26 2.1-.7l2.55 2.55a.5.5 0 10.7-.7L7.3 15.6A3.5 3.5 0 104.5 17zm0-1a2.5 2.5 0 110-5 2.5 2.5 0 010 5z",
    fill: primaryFill
  }));
};

export const TableSearchFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/TableSearchFilledIcon({}), 'TableSearchFilled');

const TableSearchRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M17 5.5A2.5 2.5 0 0014.5 3h-9A2.5 2.5 0 003 5.5v3.76c.32-.12.66-.2 1-.23V8h3v1.76a4.51 4.51 0 011 .91V8h4v4H8.74a4.5 4.5 0 01.23 1H12v3H9.12l1 1h4.38a2.5 2.5 0 002.5-2.5v-9zM14.5 16H13v-3h3V14.64A1.5 1.5 0 0114.5 16zM13 8h3v4h-3V8zm-1-1H8V4h4v3zm1-3h1.65A1.5 1.5 0 0116 5.5V7h-3V4zM4 7V5.36A1.5 1.5 0 015.5 4H7v3H4zm-2.62 4.9a3.5 3.5 0 005.22 4.4l2.54 2.56a.5.5 0 00.71-.71L7.3 15.6a3.5 3.5 0 10-5.92-3.7zm5.2.21a2.5 2.5 0 11-4.16 2.78 2.5 2.5 0 014.16-2.78z",
    fill: primaryFill
  }));
};

export const TableSearchRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/TableSearchRegularIcon({}), 'TableSearchRegular');

const TableSettingsFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M17 9.6a5.48 5.48 0 00-4-.4V8h4v1.6zM9.2 13a5.5 5.5 0 00.4 4H8v-4h1.2zM12 9.6A5.52 5.52 0 009.6 12H8V8h4v1.6zM7 8v4H3V8h4zm0 5H3v1.5A2.5 2.5 0 005.5 17H7v-4zm10-6h-4V3h1.5A2.5 2.5 0 0117 5.5V7zm-5 0V3H8v4h4zM7 7V3H5.5A2.5 2.5 0 003 5.5V7h4zm5.06 4.44a2 2 0 01-1.43 2.48l-.46.12a4.74 4.74 0 00.01 1.01l.35.09A2 2 0 0112 17.66l-.13.42c.26.2.54.38.84.52l.32-.35a2 2 0 012.91 0l.34.36c.3-.13.57-.3.82-.5l-.16-.55a2 2 0 011.44-2.48l.46-.12a4.7 4.7 0 00-.01-1.01l-.35-.09A2 2 0 0117 11.34l.13-.42c-.26-.2-.54-.38-.84-.52l-.32.35a2 2 0 01-2.91 0l-.34-.36c-.3.13-.57.3-.82.5l.15.55zm2.44 4.06a1 1 0 110-2 1 1 0 010 2z",
    fill: primaryFill
  }));
};

export const TableSettingsFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/TableSettingsFilledIcon({}), 'TableSettingsFilled');

const TableSettingsRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M14.5 3A2.5 2.5 0 0117 5.5v4.1c-.32-.16-.65-.3-1-.4V8h-3v1.2c-.35.1-.68.24-1 .4V8H8v4h1.6c-.16.32-.3.65-.4 1H8v3h1.2c.1.35.24.68.4 1H5.5A2.5 2.5 0 013 14.5v-9A2.5 2.5 0 015.5 3h9zM4 13v1.5c0 .78.6 1.42 1.36 1.5H7v-3H4zm4-6h4V4H8v3zm6.5-3H13v3h3V5.5c0-.78-.6-1.42-1.36-1.5h-.14zM4 5.5V7h3V4H5.5c-.78 0-1.42.6-1.5 1.36v.14zM7 12V8H4v4h3zm5.06-.56a2 2 0 01-1.43 2.48l-.46.12a4.74 4.74 0 00.01 1.01l.35.09A2 2 0 0112 17.66l-.13.42c.26.2.54.38.84.52l.32-.35a2 2 0 012.91 0l.34.36c.3-.13.57-.3.82-.5l-.16-.55a2 2 0 011.44-2.48l.46-.12a4.7 4.7 0 00-.01-1.01l-.35-.09A2 2 0 0117 11.34l.13-.42c-.26-.2-.54-.38-.84-.52l-.32.35a2 2 0 01-2.91 0l-.34-.36c-.3.13-.57.3-.82.5l.15.55zm2.44 4.06a1 1 0 110-2 1 1 0 010 2z",
    fill: primaryFill
  }));
};

export const TableSettingsRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/TableSettingsRegularIcon({}), 'TableSettingsRegular');

const TableSimpleFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M5.5 3A2.5 2.5 0 003 5.5v4h6.5V3h-4zm4 7.5H3v4A2.5 2.5 0 005.5 17h4v-6.5zm1 0H17v4a2.5 2.5 0 01-2.5 2.5h-4v-6.5zm6.5-1v-4A2.5 2.5 0 0014.5 3h-4v6.5H17z",
    fill: primaryFill
  }));
};

export const TableSimpleFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/TableSimpleFilledIcon({}), 'TableSimpleFilled');

const TableSimpleRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M3 5.5A2.5 2.5 0 015.5 3h9A2.5 2.5 0 0117 5.5v9a2.5 2.5 0 01-2.5 2.5h-9A2.5 2.5 0 013 14.5v-9zm1 5v4c0 .83.67 1.5 1.5 1.5h4v-5.5H4zm5.5-1V4h-4C4.67 4 4 4.67 4 5.5v4h5.5zm1 1V16h4c.83 0 1.5-.67 1.5-1.5v-4h-5.5zm5.5-1v-4c0-.83-.67-1.5-1.5-1.5h-4v5.5H16z",
    fill: primaryFill
  }));
};

export const TableSimpleRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/TableSimpleRegularIcon({}), 'TableSimpleRegular');

const TableSplitFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M8 6h4V2H8v4zM7 2H3.5a.5.5 0 00-.5.5V4c0 1.1.9 2 2 2h2V2zm6 4h2a2 2 0 002-2V2.5a.5.5 0 00-.5-.5H13v4zm4 11.5a.5.5 0 01-.5.5H13v-4h2a2 2 0 012 2v1.5zM12 14v4H8v-4h4zm-8.5 4H7v-4H5a2 2 0 00-2 2v1.5c0 .28.22.5.5.5zm-1-8.5h15a.5.5 0 110 1h-15a.5.5 0 010-1z",
    fill: primaryFill
  }));
};

export const TableSplitFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/TableSplitFilledIcon({}), 'TableSplitFilled');

const TableSplitRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M16.5 2c.28 0 .5.22.5.5V4a2 2 0 01-2 2H5a2 2 0 01-2-2V2.5a.5.5 0 011 0V4a1 1 0 001 1h2V2.5a.5.5 0 011 0V5h4V2.5a.5.5 0 011 0V5h2a1 1 0 001-1V2.5c0-.28.22-.5.5-.5zm0 16a.5.5 0 00.5-.5V16a2 2 0 00-2-2H5a2 2 0 00-2 2v1.5a.5.5 0 001 0V16a1 1 0 011-1h2v2.5a.5.5 0 001 0V15h4v2.5a.5.5 0 001 0V15h2a1 1 0 011 1v1.5c0 .28.22.5.5.5zm-14-8.5h15a.5.5 0 110 1h-15a.5.5 0 010-1z",
    fill: primaryFill
  }));
};

export const TableSplitRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/TableSplitRegularIcon({}), 'TableSplitRegular');

const TableStackAboveFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M3.5 3a.5.5 0 000 1h13a.5.5 0 000-1h-13zM15 17h-2v-4h4v2a2 2 0 01-2 2zm2-5h-4V8h3.5c.28 0 .5.22.5.5V12zm-5 0V8H8v4h4zm-4 5h4v-4H8v4zM7 8v4H3V8.5c0-.28.22-.5.5-.5H7zm0 9H5a2 2 0 01-2-2v-2h4v4z",
    fill: primaryFill
  }));
};

export const TableStackAboveFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/TableStackAboveFilledIcon({}), 'TableStackAboveFilled');

const TableStackAboveRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M3 3.5c0-.28.22-.5.5-.5h13a.5.5 0 010 1h-13a.5.5 0 01-.5-.5zm0 5c0-.28.22-.5.5-.5h13c.28 0 .5.22.5.5V15a2 2 0 01-2 2H5a2 2 0 01-2-2V8.5zM4 13v2a1 1 0 001 1h2v-3H4zm8 3v-3H8v3h4zm1 0h2a1 1 0 001-1v-2h-3v3zm0-4h3V9h-3v3zm-1-3H8v3h4V9zM4 9v3h3V9H4z",
    fill: primaryFill
  }));
};

export const TableStackAboveRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/TableStackAboveRegularIcon({}), 'TableStackAboveRegular');

const TableStackBelowFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M16.5 17a.5.5 0 000-1h-13a.5.5 0 000 1h13zM5 3h2v4H3V5c0-1.1.9-2 2-2zM3 8h4v4H3.5a.5.5 0 01-.5-.5V8zm5 0v4h4V8H8zm4-5H8v4h4V3zm1 9V8h4v3.5a.5.5 0 01-.5.5H13zm0-9h2a2 2 0 012 2v2h-4V3z",
    fill: primaryFill
  }));
};

export const TableStackBelowFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/TableStackBelowFilledIcon({}), 'TableStackBelowFilled');

const TableStackBelowRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M17 16.5a.5.5 0 01-.5.5h-13a.5.5 0 010-1h13c.28 0 .5.22.5.5zm0-5a.5.5 0 01-.5.5h-13a.5.5 0 01-.5-.5V5c0-1.1.9-2 2-2h10a2 2 0 012 2v6.5zM16 7V5a1 1 0 00-1-1h-2v3h3zM8 4v3h4V4H8zM7 4H5a1 1 0 00-1 1v2h3V4zm0 4H4v3h3V8zm1 3h4V8H8v3zm8 0V8h-3v3h3z",
    fill: primaryFill
  }));
};

export const TableStackBelowRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/TableStackBelowRegularIcon({}), 'TableStackBelowRegular');

const TableStackLeftFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M3 16.5a.5.5 0 001 0v-13a.5.5 0 00-1 0v13zM17 5v2h-4V3h2a2 2 0 012 2zm-5-2v4H8V3.5c0-.28.22-.5.5-.5H12zm0 5H8v4h4V8zm5 4V8h-4v4h4zm-9 1h4v4H8.5a.5.5 0 01-.5-.5V13zm9 0v2a2 2 0 01-2 2h-2v-4h4z",
    fill: primaryFill
  }));
};

export const TableStackLeftFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/TableStackLeftFilledIcon({}), 'TableStackLeftFilled');

const TableStackLeftRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M3.5 17a.5.5 0 01-.5-.5v-13a.5.5 0 011 0v13a.5.5 0 01-.5.5zm5 0a.5.5 0 01-.5-.5v-13c0-.28.22-.5.5-.5H15a2 2 0 012 2v10a2 2 0 01-2 2H8.5zm4.5-1h2a1 1 0 001-1v-2h-3v3zm3-8h-3v4h3V8zm0-1V5a1 1 0 00-1-1h-2v3h3zm-4 0V4H9v3h3zM9 8v4h3V8H9zm0 8h3v-3H9v3z",
    fill: primaryFill
  }));
};

export const TableStackLeftRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/TableStackLeftRegularIcon({}), 'TableStackLeftRegular');

const TableStackRightFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M17 3.5a.5.5 0 00-1 0v13a.5.5 0 001 0v-13zM3 15v-2h4v4H5a2 2 0 01-2-2zm5 2v-4h4v3.5a.5.5 0 01-.5.5H8zm0-5h4V8H8v4zM3 8v4h4V8H3zm9-1H8V3h3.5c.28 0 .5.22.5.5V7zM3 7V5c0-1.1.9-2 2-2h2v4H3z",
    fill: primaryFill
  }));
};

export const TableStackRightFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/TableStackRightFilledIcon({}), 'TableStackRightFilled');

const TableStackRightRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M16.5 3c.28 0 .5.22.5.5v13a.5.5 0 01-1 0v-13c0-.28.22-.5.5-.5zm-5 0c.28 0 .5.22.5.5v13a.5.5 0 01-.5.5H5a2 2 0 01-2-2V5c0-1.1.9-2 2-2h6.5zM7 4H5a1 1 0 00-1 1v2h3V4zm-3 8h3V8H4v4zm0 1v2a1 1 0 001 1h2v-3H4zm4 0v3h3v-3H8zm3-1V8H8v4h3zm0-8H8v3h3V4z",
    fill: primaryFill
  }));
};

export const TableStackRightRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/TableStackRightRegularIcon({}), 'TableStackRightRegular');

const TableSwitchFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M7.85 1.15a.5.5 0 10-.7.7L8.29 3H6a3 3 0 00-3 3v2.3L1.85 7.14a.5.5 0 10-.7.7l2 2c.2.2.5.2.7 0l2-2a.5.5 0 10-.7-.7L4 8.29V6c0-1.1.9-2 2-2h2.3L7.14 5.15a.5.5 0 10.7.7l2-2a.5.5 0 000-.7l-2-2zm.71 5.41a1.5 1.5 0 01-.56.35V7h4V3h-1.09a1.5 1.5 0 01-.35 1.56l-2 2zm-4 4a1.5 1.5 0 01-1.56.35V12h4V8h-.09c-.07.2-.19.4-.35.56l-2 2zM13 17h1.5a2.5 2.5 0 002.5-2.5V13h-4v4zm0-5V8h4v4h-4zm-1 0H8V8h4v4zm-4 1h4v4H8v-4zm-5 0h4v4H5.5A2.5 2.5 0 013 14.5V13zm10-6h4V5.5A2.5 2.5 0 0014.5 3H13v4z",
    fill: primaryFill
  }));
};

export const TableSwitchFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/TableSwitchFilledIcon({}), 'TableSwitchFilled');

const TableSwitchRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M7.85 1.15a.5.5 0 10-.7.7L8.29 3H6a3 3 0 00-3 3v2.3L1.85 7.14a.5.5 0 10-.7.7l2 2c.2.2.5.2.7 0l2-2a.5.5 0 10-.7-.7L4 8.29V6c0-1.1.9-2 2-2h2.3L7.14 5.15a.5.5 0 10.7.7l2-2a.5.5 0 000-.7l-2-2zM7 12V7h5V4h-1.09a1.5 1.5 0 000-1h3.59A2.5 2.5 0 0117 5.5v9a2.5 2.5 0 01-2.5 2.5h-9A2.5 2.5 0 013 14.5v-3.59c.32.12.68.12 1 0V12h3zm-3 2.5c0 .78.6 1.42 1.36 1.5H7v-3H4v1.5zm8-1.5H8v3h4v-3zm2.5 3c.78 0 1.42-.6 1.5-1.36V13h-3v3h1.5zM12 8H8v4h4V8zm1 0v4h3V8h-3zm0-4v3h3V5.5c0-.78-.6-1.42-1.36-1.5H13z",
    fill: primaryFill
  }));
};

export const TableSwitchRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/TableSwitchRegularIcon({}), 'TableSwitchRegular');

const TabletFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M2 6c0-1.1.9-2 2-2h12a2 2 0 012 2v8a2 2 0 01-2 2H4a2 2 0 01-2-2V6zm6.5 6a.5.5 0 000 1h3a.5.5 0 000-1h-3z",
    fill: primaryFill
  }));
};

export const TabletFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/TabletFilledIcon({}), 'TabletFilled');

const TabletRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M8.5 12a.5.5 0 000 1h3a.5.5 0 000-1h-3zM4 4a2 2 0 00-2 2v8c0 1.1.9 2 2 2h12a2 2 0 002-2V6a2 2 0 00-2-2H4zM3 6a1 1 0 011-1h12a1 1 0 011 1v8a1 1 0 01-1 1H4a1 1 0 01-1-1V6z",
    fill: primaryFill
  }));
};

export const TabletRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/TabletRegularIcon({}), 'TabletRegular');

const TabletSpeakerFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M13.7 2.04c.18.08.3.26.3.46v6a.5.5 0 01-.85.35L11.29 7h-.79a.5.5 0 01-.5-.5v-2c0-.28.22-.5.5-.5h.8l1.85-1.85a.5.5 0 01.54-.11zm3.95.16c.12.16.29.45.44.87.26.68.41 1.5.41 2.43 0 .94-.15 1.75-.4 2.43-.16.42-.33.7-.45.87a.5.5 0 01-.85-.52l.12-.19a5.9 5.9 0 00.58-2.6 5.9 5.9 0 00-.58-2.58l-.07-.11a.5.5 0 11.8-.6zm-1.7 1.08a5.5 5.5 0 01.55 2.22 4.9 4.9 0 01-.55 2.22.5.5 0 11-.9-.44l.08-.17.15-.4c.14-.42.22-.83.22-1.21s-.08-.8-.22-1.22a4.59 4.59 0 00-.23-.56.5.5 0 11.9-.44zm.4 6.42a1.5 1.5 0 01-.53-.74 1.5 1.5 0 01-.87-.07 1.5 1.5 0 01-2.51.67L10.88 8h-.38A1.5 1.5 0 019 6.5v-2c0-.18.03-.34.09-.5H4a2 2 0 00-2 2v8c0 1.1.9 2 2 2h12a2 2 0 002-2V9.8c-.5.29-1.15.27-1.65-.1zM8.5 13h3a.5.5 0 010 1h-3a.5.5 0 010-1z",
    fill: primaryFill
  }));
};

export const TabletSpeakerFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/TabletSpeakerFilledIcon({}), 'TabletSpeakerFilled');

const TabletSpeakerRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M18.1 3.07a3.67 3.67 0 00-.45-.87.5.5 0 00-.8.6l.07.1a5.9 5.9 0 01.58 2.6 5.9 5.9 0 01-.58 2.6l-.12.18a.5.5 0 00.85.52c.12-.16.29-.45.44-.87.26-.68.41-1.5.41-2.43 0-.94-.15-1.75-.4-2.43zM14 2.5a.5.5 0 00-.85-.35L11.29 4h-.79a.5.5 0 00-.5.5v2c0 .28.22.5.5.5h.8l1.85 1.85A.5.5 0 0014 8.5v-6zm1.95.78a5.5 5.5 0 01.55 2.22 4.9 4.9 0 01-.55 2.22.5.5 0 11-.9-.44l.08-.17.15-.4c.14-.42.22-.83.22-1.21s-.08-.8-.22-1.22a4.59 4.59 0 00-.23-.56.5.5 0 11.9-.44zM17 9.98V14a1 1 0 01-1 1H4a1 1 0 01-1-1V6a1 1 0 011-1h5v-.5c0-.18.03-.34.09-.5H4a2 2 0 00-2 2v8c0 1.1.9 2 2 2h12a2 2 0 002-2V9.8c-.3.17-.66.24-1 .18zM8.5 13a.5.5 0 000 1h3a.5.5 0 000-1h-3z",
    fill: primaryFill
  }));
};

export const TabletSpeakerRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/TabletSpeakerRegularIcon({}), 'TabletSpeakerRegular');

const TagFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M18 4.03a2 2 0 00-1.98-2L11.12 2a2 2 0 00-1.42.59L3.02 9.25a2 2 0 000 2.83l4.95 4.95a2 2 0 002.83 0l6.63-6.63A2 2 0 0018 8.98V4.03zM14 7a1 1 0 110-2 1 1 0 010 2z",
    fill: primaryFill
  }));
};

export const TagFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/TagFilledIcon({}), 'TagFilled');

const TagRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M14 7a1 1 0 100-2 1 1 0 000 2zm-2.87-5a2 2 0 00-1.43.58L3.02 9.25a2 2 0 000 2.83l4.95 4.95a2 2 0 002.83 0l6.63-6.63A2 2 0 0018 8.98V4.03a2 2 0 00-1.99-2L11.12 2zm-.72 1.3a1 1 0 01.71-.3l4.9.03a1 1 0 01.99 1v4.95a1 1 0 01-.29.7l-6.63 6.64a1 1 0 01-1.41 0l-4.95-4.95a1 1 0 010-1.41l6.68-6.67z",
    fill: primaryFill
  }));
};

export const TagRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/TagRegularIcon({}), 'TagRegular');

const TagCircleFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M2 10a8 8 0 1116 0 8 8 0 01-16 0zm4-1.5v3c0 .83.67 1.5 1.5 1.5h4.06c.4 0 .79-.14 1.1-.39l1.78-1.44a1.5 1.5 0 000-2.34L12.66 7.4c-.31-.25-.7-.39-1.1-.39H7.5C6.67 7 6 7.67 6 8.5z",
    fill: primaryFill
  }));
};

export const TagCircleFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/TagCircleFilledIcon({}), 'TagCircleFilled');

const TagCircleRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M7.5 7C6.67 7 6 7.67 6 8.5v3c0 .83.67 1.5 1.5 1.5h4.06c.4 0 .79-.14 1.1-.39l1.78-1.44a1.5 1.5 0 000-2.34L12.66 7.4c-.31-.25-.7-.39-1.1-.39H7.5zM7 8.5c0-.28.22-.5.5-.5h4.06c.17 0 .34.06.47.17L13.8 9.6a.5.5 0 010 .78l-1.78 1.44c-.13.11-.3.17-.47.17H7.5a.5.5 0 01-.5-.5v-3zM10 2a8 8 0 100 16 8 8 0 000-16zm-7 8a7 7 0 1114 0 7 7 0 01-14 0z",
    fill: primaryFill
  }));
};

export const TagCircleRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/TagCircleRegularIcon({}), 'TagCircleRegular');

const TagDismissFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M18 4.03a2 2 0 00-1.98-2L11.12 2a2 2 0 00-1.42.59L3.02 9.25a2 2 0 000 2.83l4.95 4.95a2 2 0 001.95.51 5.5 5.5 0 017.8-7.5 2 2 0 00.3-1.06L18 4.03zM14 7a1 1 0 110-2 1 1 0 010 2zm5 7.5a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0zm-2.65-1.15a.5.5 0 00-.7-.7l-1.15 1.14-1.15-1.14a.5.5 0 00-.7.7l1.14 1.15-1.14 1.15a.5.5 0 00.7.7l1.15-1.14 1.15 1.14a.5.5 0 00.7-.7l-1.14-1.15 1.14-1.15z",
    fill: primaryFill
  }));
};

export const TagDismissFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/TagDismissFilledIcon({}), 'TagDismissFilled');

const TagDismissRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M14 7a1 1 0 100-2 1 1 0 000 2zm-2.87-5a2 2 0 00-1.43.58L3.02 9.25a2 2 0 000 2.83l4.95 4.95a2 2 0 001.95.51c-.2-.29-.36-.6-.5-.93a1 1 0 01-.74-.29l-4.95-4.95a1 1 0 010-1.41l6.68-6.67a1 1 0 01.71-.29l4.9.03a1 1 0 01.99 1v4.95a1 1 0 01-.16.55c.3.14.6.31.86.5a2 2 0 00.3-1.05V4.03a2 2 0 00-1.99-2L11.12 2zM19 14.5a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0zm-2.65-1.15a.5.5 0 00-.7-.7l-1.15 1.14-1.15-1.14a.5.5 0 00-.7.7l1.14 1.15-1.14 1.15a.5.5 0 00.7.7l1.15-1.14 1.15 1.14a.5.5 0 00.7-.7l-1.14-1.15 1.14-1.15z",
    fill: primaryFill
  }));
};

export const TagDismissRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/TagDismissRegularIcon({}), 'TagDismissRegular');

const TagErrorFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M18 4.03a2 2 0 00-1.98-2L11.12 2a2 2 0 00-1.42.59L3.02 9.25a2 2 0 000 2.83l4.95 4.95a2 2 0 001.95.51 5.5 5.5 0 017.8-7.5 2 2 0 00.3-1.06L18 4.03zM14 7a1 1 0 110-2 1 1 0 010 2zm5 7.5a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0zM14.5 12a.5.5 0 00-.5.5v2a.5.5 0 101 0v-2a.5.5 0 00-.5-.5zm0 5.12a.62.62 0 100-1.25.62.62 0 000 1.25z",
    fill: primaryFill
  }));
};

export const TagErrorFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/TagErrorFilledIcon({}), 'TagErrorFilled');

const TagErrorRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M14 7a1 1 0 100-2 1 1 0 000 2zm-2.87-5a2 2 0 00-1.43.58L3.02 9.25a2 2 0 000 2.83l4.95 4.95a2 2 0 001.95.51c-.2-.29-.36-.6-.5-.93a1 1 0 01-.74-.29l-4.95-4.95a1 1 0 010-1.41l6.68-6.67a1 1 0 01.71-.29l4.9.03a1 1 0 01.99 1v4.95a1 1 0 01-.16.55c.3.14.6.31.86.5a2 2 0 00.3-1.05V4.03a2 2 0 00-1.99-2L11.12 2zM19 14.5a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0zM14.5 12a.5.5 0 00-.5.5v2a.5.5 0 001 0v-2a.5.5 0 00-.5-.5zm0 5.13a.62.62 0 100-1.25.62.62 0 000 1.24z",
    fill: primaryFill
  }));
};

export const TagErrorRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/TagErrorRegularIcon({}), 'TagErrorRegular');

const TagLockFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M18 4.03a2 2 0 00-1.98-2L11.12 2a2 2 0 00-1.42.59L3.02 9.25a2 2 0 000 2.83l4.95 4.95a2 2 0 002.03.49V14a2 2 0 011.5-1.94V12a3 3 0 015.68-1.35l.25-.25A2 2 0 0018 8.98V4.03zM14 7a1 1 0 110-2 1 1 0 010 2zm-1.5 5v1H12a1 1 0 00-1 1v4a1 1 0 001 1h5a1 1 0 001-1v-4a1 1 0 00-1-1h-.5v-1a2 2 0 10-4 0zm1 1v-1a1 1 0 112 0v1h-2zm1 2.25a.75.75 0 110 1.5.75.75 0 010-1.5z",
    fill: primaryFill
  }));
};

export const TagLockFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/TagLockFilledIcon({}), 'TagLockFilled');

const TagLockRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M14 7a1 1 0 100-2 1 1 0 000 2zm-2.87-5a2 2 0 00-1.43.58L3.02 9.25a2 2 0 000 2.83l4.95 4.95a2 2 0 002.03.49V16.4a1 1 0 01-1.32-.08l-4.95-4.95a1 1 0 010-1.41l6.68-6.67a1 1 0 01.71-.29l4.9.03a1 1 0 01.99 1v4.95a1 1 0 01-.29.7l-.14.15a3 3 0 01.6.82l.25-.25A2 2 0 0018 8.98V4.03a2 2 0 00-1.99-2L11.12 2zm1.37 10v1H12a1 1 0 00-1 1v4a1 1 0 001 1h5a1 1 0 001-1v-4a1 1 0 00-1-1h-.5v-1a2 2 0 10-4 0zm1 1v-1a1 1 0 112 0v1h-2zm1 2.25a.75.75 0 110 1.5.75.75 0 010-1.5z",
    fill: primaryFill
  }));
};

export const TagLockRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/TagLockRegularIcon({}), 'TagLockRegular');

const TagLockAccentFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M17.5 4.03c0-.82-.66-1.49-1.48-1.5l-4.9-.03c-.4 0-.78.16-1.06.44L3.38 9.61a1.5 1.5 0 000 2.12l4.94 4.95a1.5 1.5 0 001.68.3V14a2 2 0 011.5-1.94V12a3 3 0 015.4-1.79l.17-.16c.29-.29.44-.67.44-1.07V4.03z",
    fill: primaryFill
  }));
};

export const TagLockAccentFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/TagLockAccentFilledIcon({}), 'TagLockAccentFilled');

const TagMultipleFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M3 11.8a2 2 0 00.46 2.11l2.97 2.98a4 4 0 005.65.02l4.4-4.36a2 2 0 00.6-1.43v-.57l-5 4.96-.15.13-.56.55a3 3 0 01-4.23 0l-.5-.5a4.05 4.05 0 01-.2-.2l-2.98-2.98A2 2 0 013 11.8zm6.2-9.21A2 2 0 0110.63 2h4.45a2 2 0 012 2v4.37a2 2 0 01-.59 1.43l-5.82 5.76a2 2 0 01-2.82-.01l-4.38-4.39a2 2 0 010-2.82L9.2 2.59zm4.3 3.91a1 1 0 100-2 1 1 0 000 2z",
    fill: primaryFill
  }));
};

export const TagMultipleFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/TagMultipleFilledIcon({}), 'TagMultipleFilled');

const TagMultipleRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M13.5 6.5a1 1 0 100-2 1 1 0 000 2zM9.2 2.59A2 2 0 0110.63 2h4.45a2 2 0 012 2v4.37a2 2 0 01-.59 1.43l-5.82 5.76a2 2 0 01-2.82-.01l-4.38-4.39a2 2 0 010-2.82L9.2 2.59zm1.42.41a1 1 0 00-.7.3L4.15 9.03a1 1 0 000 1.42l4.39 4.38a1 1 0 001.4 0l5.83-5.76a1 1 0 00.3-.7V4a1 1 0 00-1-1h-4.46zM3 11.8a2 2 0 00.46 2.11l2.97 2.98a4 4 0 005.65.02l4.4-4.36a2 2 0 00.6-1.43v-.57l-5 4.96-.15.13-.56.55a3 3 0 01-4.23 0l-.5-.5a4.05 4.05 0 01-.2-.2l-2.98-2.98A2 2 0 013 11.8z",
    fill: primaryFill
  }));
};

export const TagMultipleRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/TagMultipleRegularIcon({}), 'TagMultipleRegular');

const TagOffFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M2.85 2.15a.5.5 0 10-.7.7L5.79 6.5 3.02 9.25a2 2 0 000 2.83l4.95 4.95a2 2 0 002.83 0l2.76-2.76 3.59 3.58a.5.5 0 00.7-.7l-15-15zm14.58 8.25l-2.45 2.45L7.2 5.08l2.5-2.5A2 2 0 0111.13 2l4.89.04a2 2 0 011.99 2v4.94a2 2 0 01-.58 1.42zM14 7a1 1 0 100-2 1 1 0 000 2z",
    fill: primaryFill
  }));
};

export const TagOffFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/TagOffFilledIcon({}), 'TagOffFilled');

const TagOffRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M5.79 6.5L2.15 2.84a.5.5 0 11.7-.7l15 15a.5.5 0 01-.7.7l-3.6-3.58-2.75 2.76a2 2 0 01-2.83 0l-4.95-4.95a2 2 0 010-2.83L5.8 6.49zm7.06 7.06L6.5 7.2 3.73 9.96a1 1 0 000 1.41l4.95 4.95a1 1 0 001.41 0l2.76-2.76zm3.87-3.87l-2.45 2.45.7.71 2.46-2.45A2 2 0 0018 8.98V4.03a2 2 0 00-1.99-2L11.12 2a2 2 0 00-1.42.58l-2.5 2.5.7.7 2.51-2.49a1 1 0 01.71-.29l4.9.03a1 1 0 01.99 1v4.95a1 1 0 01-.29.7zM14 7a1 1 0 100-2 1 1 0 000 2z",
    fill: primaryFill
  }));
};

export const TagOffRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/TagOffRegularIcon({}), 'TagOffRegular');

const TagQuestionMarkFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M18 4.03a2 2 0 00-1.98-2L11.12 2a2 2 0 00-1.42.59L3.02 9.25a2 2 0 000 2.83l4.95 4.95a2 2 0 001.95.51 5.5 5.5 0 017.8-7.5 2 2 0 00.3-1.06L18 4.03zM14 7a1 1 0 110-2 1 1 0 010 2zm5 7.5a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0zm-4.5 1.88a.62.62 0 100 1.25.62.62 0 000-1.25zm0-4.88c-1.05 0-1.86.82-1.85 1.96a.5.5 0 101-.01c0-.58.36-.95.85-.95.47 0 .85.4.85.95 0 .2-.07.32-.36.55l-.27.21c-.51.4-.72.72-.72 1.29a.5.5 0 001 .09v-.16c.02-.14.1-.25.35-.44l.28-.22c.5-.4.72-.73.72-1.32 0-1.1-.82-1.95-1.85-1.95z",
    fill: primaryFill
  }));
};

export const TagQuestionMarkFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/TagQuestionMarkFilledIcon({}), 'TagQuestionMarkFilled');

const TagQuestionMarkRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M14 7a1 1 0 100-2 1 1 0 000 2zm-2.87-5a2 2 0 00-1.43.58L3.02 9.25a2 2 0 000 2.83l4.95 4.95a2 2 0 001.95.51c-.2-.29-.36-.6-.5-.93a1 1 0 01-.74-.29l-4.95-4.95a1 1 0 010-1.41l6.68-6.67a1 1 0 01.71-.29l4.9.03a1 1 0 01.99 1v4.95a1 1 0 01-.16.55c.3.14.6.31.86.5a2 2 0 00.3-1.05V4.03a2 2 0 00-1.99-2L11.12 2zM19 14.5a4.5 4.5 0 10-9 0 4.5 4.5 0 009 0zm-4.5 1.88a.62.62 0 110 1.25.62.62 0 010-1.25zm0-4.88c1.03 0 1.85.85 1.85 1.95 0 .59-.21.91-.72 1.32l-.28.22c-.25.19-.33.3-.35.44v.16a.5.5 0 01-1-.09c0-.57.21-.88.72-1.29l.27-.21c.3-.23.36-.35.36-.55 0-.55-.38-.95-.85-.95-.5 0-.86.37-.85.95a.5.5 0 11-1 0c-.01-1.13.8-1.95 1.85-1.95z",
    fill: primaryFill
  }));
};

export const TagQuestionMarkRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/TagQuestionMarkRegularIcon({}), 'TagQuestionMarkRegular');

const TagResetFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M16.02 2.04a2 2 0 011.99 2v4.94a2 2 0 01-.58 1.42l-.15.15A5 5 0 0015 10h-1.09a1.5 1.5 0 00-2.47-1.56l-2 2a1.5 1.5 0 000 2.12l1.2 1.2A1.5 1.5 0 0010 15a5 5 0 00.54 2.25 2 2 0 01-2.57-.22l-4.95-4.95a2 2 0 010-2.83L9.7 2.6A2 2 0 0111.13 2l4.89.04zM13 6a1 1 0 102 0 1 1 0 00-2 0zm-.15 3.85a.5.5 0 00-.7-.7l-2 2a.5.5 0 000 .7l2 2a.5.5 0 00.7-.7L11.71 12H15a3 3 0 11-3 3 .5.5 0 10-1 0 4 4 0 104-4h-3.3l1.15-1.15z",
    fill: primaryFill
  }));
};

export const TagResetFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/TagResetFilledIcon({}), 'TagResetFilled');

const TagResetRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M15 6a1 1 0 11-2 0 1 1 0 012 0zM9.7 2.58A2 2 0 0111.13 2l4.89.03a2 2 0 011.99 2v4.95a2 2 0 01-.58 1.42l-.15.15a5 5 0 00-1.03-.4l.47-.46a1 1 0 00.3-.7L17 4.02a1 1 0 00-1-1L11.12 3a1 1 0 00-.71.3L3.73 9.95a1 1 0 000 1.41l4.95 4.95a1 1 0 001.41 0l.07-.07a5 5 0 00.37 1 2 2 0 01-2.56-.22l-4.95-4.95a2 2 0 010-2.83L9.7 2.58zm3.15 7.27a.5.5 0 00-.7-.7l-2 2a.5.5 0 000 .7l2 2a.5.5 0 00.7-.7L11.71 12H15a3 3 0 11-3 3 .5.5 0 10-1 0 4 4 0 104-4h-3.3l1.15-1.15z",
    fill: primaryFill
  }));
};

export const TagResetRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/TagResetRegularIcon({}), 'TagResetRegular');

const TagSearchFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M16.02 2.04a2 2 0 011.99 2v4.94a2 2 0 01-.58 1.42l-.36.36a4.5 4.5 0 10-6.31 6.3 2 2 0 01-2.8-.03l-4.94-4.95a2 2 0 010-2.83L9.7 2.6A2 2 0 0111.13 2l4.89.04zM13 6a1 1 0 102 0 1 1 0 00-2 0zm3.3 9.6a3.5 3.5 0 10-.7.7l2.55 2.55a.5.5 0 10.7-.7L16.3 15.6zm-.3-2.1a2.5 2.5 0 11-5 0 2.5 2.5 0 015 0z",
    fill: primaryFill
  }));
};

export const TagSearchFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/TagSearchFilledIcon({}), 'TagSearchFilled');

const TagSearchRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M15 6a1 1 0 11-2 0 1 1 0 012 0zM9.7 2.58A2 2 0 0111.13 2l4.89.03a2 2 0 011.99 2v4.95a2 2 0 01-.58 1.42l-.36.36c-.2-.27-.44-.51-.7-.72l.35-.35a1 1 0 00.3-.7L17 4.02a1 1 0 00-1-1L11.12 3a1 1 0 00-.71.3L3.73 9.95a1 1 0 000 1.41l4.95 4.95a1 1 0 001.35.05c.22.26.46.5.73.7a2 2 0 01-2.8-.04l-4.94-4.95a2 2 0 010-2.83L9.7 2.58zm6.6 13.02a3.5 3.5 0 10-.7.7l2.55 2.55a.5.5 0 10.7-.7L16.3 15.6zm-.3-2.1a2.5 2.5 0 11-5 0 2.5 2.5 0 015 0z",
    fill: primaryFill
  }));
};

export const TagSearchRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/TagSearchRegularIcon({}), 'TagSearchRegular');

const TapDoubleFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M4 8.5a5.5 5.5 0 1110.97.6c.34.15.65.34.93.57A6.5 6.5 0 103.64 11.3c.25-.25.53-.45.82-.61A5.48 5.48 0 014 8.5zm10 0l-.01.33-1-.17.01-.16a3.5 3.5 0 10-6.57 1.69 4.4 4.4 0 00-1.05.13A4.48 4.48 0 019.5 4 4.5 4.5 0 0114 8.5zm-6-1a1.5 1.5 0 113 0v2.08l2.94.51a2.5 2.5 0 011.91 3.33l-.98 2.67a2.5 2.5 0 01-1.92 1.6l-1.52.26c-1.02.18-1.95-.45-2.43-1.23A5.87 5.87 0 004.44 14a.5.5 0 01-.43-.62c.15-.6.43-1.04.82-1.36.39-.32.85-.47 1.3-.52.63-.06 1.29.05 1.87.25V7.5z",
    fill: primaryFill
  }));
};

export const TapDoubleFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/TapDoubleFilledIcon({}), 'TapDoubleFilled');

const TapDoubleRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M9.5 3a5.5 5.5 0 00-5.04 7.7c-.3.16-.57.36-.82.61A6.5 6.5 0 1115.9 9.67a3.7 3.7 0 00-.93-.57l.03-.6A5.5 5.5 0 009.5 3zm4.49 5.83L14 8.5a4.5 4.5 0 10-8.62 1.82 4.2 4.2 0 011.05-.13A3.5 3.5 0 1113 8.66l1 .17zM9.5 6C8.67 6 8 6.67 8 7.5v4.25a4.46 4.46 0 00-1.87-.25c-.45.05-.91.2-1.3.52s-.67.77-.82 1.36a.5.5 0 00.43.62c2.6.28 3.92 1.7 4.56 2.72.48.78 1.4 1.41 2.43 1.23l1.52-.26a2.5 2.5 0 001.92-1.6l.98-2.67a2.5 2.5 0 00-1.91-3.33L11 9.58V7.5c0-.83-.67-1.5-1.5-1.5zM9 7.5a.5.5 0 011 0V10c0 .24.17.45.41.5l3.35.58a1.5 1.5 0 011.15 2l-.98 2.67c-.19.5-.62.86-1.15.95l-1.52.27c-.5.09-1.07-.23-1.41-.77a6.77 6.77 0 00-4.65-3.1c.08-.13.17-.23.26-.3.2-.17.47-.27.78-.3.64-.07 1.42.14 2.04.45A.5.5 0 009 12.5v-5z",
    fill: primaryFill
  }));
};

export const TapDoubleRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/TapDoubleRegularIcon({}), 'TapDoubleRegular');

const TapSingleFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M6 8.5a3.5 3.5 0 117 .16l.99.17.01-.33a4.5 4.5 0 10-8.62 1.82 4.2 4.2 0 011.05-.13A3.48 3.48 0 016 8.5zM9.5 6C8.67 6 8 6.67 8 7.5v4.25a4.46 4.46 0 00-1.87-.25c-.45.05-.91.2-1.3.52s-.67.77-.82 1.36a.5.5 0 00.43.62c2.6.28 3.92 1.7 4.56 2.72.48.78 1.4 1.41 2.43 1.23l1.52-.26a2.5 2.5 0 001.92-1.6l.98-2.67a2.5 2.5 0 00-1.91-3.33L11 9.58V7.5c0-.83-.67-1.5-1.5-1.5z",
    fill: primaryFill
  }));
};

export const TapSingleFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/TapSingleFilledIcon({}), 'TapSingleFilled');

const TapSingleRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M6 8.5a3.5 3.5 0 117 .16l.99.17.01-.33a4.5 4.5 0 10-8.62 1.82 4.2 4.2 0 011.05-.13A3.48 3.48 0 016 8.5zM9.5 6C8.67 6 8 6.67 8 7.5v4.25a4.46 4.46 0 00-1.87-.25c-.45.05-.91.2-1.3.52s-.67.77-.82 1.36a.5.5 0 00.43.62c2.6.28 3.92 1.7 4.56 2.72.48.78 1.4 1.41 2.43 1.23l1.52-.26a2.5 2.5 0 001.92-1.6l.98-2.67a2.5 2.5 0 00-1.91-3.33L11 9.58V7.5c0-.83-.67-1.5-1.5-1.5zM9 7.5a.5.5 0 011 0V10c0 .24.17.45.41.5l3.35.58a1.5 1.5 0 011.15 2l-.98 2.67c-.19.5-.62.86-1.15.95l-1.52.27c-.5.09-1.07-.23-1.41-.77a6.77 6.77 0 00-4.65-3.1c.08-.13.17-.23.26-.3.2-.17.47-.27.78-.3.64-.07 1.42.14 2.04.45A.5.5 0 009 12.5v-5z",
    fill: primaryFill
  }));
};

export const TapSingleRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/TapSingleRegularIcon({}), 'TapSingleRegular');

const TargetFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M10 11.5a1.5 1.5 0 100-3 1.5 1.5 0 000 3zM5 10a5 5 0 1110 0 5 5 0 01-10 0zm5-3.5a3.5 3.5 0 100 7 3.5 3.5 0 000-7zM2 10a8 8 0 1116 0 8 8 0 01-16 0zm8-6.5a6.5 6.5 0 100 13 6.5 6.5 0 000-13z",
    fill: primaryFill
  }));
};

export const TargetFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/TargetFilledIcon({}), 'TargetFilled');

const TargetRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M10 11.5a1.5 1.5 0 100-3 1.5 1.5 0 000 3zM5 10a5 5 0 1110 0 5 5 0 01-10 0zm5-4a4 4 0 100 8 4 4 0 000-8zm-8 4a8 8 0 1116 0 8 8 0 01-16 0zm8-7a7 7 0 100 14 7 7 0 000-14z",
    fill: primaryFill
  }));
};

export const TargetRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/TargetRegularIcon({}), 'TargetRegular');

const TargetArrowFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M17.6 7.52a8 8 0 11-5.11-5.13l-1.05 1.05a1.5 1.5 0 00-.16.19 6.5 6.5 0 105.09 5.1l.2-.17 1.03-1.04zM14.9 9a5.02 5.02 0 01-4.9 6 5 5 0 111-9.9v1.55A3.5 3.5 0 1013.35 9h1.55zM10 11.5a1.5 1.5 0 001.45-1.89l1.58-1.58a.74.74 0 00.03-.03h2.44a.5.5 0 00.35-.15l2-2A.5.5 0 0017.5 5H15V2.5a.5.5 0 00-.85-.35l-2 2a.5.5 0 00-.15.35v2.44a.76.76 0 00-.03.03l-1.58 1.58a1.5 1.5 0 10-.4 2.95z",
    fill: primaryFill
  }));
};

export const TargetArrowFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/TargetArrowFilledIcon({}), 'TargetArrowFilled');

const TargetArrowRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M17.96 5.3a.5.5 0 01-.1.55l-2 2a.5.5 0 01-.36.15h-2.8l-1.35 1.35a1.5 1.5 0 11-.7-.7L12 7.29V4.5a.5.5 0 01.15-.35l2-2a.5.5 0 01.85.35V5h2.5c.2 0 .38.12.46.3zM16.3 6H14.5a.5.5 0 01-.5-.5V3.7l-1 1V7h2.3l1-1zm1.32 1.52a8 8 0 11-5.12-5.13l-.81.81A7.02 7.02 0 003 10a7 7 0 1013.8-1.68l.8-.8zM14.9 9a5.02 5.02 0 01-4.9 6 5 5 0 111-9.9v1.03A4 4 0 1013.87 9h1.03z",
    fill: primaryFill
  }));
};

export const TargetArrowRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/TargetArrowRegularIcon({}), 'TargetArrowRegular');

const TargetEditFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M10 11.5a1.5 1.5 0 100-3 1.5 1.5 0 000 3zM5 10a5 5 0 0110-.05l-2.42 2.4a3.5 3.5 0 10-.23.23l-2.08 2.09c-.1.1-.2.21-.28.33A5 5 0 015 10zm5-6.5c3.28 0 5.99 2.43 6.43 5.59.5-.13 1.02-.12 1.52.03A8 8 0 109 17.93c0-.09.02-.18.05-.28l.3-1.19A6.5 6.5 0 0110 3.5zm.98 11.88l4.83-4.83a1.87 1.87 0 112.64 2.64l-4.83 4.83a2.2 2.2 0 01-1.02.58l-1.5.37a.89.89 0 01-1.07-1.08l.37-1.5c.1-.38.3-.73.58-1.01z",
    fill: primaryFill
  }));
};

export const TargetEditFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/TargetEditFilledIcon({}), 'TargetEditFilled');

const TargetEditRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M10 11.5a1.5 1.5 0 100-3 1.5 1.5 0 000 3zM5 10a5 5 0 0110-.06l-1.15 1.15a4 4 0 10-2.76 2.76l-.82.82c-.1.1-.2.21-.29.33A5 5 0 015 10zm5-7a7 7 0 016.93 6c.34-.02.69.02 1.02.12a8 8 0 10-8.94 8.82c0-.1.02-.2.05-.29l.17-.7A7 7 0 0110 3zm.98 12.38l4.83-4.83a1.87 1.87 0 012.64 2.64l-4.83 4.83a2.2 2.2 0 01-1.02.58l-1.5.37a.89.89 0 01-1.07-1.08l.37-1.5c.1-.38.3-.73.58-1.01z",
    fill: primaryFill
  }));
};

export const TargetEditRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/TargetEditRegularIcon({}), 'TargetEditRegular');

const TaskListAddFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M5.85 3.35a.5.5 0 10-.7-.7L3.5 4.29l-.65-.64a.5.5 0 10-.7.7l1 1c.2.2.5.2.7 0l2-2zm2.9.15a.75.75 0 000 1.5h8.5a.75.75 0 000-1.5h-8.5zm0 5a.75.75 0 000 1.5h8.5a.75.75 0 000-1.5h-8.5zm1.27 6.5c.05-.52.17-1.03.35-1.5H8.75a.75.75 0 000 1.5h1.27zM5.85 8.85a.5.5 0 10-.7-.7L3.5 9.79l-.65-.64a.5.5 0 10-.7.7l1 1c.2.2.5.2.7 0l2-2zm0 4.3c.2.2.2.5 0 .7l-2 2a.5.5 0 01-.7 0l-1-1a.5.5 0 01.7-.7l.65.64 1.65-1.64c.2-.2.5-.2.7 0zM20 15.5a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0zm-4-2a.5.5 0 00-1 0V15h-1.5a.5.5 0 000 1H15v1.5a.5.5 0 001 0V16h1.5a.5.5 0 000-1H16v-1.5z",
    fill: primaryFill
  }));
};

export const TaskListAddFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/TaskListAddFilledIcon({}), 'TaskListAddFilled');

const TaskListAddRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M5.85 3.35a.5.5 0 10-.7-.7L3.5 4.29l-.65-.64a.5.5 0 10-.7.7l1 1c.2.2.5.2.7 0l2-2zM8.5 4a.5.5 0 000 1h9a.5.5 0 000-1h-9zm0 5a.5.5 0 000 1h9a.5.5 0 000-1h-9zm1.52 6c.03-.34.1-.68.19-1H8.5a.5.5 0 000 1h1.52zM5.85 8.85a.5.5 0 10-.7-.7L3.5 9.79l-.65-.64a.5.5 0 10-.7.7l1 1c.2.2.5.2.7 0l2-2zm0 4.3c.2.2.2.5 0 .7l-2 2a.5.5 0 01-.7 0l-1-1a.5.5 0 01.7-.7l.65.64 1.65-1.64c.2-.2.5-.2.7 0zM20 15.5a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0zm-4-2a.5.5 0 00-1 0V15h-1.5a.5.5 0 000 1H15v1.5a.5.5 0 001 0V16h1.5a.5.5 0 000-1H16v-1.5z",
    fill: primaryFill
  }));
};

export const TaskListAddRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/TaskListAddRegularIcon({}), 'TaskListAddRegular');

const TaskListLtrFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M5.85 4.35a.5.5 0 10-.7-.7L3.5 5.29l-.65-.64a.5.5 0 10-.7.7l1 1c.2.2.5.2.7 0l2-2zm2.9.15a.75.75 0 000 1.5h8.5a.75.75 0 000-1.5h-8.5zm0 5a.75.75 0 000 1.5h8.5a.75.75 0 000-1.5h-8.5zM8 15.25c0-.41.34-.75.75-.75h8.5a.75.75 0 010 1.5h-8.5a.75.75 0 01-.75-.75zm-2.15-5.4a.5.5 0 10-.7-.7L3.5 10.79l-.65-.64a.5.5 0 00-.7.7l1 1c.2.2.5.2.7 0l2-2zm0 4.3c.2.2.2.5 0 .7l-2 2a.5.5 0 01-.7 0l-1-1a.5.5 0 01.7-.7l.65.64 1.65-1.64c.2-.2.5-.2.7 0z",
    fill: primaryFill
  }));
};

export const TaskListLtrFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/TaskListLtrFilledIcon({}), 'TaskListLtrFilled');

const TaskListLtrRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M5.85 4.35a.5.5 0 10-.7-.7L3.5 5.29l-.65-.64a.5.5 0 10-.7.7l1 1c.2.2.5.2.7 0l2-2zM8.5 5a.5.5 0 000 1h9a.5.5 0 000-1h-9zm0 5a.5.5 0 000 1h9a.5.5 0 000-1h-9zM8 15.5c0-.28.22-.5.5-.5h9a.5.5 0 010 1h-9a.5.5 0 01-.5-.5zM5.85 9.85a.5.5 0 10-.7-.7L3.5 10.79l-.65-.64a.5.5 0 00-.7.7l1 1c.2.2.5.2.7 0l2-2zm0 4.3c.2.2.2.5 0 .7l-2 2a.5.5 0 01-.7 0l-1-1a.5.5 0 01.7-.7l.65.64 1.65-1.64c.2-.2.5-.2.7 0z",
    fill: primaryFill
  }));
};

export const TaskListLtrRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/TaskListLtrRegularIcon({}), 'TaskListLtrRegular');

const TaskListRtlFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M17.85 4.35a.5.5 0 00-.7-.7L15.5 5.29l-.65-.64a.5.5 0 00-.7.7l1 1c.2.2.5.2.7 0l2-2zm-15.1.15a.75.75 0 000 1.5h8.5a.75.75 0 000-1.5h-8.5zm0 5a.75.75 0 000 1.5h8.5a.75.75 0 000-1.5h-8.5zM2 15.25c0-.41.34-.75.75-.75h8.5a.75.75 0 010 1.5h-8.5a.75.75 0 01-.75-.75zm13.85-3.4l2-2a.5.5 0 00-.7-.7l-1.65 1.64-.65-.64a.5.5 0 00-.7.7l1 1c.2.2.5.2.7 0zm2 3l-2 2a.5.5 0 01-.7 0l-1-1a.5.5 0 01.7-.7l.65.64 1.65-1.64a.5.5 0 01.7.7z",
    fill: primaryFill
  }));
};

export const TaskListRtlFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/TaskListRtlFilledIcon({}), 'TaskListRtlFilled');

const TaskListRtlRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M17.85 4.35a.5.5 0 00-.7-.7L15.5 5.29l-.65-.64a.5.5 0 00-.7.7l1 1c.2.2.5.2.7 0l2-2zM2.5 5a.5.5 0 000 1h9a.5.5 0 000-1h-9zm0 5a.5.5 0 000 1h9a.5.5 0 000-1h-9zM2 15.5c0-.28.22-.5.5-.5h9a.5.5 0 010 1h-9a.5.5 0 01-.5-.5zm15.85-5.65a.5.5 0 00-.7-.7l-1.65 1.64-.65-.64a.5.5 0 00-.7.7l1 1c.2.2.5.2.7 0l2-2zm0 4.3c.2.2.2.5 0 .7l-2 2a.5.5 0 01-.7 0l-1-1a.5.5 0 01.7-.7l.65.64 1.65-1.64c.2-.2.5-.2.7 0z",
    fill: primaryFill
  }));
};

export const TaskListRtlRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/TaskListRtlRegularIcon({}), 'TaskListRtlRegular');

const TaskListSquareAddFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M3 6a3 3 0 013-3h8a3 3 0 013 3v3.6A5.5 5.5 0 009.6 17H6a3 3 0 01-3-3V6zm6.35.4a.5.5 0 00-.7 0L7.23 7.8l-.4-.35a.5.5 0 00-.67.73l.75.69c.2.18.5.17.7-.02L9.34 7.1a.5.5 0 000-.7zm0 5.7a.5.5 0 00-.7-.7l-1.42 1.4-.4-.35a.5.5 0 00-.67.73l.75.69c.2.18.5.17.7-.02l1.74-1.75zM11 7a.5.5 0 000 1h2.5a.5.5 0 000-1H11zm8 7.5a4.5 4.5 0 10-9 0 4.5 4.5 0 009 0zm-4-2V14h1.5a.5.5 0 010 1H15v1.5a.5.5 0 01-1 0V15h-1.5a.5.5 0 010-1H14v-1.5a.5.5 0 011 0z",
    fill: primaryFill
  }));
};

export const TaskListSquareAddFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/TaskListSquareAddFilledIcon({}), 'TaskListSquareAddFilled');

const TaskListSquareAddRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M6 3a3 3 0 00-3 3v8a3 3 0 003 3h3.6c-.16-.32-.3-.65-.4-1H6a2 2 0 01-2-2V6c0-1.1.9-2 2-2h8a2 2 0 012 2v3.2c.35.1.68.24 1 .4V6a3 3 0 00-3-3H6zm3.35 4.1a.5.5 0 00-.7-.7L7.23 7.8l-.4-.35a.5.5 0 00-.67.73l.75.69c.2.18.5.17.7-.02L9.34 7.1zm0 4.3c.2.2.2.5 0 .7L7.6 13.85a.5.5 0 01-.69.02l-.75-.69a.5.5 0 01.68-.73l.4.36 1.4-1.41c.2-.2.52-.2.71 0zm1.15-3.9c0-.28.22-.5.5-.5h2.5a.5.5 0 010 1H11a.5.5 0 01-.5-.5zm8.5 7a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0zm-4-2a.5.5 0 00-1 0V14h-1.5a.5.5 0 000 1H14v1.5a.5.5 0 001 0V15h1.5a.5.5 0 000-1H15v-1.5z",
    fill: primaryFill
  }));
};

export const TaskListSquareAddRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/TaskListSquareAddRegularIcon({}), 'TaskListSquareAddRegular');

const TaskListSquareDatabaseFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M6 3a3 3 0 00-3 3v8a3 3 0 003 3h3.05a2.46 2.46 0 01-.05-.5v-4.04l-1.4 1.4a.5.5 0 01-.69 0l-.75-.68a.5.5 0 01.68-.73l.4.36 1.4-1.41a.5.5 0 01.36-.15v-.75c0-1.22.88-2.11 1.83-2.64A7.68 7.68 0 0114.5 7c.89 0 1.74.13 2.5.36V6a3 3 0 00-3-3H6zm11 5.42A7.25 7.25 0 0014.5 8C12.01 8 10 9.12 10 10.5s2.02 2.5 4.5 2.5c2.49 0 4.5-1.12 4.5-2.5 0-.87-.8-1.63-2-2.08zM9.35 6.4c.2.2.2.5 0 .7L7.6 8.85a.5.5 0 01-.69.02l-.75-.69a.5.5 0 11.68-.73l.4.36 1.4-1.41c.2-.2.52-.2.71 0zM14.5 14c1.38 0 2.68-.3 3.67-.86.29-.16.58-.36.83-.59v3.95c0 1.38-2.01 2.5-4.5 2.5S10 17.88 10 16.5v-3.95c.25.23.54.43.83.6 1 .54 2.29.85 3.67.85z",
    fill: primaryFill
  }));
};

export const TaskListSquareDatabaseFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/TaskListSquareDatabaseFilledIcon({}), 'TaskListSquareDatabaseFilled');

const TaskListSquareDatabaseRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M6 3a3 3 0 00-3 3v8a3 3 0 003 3h3.05a2.46 2.46 0 01-.05-.5V16H6a2 2 0 01-2-2V6c0-1.1.9-2 2-2h8a2 2 0 012 2v1.13c.35.06.68.14 1 .23V6a3 3 0 00-3-3H6zm11 5.42A7.81 7.81 0 0014.5 8C12.01 8 10 9.12 10 10.5s2.01 2.5 4.5 2.5 4.5-1.12 4.5-2.5c0-.87-.8-1.63-2-2.08zm-8 2.83a.5.5 0 00-.35.15l-1.42 1.4-.4-.35a.5.5 0 00-.67.73l.75.69c.2.18.5.17.7-.02L9 12.45v-1.2zm.35-4.15a.5.5 0 00-.7-.7L7.23 7.8l-.4-.35a.5.5 0 00-.67.73l.75.69c.2.18.5.17.7-.02L9.34 7.1zM14.5 14c1.38 0 2.68-.3 3.67-.86.29-.16.58-.36.83-.59v3.95c0 1.38-2.01 2.5-4.5 2.5S10 17.88 10 16.5v-3.95c.25.23.54.43.83.6 1 .54 2.29.85 3.67.85z",
    fill: primaryFill
  }));
};

export const TaskListSquareDatabaseRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/TaskListSquareDatabaseRegularIcon({}), 'TaskListSquareDatabaseRegular');

const TaskListSquareLtrFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M3 6a3 3 0 013-3h8a3 3 0 013 3v8a3 3 0 01-3 3H6a3 3 0 01-3-3V6zm6.35 1.1a.5.5 0 00-.7-.7L7.23 7.8l-.4-.35a.5.5 0 00-.67.73l.75.69c.2.18.5.17.7-.02L9.34 7.1zm0 4.3a.5.5 0 00-.7 0l-1.42 1.4-.4-.35a.5.5 0 00-.67.73l.75.69c.2.18.5.17.7-.02l1.74-1.75a.5.5 0 000-.7zM11 12a.5.5 0 000 1h2.5a.5.5 0 000-1H11zm-.5-4.5c0 .28.22.5.5.5h2.5a.5.5 0 000-1H11a.5.5 0 00-.5.5z",
    fill: primaryFill
  }));
};

export const TaskListSquareLtrFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/TaskListSquareLtrFilledIcon({}), 'TaskListSquareLtrFilled');

const TaskListSquareLtrRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M9.35 7.1a.5.5 0 00-.7-.7L7.23 7.8l-.4-.35a.5.5 0 00-.67.73l.75.69c.2.18.5.17.7-.02L9.34 7.1zm0 4.3c.2.2.2.5 0 .7L7.6 13.85a.5.5 0 01-.69.02l-.75-.69a.5.5 0 01.68-.73l.4.36 1.4-1.41c.2-.2.52-.2.71 0zM11 12a.5.5 0 000 1h2.5a.5.5 0 000-1H11zm-.5-4.5c0-.28.22-.5.5-.5h2.5a.5.5 0 010 1H11a.5.5 0 01-.5-.5zM6 3a3 3 0 00-3 3v8a3 3 0 003 3h8a3 3 0 003-3V6a3 3 0 00-3-3H6zM4 6c0-1.1.9-2 2-2h8a2 2 0 012 2v8a2 2 0 01-2 2H6a2 2 0 01-2-2V6z",
    fill: primaryFill
  }));
};

export const TaskListSquareLtrRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/TaskListSquareLtrRegularIcon({}), 'TaskListSquareLtrRegular');

const TaskListSquarePersonFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M3 6a3 3 0 013-3h8a3 3 0 013 3v3.4a3 3 0 00-4.5 2.6H11a.5.5 0 000 1h1.67a3 3 0 00.6 1.01A2.5 2.5 0 0011.04 17H6a3 3 0 01-3-3V6zm6.35 1.1a.5.5 0 00-.7-.7L7.23 7.8l-.4-.35a.5.5 0 00-.67.73l.75.69c.2.18.5.17.7-.02L9.34 7.1zm0 4.3a.5.5 0 00-.7 0l-1.42 1.4-.4-.35a.5.5 0 00-.67.73l.75.69c.2.18.5.17.7-.02l1.74-1.75a.5.5 0 000-.7zm1.15-3.9c0 .28.22.5.5.5h2.5a.5.5 0 000-1H11a.5.5 0 00-.5.5zm7 4.5a2 2 0 11-4 0 2 2 0 014 0zm1.5 4.5c0 1.25-1 2.5-3.5 2.5S12 17.75 12 16.5c0-.83.67-1.5 1.5-1.5h4c.83 0 1.5.67 1.5 1.5z",
    fill: primaryFill
  }));
};

export const TaskListSquarePersonFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/TaskListSquarePersonFilledIcon({}), 'TaskListSquarePersonFilled');

const TaskListSquarePersonRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M9.35 7.1a.5.5 0 00-.7-.7L7.23 7.8l-.4-.35a.5.5 0 00-.67.73l.75.69c.2.18.5.17.7-.02L9.34 7.1zm0 4.3c.2.2.2.5 0 .7L7.6 13.85a.5.5 0 01-.69.02l-.75-.69a.5.5 0 01.68-.73l.4.36 1.4-1.41c.2-.2.52-.2.71 0zM11 12a.5.5 0 000 1h1.67a3 3 0 01-.17-1H11zm-5 4h5.05a2.51 2.51 0 00-.01 1H6a3 3 0 01-3-3V6a3 3 0 013-3h8a3 3 0 013 3v3.4c-.3-.17-.64-.3-1-.36V6a2 2 0 00-2-2H6a2 2 0 00-2 2v8c0 1.1.9 2 2 2zm4.5-8.5c0-.28.22-.5.5-.5h2.5a.5.5 0 010 1H11a.5.5 0 01-.5-.5zm7 4.5a2 2 0 11-4 0 2 2 0 014 0zm1.5 4.5c0 1.25-1 2.5-3.5 2.5S12 17.75 12 16.5c0-.83.67-1.5 1.5-1.5h4c.83 0 1.5.67 1.5 1.5z",
    fill: primaryFill
  }));
};

export const TaskListSquarePersonRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/TaskListSquarePersonRegularIcon({}), 'TaskListSquarePersonRegular');

const TaskListSquareRtlFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M3 6a3 3 0 013-3h8a3 3 0 013 3v8a3 3 0 01-3 3H6a3 3 0 01-3-3V6zm11.35 1.1a.5.5 0 10-.7-.7l-1.42 1.4-.4-.35a.5.5 0 00-.67.73l.75.69c.2.18.5.17.7-.02l1.74-1.75zm0 4.3a.5.5 0 00-.7 0l-1.42 1.4-.4-.35a.5.5 0 00-.67.73l.75.69c.2.18.5.17.7-.02l1.74-1.75a.5.5 0 000-.7zM6.5 12a.5.5 0 000 1H9a.5.5 0 000-1H6.5zM6 7.5c0 .28.22.5.5.5H9a.5.5 0 000-1H6.5a.5.5 0 00-.5.5z",
    fill: primaryFill
  }));
};

export const TaskListSquareRtlFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/TaskListSquareRtlFilledIcon({}), 'TaskListSquareRtlFilled');

const TaskListSquareRtlRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M14.35 7.1a.5.5 0 10-.7-.7l-1.42 1.4-.4-.35a.5.5 0 00-.67.73l.75.69c.2.18.5.17.7-.02l1.74-1.75zm0 4.3c.2.2.2.5 0 .7l-1.75 1.75a.5.5 0 01-.69.02l-.75-.69a.5.5 0 01.68-.73l.4.36 1.4-1.41c.2-.2.52-.2.71 0zM6.5 12a.5.5 0 000 1H9a.5.5 0 000-1H6.5zM6 7.5c0-.28.22-.5.5-.5H9a.5.5 0 010 1H6.5a.5.5 0 01-.5-.5zM6 3a3 3 0 00-3 3v8a3 3 0 003 3h8a3 3 0 003-3V6a3 3 0 00-3-3H6zM4 6c0-1.1.9-2 2-2h8a2 2 0 012 2v8a2 2 0 01-2 2H6a2 2 0 01-2-2V6z",
    fill: primaryFill
  }));
};

export const TaskListSquareRtlRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/TaskListSquareRtlRegularIcon({}), 'TaskListSquareRtlRegular');

const TaskListSquareSettingsFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M6 3a3 3 0 00-3 3v8a3 3 0 003 3h3.6A5.5 5.5 0 0117 9.6V6a3 3 0 00-3-3H6zm3.35 3.4c.2.2.2.5 0 .7L7.6 8.85a.5.5 0 01-.69.02l-.75-.69a.5.5 0 11.68-.73l.4.36 1.4-1.41c.2-.2.52-.2.71 0zm-.7 5a.5.5 0 01.7.7L7.6 13.85a.5.5 0 01-.69.02l-.75-.69a.5.5 0 01.68-.73l.4.36 1.4-1.41zM11 8a.5.5 0 010-1h2.5a.5.5 0 010 1H11zm-.37 5.92a2 2 0 001.43-2.48l-.15-.56c.25-.2.53-.36.82-.5l.34.36a2 2 0 002.9 0l.33-.34c.3.14.58.31.83.52l-.12.42a2 2 0 001.45 2.52l.35.08a4.6 4.6 0 01.01 1.02l-.46.12a2 2 0 00-1.43 2.47l.16.56c-.26.2-.53.36-.82.5l-.34-.36a2 2 0 00-2.91 0l-.32.35c-.3-.14-.58-.31-.84-.52l.13-.42a2 2 0 00-1.46-2.52l-.34-.08a4.62 4.62 0 01-.01-1.02l.45-.12zm4.87.58a1 1 0 10-2 0 1 1 0 002 0z",
    fill: primaryFill
  }));
};

export const TaskListSquareSettingsFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/TaskListSquareSettingsFilledIcon({}), 'TaskListSquareSettingsFilled');

const TaskListSquareSettingsRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M9.35 6.4c.2.2.2.5 0 .7L7.6 8.85a.5.5 0 01-.69.02l-.75-.69a.5.5 0 11.68-.73l.4.36 1.4-1.41c.2-.2.52-.2.71 0zm0 5.7a.5.5 0 00-.7-.7l-1.42 1.4-.4-.35a.5.5 0 00-.67.73l.75.69c.2.18.5.17.7-.02l1.74-1.75zM11 7a.5.5 0 000 1h2.5a.5.5 0 000-1H11zM3 6a3 3 0 013-3h8a3 3 0 013 3v3.6a5.5 5.5 0 00-1-.4V6a2 2 0 00-2-2H6a2 2 0 00-2 2v8c0 1.1.9 2 2 2h3.2c.1.35.24.68.4 1H6a3 3 0 01-3-3V6zm7.63 7.92a2 2 0 001.43-2.48l-.15-.56c.25-.2.53-.36.82-.5l.34.36a2 2 0 002.9 0l.33-.34c.3.14.58.31.83.52l-.12.42a2 2 0 001.45 2.52l.35.08a4.6 4.6 0 01.01 1.02l-.46.12a2 2 0 00-1.43 2.47l.16.56c-.26.2-.53.36-.82.5l-.34-.36a2 2 0 00-2.91 0l-.32.35c-.3-.14-.58-.31-.84-.52l.13-.42a2 2 0 00-1.46-2.52l-.34-.08a4.62 4.62 0 01-.01-1.02l.45-.12zm4.87.58a1 1 0 10-2 0 1 1 0 002 0z",
    fill: primaryFill
  }));
};

export const TaskListSquareSettingsRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/TaskListSquareSettingsRegularIcon({}), 'TaskListSquareSettingsRegular');

const TasksAppFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M4 4c0-1.1.9-2 2-2h8a2 2 0 012 2v9.88l-2.5 2.52-.93-.95a1.5 1.5 0 10-2.14 2.1l.44.45H6a2 2 0 01-2-2V4zm5 5.5c0 .28.22.5.5.5h4a.5.5 0 000-1h-4a.5.5 0 00-.5.5zM9.5 5a.5.5 0 000 1h4a.5.5 0 000-1h-4zM9 13.5c0 .28.22.5.5.5h4a.5.5 0 000-1h-4a.5.5 0 00-.5.5zm-2-3a1 1 0 100-2 1 1 0 000 2zm1-5a1 1 0 10-2 0 1 1 0 002 0zm-1 9a1 1 0 100-2 1 1 0 000 2zm10.86.35a.5.5 0 00-.72-.7l-3.64 3.68-1.64-1.68a.5.5 0 10-.72.7l1.93 1.97a.6.6 0 00.86 0l3.93-3.97z",
    fill: primaryFill
  }));
};

export const TasksAppFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/TasksAppFilledIcon({}), 'TasksAppFilled');

const TasksAppRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M4 4c0-1.1.9-2 2-2h8a2 2 0 012 2v9.88l-1 1.01V4a1 1 0 00-1-1H6a1 1 0 00-1 1v12a1 1 0 001 1h4.09c.07.2.18.39.34.55l.44.45H6a2 2 0 01-2-2V4zm4 1.5a1 1 0 11-2 0 1 1 0 012 0zM9.5 5a.5.5 0 000 1h4a.5.5 0 000-1h-4zm0 4a.5.5 0 000 1h4a.5.5 0 000-1h-4zM9 13.5c0-.28.22-.5.5-.5h4a.5.5 0 010 1h-4a.5.5 0 01-.5-.5zm-2-3a1 1 0 100-2 1 1 0 000 2zm0 4a1 1 0 100-2 1 1 0 000 2zm10.86.35a.5.5 0 00-.72-.7l-3.64 3.68-1.64-1.68a.5.5 0 10-.72.7l1.93 1.97a.6.6 0 00.86 0l3.93-3.97z",
    fill: primaryFill
  }));
};

export const TasksAppRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/TasksAppRegularIcon({}), 'TasksAppRegular');

const TeddyFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M5.5 3a3.5 3.5 0 00-2.85 5.53 7.92 7.92 0 015.5-4.32A3.5 3.5 0 005.5 3zM18 6.5c0 .76-.24 1.46-.65 2.03a7.92 7.92 0 00-5.5-4.32A3.5 3.5 0 0118 6.5zm-15 5C3 7.87 6.17 5 10 5s7 2.87 7 6.5a6.2 6.2 0 01-1.76 4.31 5.5 5.5 0 00-10.48 0A6.2 6.2 0 013 11.5zm8.33 1.7a4.5 4.5 0 013.07 3.35A7.33 7.33 0 0110 18c-1.66 0-3.2-.54-4.4-1.45a4.5 4.5 0 013.07-3.35 1.5 1.5 0 002.66 0z",
    fill: primaryFill
  }));
};

export const TeddyFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/TeddyFilledIcon({}), 'TeddyFilled');

const TeddyRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M2 6.5a3.5 3.5 0 001.4 2.8c-.26.69-.4 1.43-.4 2.2 0 3.63 3.17 6.5 7 6.5s7-2.87 7-6.5c0-.77-.14-1.51-.4-2.2a3.5 3.5 0 10-5.31-4.19 7.54 7.54 0 00-2.58 0A3.5 3.5 0 002 6.5zM5.5 4c.97 0 1.8.55 2.22 1.35a6.92 6.92 0 00-3.87 3.03A2.5 2.5 0 015.5 4zm6.78 1.35a2.5 2.5 0 113.87 3.03 6.92 6.92 0 00-3.87-3.03zM10 6c3.35 0 6 2.5 6 5.5a5.2 5.2 0 01-1.2 3.3 5.5 5.5 0 00-9.6 0A5.2 5.2 0 014 11.5C4 8.5 6.65 6 10 6zm4.06 9.55A6.27 6.27 0 0110 17c-1.57 0-3-.55-4.06-1.45a4.51 4.51 0 012.73-2.35 1.5 1.5 0 002.66 0c1.2.37 2.19 1.23 2.73 2.35z",
    fill: primaryFill
  }));
};

export const TeddyRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/TeddyRegularIcon({}), 'TeddyRegular');

const TemperatureFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M10.75 7.25a.75.75 0 00-1.5 0v4.9a2 2 0 101.5 0v-4.9zM6.5 5.5a3.5 3.5 0 017 0v5.67A4.48 4.48 0 0110 18.5a4.5 4.5 0 01-3.5-7.33V5.5zm1.5 0v6.24l-.2.22a3 3 0 104.4 0l-.2-.22V5.5a2 2 0 00-4 0z",
    fill: primaryFill
  }));
};

export const TemperatureFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/TemperatureFilledIcon({}), 'TemperatureFilled');

const TemperatureRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M10 6.5c.28 0 .5.22.5.5v5.06a2 2 0 11-1 0V7c0-.28.22-.5.5-.5zM10 2a3 3 0 00-3 3v6.35A3.99 3.99 0 0010 18a4 4 0 003-6.65V5a3 3 0 00-3-3zm0 1a2 2 0 012 2v6.75l.14.15a3 3 0 11-4.29 0l.15-.15V5c0-1.1.9-2 2-2z",
    fill: primaryFill
  }));
};

export const TemperatureRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/TemperatureRegularIcon({}), 'TemperatureRegular');

const TentFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M10.4 2.82a.5.5 0 00-.77 0 20.89 20.89 0 01-4.91 3.9.5.5 0 00-.25.36L3.37 15H2.5a.5.5 0 000 1h3.94a.5.5 0 00.1.01h6.9a.5.5 0 00.1-.01h3.96a.5.5 0 000-1h-.84l-1.1-7.92a.5.5 0 00-.24-.36 20.89 20.89 0 01-4.92-3.9zM7.51 15c.84-1.22 1.7-2.79 2.49-5.26.7 2.23 1.5 3.78 2.49 5.26H7.5z",
    fill: primaryFill
  }));
};

export const TentFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/TentFilledIcon({}), 'TentFilled');

const TentRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M10.4 2.82a.5.5 0 00-.77 0 20.89 20.89 0 01-4.91 3.9.5.5 0 00-.25.36L3.37 15H2.5a.5.5 0 000 1h3.94a.5.5 0 00.1.01h6.9a.5.5 0 00.1-.01h3.96a.5.5 0 000-1h-.84l-1.1-7.92a.5.5 0 00-.24-.36 20.89 20.89 0 01-4.92-3.9zM13.7 15a19.92 19.92 0 01-3.22-7.2.5.5 0 00-.97 0c-.98 3.84-2.14 5.75-3.22 7.2H4.4l1.03-7.54c1.3-.76 3.3-2.2 4.6-3.57a23.15 23.15 0 004.6 3.57L15.64 15h-1.96zm-1.22 0H7.52c.84-1.22 1.7-2.78 2.48-5.25.7 2.23 1.49 3.77 2.48 5.25z",
    fill: primaryFill
  }));
};

export const TentRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/TentRegularIcon({}), 'TentRegular');

const TetrisAppFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M7 2.75c0-.41.34-.75.75-.75H11v4H7V2.75zM2.75 7a.75.75 0 00-.75.75v2.5c0 .41.34.75.75.75H6V7H2.75zM11 7H7v4h3.25c.41 0 .75-.34.75-.75V7zm4.25-5H12v4h3.25c.41 0 .75-.34.75-.75v-2.5a.75.75 0 00-.75-.75zM4 14.75c0-.41.34-.75.75-.75H8v4H4.75a.75.75 0 01-.75-.75v-2.5zM13 18v-4H9v4h4zm5-4v3.25c0 .41-.34.75-.75.75H14v-4h4zm-3.25-5a.75.75 0 00-.75.75V13h4V9.75a.75.75 0 00-.75-.75h-2.5z",
    fill: primaryFill
  }));
};

export const TetrisAppFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/TetrisAppFilledIcon({}), 'TetrisAppFilled');

const TetrisAppRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M7.25 2C6.56 2 6 2.56 6 3.25v2.5c0 .14-.11.25-.25.25h-2.5C2.56 6 2 6.56 2 7.25v2.5c0 .69.56 1.25 1.25 1.25h6.5c.69 0 1.25-.56 1.25-1.25v-2.5c0-.14.11-.25.25-.25h2.5C14.44 7 15 6.44 15 5.75v-2.5C15 2.56 14.44 2 13.75 2h-6.5zm6.5 4H11V3h2.75c.14 0 .25.11.25.25v2.5c0 .14-.11.25-.25.25zm-3.72 1c-.02.08-.03.16-.03.25v2.5c0 .14-.11.25-.25.25H7V7h3.03zM6 7v3H3.25A.25.25 0 013 9.75v-2.5c0-.14.11-.25.25-.25H6zm.97-1C7 5.92 7 5.84 7 5.75v-2.5c0-.14.11-.25.25-.25H10v3H6.97zm7.28 3c-.69 0-1.25.56-1.25 1.25v2.5c0 .14-.11.25-.25.25h-6.5C5.56 13 5 13.56 5 14.25v2.5c0 .69.56 1.25 1.25 1.25h10.5c.69 0 1.25-.56 1.25-1.25v-6.5C18 9.56 17.44 9 16.75 9h-2.5zm-.28 4c.02-.08.03-.16.03-.25v-2.5c0-.14.11-.25.25-.25h2.5c.14 0 .25.11.25.25V13h-3.03zm.03 1h3v2.75c0 .14-.11.25-.25.25H14v-3zm-1 0v3h-3v-3h3zm-4 0v3H6.25a.25.25 0 01-.25-.25v-2.5c0-.14.11-.25.25-.25H9z",
    fill: primaryFill
  }));
};

export const TetrisAppRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/TetrisAppRegularIcon({}), 'TetrisAppRegular');

const TextAddSpaceAfterFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M3 5.75c0-.41.34-.75.75-.75h12.5a.75.75 0 010 1.5H3.75A.75.75 0 013 5.75zm0 4c0-.41.34-.75.75-.75h12.5a.75.75 0 010 1.5H3.75A.75.75 0 013 9.75zm9.03 6.03c.3-.3.3-.77 0-1.06l-1.5-1.5a.75.75 0 00-1.06 0l-1.5 1.5a.75.75 0 101.06 1.06l.97-.97.97.97c.3.3.77.3 1.06 0z",
    fill: primaryFill
  }));
};

export const TextAddSpaceAfterFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/TextAddSpaceAfterFilledIcon({}), 'TextAddSpaceAfterFilled');

const TextAddSpaceAfterRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M3 5.5c0-.28.22-.5.5-.5h13a.5.5 0 010 1h-13a.5.5 0 01-.5-.5zm0 4c0-.28.22-.5.5-.5h13a.5.5 0 010 1h-13a.5.5 0 01-.5-.5zm5.15 5.15a.5.5 0 00.7.7L10 14.21l1.15 1.14a.5.5 0 00.7-.7l-1.5-1.5a.5.5 0 00-.7 0l-1.5 1.5z",
    fill: primaryFill
  }));
};

export const TextAddSpaceAfterRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/TextAddSpaceAfterRegularIcon({}), 'TextAddSpaceAfterRegular');

const TextAddSpaceBeforeFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M12.03 5.78a.75.75 0 00-1.06-1.06l-.97.97-.97-.97a.75.75 0 00-1.06 1.06l1.5 1.5c.3.3.77.3 1.06 0l1.5-1.5zM3 10.75c0-.41.34-.75.75-.75h12.5a.75.75 0 010 1.5H3.75a.75.75 0 01-.75-.75zm0 4c0-.41.34-.75.75-.75h12.5a.75.75 0 010 1.5H3.75a.75.75 0 01-.75-.75z",
    fill: primaryFill
  }));
};

export const TextAddSpaceBeforeFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/TextAddSpaceBeforeFilledIcon({}), 'TextAddSpaceBeforeFilled');

const TextAddSpaceBeforeRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M8.15 5.85a.5.5 0 11.7-.7L10 6.29l1.15-1.14a.5.5 0 01.7.7l-1.5 1.5a.5.5 0 01-.7 0l-1.5-1.5zM3 10.5c0-.28.22-.5.5-.5h13a.5.5 0 010 1h-13a.5.5 0 01-.5-.5zm0 4c0-.28.22-.5.5-.5h13a.5.5 0 010 1h-13a.5.5 0 01-.5-.5z",
    fill: primaryFill
  }));
};

export const TextAddSpaceBeforeRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/TextAddSpaceBeforeRegularIcon({}), 'TextAddSpaceBeforeRegular');

const TextAlignCenterFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M4 4.25c0-.41.34-.75.75-.75h10.5a.75.75 0 010 1.5H4.75A.75.75 0 014 4.25zm-2 5c0-.41.34-.75.75-.75h14.5a.75.75 0 010 1.5H2.75A.75.75 0 012 9.25zm4.75 4.25a.75.75 0 000 1.5h6.5a.75.75 0 000-1.5h-6.5z",
    fill: primaryFill
  }));
};

export const TextAlignCenterFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/TextAlignCenterFilledIcon({}), 'TextAlignCenterFilled');

const TextAlignCenterRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M4 4.5c0-.28.22-.5.5-.5h11a.5.5 0 010 1h-11a.5.5 0 01-.5-.5zm-2 5c0-.28.22-.5.5-.5h15a.5.5 0 010 1h-15a.5.5 0 01-.5-.5zM6.5 14a.5.5 0 000 1h7a.5.5 0 000-1h-7z",
    fill: primaryFill
  }));
};

export const TextAlignCenterRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/TextAlignCenterRegularIcon({}), 'TextAlignCenterRegular');

const TextAlignDistributedFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M4.78 6.28c.3-.3.3-.77 0-1.06L4.56 5h12.69a.75.75 0 000-1.5H4.56l.22-.22a.75.75 0 00-1.06-1.06l-1.5 1.5c-.3.3-.3.77 0 1.06l1.5 1.5c.3.3.77.3 1.06 0zM18 9.25c0 .41-.34.75-.75.75H2.75a.75.75 0 010-1.5h14.5c.41 0 .75.34.75.75zM2.75 13.5h12.69l-.22-.22a.75.75 0 111.06-1.06l1.5 1.5c.3.3.3.77 0 1.06l-1.5 1.5a.75.75 0 11-1.06-1.06l.22-.22H2.75a.75.75 0 010-1.5z",
    fill: primaryFill
  }));
};

export const TextAlignDistributedFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/TextAlignDistributedFilledIcon({}), 'TextAlignDistributedFilled');

const TextAlignDistributedRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M4.35 5.65L3.71 5H17.5a.5.5 0 000-1H3.7l.65-.65a.5.5 0 10-.7-.7l-1.5 1.5a.5.5 0 000 .7l1.5 1.5a.5.5 0 10.7-.7zM2 9.5c0-.28.22-.5.5-.5h15a.5.5 0 010 1h-15a.5.5 0 01-.5-.5zm.5 4.5h13.8l-.65-.65a.5.5 0 01.7-.7l1.5 1.5c.2.2.2.5 0 .7l-1.5 1.5a.5.5 0 01-.7-.7l.64-.65H2.5a.5.5 0 010-1z",
    fill: primaryFill
  }));
};

export const TextAlignDistributedRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/TextAlignDistributedRegularIcon({}), 'TextAlignDistributedRegular');

const TextAlignDistributedEvenlyFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M2 3.5c0-.41.34-.75.75-.75h14.5a.75.75 0 010 1.5H2.75A.75.75 0 012 3.5zm0 5c0-.41.34-.75.75-.75h14.5a.75.75 0 010 1.5H2.75A.75.75 0 012 8.5zm2.56 6.75h10.88l-.72.72a.75.75 0 101.06 1.06l2-2c.3-.3.3-.77 0-1.06l-2-2a.75.75 0 10-1.06 1.06l.72.72H4.56l.72-.72a.75.75 0 10-1.06-1.06l-2 2c-.3.3-.3.77 0 1.06l2 2a.75.75 0 001.06-1.06l-.72-.72z",
    fill: primaryFill
  }));
};

export const TextAlignDistributedEvenlyFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/TextAlignDistributedEvenlyFilledIcon({}), 'TextAlignDistributedEvenlyFilled');

const TextAlignDistributedEvenlyRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M2 3.5c0-.28.22-.5.5-.5h15a.5.5 0 010 1h-15a.5.5 0 01-.5-.5zm0 5c0-.28.22-.5.5-.5h15a.5.5 0 010 1h-15a.5.5 0 01-.5-.5zM3.7 15h12.6l-1.15 1.15a.5.5 0 00.7.7l2-2a.5.5 0 000-.7l-2-2a.5.5 0 00-.7.7L16.29 14H3.71l1.14-1.15a.5.5 0 00-.7-.7l-2 2a.5.5 0 000 .7l2 2a.5.5 0 00.7-.7L3.71 15z",
    fill: primaryFill
  }));
};

export const TextAlignDistributedEvenlyRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/TextAlignDistributedEvenlyRegularIcon({}), 'TextAlignDistributedEvenlyRegular');

const TextAlignDistributedVerticalFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M3.03 14.72a.75.75 0 00-1.06 1.06l2 2c.3.3.77.3 1.06 0l2-2a.75.75 0 10-1.06-1.06l-.72.72V2.75a.75.75 0 00-1.5 0v12.69l-.72-.72zM10 18a.75.75 0 01-.75-.75V2.75a.75.75 0 011.5 0v14.5c0 .41-.34.75-.75.75zm8.03-12.72c-.3.3-.77.3-1.06 0l-.72-.72v12.69a.75.75 0 01-1.5 0V4.56l-.72.72a.75.75 0 11-1.06-1.06l2-2c.3-.3.77-.3 1.06 0l2 2c.3.3.3.77 0 1.06z",
    fill: primaryFill
  }));
};

export const TextAlignDistributedVerticalFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/TextAlignDistributedVerticalFilledIcon({}), 'TextAlignDistributedVerticalFilled');

const TextAlignDistributedVerticalRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M17.85 4.85a.5.5 0 01-.7 0L16 3.71V17.5a.5.5 0 11-1 0V3.7l-1.15 1.15a.5.5 0 01-.7-.7l2-2c.2-.2.5-.2.7 0l2 2c.2.2.2.5 0 .7zm-15 10.3a.5.5 0 10-.7.7l2 2c.2.2.5.2.7 0l2-2a.5.5 0 10-.7-.7L5 16.29V2.5a.5.5 0 00-1 0v13.8l-1.15-1.15zM10 18a.5.5 0 01-.5-.5v-15a.5.5 0 011 0v15a.5.5 0 01-.5.5z",
    fill: primaryFill
  }));
};

export const TextAlignDistributedVerticalRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/TextAlignDistributedVerticalRegularIcon({}), 'TextAlignDistributedVerticalRegular');

const TextAlignJustifyFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M2 4.25c0-.41.34-.75.75-.75h14.5a.75.75 0 010 1.5H2.75A.75.75 0 012 4.25zm0 5c0-.41.34-.75.75-.75h14.5a.75.75 0 010 1.5H2.75A.75.75 0 012 9.25zm.75 4.25a.75.75 0 000 1.5h14.5a.75.75 0 000-1.5H2.75z",
    fill: primaryFill
  }));
};

export const TextAlignJustifyFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/TextAlignJustifyFilledIcon({}), 'TextAlignJustifyFilled');

const TextAlignJustifyRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M2 4.5c0-.28.22-.5.5-.5h15a.5.5 0 010 1h-15a.5.5 0 01-.5-.5zm0 5c0-.28.22-.5.5-.5h15a.5.5 0 010 1h-15a.5.5 0 01-.5-.5zm.5 4.5a.5.5 0 000 1h15a.5.5 0 000-1h-15z",
    fill: primaryFill
  }));
};

export const TextAlignJustifyRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/TextAlignJustifyRegularIcon({}), 'TextAlignJustifyRegular');

const TextAlignJustifyLowFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M9 4.5c0-.41.34-.75.75-.75h7.5a.75.75 0 010 1.5h-7.5A.75.75 0 019 4.5zm0 5c0-.41.34-.75.75-.75h7.5a.75.75 0 010 1.5h-7.5A.75.75 0 019 9.5zm-6.25 4.25a.75.75 0 000 1.5h14.5a.75.75 0 000-1.5H2.75z",
    fill: primaryFill
  }));
};

export const TextAlignJustifyLowFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/TextAlignJustifyLowFilledIcon({}), 'TextAlignJustifyLowFilled');

const TextAlignJustifyLowRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M9 4.5c0-.28.22-.5.5-.5h8a.5.5 0 010 1h-8a.5.5 0 01-.5-.5zm0 5c0-.28.22-.5.5-.5h8a.5.5 0 010 1h-8a.5.5 0 01-.5-.5zM2.5 14a.5.5 0 000 1h15a.5.5 0 000-1h-15z",
    fill: primaryFill
  }));
};

export const TextAlignJustifyLowRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/TextAlignJustifyLowRegularIcon({}), 'TextAlignJustifyLowRegular');

const TextAlignLeftFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M2 4.25c0-.41.34-.75.75-.75h10.5a.75.75 0 010 1.5H2.75A.75.75 0 012 4.25zm0 5c0-.41.34-.75.75-.75h14.5a.75.75 0 010 1.5H2.75A.75.75 0 012 9.25zm.75 4.25a.75.75 0 000 1.5h8.5a.75.75 0 000-1.5h-8.5z",
    fill: primaryFill
  }));
};

export const TextAlignLeftFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/TextAlignLeftFilledIcon({}), 'TextAlignLeftFilled');

const TextAlignLeftRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M2 4.5c0-.28.22-.5.5-.5h11a.5.5 0 010 1h-11a.5.5 0 01-.5-.5zm0 5c0-.28.22-.5.5-.5h15a.5.5 0 010 1h-15a.5.5 0 01-.5-.5zm.5 4.5a.5.5 0 000 1h9a.5.5 0 000-1h-9z",
    fill: primaryFill
  }));
};

export const TextAlignLeftRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/TextAlignLeftRegularIcon({}), 'TextAlignLeftRegular');

const TextAlignRightFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M6 4.25c0-.41.34-.75.75-.75h10.5a.75.75 0 010 1.5H6.75A.75.75 0 016 4.25zm-4 5c0-.41.34-.75.75-.75h14.5a.75.75 0 010 1.5H2.75A.75.75 0 012 9.25zm7.75 4.25a.75.75 0 000 1.5h7.5a.75.75 0 000-1.5h-7.5z",
    fill: primaryFill
  }));
};

export const TextAlignRightFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/TextAlignRightFilledIcon({}), 'TextAlignRightFilled');

const TextAlignRightRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M6 4.5c0-.28.22-.5.5-.5h11a.5.5 0 010 1h-11a.5.5 0 01-.5-.5zm-4 5c0-.28.22-.5.5-.5h15a.5.5 0 010 1h-15a.5.5 0 01-.5-.5zM9.5 14a.5.5 0 000 1h8a.5.5 0 000-1h-8z",
    fill: primaryFill
  }));
};

export const TextAlignRightRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/TextAlignRightRegularIcon({}), 'TextAlignRightRegular');

const TextAsteriskFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M10.6 2.5a.6.6 0 10-1.2 0v6.05L5.12 4.27a.6.6 0 10-.85.85L8.55 9.4H2.5a.6.6 0 100 1.2h6.05l-4.28 4.28a.6.6 0 00.85.85l4.28-4.28v6.05a.6.6 0 101.2 0v-6.05l4.28 4.28a.6.6 0 00.85-.85l-4.28-4.28h6.05a.6.6 0 100-1.2h-6.05l4.28-4.28a.6.6 0 00-.85-.85L10.6 8.55V2.5z",
    fill: primaryFill
  }));
};

export const TextAsteriskFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/TextAsteriskFilledIcon({}), 'TextAsteriskFilled');

const TextAsteriskRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M10.5 2.5a.5.5 0 00-1 0v6.3L5.05 4.33a.5.5 0 10-.7.71L8.78 9.5H2.5a.5.5 0 000 1h6.3l-4.46 4.45a.5.5 0 10.71.7l4.45-4.44v6.29a.5.5 0 001 0v-6.3l4.45 4.46a.5.5 0 10.7-.71l-4.44-4.45h6.29a.5.5 0 000-1h-6.3l4.46-4.45a.5.5 0 10-.71-.7L10.5 8.78V2.5z",
    fill: primaryFill
  }));
};

export const TextAsteriskRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/TextAsteriskRegularIcon({}), 'TextAsteriskRegular');

const TextBaselineFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M10.7 3.47a.75.75 0 00-1.4 0l-3.75 9.5a.75.75 0 001.4.56l1.2-3.03h3.7l1.2 3.03a.75.75 0 001.4-.56l-3.75-9.5zM11.27 9H8.73L10 5.8 11.27 9z",
    fill: primaryFill
  }), React.createElement("path", {
    d: "M2.5 16a.5.5 0 000 1h15a.5.5 0 000-1h-15z",
    fill: primaryFill
  }));
};

export const TextBaselineFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/TextBaselineFilledIcon({}), 'TextBaselineFilled');

const TextBaselineRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M10.46 3.8a.5.5 0 00-.92 0l-4 9.5a.5.5 0 10.92.4L8.02 10h3.96l1.56 3.7a.5.5 0 10.92-.4l-4-9.5zm1.1 5.2H8.44L10 5.29 11.56 9z",
    fill: primaryFill
  }), React.createElement("path", {
    d: "M2.5 16a.5.5 0 000 1h15a.5.5 0 000-1h-15z",
    fill: primaryFill
  }));
};

export const TextBaselineRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/TextBaselineRegularIcon({}), 'TextBaselineRegular');

const TextBoldFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M5 4.5C5 3.67 5.67 3 6.5 3h3.88a4.12 4.12 0 013.44 6.39 4.24 4.24 0 011.43 3.24A4.36 4.36 0 0110.88 17H6.5A1.5 1.5 0 015 15.5v-11zM8 6v2.25h2.38a1.13 1.13 0 000-2.25H8zm0 5.25V14h2.88c.7 0 1.37-.54 1.37-1.37 0-.84-.69-1.38-1.37-1.38H8z",
    fill: primaryFill
  }));
};

export const TextBoldFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/TextBoldFilledIcon({}), 'TextBoldFilled');

const TextBoldRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M5.5 4.25C5.5 3.56 6.06 3 6.75 3h3.5a4 4 0 013.17 6.44c.9.7 1.58 1.8 1.58 3.31A4.23 4.23 0 0110.75 17h-4c-.69 0-1.25-.56-1.25-1.25V4.25zM8 11v3.5h2.75c.81 0 1.75-.62 1.75-1.75S11.56 11 10.75 11H8zm0-2.5h2.25a1.5 1.5 0 100-3H8v3z",
    fill: primaryFill
  }));
};

export const TextBoldRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/TextBoldRegularIcon({}), 'TextBoldRegular');

const TextBoxSettingsFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M17 5.5A2.5 2.5 0 0014.5 3h-9A2.5 2.5 0 003 5.5v9A2.5 2.5 0 005.5 17h4.1a5.48 5.48 0 01-.5-3.5H6.7c-.38 0-.7-.34-.7-.75s.32-.75.7-.75h2.9c.29-.56.67-1.07 1.13-1.5H6.7c-.4 0-.71-.34-.71-.75S6.32 9 6.7 9H14.36a5.63 5.63 0 012.65.6V5.5zM6 6.75c0-.41.32-.75.7-.75h6.6c.38 0 .7.34.7.75s-.32.75-.7.75H6.7c-.38 0-.7-.34-.7-.75zm6.07 4.7a2 2 0 01-1.44 2.47l-.46.12a4.74 4.74 0 00.01 1.01l.35.09A2 2 0 0112 17.66l-.13.42c.26.2.54.38.84.52l.32-.35a2 2 0 012.91 0l.34.36c.3-.13.57-.3.82-.5l-.15-.55a2 2 0 011.43-2.48l.46-.12a4.73 4.73 0 00-.01-1.01l-.35-.09A2 2 0 0117 11.34l.13-.42c-.26-.2-.54-.38-.84-.52l-.32.35a2 2 0 01-2.91 0l-.34-.36c-.3.13-.57.3-.82.5l.16.55zm2.43 4.05a1 1 0 110-2 1 1 0 010 2z",
    fill: primaryFill
  }));
};

export const TextBoxSettingsFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/TextBoxSettingsFilledIcon({}), 'TextBoxSettingsFilled');

const TextBoxSettingsRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M6.5 6a.5.5 0 000 1h7a.5.5 0 000-1h-7zM6 9.5c0-.28.22-.5.5-.5h4a.5.5 0 010 1h-4a.5.5 0 01-.5-.5zm.5 2.5a.5.5 0 000 1h2.7c.1-.35.24-.68.4-1H6.5zm-1 4h3.7c.1.35.24.68.4 1H5.5A2.5 2.5 0 013 14.5v-9A2.5 2.5 0 015.5 3h9A2.5 2.5 0 0117 5.5v4.1c-.32-.16-.65-.3-1-.4V5.5c0-.83-.67-1.5-1.5-1.5h-9C4.67 4 4 4.67 4 5.5v9c0 .83.67 1.5 1.5 1.5zm6.57-4.56a2 2 0 01-1.44 2.48l-.46.12a4.74 4.74 0 00.01 1.01l.35.09A2 2 0 0112 17.66l-.13.42c.26.2.54.38.84.52l.32-.35a2 2 0 012.91 0l.34.36c.3-.13.57-.3.82-.5l-.15-.55a2 2 0 011.43-2.48l.46-.12a4.73 4.73 0 00-.01-1.01l-.35-.09A2 2 0 0117 11.34l.13-.42c-.26-.2-.54-.38-.84-.52l-.32.35a2 2 0 01-2.91 0l-.34-.36c-.3.13-.57.3-.82.5l.16.55zm2.43 4.06a1 1 0 110-2 1 1 0 010 2z",
    fill: primaryFill
  }));
};

export const TextBoxSettingsRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/TextBoxSettingsRegularIcon({}), 'TextBoxSettingsRegular');

const TextBulletListAddFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M3.25 7a1.25 1.25 0 100-2.5 1.25 1.25 0 000 2.5zM7 5.75c0-.41.34-.75.75-.75h9.5a.75.75 0 010 1.5h-9.5A.75.75 0 017 5.75zM7.75 10a.75.75 0 000 1.5h3.14c.38-.59.87-1.1 1.45-1.5H7.75zm0 5h2.27c.05.52.17 1.03.35 1.5H7.75a.75.75 0 010-1.5zM4.5 10.75a1.25 1.25 0 11-2.5 0 1.25 1.25 0 012.5 0zM3.25 17a1.25 1.25 0 100-2.5 1.25 1.25 0 000 2.5zM20 14.5a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0zm-4-2a.5.5 0 00-1 0V14h-1.5a.5.5 0 000 1H15v1.5a.5.5 0 001 0V15h1.5a.5.5 0 000-1H16v-1.5z",
    fill: primaryFill
  }));
};

export const TextBulletListAddFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/TextBulletListAddFilledIcon({}), 'TextBulletListAddFilled');

const TextBulletListAddRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M3 6.5a1 1 0 100-2 1 1 0 000 2zm3-1c0-.28.22-.5.5-.5h11a.5.5 0 010 1h-11a.5.5 0 01-.5-.5zm0 5c0-.28.22-.5.5-.5h5.84c-.4.28-.77.62-1.08 1H6.5a.5.5 0 01-.5-.5zm4.2 5.5c-.08-.32-.15-.66-.18-1H6.5a.5.5 0 000 1h3.7zM4 15.5a1 1 0 11-2 0 1 1 0 012 0zm-1-4a1 1 0 100-2 1 1 0 000 2zm17 3a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0zm-4-2a.5.5 0 00-1 0V14h-1.5a.5.5 0 000 1H15v1.5a.5.5 0 001 0V15h1.5a.5.5 0 000-1H16v-1.5z",
    fill: primaryFill
  }));
};

export const TextBulletListAddRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/TextBulletListAddRegularIcon({}), 'TextBulletListAddRegular');

const TextBulletListCheckmarkFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M3.25 7a1.25 1.25 0 100-2.5 1.25 1.25 0 000 2.5zM7 5.75c0-.41.34-.75.75-.75h9.5a.75.75 0 010 1.5h-9.5A.75.75 0 017 5.75zm0 5c0-.41.34-.75.75-.75h4.59c-.58.4-1.07.91-1.45 1.5H7.75a.75.75 0 01-.75-.75zM7.75 15h2.27c.05.52.17 1.03.35 1.5H7.75a.75.75 0 010-1.5zm-4.5-3a1.25 1.25 0 100-2.5 1.25 1.25 0 000 2.5zm0 5a1.25 1.25 0 100-2.5 1.25 1.25 0 000 2.5zM20 14.5a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0zm-2.15-1.85a.5.5 0 00-.7 0l-2.65 2.64-.65-.64a.5.5 0 00-.7.7l1 1c.2.2.5.2.7 0l3-3a.5.5 0 000-.7z",
    fill: primaryFill
  }));
};

export const TextBulletListCheckmarkFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/TextBulletListCheckmarkFilledIcon({}), 'TextBulletListCheckmarkFilled');

const TextBulletListCheckmarkRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M3 6.5a1 1 0 100-2 1 1 0 000 2zm3-1c0-.28.22-.5.5-.5h11a.5.5 0 010 1h-11a.5.5 0 01-.5-.5zm.5 4.5a.5.5 0 000 1h4.76c.31-.38.67-.72 1.08-1H6.5zm3.7 6c-.08-.32-.15-.66-.18-1H6.5a.5.5 0 000 1h3.7zm-7.2.5a1 1 0 100-2 1 1 0 000 2zm0-5a1 1 0 100-2 1 1 0 000 2zm17 3a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0zm-2.15-1.85a.5.5 0 00-.7 0l-2.65 2.64-.65-.64a.5.5 0 00-.7.7l1 1c.2.2.5.2.7 0l3-3a.5.5 0 000-.7z",
    fill: primaryFill
  }));
};

export const TextBulletListCheckmarkRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/TextBulletListCheckmarkRegularIcon({}), 'TextBulletListCheckmarkRegular');

const TextBulletListDismissFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M3.25 7a1.25 1.25 0 100-2.5 1.25 1.25 0 000 2.5zM7 5.75c0-.41.34-.75.75-.75h9.5a.75.75 0 010 1.5h-9.5A.75.75 0 017 5.75zm0 5c0-.41.34-.75.75-.75h4.59c-.58.4-1.07.91-1.45 1.5H7.75a.75.75 0 01-.75-.75zM7.75 15h2.27c.05.52.17 1.03.35 1.5H7.75a.75.75 0 010-1.5zm-4.5-3a1.25 1.25 0 100-2.5 1.25 1.25 0 000 2.5zm0 5a1.25 1.25 0 100-2.5 1.25 1.25 0 000 2.5zM20 14.5a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0zm-2.65-1.15a.5.5 0 00-.7-.7l-1.15 1.14-1.15-1.14a.5.5 0 00-.7.7l1.14 1.15-1.14 1.15a.5.5 0 00.7.7l1.15-1.14 1.15 1.14a.5.5 0 00.7-.7l-1.14-1.15 1.14-1.15z",
    fill: primaryFill
  }));
};

export const TextBulletListDismissFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/TextBulletListDismissFilledIcon({}), 'TextBulletListDismissFilled');

const TextBulletListDismissRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M3 6.5a1 1 0 100-2 1 1 0 000 2zm3-1c0-.28.22-.5.5-.5h11a.5.5 0 010 1h-11a.5.5 0 01-.5-.5zm.5 4.5a.5.5 0 000 1h4.76c.31-.38.67-.72 1.08-1H6.5zm3.7 6c-.08-.32-.15-.66-.18-1H6.5a.5.5 0 000 1h3.7zm-7.2.5a1 1 0 100-2 1 1 0 000 2zm0-5a1 1 0 100-2 1 1 0 000 2zm17 3a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0zm-2.65-1.15a.5.5 0 00-.7-.7l-1.15 1.14-1.15-1.14a.5.5 0 00-.7.7l1.14 1.15-1.14 1.15a.5.5 0 00.7.7l1.15-1.14 1.15 1.14a.5.5 0 00.7-.7l-1.14-1.15 1.14-1.15z",
    fill: primaryFill
  }));
};

export const TextBulletListDismissRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/TextBulletListDismissRegularIcon({}), 'TextBulletListDismissRegular');

const TextBulletListLtrFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M3.25 7a1.25 1.25 0 100-2.5 1.25 1.25 0 000 2.5zM7 5.75c0-.41.34-.75.75-.75h9.5a.75.75 0 010 1.5h-9.5A.75.75 0 017 5.75zM7.75 10a.75.75 0 000 1.5h9.5a.75.75 0 000-1.5h-9.5zm0 5a.75.75 0 000 1.5h9.5a.75.75 0 000-1.5h-9.5zM4.5 10.75a1.25 1.25 0 11-2.5 0 1.25 1.25 0 012.5 0zM3.25 17a1.25 1.25 0 100-2.5 1.25 1.25 0 000 2.5z",
    fill: primaryFill
  }));
};

export const TextBulletListLtrFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/TextBulletListLtrFilledIcon({}), 'TextBulletListLtrFilled');

const TextBulletListLtrRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M3 6.5a1 1 0 100-2 1 1 0 000 2zm3-1c0-.28.22-.5.5-.5h11a.5.5 0 010 1h-11a.5.5 0 01-.5-.5zm0 5c0-.28.22-.5.5-.5h11a.5.5 0 010 1h-11a.5.5 0 01-.5-.5zm.5 4.5a.5.5 0 000 1h11a.5.5 0 000-1h-11zm-2.5.5a1 1 0 11-2 0 1 1 0 012 0zm-1-4a1 1 0 100-2 1 1 0 000 2z",
    fill: primaryFill
  }));
};

export const TextBulletListLtrRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/TextBulletListLtrRegularIcon({}), 'TextBulletListLtrRegular');

const TextBulletListRtlFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M16.75 7a1.25 1.25 0 110-2.5 1.25 1.25 0 010 2.5zM13 5.75a.75.75 0 00-.75-.75h-9.5a.75.75 0 000 1.5h9.5c.41 0 .75-.34.75-.75zM12.25 10a.75.75 0 010 1.5h-9.5a.75.75 0 010-1.5h9.5zm0 5a.75.75 0 010 1.5h-9.5a.75.75 0 010-1.5h9.5zm3.25-4.25a1.25 1.25 0 102.5 0 1.25 1.25 0 00-2.5 0zM16.75 17a1.25 1.25 0 110-2.5 1.25 1.25 0 010 2.5z",
    fill: primaryFill
  }));
};

export const TextBulletListRtlFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/TextBulletListRtlFilledIcon({}), 'TextBulletListRtlFilled');

const TextBulletListRtlRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M17 6.5a1 1 0 110-2 1 1 0 010 2zm-3-1a.5.5 0 00-.5-.5h-11a.5.5 0 000 1h11a.5.5 0 00.5-.5zm0 5a.5.5 0 00-.5-.5h-11a.5.5 0 000 1h11a.5.5 0 00.5-.5zm-.5 4.5a.5.5 0 010 1h-11a.5.5 0 010-1h11zm2.5.5a1 1 0 102 0 1 1 0 00-2 0zm1-4a1 1 0 110-2 1 1 0 010 2z",
    fill: primaryFill
  }));
};

export const TextBulletListRtlRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/TextBulletListRtlRegularIcon({}), 'TextBulletListRtlRegular');

const TextBulletListSquareFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M5 3a2 2 0 00-2 2v10c0 1.1.9 2 2 2h10a2 2 0 002-2V5a2 2 0 00-2-2H5zm2.5 4.25a.75.75 0 11-1.5 0 .75.75 0 011.5 0zM6.75 11a.75.75 0 110-1.5.75.75 0 010 1.5zm.75 2.25a.75.75 0 11-1.5 0 .75.75 0 011.5 0zM9.5 7h4a.5.5 0 010 1h-4a.5.5 0 010-1zM9 10.5c0-.28.22-.5.5-.5h4a.5.5 0 010 1h-4a.5.5 0 01-.5-.5zm.5 2.5h4a.5.5 0 010 1h-4a.5.5 0 010-1z",
    fill: primaryFill
  }));
};

export const TextBulletListSquareFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/TextBulletListSquareFilledIcon({}), 'TextBulletListSquareFilled');

const TextBulletListSquareRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M7.5 7.25a.75.75 0 11-1.5 0 .75.75 0 011.5 0zM6.75 11a.75.75 0 100-1.5.75.75 0 000 1.5zm.75 2.25a.75.75 0 11-1.5 0 .75.75 0 011.5 0zM9.5 7a.5.5 0 000 1h4a.5.5 0 000-1h-4zM9 10.5c0-.28.22-.5.5-.5h4a.5.5 0 010 1h-4a.5.5 0 01-.5-.5zm.5 2.5a.5.5 0 000 1h4a.5.5 0 000-1h-4zM3 5c0-1.1.9-2 2-2h10a2 2 0 012 2v10a2 2 0 01-2 2H5a2 2 0 01-2-2V5zm2-1a1 1 0 00-1 1v10a1 1 0 001 1h10a1 1 0 001-1V5a1 1 0 00-1-1H5z",
    fill: primaryFill
  }));
};

export const TextBulletListSquareRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/TextBulletListSquareRegularIcon({}), 'TextBulletListSquareRegular');

const TextBulletListSquareClockFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M3 5c0-1.1.9-2 2-2h10a2 2 0 012 2v4.6a5.48 5.48 0 00-5.66.4H9.5a.5.5 0 000 1h.76a5.48 5.48 0 00-.66 6H5a2 2 0 01-2-2V5zm3.75 3a.75.75 0 100-1.5.75.75 0 000 1.5zM6 10.25a.75.75 0 101.5 0 .75.75 0 00-1.5 0zM6.75 14a.75.75 0 100-1.5.75.75 0 000 1.5zm6.75-7h-4a.5.5 0 000 1h4a.5.5 0 000-1zm1 12a4.5 4.5 0 100-9 4.5 4.5 0 000 9zm-.5-6.5a.5.5 0 011 0V14h1a.5.5 0 010 1h-1.5a.5.5 0 01-.5-.5v-2z",
    fill: primaryFill
  }));
};

export const TextBulletListSquareClockFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/TextBulletListSquareClockFilledIcon({}), 'TextBulletListSquareClockFilled');

const TextBulletListSquareClockRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M16 9.2V5a1 1 0 00-1-1H5a1 1 0 00-1 1v10a1 1 0 001 1h4.2c.1.35.24.68.4 1H5a2 2 0 01-2-2V5c0-1.1.9-2 2-2h10a2 2 0 012 2v4.6c-.32-.16-.65-.3-1-.4zM6.75 8a.75.75 0 100-1.5.75.75 0 000 1.5zm.75 2.25a.75.75 0 11-1.5 0 .75.75 0 011.5 0zm0 3a.75.75 0 11-1.5 0 .75.75 0 011.5 0zM9 7.5c0-.28.22-.5.5-.5h4a.5.5 0 010 1h-4a.5.5 0 01-.5-.5zm0 3c0-.28.22-.5.5-.5h1.84c-.4.28-.77.62-1.08 1H9.5a.5.5 0 01-.5-.5zm10 4a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0zM14.5 12a.5.5 0 00-.5.5v2c0 .28.22.5.5.5H16a.5.5 0 000-1h-1v-1.5a.5.5 0 00-.5-.5z",
    fill: primaryFill
  }));
};

export const TextBulletListSquareClockRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/TextBulletListSquareClockRegularIcon({}), 'TextBulletListSquareClockRegular');

const TextBulletListSquareEditFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M5 3a2 2 0 00-2 2v10c0 1.1.9 2 2 2h4.22l.21-.84a3.2 3.2 0 01.84-1.49l.67-.67H9.5a.5.5 0 010-1h2.44l3.16-3.16c.53-.53 1.21-.8 1.9-.84V5a2 2 0 00-2-2H5zm2.5 4.25a.75.75 0 11-1.5 0 .75.75 0 011.5 0zM6.75 11a.75.75 0 110-1.5.75.75 0 010 1.5zm.75 2.25a.75.75 0 11-1.5 0 .75.75 0 011.5 0zM9.5 7h4a.5.5 0 010 1h-4a.5.5 0 010-1zM9 10.5c0-.28.22-.5.5-.5h4a.5.5 0 010 1h-4a.5.5 0 01-.5-.5zm1.98 4.88l4.83-4.83a1.87 1.87 0 112.64 2.64l-4.83 4.83a2.2 2.2 0 01-1.02.58l-1.5.37a.89.89 0 01-1.07-1.07l.37-1.5c.1-.39.3-.74.58-1.02z",
    fill: primaryFill
  }));
};

export const TextBulletListSquareEditFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/TextBulletListSquareEditFilledIcon({}), 'TextBulletListSquareEditFilled');

const TextBulletListSquareEditRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M5 3a2 2 0 00-2 2v10c0 1.1.9 2 2 2h4.22l.21-.84.04-.16H5a1 1 0 01-1-1V5a1 1 0 011-1h10a1 1 0 011 1v4.23c.32-.14.66-.21 1-.23V5a2 2 0 00-2-2H5zm4.5 11h1.44l1-1H9.5a.5.5 0 000 1zm-2-6.75a.75.75 0 11-1.5 0 .75.75 0 011.5 0zM6.75 11a.75.75 0 100-1.5.75.75 0 000 1.5zm0 3a.75.75 0 100-1.5.75.75 0 000 1.5zM9.5 7a.5.5 0 000 1h4a.5.5 0 000-1h-4zm0 3a.5.5 0 000 1h4a.5.5 0 000-1h-4zm1.48 5.38l4.83-4.83a1.87 1.87 0 112.64 2.64l-4.83 4.83a2.2 2.2 0 01-1.02.58l-1.5.37a.89.89 0 01-1.07-1.07l.37-1.5c.1-.39.3-.74.58-1.02z",
    fill: primaryFill
  }));
};

export const TextBulletListSquareEditRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/TextBulletListSquareEditRegularIcon({}), 'TextBulletListSquareEditRegular');

const TextBulletListSquarePersonFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M5 3a2 2 0 00-2 2v10c0 1.1.9 2 2 2h5.2c-.24-.76-.34-1.7.1-2.4.13-.24.31-.44.52-.6H9.5a.5.5 0 010-1h2.9a2.87 2.87 0 01-.36-2H9.5a.5.5 0 010-1h2.88c.5-.9 1.47-1.5 2.62-1.5.5 0 1 .1 1.5.4.18.1.35.22.5.36V5a2 2 0 00-2-2H5zm2.5 4.25a.75.75 0 11-1.5 0 .75.75 0 011.5 0zM6.75 11a.75.75 0 110-1.5.75.75 0 010 1.5zm.75 2.25a.75.75 0 11-1.5 0 .75.75 0 011.5 0zM9.5 7h4a.5.5 0 010 1h-4a.5.5 0 010-1zM16 9.77a2 2 0 10-2 3.46 2 2 0 002-3.46zm-5 5.98c0-.69.56-1.25 1.25-1.25h5.5A1.25 1.25 0 0119 15.84v.21a2.03 2.03 0 01-.07.45c-.06.29-.2.66-.46 1.04C17.93 18.32 16.9 19 15 19c-1.61 0-2.6-.5-3.2-1.13a2.94 2.94 0 01-.8-1.82v-.3z",
    fill: primaryFill
  }));
};

export const TextBulletListSquarePersonFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/TextBulletListSquarePersonFilledIcon({}), 'TextBulletListSquarePersonFilled');

const TextBulletListSquarePersonRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M16 8.66V5a1 1 0 00-1-1H5a1 1 0 00-1 1v10a1 1 0 001 1h5c.03.34.1.69.2 1H5a2 2 0 01-2-2V5c0-1.1.9-2 2-2h10a2 2 0 012 2v4.26a2.8 2.8 0 00-.5-.36c-.17-.1-.33-.18-.5-.24zM6.75 8a.75.75 0 100-1.5.75.75 0 000 1.5zm.75 2.25a.75.75 0 11-1.5 0 .75.75 0 011.5 0zm0 3a.75.75 0 11-1.5 0 .75.75 0 011.5 0zM9 7.5c0-.28.22-.5.5-.5h4a.5.5 0 010 1h-4a.5.5 0 01-.5-.5zm0 3c0-.28.22-.5.5-.5h2.88a3 3 0 00-.34 1H9.5a.5.5 0 01-.5-.5zm3.8 3a2.66 2.66 0 01-.4-.5H9.5a.5.5 0 000 1h1.32c.42-.32.95-.5 1.48-.5h.5zM16 9.77a2 2 0 10-2 3.46 2 2 0 002-3.46zm-5 5.98c0-.69.56-1.25 1.25-1.25h5.5A1.25 1.25 0 0119 15.84v.21a2.03 2.03 0 01-.07.45c-.06.29-.2.66-.46 1.04C17.93 18.32 16.9 19 15 19c-1.61 0-2.6-.5-3.2-1.13a2.94 2.94 0 01-.8-1.82v-.3z",
    fill: primaryFill
  }));
};

export const TextBulletListSquarePersonRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/TextBulletListSquarePersonRegularIcon({}), 'TextBulletListSquarePersonRegular');

const TextBulletListSquareSearchFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M5 3a2 2 0 00-2 2v4.76A4.5 4.5 0 019.97 13h3.53a.5.5 0 010 1H9.97c-.05.5-.2.98-.4 1.44L11.11 17H15a2 2 0 002-2V5a2 2 0 00-2-2H5zm2.5 4.25a.75.75 0 11-1.5 0 .75.75 0 011.5 0zm2-.25h4a.5.5 0 010 1h-4a.5.5 0 010-1zM9 10.5c0-.28.22-.5.5-.5h4a.5.5 0 010 1h-4a.5.5 0 01-.5-.5zm-6.62 1.4a3.5 3.5 0 005.22 4.4l2.54 2.56a.5.5 0 00.71-.71L8.3 15.6a3.5 3.5 0 10-5.92-3.7zm5.2.21a2.5 2.5 0 11-4.16 2.78 2.5 2.5 0 014.16-2.78z",
    fill: primaryFill
  }));
};

export const TextBulletListSquareSearchFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/TextBulletListSquareSearchFilledIcon({}), 'TextBulletListSquareSearchFilled');

const TextBulletListSquareSearchRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M10.12 16H15a1 1 0 001-1V5a1 1 0 00-1-1H5a1 1 0 00-1 1v4.26c-.35.12-.69.29-1 .5V5c0-1.1.9-2 2-2h10a2 2 0 012 2v10a2 2 0 01-2 2h-3.88l-1-1zM6.75 8a.75.75 0 100-1.5.75.75 0 000 1.5zM9 7.5c0-.28.22-.5.5-.5h4a.5.5 0 010 1h-4a.5.5 0 01-.5-.5zm0 3c0-.28.22-.5.5-.5h4a.5.5 0 010 1h-4a.5.5 0 01-.5-.5zm4.5 3.5H9.97a4.5 4.5 0 000-1h3.53a.5.5 0 010 1zM2.38 11.9a3.5 3.5 0 005.22 4.4l2.54 2.56a.5.5 0 00.71-.71L8.3 15.6a3.5 3.5 0 10-5.92-3.7zm5.2.21a2.5 2.5 0 11-4.16 2.78 2.5 2.5 0 014.16-2.78z",
    fill: primaryFill
  }));
};

export const TextBulletListSquareSearchRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/TextBulletListSquareSearchRegularIcon({}), 'TextBulletListSquareSearchRegular');

const TextBulletListSquareSettingsFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M5 3a2 2 0 00-2 2v10c0 1.1.9 2 2 2h4.6a5.48 5.48 0 01.66-6H9.5a.5.5 0 010-1h1.84A5.47 5.47 0 0117 9.6V5a2 2 0 00-2-2H5zm2.5 4.25a.75.75 0 11-1.5 0 .75.75 0 011.5 0zM6.75 11a.75.75 0 110-1.5.75.75 0 010 1.5zm.75 2.25a.75.75 0 11-1.5 0 .75.75 0 011.5 0zM9.5 7h4a.5.5 0 010 1h-4a.5.5 0 010-1zm2.56 4.44a2 2 0 01-1.43 2.48l-.46.12a4.74 4.74 0 00.01 1.01l.35.09A2 2 0 0112 17.66l-.13.42c.26.2.54.38.84.52l.32-.35a2 2 0 012.91 0l.34.36c.3-.13.57-.3.82-.5l-.16-.55a2 2 0 011.44-2.48l.46-.12a4.7 4.7 0 00-.01-1.01l-.35-.09A2 2 0 0117 11.34l.13-.42c-.26-.2-.54-.38-.84-.52l-.32.35a2 2 0 01-2.91 0l-.34-.36c-.3.13-.57.3-.82.5l.15.55zm2.44 4.06a1 1 0 110-2 1 1 0 010 2z",
    fill: primaryFill
  }));
};

export const TextBulletListSquareSettingsFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/TextBulletListSquareSettingsFilledIcon({}), 'TextBulletListSquareSettingsFilled');

const TextBulletListSquareSettingsRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M7.5 7.25a.75.75 0 11-1.5 0 .75.75 0 011.5 0zM6.75 11a.75.75 0 100-1.5.75.75 0 000 1.5zm.75 2.25a.75.75 0 11-1.5 0 .75.75 0 011.5 0zM9.5 7a.5.5 0 000 1h4a.5.5 0 000-1h-4zM9 10.5c0-.28.22-.5.5-.5h1.84c-.4.28-.77.62-1.08 1H9.5a.5.5 0 01-.5-.5zM16 5v4.2c.35.1.68.24 1 .4V5a2 2 0 00-2-2H5a2 2 0 00-2 2v10c0 1.1.9 2 2 2h4.6c-.16-.32-.3-.65-.4-1H5a1 1 0 01-1-1V5a1 1 0 011-1h10a1 1 0 011 1zm-3.94 6.44a2 2 0 01-1.43 2.48l-.46.12a4.74 4.74 0 00.01 1.01l.35.09A2 2 0 0112 17.66l-.13.42c.26.2.54.38.84.52l.32-.35a2 2 0 012.91 0l.34.36c.3-.13.57-.3.82-.5l-.16-.55a2 2 0 011.44-2.48l.46-.12a4.7 4.7 0 00-.01-1.01l-.35-.09A2 2 0 0117 11.34l.13-.42c-.26-.2-.54-.38-.84-.52l-.32.35a2 2 0 01-2.91 0l-.34-.36c-.3.13-.57.3-.82.5l.15.55zm2.44 4.06a1 1 0 110-2 1 1 0 010 2z",
    fill: primaryFill
  }));
};

export const TextBulletListSquareSettingsRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/TextBulletListSquareSettingsRegularIcon({}), 'TextBulletListSquareSettingsRegular');

const TextBulletListSquareShieldFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M5 3a2 2 0 00-2 2v10c0 1.1.9 2 2 2h5.8c-.47-.8-.8-1.8-.8-3h-.5a.5.5 0 010-1h.5v-1.5c0-.18.03-.35.08-.5H9.5a.5.5 0 010-1h1.72l.14-.03a4.71 4.71 0 002.5-1.43 1.62 1.62 0 012.29 0c.22.23.51.49.85.73V5a2 2 0 00-2-2H5zm2.5 4.25a.75.75 0 11-1.5 0 .75.75 0 011.5 0zM6.75 11a.75.75 0 110-1.5.75.75 0 010 1.5zm.75 2.25a.75.75 0 11-1.5 0 .75.75 0 011.5 0zM9.5 7h4a.5.5 0 010 1h-4a.5.5 0 010-1zm5.94 2.24a5.7 5.7 0 003.06 1.72c.27.04.5.26.5.54V14c0 3.47-3.18 4.73-3.87 4.96a.4.4 0 01-.26 0C14.18 18.73 11 17.46 11 14v-2.5c0-.28.23-.5.5-.54a5.7 5.7 0 003.06-1.72.62.62 0 01.88 0z",
    fill: primaryFill
  }));
};

export const TextBulletListSquareShieldFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/TextBulletListSquareShieldFilledIcon({}), 'TextBulletListSquareShieldFilled');

const TextBulletListSquareShieldRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M16 8.4V5a1 1 0 00-1-1H5a1 1 0 00-1 1v10a1 1 0 001 1h5.33c.13.36.3.7.48 1H5a2 2 0 01-2-2V5c0-1.1.9-2 2-2h10a2 2 0 012 2v4.27a6.33 6.33 0 01-1-.86zM6.75 8a.75.75 0 100-1.5.75.75 0 000 1.5zm.75 2.25a.75.75 0 11-1.5 0 .75.75 0 011.5 0zm0 3a.75.75 0 11-1.5 0 .75.75 0 011.5 0zM9 7.5c0-.28.22-.5.5-.5h4a.5.5 0 010 1h-4a.5.5 0 01-.5-.5zm0 3c0-.28.22-.5.5-.5h1.72a1.6 1.6 0 00-1.14 1H9.5a.5.5 0 01-.5-.5zm.5 3.5h.5v-1h-.5a.5.5 0 000 1zm5.94-4.76a5.7 5.7 0 003.06 1.72c.27.04.5.26.5.54V14c0 3.47-3.18 4.73-3.87 4.96a.4.4 0 01-.26 0C14.18 18.73 11 17.46 11 14v-2.5c0-.28.23-.5.5-.54a5.7 5.7 0 003.06-1.72.62.62 0 01.88 0z",
    fill: primaryFill
  }));
};

export const TextBulletListSquareShieldRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/TextBulletListSquareShieldRegularIcon({}), 'TextBulletListSquareShieldRegular');

const TextBulletListSquareToolboxFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M3 5c0-1.1.9-2 2-2h10a2 2 0 012 2v4.5c-.42-.31-.94-.5-1.5-.5h-2c-.82 0-1.54.4-2 1h-2a.5.5 0 000 1h1.55v.04A2.5 2.5 0 009 13.5V17H5a2 2 0 01-2-2V5zm3.75 3a.75.75 0 100-1.5.75.75 0 000 1.5zM6 10.25a.75.75 0 101.5 0 .75.75 0 00-1.5 0zM6.75 14a.75.75 0 100-1.5.75.75 0 000 1.5zm6.75-7h-4a.5.5 0 000 1h4a.5.5 0 000-1zM12 12v-.5c0-.83.67-1.5 1.5-1.5h2c.83 0 1.5.67 1.5 1.5v.5h.5c.83 0 1.5.67 1.5 1.5V15h-2v-.5a.5.5 0 00-1 0v.5h-3v-.5a.5.5 0 00-1 0v.5h-2v-1.5c0-.83.67-1.5 1.5-1.5h.5zm1-.5v.5h3v-.5a.5.5 0 00-.5-.5h-2a.5.5 0 00-.5.5zm4 4.5h2v1.5c0 .83-.67 1.5-1.5 1.5h-6a1.5 1.5 0 01-1.5-1.5V16h2v.5a.5.5 0 001 0V16h3v.5a.5.5 0 001 0V16z",
    fill: primaryFill
  }));
};

export const TextBulletListSquareToolboxFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/TextBulletListSquareToolboxFilledIcon({}), 'TextBulletListSquareToolboxFilled');

const TextBulletListSquareToolboxRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M5 17h4v-1H5a1 1 0 01-1-1V5a1 1 0 011-1h10a1 1 0 011 1v4.05c.37.07.7.23 1 .45V5a2 2 0 00-2-2H5a2 2 0 00-2 2v10c0 1.1.9 2 2 2zm4.5-6h1.55c.07-.37.23-.7.45-1h-2a.5.5 0 000 1zm-2-3.75a.75.75 0 11-1.5 0 .75.75 0 011.5 0zm0 3a.75.75 0 11-1.5 0 .75.75 0 011.5 0zM6.75 14a.75.75 0 100-1.5.75.75 0 000 1.5zM9 7.5c0-.28.22-.5.5-.5h4a.5.5 0 010 1h-4a.5.5 0 01-.5-.5zm3 4.5v-.5c0-.83.67-1.5 1.5-1.5h2c.83 0 1.5.67 1.5 1.5v.5h.5c.83 0 1.5.67 1.5 1.5V15h-2v-.5a.5.5 0 00-1 0v.5h-3v-.5a.5.5 0 00-1 0v.5h-2v-1.5c0-.83.67-1.5 1.5-1.5h.5zm1-.5v.5h3v-.5a.5.5 0 00-.5-.5h-2a.5.5 0 00-.5.5zm4 4.5h2v1.5c0 .83-.67 1.5-1.5 1.5h-6a1.5 1.5 0 01-1.5-1.5V16h2v.5a.5.5 0 001 0V16h3v.5a.5.5 0 001 0V16z",
    fill: primaryFill
  }));
};

export const TextBulletListSquareToolboxRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/TextBulletListSquareToolboxRegularIcon({}), 'TextBulletListSquareToolboxRegular');

const TextBulletListSquareWarningFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M3 5c0-1.1.9-2 2-2h10a2 2 0 012 2v6.87l-.98-1.7a2.32 2.32 0 00-3.47-.67H8.5a.5.5 0 000 1h3.28L10.34 13H8.5a.5.5 0 000 1h1.26l-1.45 2.53c-.1.15-.16.3-.21.47H5a2 2 0 01-2-2V5zm4 1.5a.75.75 0 10-1.5 0 .75.75 0 001.5 0zM7 10a.75.75 0 10-1.5 0A.75.75 0 007 10zm-.75 4.25a.75.75 0 100-1.5.75.75 0 000 1.5zM8 6.5c0 .27.22.5.5.5h5a.5.5 0 000-1h-5a.5.5 0 00-.5.5zm5.65 3.55a1.34 1.34 0 011.5.61l3.67 6.37a1.3 1.3 0 01-.5 1.8c-.2.1-.42.17-.65.17h-7.34A1.33 1.33 0 019 17.68c0-.23.06-.45.17-.65l3.67-6.37c.18-.31.48-.52.8-.61zm.85 2.45a.5.5 0 10-1 0V15a.5.5 0 101 0v-2.5zM14 18a.75.75 0 100-1.5.75.75 0 000 1.5z",
    fill: primaryFill
  }));
};

export const TextBulletListSquareWarningFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/TextBulletListSquareWarningFilledIcon({}), 'TextBulletListSquareWarningFilled');

const TextBulletListSquareWarningRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M3 5c0-1.1.9-2 2-2h10a2 2 0 012 2v6.87l-.98-1.7-.02-.04V5a1 1 0 00-1-1H5a1 1 0 00-1 1v10a1 1 0 001 1h3.61l-.3.53c-.1.15-.16.3-.21.47H5a2 2 0 01-2-2V5zm6.76 9l.58-1H8.5a.5.5 0 000 1h1.26zm2.02-3.5l.2-.34c.15-.26.34-.48.57-.66H8.5a.5.5 0 000 1h3.28zM7 6.5a.75.75 0 11-1.5 0 .75.75 0 011.5 0zm-.75 4.25a.75.75 0 100-1.5.75.75 0 000 1.5zM7 13.5a.75.75 0 11-1.5 0 .75.75 0 011.5 0zM8.5 6a.5.5 0 000 1h5a.5.5 0 000-1h-5zm5.15 4.05a1.34 1.34 0 011.5.61l3.67 6.37a1.3 1.3 0 01-.5 1.8c-.2.1-.42.17-.65.17h-7.34A1.33 1.33 0 019 17.68c0-.23.06-.45.17-.65l3.67-6.37c.18-.31.48-.52.8-.61zm.85 2.45a.5.5 0 10-1 0V15a.5.5 0 101 0v-2.5zM14 18a.75.75 0 100-1.5.75.75 0 000 1.5z",
    fill: primaryFill
  }));
};

export const TextBulletListSquareWarningRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/TextBulletListSquareWarningRegularIcon({}), 'TextBulletListSquareWarningRegular');

const TextBulletListTreeFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M3.25 7a1.25 1.25 0 100-2.5 1.25 1.25 0 000 2.5zM7 5.75c0-.41.34-.75.75-.75h9.5a.75.75 0 010 1.5h-9.5A.75.75 0 017 5.75zM7.75 10a.75.75 0 000 1.5h9.5a.75.75 0 000-1.5h-9.5zm4 5a.75.75 0 000 1.5h5.5a.75.75 0 000-1.5h-5.5zM4.5 10.75a1.25 1.25 0 11-2.5 0 1.25 1.25 0 012.5 0zM7.25 17a1.25 1.25 0 100-2.5 1.25 1.25 0 000 2.5z",
    fill: primaryFill
  }));
};

export const TextBulletListTreeFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/TextBulletListTreeFilledIcon({}), 'TextBulletListTreeFilled');

const TextBulletListTreeRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M3 6.5a1 1 0 100-2 1 1 0 000 2zm3-1c0-.28.22-.5.5-.5h11a.5.5 0 010 1h-11a.5.5 0 01-.5-.5zm0 5c0-.28.22-.5.5-.5h11a.5.5 0 010 1h-11a.5.5 0 01-.5-.5zm4.5 4.5a.5.5 0 000 1h7a.5.5 0 000-1h-7zm-2.5.5a1 1 0 11-2 0 1 1 0 012 0zm-5-4a1 1 0 100-2 1 1 0 000 2z",
    fill: primaryFill
  }));
};

export const TextBulletListTreeRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/TextBulletListTreeRegularIcon({}), 'TextBulletListTreeRegular');

const TextCaseLowercaseFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M11.75 3.25c.41 0 .75.34.75.75v4.66C13 8.24 13.6 8 14.25 8c1.66 0 3 1.57 3 3.5s-1.34 3.5-3 3.5c-.65 0-1.26-.24-1.75-.66v.16a.75.75 0 01-1.5 0V4c0-.41.34-.75.75-.75zm2.5 10.25c.62 0 1.5-.67 1.5-2s-.88-2-1.5-2-1.5.67-1.5 2 .88 2 1.5 2zm-8.6-4.56a2.8 2.8 0 00-1.06.23.75.75 0 01-.68-1.34 4.26 4.26 0 011.69-.4c.63-.02 1.34.08 1.99.4C9 8.54 9 9.95 9 10.46v4.04a.75.75 0 01-1.5.06c-.87.53-1.89.85-2.94.57a2.61 2.61 0 01-.73-4.75c.78-.52 1.7-.66 2.53-.61a6 6 0 011.1.16.97.97 0 00-.55-.76c-.35-.18-.8-.25-1.26-.23zM7.5 11.5a4.5 4.5 0 00-1.22-.24c-.62-.03-1.2.09-1.61.36-.93.62-.65 1.8.27 2.06.75.2 1.67-.19 2.56-1V11.5z",
    fill: primaryFill
  }));
};

export const TextCaseLowercaseFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/TextCaseLowercaseFilledIcon({}), 'TextCaseLowercaseFilled');

const TextCaseLowercaseRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M11.5 3.5c.28 0 .5.22.5.5v4.9c.53-.56 1.23-.9 2-.9 1.66 0 3 1.57 3 3.5S15.66 15 14 15c-.77 0-1.47-.34-2-.9v.4a.5.5 0 01-1 0V4c0-.28.22-.5.5-.5zM14 14c.97 0 2-.97 2-2.5S14.97 9 14 9s-2 .97-2 2.5 1.03 2.5 2 2.5zM5.9 8.69c-.5.02-.92.13-1.18.26a.5.5 0 11-.44-.9c.4-.2.98-.34 1.58-.36.6-.03 1.27.07 1.86.36C9 8.7 9 9.96 9 10.46v4.04a.5.5 0 01-1 0v-.41c-.91.66-2.01 1.1-3.13.8a2.36 2.36 0 01-.65-4.3c.72-.48 1.59-.61 2.38-.57.49.02.97.11 1.4.25-.02-.48-.12-1.02-.72-1.32-.4-.2-.9-.28-1.39-.26zM8 11.33c-.4-.17-.92-.29-1.45-.32-.66-.03-1.3.09-1.77.4-1.12.75-.77 2.21.35 2.5.9.25 1.94-.24 2.87-1.12v-1.46z",
    fill: primaryFill
  }));
};

export const TextCaseLowercaseRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/TextCaseLowercaseRegularIcon({}), 'TextCaseLowercaseRegular');

const TextCaseTitleFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M12.5 3.25c.41 0 .75.34.75.75v4.66c.5-.42 1.1-.66 1.75-.66 1.66 0 3 1.57 3 3.5S16.66 15 15 15c-.65 0-1.26-.24-1.75-.66v.16a.75.75 0 01-1.5 0V4c0-.41.34-.75.75-.75zM15 13.5c.62 0 1.5-.67 1.5-2s-.88-2-1.5-2-1.5.67-1.5 2 .88 2 1.5 2zM6.5 3.25c.31 0 .59.2.7.5l3.64 10.5a.75.75 0 11-1.41.5l-.78-2.25H4.06l-.86 2.27a.75.75 0 01-1.4-.54l3.98-10.5c.12-.3.4-.48.71-.48zM4.62 11h3.5L6.45 6.2 4.63 11z",
    fill: primaryFill
  }));
};

export const TextCaseTitleFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/TextCaseTitleFilledIcon({}), 'TextCaseTitleFilled');

const TextCaseTitleRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M12.5 3.5c.28 0 .5.22.5.5v4.9c.53-.56 1.23-.9 2-.9 1.66 0 3 1.57 3 3.5S16.66 15 15 15c-.77 0-1.47-.34-2-.9v.4a.5.5 0 01-1 0V4c0-.28.22-.5.5-.5zM15 14c.97 0 2-.97 2-2.5S15.97 9 15 9s-2 .97-2 2.5 1.03 2.5 2 2.5zM6.96 3.84a.5.5 0 00-.94-.02L3.29 11h-.02v.05l-1.24 3.27a.5.5 0 00.94.36L3.98 12h4.76l.92 2.66a.5.5 0 10.95-.32L6.96 3.84zM4.36 11l2.1-5.54L8.4 11H4.36z",
    fill: primaryFill
  }));
};

export const TextCaseTitleRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/TextCaseTitleRegularIcon({}), 'TextCaseTitleRegular');

const TextCaseUppercaseFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M6.5 3.25c.31 0 .59.2.7.5l3.64 10.5a.75.75 0 11-1.41.5l-.78-2.25H4.06l-.86 2.27a.75.75 0 01-1.4-.54l3.98-10.5c.12-.3.4-.48.71-.48zM4.62 11h3.5L6.45 6.2 4.63 11zM12 3.5a.75.75 0 00-.75.75V14.5c0 .41.34.75.75.75h2.75a3.5 3.5 0 001.71-6.55 3.12 3.12 0 00-2.34-5.2H12zm3.75 3.13c0 .9-.73 1.62-1.63 1.62h-1.37V5h1.38c.9 0 1.62.73 1.62 1.63zm-1 7.12h-2v-4h2a2 2 0 110 4z",
    fill: primaryFill
  }));
};

export const TextCaseUppercaseFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/TextCaseUppercaseFilledIcon({}), 'TextCaseUppercaseFilled');

const TextCaseUppercaseRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M6.96 3.84a.5.5 0 00-.94-.02L3.29 11h-.02v.05l-1.24 3.27a.5.5 0 00.94.36L3.98 12h4.76l.92 2.66a.5.5 0 10.95-.32L6.96 3.84zM4.36 11l2.1-5.54L8.4 11H4.36zm7.14-7.25a.5.5 0 00-.5.5V14.5c0 .28.22.5.5.5h2.75a3.25 3.25 0 001.3-6.23 2.87 2.87 0 00-1.93-5.02H11.5zm4 2.88c0 1.03-.84 1.87-1.88 1.87H12V4.75h1.63c1.03 0 1.87.84 1.87 1.88zM14.25 14H12V9.5h2.25a2.25 2.25 0 010 4.5z",
    fill: primaryFill
  }));
};

export const TextCaseUppercaseRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/TextCaseUppercaseRegularIcon({}), 'TextCaseUppercaseRegular');

const TextChangeCaseFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M13.5 3.25c.31 0 .59.2.7.5l3.64 10.5a.75.75 0 11-1.41.5l-.78-2.25h-4.59l-.86 2.27a.75.75 0 11-1.4-.54l3.98-10.5c.12-.3.4-.48.71-.48zM11.62 11h3.5l-1.68-4.8-1.82 4.8zM4.9 8.94a2.8 2.8 0 00-1.06.23.75.75 0 01-.68-1.34 4.26 4.26 0 011.69-.4c.63-.02 1.34.08 1.99.4 1.42.71 1.41 2.12 1.41 2.63v4.04a.75.75 0 01-1.5.06c-.87.53-1.89.85-2.94.57a2.61 2.61 0 01-.73-4.75c.78-.52 1.7-.66 2.53-.61a6 6 0 011.1.16.97.97 0 00-.55-.76c-.35-.18-.8-.25-1.26-.23zm1.85 2.56a4.51 4.51 0 00-1.22-.24c-.62-.03-1.2.09-1.61.36-.93.62-.65 1.8.27 2.06.75.2 1.67-.19 2.56-1V11.5z",
    fill: primaryFill
  }));
};

export const TextChangeCaseFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/TextChangeCaseFilledIcon({}), 'TextChangeCaseFilled');

const TextChangeCaseRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M13.5 3.5c.2 0 .39.14.46.34l3.65 10.5a.5.5 0 01-.95.32L15.74 12h-4.76l-1.01 2.68a.5.5 0 01-.93.01l.24-1.03 1-2.6V11h.01l2.73-7.18a.5.5 0 01.47-.32zm-.04 1.96L11.36 11h4.03l-1.93-5.54zM4.9 8.7c-.48.02-.9.13-1.17.26a.5.5 0 01-.44-.9c.4-.2.98-.34 1.58-.36.6-.03 1.27.07 1.86.36C8 8.7 8 9.96 8 10.46v4.04a.5.5 0 01-1 0v-.41c-.91.66-2.01 1.1-3.13.8a2.36 2.36 0 01-.65-4.3c.72-.48 1.59-.61 2.38-.57.49.02.97.11 1.4.25-.02-.48-.12-1.02-.72-1.32-.4-.2-.9-.28-1.39-.26zM7 11.33c-.4-.17-.92-.29-1.45-.32-.66-.03-1.3.09-1.77.4-1.12.75-.77 2.21.35 2.5.9.25 1.94-.24 2.87-1.12v-1.46z",
    fill: primaryFill
  }));
};

export const TextChangeCaseRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/TextChangeCaseRegularIcon({}), 'TextChangeCaseRegular');

const TextClearFormattingFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M6 2c.2 0 .4.13.47.32l3.5 8.95a.5.5 0 01-.94.37L8.01 9H4l-1.04 2.68a.5.5 0 11-.94-.36l3.5-9A.5.5 0 016 2zm0 1.88L4.4 8H7.6l-1.6-4.12zM11.5 2c.28 0 .5.22.5.5v3.52a2.48 2.48 0 012.26-1.3c.89 0 1.6.34 2.15 1 .55.66.82 1.54.82 2.64l-.01.42-.05-.05a2.49 2.49 0 00-1.15-.65 2.86 2.86 0 00-.53-1.62c-.36-.47-.86-.7-1.48-.7-.6 0-1.09.24-1.47.72-.3.37-.47.83-.54 1.37v1.03c.05.43.18.8.37 1.12L11 11.37V2.5c0-.28.22-.5.5-.5zm4.97 7.44l2.1 2.1a1.5 1.5 0 01-.01 2.12l-3.6 3.6-4.21-4.22 3.6-3.6a1.5 1.5 0 012.12 0zm-2.22 8.52l-4.21-4.21-.6.6a1.5 1.5 0 000 2.12l2.1 2.1c.3.3.71.45 1.12.43h4.09a.5.5 0 100-1h-2.53l.03-.04z",
    fill: primaryFill
  }));
};

export const TextClearFormattingFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/TextClearFormattingFilledIcon({}), 'TextClearFormattingFilled');

const TextClearFormattingRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M6 2c.2 0 .4.13.47.32l3.5 8.95a.5.5 0 01-.94.37L8.01 9H4l-1.04 2.68a.5.5 0 11-.94-.36l3.5-9A.5.5 0 016 2zm0 1.88L4.4 8H7.6l-1.6-4.12zM11.5 2c.28 0 .5.22.5.5v3.52a2.48 2.48 0 012.26-1.3c.89 0 1.6.34 2.15 1 .55.66.82 1.54.82 2.64l-.01.42-.05-.05a2.49 2.49 0 00-1.15-.65 2.86 2.86 0 00-.53-1.62c-.36-.47-.86-.7-1.48-.7-.6 0-1.09.24-1.47.72-.3.37-.47.83-.54 1.37v1.03c.05.43.18.8.37 1.12L11 11.37V2.5c0-.28.22-.5.5-.5zM9.44 16.47a1.5 1.5 0 010-2.13l4.9-4.9a1.5 1.5 0 012.13 0l2.1 2.1a1.5 1.5 0 01-.01 2.12L14.22 18h2.53a.5.5 0 110 1h-4.1a1.5 1.5 0 01-1.12-.44l-2.1-2.1zm5.61-6.32l-3.6 3.6 2.8 2.8 3.6-3.6a.5.5 0 000-.7l-2.1-2.1a.5.5 0 00-.7 0zm-1.5 7.1l-2.8-2.8-.6.6a.5.5 0 000 .7l2.1 2.1c.19.2.5.2.7 0l.6-.6z",
    fill: primaryFill
  }));
};

export const TextClearFormattingRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/TextClearFormattingRegularIcon({}), 'TextClearFormattingRegular');

const TextCollapseFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M5 3.5c0-.41.34-.75.75-.75h11.5a.75.75 0 010 1.5H5.75A.75.75 0 015 3.5zm0 12c0-.41.34-.75.75-.75h11.5a.75.75 0 010 1.5H5.75A.75.75 0 015 15.5zm6.75-8.75a.75.75 0 000 1.5h5.5a.75.75 0 000-1.5h-5.5zM11 11.5c0-.41.34-.75.75-.75h5.5a.75.75 0 010 1.5h-5.5a.75.75 0 01-.75-.75zm-2-2a3.5 3.5 0 11-7 0 3.5 3.5 0 017 0zm-6 0c0 .28.22.5.5.5h4a.5.5 0 000-1h-4a.5.5 0 00-.5.5z",
    fill: primaryFill
  }));
};

export const TextCollapseFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/TextCollapseFilledIcon({}), 'TextCollapseFilled');

const TextCollapseRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M5 3.5c0-.28.22-.5.5-.5h12a.5.5 0 010 1h-12a.5.5 0 01-.5-.5zm0 12c0-.28.22-.5.5-.5h12a.5.5 0 010 1h-12a.5.5 0 01-.5-.5zm6-8c0-.28.22-.5.5-.5h6a.5.5 0 010 1h-6a.5.5 0 01-.5-.5zm0 4c0-.28.22-.5.5-.5h6a.5.5 0 010 1h-6a.5.5 0 01-.5-.5zm-2-2a3.5 3.5 0 11-7 0 3.5 3.5 0 017 0zM3.5 9a.5.5 0 000 1h4a.5.5 0 000-1h-4z",
    fill: primaryFill
  }));
};

export const TextCollapseRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/TextCollapseRegularIcon({}), 'TextCollapseRegular');

const TextColorFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M10.46 2.31a.5.5 0 00-.92 0l-3 7.5a.5.5 0 10.92.38L8.54 7.5h2.92l1.08 2.69a.5.5 0 10.92-.38l-3-7.5zM10 3.85l1.06 2.65H8.94L10 3.85zM4.5 12c-.83 0-1.5.67-1.5 1.5v3c0 .83.67 1.5 1.5 1.5h11c.83 0 1.5-.67 1.5-1.5v-3c0-.83-.67-1.5-1.5-1.5h-11z",
    fill: primaryFill
  }));
};

export const TextColorFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/TextColorFilledIcon({}), 'TextColorFilled');

const TextColorRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M10.46 2.31a.5.5 0 00-.92 0l-3 7.5a.5.5 0 10.92.38L8.54 7.5h2.92l1.08 2.69a.5.5 0 10.92-.38l-3-7.5zM10 3.85l1.06 2.65H8.94L10 3.85zM4.5 12c-.83 0-1.5.67-1.5 1.5v3c0 .83.67 1.5 1.5 1.5h11c.83 0 1.5-.67 1.5-1.5v-3c0-.83-.67-1.5-1.5-1.5h-11zM4 13.5c0-.28.22-.5.5-.5h11c.28 0 .5.22.5.5v3a.5.5 0 01-.5.5h-11a.5.5 0 01-.5-.5v-3z",
    fill: primaryFill
  }));
};

export const TextColorRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/TextColorRegularIcon({}), 'TextColorRegular');

const TextColorAccentFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M3.5 13.13c0-.35.24-.63.54-.63h11.92c.3 0 .54.28.54.63v3.74c0 .35-.24.63-.54.63H4.04c-.3 0-.54-.28-.54-.63v-3.75z",
    fill: primaryFill
  }));
};

export const TextColorAccentFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/TextColorAccentFilledIcon({}), 'TextColorAccentFilled');

const TextColumnOneFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M15 5.75a.75.75 0 00-.75-.75h-8.5a.75.75 0 000 1.5h8.5c.41 0 .75-.34.75-.75zm0 3a.75.75 0 00-.75-.75h-8.5a.75.75 0 000 1.5h8.5c.41 0 .75-.34.75-.75zm0 3a.75.75 0 00-.75-.75h-8.5a.75.75 0 000 1.5h8.5c.41 0 .75-.34.75-.75zm0 3a.75.75 0 00-.75-.75h-8.5a.75.75 0 000 1.5h8.5c.41 0 .75-.34.75-.75z",
    fill: primaryFill
  }));
};

export const TextColumnOneFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/TextColumnOneFilledIcon({}), 'TextColumnOneFilled');

const TextColumnOneRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M15 5.5a.5.5 0 00-.5-.5h-9a.5.5 0 000 1h9a.5.5 0 00.5-.5zm0 3a.5.5 0 00-.5-.5h-9a.5.5 0 000 1h9a.5.5 0 00.5-.5zm0 3a.5.5 0 00-.5-.5h-9a.5.5 0 000 1h9a.5.5 0 00.5-.5zm0 3a.5.5 0 00-.5-.5h-9a.5.5 0 000 1h9a.5.5 0 00.5-.5z",
    fill: primaryFill
  }));
};

export const TextColumnOneRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/TextColumnOneRegularIcon({}), 'TextColumnOneRegular');

const TextColumnOneNarrowFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M7.75 5a.75.75 0 000 1.5h4.5a.75.75 0 000-1.5h-4.5zm0 3a.75.75 0 000 1.5h4.5a.75.75 0 000-1.5h-4.5zM7 11.75c0-.41.34-.75.75-.75h4.5a.75.75 0 010 1.5h-4.5a.75.75 0 01-.75-.75zM7.75 14a.75.75 0 000 1.5h4.5a.75.75 0 000-1.5h-4.5z",
    fill: primaryFill
  }));
};

export const TextColumnOneNarrowFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/TextColumnOneNarrowFilledIcon({}), 'TextColumnOneNarrowFilled');

const TextColumnOneNarrowRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M7.5 5a.5.5 0 000 1h5a.5.5 0 000-1h-5zm0 3a.5.5 0 000 1h5a.5.5 0 000-1h-5zM7 11.5c0-.28.22-.5.5-.5h5a.5.5 0 010 1h-5a.5.5 0 01-.5-.5zm.5 2.5a.5.5 0 000 1h5a.5.5 0 000-1h-5z",
    fill: primaryFill
  }));
};

export const TextColumnOneNarrowRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/TextColumnOneNarrowRegularIcon({}), 'TextColumnOneNarrowRegular');

const TextColumnOneWideFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M3.75 5a.75.75 0 000 1.5h12.5a.75.75 0 000-1.5H3.75zm0 3a.75.75 0 000 1.5h12.5a.75.75 0 000-1.5H3.75zM3 11.75c0-.41.34-.75.75-.75h12.5a.75.75 0 010 1.5H3.75a.75.75 0 01-.75-.75zM3.75 14a.75.75 0 000 1.5h12.5a.75.75 0 000-1.5H3.75z",
    fill: primaryFill
  }));
};

export const TextColumnOneWideFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/TextColumnOneWideFilledIcon({}), 'TextColumnOneWideFilled');

const TextColumnOneWideRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M3.5 5a.5.5 0 000 1h13a.5.5 0 000-1h-13zm0 3a.5.5 0 000 1h13a.5.5 0 000-1h-13zM3 11.5c0-.28.22-.5.5-.5h13a.5.5 0 010 1h-13a.5.5 0 01-.5-.5zm.5 2.5a.5.5 0 000 1h13a.5.5 0 000-1h-13z",
    fill: primaryFill
  }));
};

export const TextColumnOneWideRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/TextColumnOneWideRegularIcon({}), 'TextColumnOneWideRegular');

const TextColumnOneWideLightningFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M3.75 5a.75.75 0 000 1.5h12.5a.75.75 0 000-1.5H3.75zm0 3a.75.75 0 000 1.5h8.46a5.48 5.48 0 014.39-.09.75.75 0 00-.35-1.41H3.75zm0 3h6.5a5.5 5.5 0 00-.88 1.5H3.75a.75.75 0 010-1.5zm0 3h5.27a5.57 5.57 0 00.07 1.5H3.75a.75.75 0 010-1.5zm15.25.5a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0zm-5.12-3a.5.5 0 00-.47.33l-.88 2.5A.5.5 0 0013 15h.78l-.51 1.87a.5.5 0 00.9.4l2.25-3.5A.5.5 0 0016 13h-.75l.28-.84a.5.5 0 00-.47-.66h-1.18z",
    fill: primaryFill
  }));
};

export const TextColumnOneWideLightningFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/TextColumnOneWideLightningFilledIcon({}), 'TextColumnOneWideLightningFilled');

const TextColumnOneWideLightningRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M3.5 5a.5.5 0 000 1h13a.5.5 0 000-1h-13zm0 3a.5.5 0 000 1h13a.5.5 0 000-1h-13zM9 14.5c0-.17 0-.34.02-.5H3.5a.5.5 0 000 1h5.52a5.57 5.57 0 01-.02-.5zm.6-2.5c.18-.36.4-.7.66-1H3.5a.5.5 0 000 1h6.1zm9.4 2.5a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0zm-5.12-3a.5.5 0 00-.47.33l-.88 2.5A.5.5 0 0013 15h.78l-.51 1.87a.5.5 0 00.9.4l2.25-3.5A.5.5 0 0016 13h-.75l.28-.84a.5.5 0 00-.47-.66h-1.18z",
    fill: primaryFill
  }));
};

export const TextColumnOneWideLightningRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/TextColumnOneWideLightningRegularIcon({}), 'TextColumnOneWideLightningRegular');

const TextColumnThreeFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M12 5.75a.75.75 0 00-.75-.75h-2.5a.75.75 0 000 1.5h2.5c.41 0 .75-.34.75-.75zm5 0a.75.75 0 00-.75-.75h-2.5a.75.75 0 000 1.5h2.5c.41 0 .75-.34.75-.75zm-10 0A.75.75 0 006.25 5h-2.5a.75.75 0 000 1.5h2.5c.41 0 .75-.34.75-.75zm5 3a.75.75 0 00-.75-.75h-2.5a.75.75 0 000 1.5h2.5c.41 0 .75-.34.75-.75zm5 0a.75.75 0 00-.75-.75h-2.5a.75.75 0 000 1.5h2.5c.41 0 .75-.34.75-.75zm-10 0A.75.75 0 006.25 8h-2.5a.75.75 0 000 1.5h2.5c.41 0 .75-.34.75-.75zm5 3a.75.75 0 00-.75-.75h-2.5a.75.75 0 000 1.5h2.5c.41 0 .75-.34.75-.75zm5 0a.75.75 0 00-.75-.75h-2.5a.75.75 0 000 1.5h2.5c.41 0 .75-.34.75-.75zm-10 0a.75.75 0 00-.75-.75h-2.5a.75.75 0 000 1.5h2.5c.41 0 .75-.34.75-.75zm5 3a.75.75 0 00-.75-.75h-2.5a.75.75 0 000 1.5h2.5c.41 0 .75-.34.75-.75zm5 0a.75.75 0 00-.75-.75h-2.5a.75.75 0 000 1.5h2.5c.41 0 .75-.34.75-.75zm-10 0a.75.75 0 00-.75-.75h-2.5a.75.75 0 000 1.5h2.5c.41 0 .75-.34.75-.75z",
    fill: primaryFill
  }));
};

export const TextColumnThreeFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/TextColumnThreeFilledIcon({}), 'TextColumnThreeFilled');

const TextColumnThreeRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M12 5.5a.5.5 0 00-.5-.5h-3a.5.5 0 000 1h3a.5.5 0 00.5-.5zm5 0a.5.5 0 00-.5-.5h-3a.5.5 0 000 1h3a.5.5 0 00.5-.5zm-10 0a.5.5 0 00-.5-.5h-3a.5.5 0 000 1h3a.5.5 0 00.5-.5zm5 3a.5.5 0 00-.5-.5h-3a.5.5 0 000 1h3a.5.5 0 00.5-.5zm5 0a.5.5 0 00-.5-.5h-3a.5.5 0 000 1h3a.5.5 0 00.5-.5zm-10 0a.5.5 0 00-.5-.5h-3a.5.5 0 000 1h3a.5.5 0 00.5-.5zm5 3a.5.5 0 00-.5-.5h-3a.5.5 0 000 1h3a.5.5 0 00.5-.5zm5 0a.5.5 0 00-.5-.5h-3a.5.5 0 000 1h3a.5.5 0 00.5-.5zm-10 0a.5.5 0 00-.5-.5h-3a.5.5 0 000 1h3a.5.5 0 00.5-.5zm5 3a.5.5 0 00-.5-.5h-3a.5.5 0 000 1h3a.5.5 0 00.5-.5zm5 0a.5.5 0 00-.5-.5h-3a.5.5 0 000 1h3a.5.5 0 00.5-.5zm-10 0a.5.5 0 00-.5-.5h-3a.5.5 0 000 1h3a.5.5 0 00.5-.5z",
    fill: primaryFill
  }));
};

export const TextColumnThreeRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/TextColumnThreeRegularIcon({}), 'TextColumnThreeRegular');

const TextColumnTwoFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M17 5.75a.75.75 0 00-.75-.75h-4.5a.75.75 0 000 1.5h4.5c.41 0 .75-.34.75-.75zm-8 0A.75.75 0 008.25 5h-4.5a.75.75 0 000 1.5h4.5c.41 0 .75-.34.75-.75zm8 3a.75.75 0 00-.75-.75h-4.5a.75.75 0 000 1.5h4.5c.41 0 .75-.34.75-.75zm-8 0A.75.75 0 008.25 8h-4.5a.75.75 0 000 1.5h4.5c.41 0 .75-.34.75-.75zm8 3a.75.75 0 00-.75-.75h-4.5a.75.75 0 000 1.5h4.5c.41 0 .75-.34.75-.75zm-8 0a.75.75 0 00-.75-.75h-4.5a.75.75 0 000 1.5h4.5c.41 0 .75-.34.75-.75zm8 3a.75.75 0 00-.75-.75h-4.5a.75.75 0 000 1.5h4.5c.41 0 .75-.34.75-.75zm-8 0a.75.75 0 00-.75-.75h-4.5a.75.75 0 000 1.5h4.5c.41 0 .75-.34.75-.75z",
    fill: primaryFill
  }));
};

export const TextColumnTwoFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/TextColumnTwoFilledIcon({}), 'TextColumnTwoFilled');

const TextColumnTwoRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M17 5.5a.5.5 0 00-.5-.5h-5a.5.5 0 000 1h5a.5.5 0 00.5-.5zm-8 0a.5.5 0 00-.5-.5h-5a.5.5 0 000 1h5a.5.5 0 00.5-.5zm8 3a.5.5 0 00-.5-.5h-5a.5.5 0 000 1h5a.5.5 0 00.5-.5zm-8 0a.5.5 0 00-.5-.5h-5a.5.5 0 000 1h5a.5.5 0 00.5-.5zm8 3a.5.5 0 00-.5-.5h-5a.5.5 0 000 1h5a.5.5 0 00.5-.5zm-8 0a.5.5 0 00-.5-.5h-5a.5.5 0 000 1h5a.5.5 0 00.5-.5zm8 3a.5.5 0 00-.5-.5h-5a.5.5 0 000 1h5a.5.5 0 00.5-.5zm-8 0a.5.5 0 00-.5-.5h-5a.5.5 0 000 1h5a.5.5 0 00.5-.5z",
    fill: primaryFill
  }));
};

export const TextColumnTwoRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/TextColumnTwoRegularIcon({}), 'TextColumnTwoRegular');

const TextColumnTwoLeftFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M3 5.75c0-.41.34-.75.75-.75h2.5a.75.75 0 010 1.5h-2.5A.75.75 0 013 5.75zm6 0c0-.41.34-.75.75-.75h6.5a.75.75 0 010 1.5h-6.5A.75.75 0 019 5.75zm-6 3c0-.41.34-.75.75-.75h2.5a.75.75 0 010 1.5h-2.5A.75.75 0 013 8.75zm6 0c0-.41.34-.75.75-.75h6.5a.75.75 0 010 1.5h-6.5A.75.75 0 019 8.75zm-6 3c0-.41.34-.75.75-.75h2.5a.75.75 0 010 1.5h-2.5a.75.75 0 01-.75-.75zm6 0c0-.41.34-.75.75-.75h6.5a.75.75 0 010 1.5h-6.5a.75.75 0 01-.75-.75zm-6 3c0-.41.34-.75.75-.75h2.5a.75.75 0 010 1.5h-2.5a.75.75 0 01-.75-.75zm6 0c0-.41.34-.75.75-.75h6.5a.75.75 0 010 1.5h-6.5a.75.75 0 01-.75-.75z",
    fill: primaryFill
  }));
};

export const TextColumnTwoLeftFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/TextColumnTwoLeftFilledIcon({}), 'TextColumnTwoLeftFilled');

const TextColumnTwoLeftRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M3 5.5c0-.28.22-.5.5-.5h3a.5.5 0 010 1h-3a.5.5 0 01-.5-.5zm6 0c0-.28.22-.5.5-.5h7a.5.5 0 010 1h-7a.5.5 0 01-.5-.5zm-6 3c0-.28.22-.5.5-.5h3a.5.5 0 010 1h-3a.5.5 0 01-.5-.5zm6 0c0-.28.22-.5.5-.5h7a.5.5 0 010 1h-7a.5.5 0 01-.5-.5zm-6 3c0-.28.22-.5.5-.5h3a.5.5 0 010 1h-3a.5.5 0 01-.5-.5zm6 0c0-.28.22-.5.5-.5h7a.5.5 0 010 1h-7a.5.5 0 01-.5-.5zm-6 3c0-.28.22-.5.5-.5h3a.5.5 0 010 1h-3a.5.5 0 01-.5-.5zm6 0c0-.28.22-.5.5-.5h7a.5.5 0 010 1h-7a.5.5 0 01-.5-.5z",
    fill: primaryFill
  }));
};

export const TextColumnTwoLeftRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/TextColumnTwoLeftRegularIcon({}), 'TextColumnTwoLeftRegular');

const TextColumnTwoRightFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M17 5.75a.75.75 0 00-.75-.75h-2.5a.75.75 0 000 1.5h2.5c.41 0 .75-.34.75-.75zm-6 0a.75.75 0 00-.75-.75h-6.5a.75.75 0 000 1.5h6.5c.41 0 .75-.34.75-.75zm6 3a.75.75 0 00-.75-.75h-2.5a.75.75 0 000 1.5h2.5c.41 0 .75-.34.75-.75zm-6 0a.75.75 0 00-.75-.75h-6.5a.75.75 0 000 1.5h6.5c.41 0 .75-.34.75-.75zm6 3a.75.75 0 00-.75-.75h-2.5a.75.75 0 000 1.5h2.5c.41 0 .75-.34.75-.75zm-6 0a.75.75 0 00-.75-.75h-6.5a.75.75 0 000 1.5h6.5c.41 0 .75-.34.75-.75zm6 3a.75.75 0 00-.75-.75h-2.5a.75.75 0 000 1.5h2.5c.41 0 .75-.34.75-.75zm-6 0a.75.75 0 00-.75-.75h-6.5a.75.75 0 000 1.5h6.5c.41 0 .75-.34.75-.75z",
    fill: primaryFill
  }));
};

export const TextColumnTwoRightFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/TextColumnTwoRightFilledIcon({}), 'TextColumnTwoRightFilled');

const TextColumnTwoRightRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M17 5.5a.5.5 0 00-.5-.5h-3a.5.5 0 000 1h3a.5.5 0 00.5-.5zm-6 0a.5.5 0 00-.5-.5h-7a.5.5 0 000 1h7a.5.5 0 00.5-.5zm6 3a.5.5 0 00-.5-.5h-3a.5.5 0 000 1h3a.5.5 0 00.5-.5zm-6 0a.5.5 0 00-.5-.5h-7a.5.5 0 000 1h7a.5.5 0 00.5-.5zm6 3a.5.5 0 00-.5-.5h-3a.5.5 0 000 1h3a.5.5 0 00.5-.5zm-6 0a.5.5 0 00-.5-.5h-7a.5.5 0 000 1h7a.5.5 0 00.5-.5zm6 3a.5.5 0 00-.5-.5h-3a.5.5 0 000 1h3a.5.5 0 00.5-.5zm-6 0a.5.5 0 00-.5-.5h-7a.5.5 0 000 1h7a.5.5 0 00.5-.5z",
    fill: primaryFill
  }));
};

export const TextColumnTwoRightRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/TextColumnTwoRightRegularIcon({}), 'TextColumnTwoRightRegular');

const TextContinuousFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M2 5.5c0-.41.34-.75.75-.75h14.5a.75.75 0 010 1.5H2.75A.75.75 0 012 5.5zm0 9c0-.41.34-.75.75-.75h14.5a.75.75 0 010 1.5H2.75A.75.75 0 012 14.5zm2.78-5.03l-1.5-1.5a.75.75 0 00-1.06 1.06l.97.97-.97.97a.75.75 0 101.06 1.06l1.5-1.5c.3-.3.3-.77 0-1.06zM7 8.5c0-.41.34-.75.75-.75h9.5a.75.75 0 010 1.5h-9.5A.75.75 0 017 8.5zm.75 2.25a.75.75 0 000 1.5h9.5a.75.75 0 000-1.5h-9.5z",
    fill: primaryFill
  }));
};

export const TextContinuousFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/TextContinuousFilledIcon({}), 'TextContinuousFilled');

const TextContinuousRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M2 5.5c0-.28.22-.5.5-.5h15a.5.5 0 010 1h-15a.5.5 0 01-.5-.5zm0 9c0-.28.22-.5.5-.5h15a.5.5 0 010 1h-15a.5.5 0 01-.5-.5zm1.35-6.35a.5.5 0 10-.7.7L3.79 10l-1.14 1.15a.5.5 0 00.7.7l1.5-1.5a.5.5 0 000-.7l-1.5-1.5zM7.5 8h10a.5.5 0 010 1h-10a.5.5 0 010-1zm0 3a.5.5 0 000 1h10a.5.5 0 000-1h-10z",
    fill: primaryFill
  }));
};

export const TextContinuousRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/TextContinuousRegularIcon({}), 'TextContinuousRegular');

const TextDensityFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M10.5 2c.28 0 .5.22.5.5v15a.5.5 0 01-1 0v-15c0-.28.22-.5.5-.5zM9 5H2.5a.5.5 0 000 1H9V5zm0 3H2.5a.5.5 0 000 1H9V8zm0 3H2.5a.5.5 0 000 1H9v-1zm0 3H2.5a.5.5 0 000 1H9v-1zm7.5 0H12v-3h4.5a1.5 1.5 0 010 3zm0-5H12V6h4.5a1.5 1.5 0 010 3z",
    fill: primaryFill
  }));
};

export const TextDensityFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/TextDensityFilledIcon({}), 'TextDensityFilled');

const TextDensityRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M10.5 2c.28 0 .5.22.5.5v15a.5.5 0 01-1 0v-15c0-.28.22-.5.5-.5zM9 5H2.5a.5.5 0 000 1H9V5zm0 3H2.5a.5.5 0 000 1H9V8zm0 3H2.5a.5.5 0 000 1H9v-1zm0 3H2.5a.5.5 0 000 1H9v-1zm7.5 0H12v-1h4.5a.5.5 0 000-1H12v-1h4.5a1.5 1.5 0 010 3zm0-5H12V8h4.5a.5.5 0 000-1H12V6h4.5a1.5 1.5 0 010 3z",
    fill: primaryFill
  }));
};

export const TextDensityRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/TextDensityRegularIcon({}), 'TextDensityRegular');

const TextDescriptionFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M2.75 4.5a.75.75 0 000 1.5h14.5a.75.75 0 000-1.5H2.75zm0 3a.75.75 0 000 1.5h14.5a.75.75 0 000-1.5H2.75zM2 11.25c0-.41.34-.75.75-.75h14.5a.75.75 0 010 1.5H2.75a.75.75 0 01-.75-.75zm.75 2.25a.75.75 0 000 1.5h9.5a.75.75 0 000-1.5h-9.5z",
    fill: primaryFill
  }));
};

export const TextDescriptionFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/TextDescriptionFilledIcon({}), 'TextDescriptionFilled');

const TextDescriptionRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M2.5 5a.5.5 0 000 1h15a.5.5 0 000-1h-15zm0 3a.5.5 0 000 1h15a.5.5 0 000-1h-15zM2 11.5c0-.28.22-.5.5-.5h15a.5.5 0 010 1h-15a.5.5 0 01-.5-.5zm.5 2.5a.5.5 0 000 1h10a.5.5 0 000-1h-10z",
    fill: primaryFill
  }));
};

export const TextDescriptionRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/TextDescriptionRegularIcon({}), 'TextDescriptionRegular');

const TextDirectionHorizontalLeftFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M13.5 3c-.3 0-.58.19-.7.47l-3 7.5a.75.75 0 001.4.56L12 9.5h3l.8 2.03a.75.75 0 001.4-.56l-3-7.5a.75.75 0 00-.7-.47zm0 2.77L14.4 8h-1.8l.9-2.23zM5.22 4.22a.75.75 0 011.06 1.06L5.56 6h3.69a.75.75 0 010 1.5H5.56l.72.72a.75.75 0 01-1.06 1.06l-2-2a.75.75 0 010-1.06l2-2zm0 7.5a.75.75 0 011.06 1.06l-.72.72h10.69a.75.75 0 010 1.5H5.56l.72.72a.75.75 0 11-1.06 1.06l-2-2a.75.75 0 010-1.06l2-2z",
    fill: primaryFill
  }));
};

export const TextDirectionHorizontalLeftFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/TextDirectionHorizontalLeftFilledIcon({}), 'TextDirectionHorizontalLeftFilled');

const TextDirectionHorizontalLeftRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M13.5 3a.5.5 0 00-.47.32l-3 8a.5.5 0 00.94.36l1-2.68h3.06l1 2.68a.5.5 0 00.94-.36l-3-8A.5.5 0 0013.5 3zm0 1.92L14.65 8h-2.3l1.15-3.08zm-8.35-.77a.5.5 0 11.7.7L4.71 6H9.5a.5.5 0 010 1H4.7l1.15 1.15a.5.5 0 11-.7.7l-2-2a.5.5 0 010-.7l2-2zm0 8a.5.5 0 01.7.7L4.71 14H16.5a.5.5 0 010 1H4.7l1.15 1.15a.5.5 0 01-.7.7l-2-2a.5.5 0 010-.7l2-2z",
    fill: primaryFill
  }));
};

export const TextDirectionHorizontalLeftRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/TextDirectionHorizontalLeftRegularIcon({}), 'TextDirectionHorizontalLeftRegular');

const TextDirectionHorizontalRightFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M6.5 3c.3 0 .58.19.7.47l3 7.5a.75.75 0 01-1.4.56L8 9.5H5l-.8 2.03a.75.75 0 01-1.4-.56l3-7.5A.75.75 0 016.5 3zm0 2.77L5.6 8h1.8l-.9-2.23zm8.28-1.55a.75.75 0 10-1.06 1.06l.72.72h-3.69a.75.75 0 000 1.5h3.69l-.72.72a.75.75 0 001.06 1.06l2-2c.3-.3.3-.77 0-1.06l-2-2zm0 7.5a.75.75 0 10-1.06 1.06l.72.72H3.75a.75.75 0 000 1.5h10.69l-.72.72a.75.75 0 101.06 1.06l2-2c.3-.3.3-.77 0-1.06l-2-2z",
    fill: primaryFill
  }));
};

export const TextDirectionHorizontalRightFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/TextDirectionHorizontalRightFilledIcon({}), 'TextDirectionHorizontalRightFilled');

const TextDirectionHorizontalRightRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M6.5 3c.2 0 .4.13.47.32l3 8a.5.5 0 01-.94.36L8.03 9H4.97l-1 2.68a.5.5 0 01-.94-.36l3-8A.5.5 0 016.5 3zm0 1.92L5.35 8h2.3L6.5 4.92zm8.35-.77a.5.5 0 10-.7.7L15.29 6H10.5a.5.5 0 000 1h4.8l-1.15 1.15a.5.5 0 10.7.7l2-2a.5.5 0 000-.7l-2-2zm0 8a.5.5 0 00-.7.7L15.29 14H3.5a.5.5 0 000 1h11.8l-1.15 1.15a.5.5 0 00.7.7l2-2a.5.5 0 000-.7l-2-2z",
    fill: primaryFill
  }));
};

export const TextDirectionHorizontalRightRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/TextDirectionHorizontalRightRegularIcon({}), 'TextDirectionHorizontalRightRegular');

const TextDirectionRotate270RightFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M4.22 5.22a.75.75 0 001.06 1.06L6 5.56v3.69a.75.75 0 001.5 0V5.56l.72.72a.75.75 0 001.06-1.06l-2-2a.75.75 0 00-1.06 0l-2 2zm7.5 0a.75.75 0 101.06 1.06l.72-.72v10.69a.75.75 0 101.5 0V5.56l.72.72a.75.75 0 001.06-1.06l-2-2a.75.75 0 00-1.06 0l-2 2zM3 13.5c0-.3.19-.58.47-.7l7.5-3a.75.75 0 11.56 1.4L9.5 12v3l2.03.8a.75.75 0 01-.56 1.4l-7.5-3a.75.75 0 01-.47-.7zm2.77 0l2.23.9v-1.8l-2.23.9z",
    fill: primaryFill
  }));
};

export const TextDirectionRotate270RightFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/TextDirectionRotate270RightFilledIcon({}), 'TextDirectionRotate270RightFilled');

const TextDirectionRotate270RightRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M8.85 5.15a.5.5 0 11-.7.7L7 4.71V9.5a.5.5 0 01-1 0V4.7L4.85 5.86a.5.5 0 11-.7-.7l2-2c.2-.2.5-.2.7 0l2 2zm8 0a.5.5 0 11-.7.7L15 4.71V16.5a.5.5 0 01-1 0V4.7l-1.15 1.15a.5.5 0 11-.7-.7l2-2c.2-.2.5-.2.7 0l2 2zM3 13.5c0-.2.13-.4.32-.47l8-3a.5.5 0 01.36.94l-2.68 1v3.06l2.68 1a.5.5 0 01-.36.94l-8-3A.5.5 0 013 13.5zm1.92 0L8 14.65v-2.3L4.92 13.5z",
    fill: primaryFill
  }));
};

export const TextDirectionRotate270RightRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/TextDirectionRotate270RightRegularIcon({}), 'TextDirectionRotate270RightRegular');

const TextDirectionRotate90LeftFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M17 13.5c0 .3-.19.58-.47.7l-7.5 3a.75.75 0 01-.56-1.4l2.03-.8v-3l-2.03-.8a.75.75 0 01.56-1.4l7.5 3c.28.12.47.4.47.7zm-2.77 0L12 12.6v1.8l2.23-.9zM5 16.25a.75.75 0 001.5 0V5.56l.72.72a.75.75 0 001.06-1.06l-2-2a.75.75 0 00-1.06 0l-2 2a.75.75 0 001.06 1.06L5 5.56v10.69zm8-7a.75.75 0 001.5 0V5.56l.72.72a.75.75 0 101.06-1.06l-2-2a.75.75 0 00-1.06 0l-2 2a.75.75 0 001.06 1.06l.72-.72v3.69z",
    fill: primaryFill
  }));
};

export const TextDirectionRotate90LeftFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/TextDirectionRotate90LeftFilledIcon({}), 'TextDirectionRotate90LeftFilled');

const TextDirectionRotate90LeftRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M17 13.5c0 .2-.13.4-.32.47l-8 3a.5.5 0 11-.36-.94l2.68-1v-3.06l-2.68-1a.5.5 0 11.36-.94l8 3c.2.07.32.26.32.47zm-1.92 0L12 12.35v2.3l3.08-1.15zM5 16.5a.5.5 0 101 0V4.7l1.15 1.15a.5.5 0 00.7-.7l-2-2A.5.5 0 005.5 3a.5.5 0 00-.35.15l-2 2a.5.5 0 10.7.7L5 4.71V16.5zm8-7a.5.5 0 001 0V4.7l1.15 1.15a.5.5 0 00.7-.7l-2-2a.5.5 0 00-.7 0l-2 2a.5.5 0 00.7.7L13 4.71V9.5z",
    fill: primaryFill
  }));
};

export const TextDirectionRotate90LeftRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/TextDirectionRotate90LeftRegularIcon({}), 'TextDirectionRotate90LeftRegular');

const TextDirectionRotate90RightFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M17 6.5c0-.3-.19-.58-.47-.7l-7.5-3a.75.75 0 00-.56 1.4l2.03.8v3l-2.03.8a.75.75 0 10.56 1.4l7.5-3a.75.75 0 00.47-.7zm-2.77 0L12 7.4V5.6l2.23.9zM5 3.75a.75.75 0 011.5 0v10.69l.72-.72a.75.75 0 111.06 1.06l-2 2c-.3.3-.77.3-1.06 0l-2-2a.75.75 0 011.06-1.06l.72.72V3.75zm8 7a.75.75 0 011.5 0v3.69l.72-.72a.75.75 0 111.06 1.06l-2 2a.75.75 0 01-1.06 0l-2-2a.75.75 0 011.06-1.06l.72.72v-3.69z",
    fill: primaryFill
  }));
};

export const TextDirectionRotate90RightFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/TextDirectionRotate90RightFilledIcon({}), 'TextDirectionRotate90RightFilled');

const TextDirectionRotate90RightRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M17 6.5a.5.5 0 00-.32-.47l-8-3a.5.5 0 10-.36.94l2.68 1v3.06l-2.68 1a.5.5 0 00.36.94l8-3A.5.5 0 0017 6.5zm-1.92 0L12 7.65v-2.3l3.08 1.15zM5 3.5a.5.5 0 011 0v11.8l1.15-1.15a.5.5 0 11.7.7l-2 2a.5.5 0 01-.35.15.5.5 0 01-.35-.15l-2-2a.5.5 0 11.7-.7L5 15.29V3.5zm8 7a.5.5 0 011 0v4.8l1.15-1.15a.5.5 0 01.7.7l-2 2a.5.5 0 01-.7 0l-2-2a.5.5 0 01.7-.7L13 15.29V10.5z",
    fill: primaryFill
  }));
};

export const TextDirectionRotate90RightRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/TextDirectionRotate90RightRegularIcon({}), 'TextDirectionRotate90RightRegular');

const TextDirectionVerticalFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M5 3.75a.75.75 0 011.5 0v10.69l.72-.72a.75.75 0 011.06 1.06l-2 2c-.3.3-.77.3-1.06 0l-2-2a.75.75 0 111.06-1.06l.72.72V3.75zm8 9a.75.75 0 011.5 0v1.69l.72-.72a.75.75 0 111.06 1.06l-2 2a.75.75 0 01-1.06 0l-2-2a.76.76 0 010-1.07c.3-.3.77-.28 1.06.01l.72.72v-1.69zM13.5 3c.3 0 .58.19.7.47l3 7.5a.75.75 0 01-1.4.56L15 9.5h-3l-.8 2.03a.75.75 0 01-1.4-.56l3-7.5a.75.75 0 01.7-.47zm0 2.77L12.6 8h1.8l-.9-2.23z",
    fill: primaryFill
  }));
};

export const TextDirectionVerticalFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/TextDirectionVerticalFilledIcon({}), 'TextDirectionVerticalFilled');

const TextDirectionVerticalRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M5 3.5a.5.5 0 011 0v11.8l1.15-1.15a.5.5 0 01.7.7l-2 2a.5.5 0 01-.35.15.5.5 0 01-.35-.15l-2-2a.5.5 0 01.7-.7L5 15.29V3.5zm8 9a.5.5 0 011 0v2.8l1.15-1.15a.5.5 0 01.7.7l-2 2a.5.5 0 01-.7 0l-2-2a.5.5 0 01.7-.7L13 15.29V12.5zm.5-9.5a.5.5 0 00-.47.32l-3 8a.5.5 0 00.94.36l1-2.68h3.06l1 2.68a.5.5 0 00.94-.36l-3-8A.5.5 0 0013.5 3zm0 1.92L14.65 8h-2.3l1.15-3.08z",
    fill: primaryFill
  }));
};

export const TextDirectionVerticalRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/TextDirectionVerticalRegularIcon({}), 'TextDirectionVerticalRegular');

const TextEditStyleFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M14.09 6.7a2.26 2.26 0 013.07-.12l.13.12.12.13c.73.85.73 2.1 0 2.96l-.12.13-6.87 6.9a1.5 1.5 0 01-.55.35l-.16.05-3.08.76a.5.5 0 01-.62-.53l.01-.08.8-3.07c.05-.21.15-.4.28-.57l.1-.12 6.89-6.9zM6.42 2.23l.05.08 2.98 7.63-.77.78L8 9H4l-1.03 2.68a.5.5 0 01-.56.3l-.1-.02a.5.5 0 01-.3-.56l.02-.08 3.5-9a.5.5 0 01.9-.1zM6 3.87L4.4 8H7.6l-1.6-4.13z",
    fill: primaryFill
  }));
};

export const TextEditStyleFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/TextEditStyleFilledIcon({}), 'TextEditStyleFilled');

const TextEditStyleRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M14.09 6.7a2.26 2.26 0 013.07-.12l.13.12.12.13c.73.85.73 2.1 0 2.96l-.12.13-6.87 6.9a1.5 1.5 0 01-.55.35l-.16.05-3.08.76a.5.5 0 01-.62-.53l.01-.08.8-3.07c.05-.21.15-.4.28-.57l.1-.12 6.89-6.9zm2.5.7a1.26 1.26 0 00-1.7-.08l-.1.09-6.88 6.9a.5.5 0 00-.1.15l-.03.08-.58 2.27 2.27-.56a.5.5 0 00.12-.05l.05-.03.07-.06 6.87-6.9c.5-.5.5-1.3 0-1.8zM6.41 2.24l.05.08 2.98 7.63-.77.78L8 9H4l-1.03 2.68a.5.5 0 01-.56.3l-.1-.02a.5.5 0 01-.3-.56l.02-.08 3.5-9a.5.5 0 01.9-.1zM6 3.87L4.4 8H7.6l-1.6-4.13z",
    fill: primaryFill
  }));
};

export const TextEditStyleRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/TextEditStyleRegularIcon({}), 'TextEditStyleRegular');

const TextEffectsFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M12.09 3.9a2.25 2.25 0 00-4.18 0L4.9 11.37a2.2 2.2 0 00-.04.1l-1.2 2.95a2.25 2.25 0 004.18 1.68l.64-1.59h3.04l.64 1.6a2.25 2.25 0 104.18-1.7l-1.2-2.95a2.27 2.27 0 00-.04-.1L12.1 3.92zm-1.4.57l3.04 7.48v.03l1.22 2.99a.75.75 0 01-1.4.56L12.54 13H7.47l-1.02 2.53a.75.75 0 01-1.4-.56l1.21-2.99.02-.03L9.3 4.47a.75.75 0 011.39 0zm1.23 7.03H8.08L10 6.75l1.92 4.75z",
    fill: primaryFill
  }));
};

export const TextEffectsFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/TextEffectsFilledIcon({}), 'TextEffectsFilled');

const TextEffectsRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M11.62 4.1a1.75 1.75 0 00-3.24 0l-3.02 7.46-.03.07-1.2 2.96a1.75 1.75 0 003.24 1.32L8.14 14h3.72l.77 1.9a1.75 1.75 0 003.24-1.3l-1.2-2.97a1.73 1.73 0 00-.03-.07l-3.02-7.47zm-1.18 6.4L10 9.41l-.44 1.09h.88zm.26-6.03l3.03 7.48v.03l1.22 2.99a.75.75 0 01-1.4.56L12.54 13H7.47l-1.02 2.53a.75.75 0 01-1.4-.56l1.21-2.99.02-.03L9.3 4.47a.75.75 0 011.39 0zm1.22 7.03H8.08L10 6.75l1.92 4.75z",
    fill: primaryFill
  }));
};

export const TextEffectsRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/TextEffectsRegularIcon({}), 'TextEffectsRegular');

const TextExpandFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M4.75 3.5a.75.75 0 000 1.5h12.5a.75.75 0 000-1.5H4.75zM4 16.25c0-.41.34-.75.75-.75h12.5a.75.75 0 010 1.5H4.75a.75.75 0 01-.75-.75zm7-4c0-.41.34-.75.75-.75h5.5a.75.75 0 010 1.5h-5.5a.75.75 0 01-.75-.75zm0-4c0-.41.34-.75.75-.75h5.5a.75.75 0 010 1.5h-5.5a.75.75 0 01-.75-.75zM5.5 14a3.5 3.5 0 100-7 3.5 3.5 0 000 7zM6 8.5V10h1.5a.5.5 0 010 1H6v1.5a.5.5 0 01-1 0V11H3.5a.5.5 0 010-1H5V8.5a.5.5 0 011 0z",
    fill: primaryFill
  }));
};

export const TextExpandFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/TextExpandFilledIcon({}), 'TextExpandFilled');

const TextExpandRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M4 4.5c0-.28.22-.5.5-.5h13a.5.5 0 010 1h-13a.5.5 0 01-.5-.5zm0 12c0-.28.22-.5.5-.5h13a.5.5 0 010 1h-13a.5.5 0 01-.5-.5zm6-4c0-.28.22-.5.5-.5h7a.5.5 0 010 1h-7a.5.5 0 01-.5-.5zm0-4c0-.28.22-.5.5-.5h7a.5.5 0 010 1h-7a.5.5 0 01-.5-.5zM5.5 14a3.5 3.5 0 110-7 3.5 3.5 0 010 7zM6 8.5a.5.5 0 00-1 0V10H3.5a.5.5 0 000 1H5v1.5a.5.5 0 001 0V11h1.5a.5.5 0 000-1H6V8.5z",
    fill: primaryFill
  }));
};

export const TextExpandRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/TextExpandRegularIcon({}), 'TextExpandRegular');

const TextFieldFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M2 7a3 3 0 013-3h10a3 3 0 013 3v6a3 3 0 01-3 3H5a3 3 0 01-3-3V7zm5-.5v1a.5.5 0 001 0V7h1.5v6H9a.5.5 0 000 1h2a.5.5 0 000-1h-.5V7H12v.5a.5.5 0 001 0v-1a.5.5 0 00-.5-.5h-5a.5.5 0 00-.5.5z",
    fill: primaryFill
  }));
};

export const TextFieldFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/TextFieldFilledIcon({}), 'TextFieldFilled');

const TextFieldRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M10.5 7H12v.5a.5.5 0 001 0v-1a.5.5 0 00-.5-.5h-5a.5.5 0 00-.5.5v1a.5.5 0 001 0V7h1.5v6H9a.5.5 0 000 1h2a.5.5 0 000-1h-.5V7zM2 7a3 3 0 013-3h10a3 3 0 013 3v6a3 3 0 01-3 3H5a3 3 0 01-3-3V7zm3-2a2 2 0 00-2 2v6c0 1.1.9 2 2 2h10a2 2 0 002-2V7a2 2 0 00-2-2H5z",
    fill: primaryFill
  }));
};

export const TextFieldRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/TextFieldRegularIcon({}), 'TextFieldRegular');

const TextFirstLineFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M4.28 2.22a.75.75 0 00-1.06 1.06l.97.97-.97.97a.75.75 0 001.06 1.06l1.5-1.5c.3-.3.3-.77 0-1.06l-1.5-1.5zM16.25 3.5h-7.5a.75.75 0 000 1.5h7.5a.75.75 0 000-1.5zm-12.5 10a.75.75 0 000 1.5h12.5a.75.75 0 000-1.5H3.75zm12.5-3.5H3.75a.75.75 0 010-1.5h12.5a.75.75 0 010 1.5z",
    fill: primaryFill
  }));
};

export const TextFirstLineFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/TextFirstLineFilledIcon({}), 'TextFirstLineFilled');

const TextFirstLineRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M3.35 3.15a.5.5 0 10-.7.7L3.79 5 2.65 6.15a.5.5 0 10.7.7l1.5-1.5a.5.5 0 000-.7l-1.5-1.5zM7.5 4a.5.5 0 000 1h10a.5.5 0 000-1h-10zm-5 10a.5.5 0 000 1h15a.5.5 0 000-1h-15zM2 9.5c0-.28.22-.5.5-.5h15a.5.5 0 010 1h-15a.5.5 0 01-.5-.5z",
    fill: primaryFill
  }));
};

export const TextFirstLineRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/TextFirstLineRegularIcon({}), 'TextFirstLineRegular');

const TextFontFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M6 2c.3 0 .59.2.7.48l2.27 5.94.05.13.03.1-.79 2.12-.49-1.27H4.22l-.77 2.02a.75.75 0 01-1.4-.53l3.25-8.5A.75.75 0 016 2zM4.8 8h2.4L6 4.85 4.8 8zm7.9-2.51a.75.75 0 00-1.4 0L7.2 16.5h-.45a.75.75 0 000 1.5h2.5a.75.75 0 100-1.5H8.8l.75-2h4.92l.75 2h-.46a.75.75 0 000 1.5h2.5a.75.75 0 100-1.5h-.44L12.7 5.49zm1.2 7.5h-3.8L12 7.9l1.9 5.1z",
    fill: primaryFill
  }));
};

export const TextFontFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/TextFontFilledIcon({}), 'TextFontFilled');

const TextFontRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M6 2c.2 0 .4.13.47.32L8.9 8.57v.02l.18.44-.53 1.4-.46-1.17H3.91l-.94 2.42a.5.5 0 11-.94-.36L3.1 8.59v-.02l2.43-6.25A.5.5 0 016 2zM4.3 8.26h3.4L6 3.88 4.3 8.26zm8.17-2.94a.5.5 0 00-.94 0L7.15 17H6.5a.5.5 0 000 1h2a.5.5 0 000-1h-.28l1.13-3h5.37l1.15 3h-.37a.5.5 0 100 1h2a.5.5 0 100-1h-.56L12.47 5.32zM14.34 13H9.72l2.29-6.09L14.34 13z",
    fill: primaryFill
  }));
};

export const TextFontRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/TextFontRegularIcon({}), 'TextFontRegular');

const TextFontInfoFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M8.2 3.75a.75.75 0 00-1.42-.02L2.8 14.23a.75.75 0 101.4.54l.86-2.27H8.1c.1-.53.27-1.03.51-1.5H5.63l1.82-4.8 1.48 4.24c.32-.47.7-.9 1.15-1.25L8.2 3.75zm5.3 7.13a.62.62 0 100 1.24.62.62 0 000-1.24zm0 5.12a.5.5 0 00.5-.5v-2a.5.5 0 00-1 0v2c0 .28.22.5.5.5zm0-7a4.5 4.5 0 100 9 4.5 4.5 0 000-9zm0 8a3.5 3.5 0 110-7 3.5 3.5 0 010 7z",
    fill: primaryFill
  }));
};

export const TextFontInfoFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/TextFontInfoFilledIcon({}), 'TextFontInfoFilled');

const TextFontInfoRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M7.96 3.84a.5.5 0 00-.94-.02L4.29 11h-.02v.05l-1.24 3.27a.5.5 0 00.94.36L4.98 12h3.23c.1-.35.23-.68.39-1H5.36l2.1-5.54 1.65 4.73c.23-.3.48-.58.77-.83L7.96 3.84zm5.54 7.04a.62.62 0 100 1.24.62.62 0 000-1.24zm0 5.12a.5.5 0 00.5-.5v-2a.5.5 0 00-1 0v2c0 .28.22.5.5.5zm0-7a4.5 4.5 0 100 9 4.5 4.5 0 000-9zm0 8a3.5 3.5 0 110-7 3.5 3.5 0 010 7z",
    fill: primaryFill
  }));
};

export const TextFontInfoRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/TextFontInfoRegularIcon({}), 'TextFontInfoRegular');

const TextFontSizeFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M13 3c.32 0 .6.2.7.5l4.26 12.25a.75.75 0 01-1.42.5l-1.3-3.75h-4.66L9.2 16.26a.75.75 0 01-1.4.01L6.92 14H4.26l-.8 2.25a.75.75 0 01-1.42-.5L4.8 8a.75.75 0 011.41-.02l2.28 5.9L12.3 3.48c.1-.3.39-.5.7-.49zM4.8 12.5h1.55l-.8-2.1-.75 2.1zm8.19-6.52L11.14 11h3.58l-1.74-5.02z",
    fill: primaryFill
  }));
};

export const TextFontSizeFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/TextFontSizeFilledIcon({}), 'TextFontSizeFilled');

const TextFontSizeRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M13 3.5c.2 0 .4.13.47.32l3 8v.02l1.5 3.98a.5.5 0 11-.94.36l-1.38-3.68h-5.3l-1.38 3.68a.5.5 0 01-.93 0L6.96 13.5H4.04l-1.08 2.69a.5.5 0 11-.92-.38l1.2-2.98v-.03l1.8-4.49a.5.5 0 01.92 0l1.8 4.5v.02l.73 1.79 1.04-2.78v-.03l3-7.99A.5.5 0 0113 3.5zm-2.28 8h4.56L13 5.42l-2.28 6.08zm-4.16 1L5.5 9.85 4.44 12.5h2.12z",
    fill: primaryFill
  }));
};

export const TextFontSizeRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/TextFontSizeRegularIcon({}), 'TextFontSizeRegular');

const TextFootnoteFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M17.3 3c.4.03.7.35.7.75v5.5a.75.75 0 01-1.5 0V6.11l-.31.23a.75.75 0 01-.83-1.25 2.84 2.84 0 001.16-1.5.75.75 0 01.79-.59zm-7.1 12.07a.79.79 0 01-.2-.55V6.61c0-.22.07-.42.21-.58a.76.76 0 01.57-.24c.22 0 .41.08.56.24.15.16.22.36.22.58v2.35a2.6 2.6 0 011.8-.71c.88 0 1.6.32 2.13.98.54.65.8 1.5.8 2.54 0 1.03-.26 1.89-.8 2.54-.54.66-1.26.98-2.14.98a2.5 2.5 0 01-1.84-.72.74.74 0 01-.77.72c-.2 0-.4-.06-.54-.22zm1.8-1.76c.3.37.68.55 1.14.55.49 0 .86-.18 1.13-.53.28-.36.43-.88.43-1.56s-.15-1.2-.43-1.56a1.33 1.33 0 00-1.13-.54c-.46 0-.83.19-1.13.56-.3.38-.46.88-.46 1.54s.16 1.16.46 1.54zm-10.25 1.2c0 .22.08.4.24.54H2c.16.14.36.2.57.2a.8.8 0 00.5-.16c.14-.1.23-.25.3-.43l.74-2.02h3.27l.76 2.02a.8.8 0 00.8.59c.2 0 .4-.06.56-.2a.69.69 0 00.25-.53c0-.13-.03-.26-.09-.4L6.71 6.44a1.1 1.1 0 00-.36-.51.97.97 0 00-.59-.18c-.22 0-.43.06-.6.18-.18.12-.3.3-.38.51l-2.94 7.68c-.06.14-.09.27-.09.4zm5.13-3.3H4.62l1.13-3.1 1.13 3.1z",
    fill: primaryFill
  }));
};

export const TextFootnoteFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/TextFootnoteFilledIcon({}), 'TextFootnoteFilled');

const TextFootnoteRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M18 3.5a.5.5 0 00-1 0c0 .47-.1.84-.3 1.17-.2.33-.52.65-.99.97a.5.5 0 10.58.83c.26-.19.5-.38.71-.59V9.5a.5.5 0 001 0v-6zm-7.5 11.54a.5.5 0 00.36-.14.5.5 0 00.15-.38v-.66h.02a2.3 2.3 0 002.07 1.18c.8 0 1.46-.3 1.95-.89.5-.6.74-1.39.74-2.38 0-1-.25-1.79-.74-2.38-.49-.6-1.14-.9-1.93-.9a2.23 2.23 0 00-2.03 1.17h-.03V6.61c0-.17-.05-.3-.15-.41a.49.49 0 00-.38-.16.51.51 0 00-.38.16c-.1.1-.15.24-.15.4v7.92c0 .16.04.28.13.38.1.1.21.14.36.14zm3.72-1.56c-.33.42-.77.63-1.33.63-.54 0-.98-.21-1.33-.64-.34-.43-.5-1-.5-1.7s.16-1.26.5-1.7c.35-.43.8-.65 1.33-.65.56 0 1 .22 1.33.64.32.42.48.99.48 1.7 0 .73-.16 1.3-.48 1.72zM2.16 14.87c.1.09.25.13.41.13.27 0 .46-.14.56-.42l.8-2.2h3.63l.81 2.2c.1.28.29.42.56.42a.6.6 0 00.4-.13c.12-.1.17-.21.17-.35a.9.9 0 00-.07-.3l-2.95-7.7C6.34 6.19 6.11 6 5.76 6c-.36 0-.61.18-.75.53l-2.94 7.68a.9.9 0 00-.07.3c0 .15.05.26.16.36zm5.07-3.42H4.27l1.46-4.02h.04l1.46 4.02z",
    fill: primaryFill
  }));
};

export const TextFootnoteRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/TextFootnoteRegularIcon({}), 'TextFootnoteRegular');

const TextGrammarArrowLeftFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M17.25 5a.75.75 0 010 1.5H2.75a.75.75 0 010-1.5h14.5zm0 3a.75.75 0 010 1.5h-.46a5.48 5.48 0 00-4.58 0H2.75a.75.75 0 010-1.5h14.5zm-14.5 7.5h6.34a5.53 5.53 0 01-.07-1.5H2.75a.75.75 0 000 1.5zm0-3h6.62a5.5 5.5 0 01.89-1.5H2.75a.75.75 0 000 1.5zm7.25 2a4.5 4.5 0 109 0 4.5 4.5 0 00-9 0zm4.15-2.35a.5.5 0 01.7.7L13.71 14h2.79a.5.5 0 010 1h-2.8l1.15 1.15a.5.5 0 01-.7.7l-2-2a.5.5 0 01-.15-.35.5.5 0 01.14-.35l2-2z",
    fill: primaryFill
  }));
};

export const TextGrammarArrowLeftFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/TextGrammarArrowLeftFilledIcon({}), 'TextGrammarArrowLeftFilled');

const TextGrammarArrowLeftRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M17.5 5a.5.5 0 010 1h-15a.5.5 0 010-1h15zm0 3a.5.5 0 010 1h-15a.5.5 0 010-1h15zm-7.24 3c-.26.3-.48.64-.66 1H2.5a.5.5 0 010-1h7.76zM9 14.5c0 .17 0 .34.02.5H2.5a.5.5 0 010-1h6.52l-.02.5zm1 0a4.5 4.5 0 109 0 4.5 4.5 0 00-9 0zm4.15-2.35a.5.5 0 01.7.7L13.71 14h2.79a.5.5 0 010 1h-2.8l1.15 1.15a.5.5 0 01-.7.7l-2-2a.5.5 0 01-.15-.35.5.5 0 01.14-.35l2-2z",
    fill: primaryFill
  }));
};

export const TextGrammarArrowLeftRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/TextGrammarArrowLeftRegularIcon({}), 'TextGrammarArrowLeftRegular');

const TextGrammarArrowRightFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M14.5 10a4.5 4.5 0 110 9 4.5 4.5 0 010-9zm2.35 4.85a.5.5 0 00.15-.35.5.5 0 00-.15-.35l-2-2a.5.5 0 00-.7.7L15.29 14H12.5a.5.5 0 000 1h2.8l-1.15 1.15a.5.5 0 00.7.7l2-2zM18 5.75a.75.75 0 00-.75-.75H2.75a.75.75 0 100 1.5h14.5c.41 0 .75-.34.75-.75zm0 3a.75.75 0 00-.75-.75H2.75a.75.75 0 100 1.5h9.46a5.48 5.48 0 014.58 0h.46c.41 0 .75-.34.75-.75zM9.1 15.5H2.74a.75.75 0 010-1.5h6.27a5.57 5.57 0 00.07 1.5zm.27-3H2.75a.75.75 0 010-1.5h7.5a5.5 5.5 0 00-.88 1.5z",
    fill: primaryFill
  }));
};

export const TextGrammarArrowRightFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/TextGrammarArrowRightFilledIcon({}), 'TextGrammarArrowRightFilled');

const TextGrammarArrowRightRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M17.5 5a.5.5 0 010 1h-15a.5.5 0 010-1h15zm0 3a.5.5 0 010 1h-15a.5.5 0 010-1h15zm-7.24 3c-.26.3-.48.64-.66 1H2.5a.5.5 0 010-1h7.76zM9 14.5c0 .17 0 .34.02.5H2.5a.5.5 0 010-1h6.52l-.02.5zm10 0a4.5 4.5 0 10-9 0 4.5 4.5 0 009 0zm-4.15 2.35a.5.5 0 01-.7-.7L15.29 15H12.5a.5.5 0 010-1h2.8l-1.15-1.15a.5.5 0 01.7-.7l2 2a.5.5 0 01.15.35.5.5 0 01-.14.35l-2 2z",
    fill: primaryFill
  }));
};

export const TextGrammarArrowRightRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/TextGrammarArrowRightRegularIcon({}), 'TextGrammarArrowRightRegular');

const TextGrammarCheckmarkFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M18 5.75a.75.75 0 00-.75-.75H2.75a.75.75 0 000 1.5h14.5c.41 0 .75-.34.75-.75zm0 3a.75.75 0 00-.75-.75H2.75a.75.75 0 000 1.5h9.46a5.48 5.48 0 014.58 0h.46c.41 0 .75-.34.75-.75zM9.02 14a5.57 5.57 0 00.07 1.5H2.75a.75.75 0 010-1.5h6.27zm1.24-3a5.5 5.5 0 00-.89 1.5H2.75a.75.75 0 010-1.5h7.5zM19 14.5a4.5 4.5 0 10-9 0 4.5 4.5 0 009 0zm-2.5-2a.5.5 0 01.75.66l-.06.06-3.51 3.65a.5.5 0 01-.67.02l-.07-.07-1.34-1.65a.5.5 0 01.72-.7l.06.07 1 1.23 3.12-3.27z",
    fill: primaryFill
  }));
};

export const TextGrammarCheckmarkFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/TextGrammarCheckmarkFilledIcon({}), 'TextGrammarCheckmarkFilled');

const TextGrammarCheckmarkRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M17.5 5a.5.5 0 010 1h-15a.5.5 0 010-1h15zm0 3a.5.5 0 010 1h-15a.5.5 0 010-1h15zM9 14.5c0-.17 0-.34.02-.5H2.5a.5.5 0 000 1h6.52a5.57 5.57 0 01-.02-.5zm.6-2.5c.18-.36.4-.7.66-1H2.5a.5.5 0 000 1h7.1zm4.9-2a4.5 4.5 0 110 9 4.5 4.5 0 010-9zm-1.12 5.77l-1-1.23-.06-.06a.5.5 0 00-.72.7l1.34 1.64.07.07c.2.16.48.15.67-.02l3.5-3.65.07-.06a.5.5 0 00-.75-.66l-3.12 3.27z",
    fill: primaryFill
  }));
};

export const TextGrammarCheckmarkRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/TextGrammarCheckmarkRegularIcon({}), 'TextGrammarCheckmarkRegular');

const TextGrammarDismissFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M18 5.75a.75.75 0 00-.75-.75H2.75a.75.75 0 100 1.5h14.5c.41 0 .75-.34.75-.75zm0 3a.75.75 0 00-.75-.75H2.75a.75.75 0 100 1.5h9.46a5.48 5.48 0 014.58 0h.46c.41 0 .75-.34.75-.75zM9.1 15.5H2.74a.75.75 0 010-1.5h6.27a5.57 5.57 0 00.07 1.5zm.27-3H2.75a.75.75 0 010-1.5h7.5a5.5 5.5 0 00-.88 1.5zm9.63 2a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0zm-4.5.7l1.15 1.15a.5.5 0 00.7-.7l-1.14-1.15 1.14-1.15a.5.5 0 00-.7-.7l-1.15 1.14-1.15-1.14a.5.5 0 00-.7.7l1.14 1.15-1.14 1.15a.5.5 0 00.7.7l1.15-1.14z",
    fill: primaryFill
  }));
};

export const TextGrammarDismissFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/TextGrammarDismissFilledIcon({}), 'TextGrammarDismissFilled');

const TextGrammarDismissRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M17.5 5a.5.5 0 010 1h-15a.5.5 0 010-1h15zm0 3a.5.5 0 010 1h-15a.5.5 0 010-1h15zm-7.24 3c-.26.3-.48.64-.66 1H2.5a.5.5 0 010-1h7.76zM9 14.5c0 .17 0 .34.02.5H2.5a.5.5 0 010-1h6.52l-.02.5zm5.5 4.5a4.5 4.5 0 100-9 4.5 4.5 0 000 9zm1.15-2.65l-1.15-1.14-1.15 1.14a.5.5 0 01-.7-.7l1.14-1.15-1.14-1.15a.5.5 0 01.7-.7l1.15 1.14 1.15-1.14a.5.5 0 01.7.7l-1.14 1.15 1.14 1.15a.5.5 0 01-.7.7z",
    fill: primaryFill
  }));
};

export const TextGrammarDismissRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/TextGrammarDismissRegularIcon({}), 'TextGrammarDismissRegular');

const TextGrammarErrorFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M2.75 5a.75.75 0 000 1.5h14.5a.75.75 0 000-1.5H2.75zm0 3a.75.75 0 000 1.5h9.46a5.48 5.48 0 014.58 0h.46a.75.75 0 000-1.5H2.75zm0 3h7.5a5.5 5.5 0 00-.88 1.5H2.75a.75.75 0 010-1.5zm0 3h6.27a5.57 5.57 0 00.07 1.5H2.75a.75.75 0 010-1.5zm16.25.5a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0zM14.5 12a.5.5 0 00-.5.5v2a.5.5 0 001 0v-2a.5.5 0 00-.5-.5zm0 5.13a.62.62 0 100-1.25.62.62 0 000 1.24z",
    fill: primaryFill
  }));
};

export const TextGrammarErrorFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/TextGrammarErrorFilledIcon({}), 'TextGrammarErrorFilled');

const TextGrammarErrorRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M2.5 5a.5.5 0 000 1h15a.5.5 0 000-1h-15zm0 3a.5.5 0 000 1h15a.5.5 0 000-1h-15zM9 14.5c0-.17 0-.34.02-.5H2.5a.5.5 0 000 1h6.52a5.57 5.57 0 01-.02-.5zm.6-2.5c.18-.36.4-.7.66-1H2.5a.5.5 0 000 1h7.1zm9.4 2.5a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0zM14.5 12a.5.5 0 00-.5.5v2a.5.5 0 001 0v-2a.5.5 0 00-.5-.5zm0 5.13a.62.62 0 100-1.25.62.62 0 000 1.24z",
    fill: primaryFill
  }));
};

export const TextGrammarErrorRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/TextGrammarErrorRegularIcon({}), 'TextGrammarErrorRegular');

const TextGrammarSettingsFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M18 5.75a.75.75 0 00-.75-.75H2.75a.75.75 0 100 1.5h14.5c.41 0 .75-.34.75-.75zm0 3a.75.75 0 00-.75-.75H2.75a.75.75 0 100 1.5h9.46a5.48 5.48 0 014.58 0h.46c.41 0 .75-.34.75-.75zM2.75 11h7.5a5.5 5.5 0 00-.88 1.5H2.75a.75.75 0 010-1.5zm0 3h6.27a5.57 5.57 0 00.07 1.5H2.75a.75.75 0 010-1.5zm9.32-2.56a2 2 0 01-1.43 2.48l-.47.12a4.7 4.7 0 00.01 1.01l.35.09A2 2 0 0112 17.66l-.13.42c.26.2.54.38.84.52l.32-.35a2 2 0 012.91 0l.34.36c.3-.13.57-.3.82-.5l-.15-.55a2 2 0 011.43-2.48l.46-.12a4.73 4.73 0 00-.01-1.01l-.35-.09A2 2 0 0117 11.34l.13-.42c-.26-.2-.54-.38-.84-.52l-.32.35a2 2 0 01-2.91 0l-.34-.36c-.3.13-.57.3-.82.5l.16.55zm2.43 4.06a1 1 0 110-2 1 1 0 010 2z",
    fill: primaryFill
  }));
};

export const TextGrammarSettingsFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/TextGrammarSettingsFilledIcon({}), 'TextGrammarSettingsFilled');

const TextGrammarSettingsRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M18 5.5a.5.5 0 00-.5-.5h-15a.5.5 0 000 1h15a.5.5 0 00.5-.5zm0 3a.5.5 0 00-.5-.5h-15a.5.5 0 000 1h15a.5.5 0 00.5-.5zm-9 6c0 .17 0 .34.02.5H2.5a.5.5 0 010-1h6.52l-.02.5zm1.26-3.5c-.26.3-.48.64-.66 1H2.5a.5.5 0 010-1h7.76zm1.8.44a2 2 0 01-1.42 2.48l-.47.12a4.7 4.7 0 00.01 1.01l.35.09A2 2 0 0112 17.66l-.13.42c.26.2.54.38.84.52l.32-.35a2 2 0 012.91 0l.34.36c.3-.13.57-.3.82-.5l-.15-.55a2 2 0 011.43-2.48l.46-.12a4.73 4.73 0 00-.01-1.01l-.35-.09A2 2 0 0117 11.34l.13-.42c-.26-.2-.54-.38-.84-.52l-.32.35a2 2 0 01-2.91 0l-.34-.36c-.3.13-.57.3-.82.5l.16.55zm2.44 4.06a1 1 0 110-2 1 1 0 010 2z",
    fill: primaryFill
  }));
};

export const TextGrammarSettingsRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/TextGrammarSettingsRegularIcon({}), 'TextGrammarSettingsRegular');

const TextGrammarWandFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M2.75 4.5a.75.75 0 000 1.5h14.5a.75.75 0 000-1.5H2.75zm0 3a.75.75 0 000 1.5h8.5a.75.75 0 000-1.5h-8.5zm0 3a.75.75 0 000 1.5h6.63a1.5 1.5 0 01-.28-1.5H2.75zm0 3h6.63L7.88 15H2.75a.75.75 0 010-1.5zM14.5 7.44a.5.5 0 00-1 0l-.1.79a2.5 2.5 0 01-2.17 2.18l-.8.1a.5.5 0 000 .99l.8.1a2.5 2.5 0 012.18 2.17l.1.8a.5.5 0 00.99 0l.1-.8a2.5 2.5 0 012.17-2.18l.8-.1a.5.5 0 000-.99l-.8-.1a2.5 2.5 0 01-2.18-2.17l-.1-.8zm-2.65 5.7c.2.2.2.52 0 .71l-4 4a.5.5 0 01-.7-.7l4-4c.2-.2.5-.2.7 0z",
    fill: primaryFill
  }));
};

export const TextGrammarWandFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/TextGrammarWandFilledIcon({}), 'TextGrammarWandFilled');

const TextGrammarWandRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M2.5 5a.5.5 0 000 1h15a.5.5 0 000-1h-15zm0 3a.5.5 0 000 1h9a.5.5 0 000-1h-9zm0 3a.5.5 0 000 1h6.88a1.5 1.5 0 01-.37-.99V11H2.5zm0 3h6.38l-1 1H2.5a.5.5 0 010-1zM14 7a.5.5 0 01.5.44l.1.79a2.5 2.5 0 002.17 2.18l.8.1a.5.5 0 010 .99l-.8.1a2.5 2.5 0 00-2.18 2.17l-.1.8a.5.5 0 01-.99 0l-.1-.8a2.5 2.5 0 00-2.17-2.18l-.8-.1a.5.5 0 010-.99l.8-.1a2.5 2.5 0 002.18-2.17l.1-.8A.5.5 0 0114 7zm0 2.6a3.5 3.5 0 01-1.4 1.4c.59.32 1.08.81 1.4 1.4a3.5 3.5 0 011.4-1.4A3.5 3.5 0 0114 9.6zm-2.15 3.55c.2.2.2.5 0 .7l-4 4a.5.5 0 01-.7-.7l4-4c.2-.2.5-.2.7 0z",
    fill: primaryFill
  }));
};

export const TextGrammarWandRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/TextGrammarWandRegularIcon({}), 'TextGrammarWandRegular');

const TextHangingFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M3.75 3.5a.75.75 0 000 1.5h12.5a.75.75 0 000-1.5H3.75zm5 10a.75.75 0 000 1.5h7.5a.75.75 0 000-1.5h-7.5zM8 9.25c0-.41.34-.75.75-.75h7.5a.75.75 0 010 1.5h-7.5A.75.75 0 018 9.25zm-3.72 1.47a.75.75 0 00-1.06 1.06l.97.97-.97.97a.75.75 0 101.06 1.06l1.5-1.5c.3-.3.3-.77 0-1.06l-1.5-1.5z",
    fill: primaryFill
  }));
};

export const TextHangingFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/TextHangingFilledIcon({}), 'TextHangingFilled');

const TextHangingRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M3.5 4a.5.5 0 000 1h13a.5.5 0 000-1h-13zm4 10a.5.5 0 000 1h9a.5.5 0 000-1h-9zM7 9.5c0-.28.22-.5.5-.5h9a.5.5 0 010 1h-9a.5.5 0 01-.5-.5zm-2.15 2.15l-1.5-1.5a.5.5 0 00-.7.7L3.79 12l-1.14 1.15a.5.5 0 00.7.7l1.5-1.5a.5.5 0 000-.7z",
    fill: primaryFill
  }));
};

export const TextHangingRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/TextHangingRegularIcon({}), 'TextHangingRegular');

const TextHeader1FilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M16.57 3.82a.74.74 0 00-.8.1.75.75 0 00-.26.43 6.52 6.52 0 01-2.68 3.53.75.75 0 10.84 1.24 8.77 8.77 0 001.83-1.65v8.03a.75.75 0 001.5 0V4.52a.75.75 0 00-.43-.7zM3.5 4.5a.75.75 0 10-1.5 0v11a.75.75 0 001.5 0v-5h5v5a.75.75 0 001.5 0v-11a.75.75 0 10-1.5 0V9h-5V4.5z",
    fill: primaryFill
  }));
};

export const TextHeader1Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/TextHeader1FilledIcon({}), 'TextHeader1Filled');

const TextHeader1RegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M16.55 4a.5.5 0 01.45.5v11a.5.5 0 01-1 0V6.73a8.58 8.58 0 01-2.22 2.19.5.5 0 11-.56-.84 6.76 6.76 0 002.83-3.8.5.5 0 01.5-.28zM2.5 4c.28 0 .5.22.5.5V9h6V4.5a.5.5 0 111 0v11a.5.5 0 01-1 0V10H3v5.5a.5.5 0 01-1 0v-11c0-.28.22-.5.5-.5z",
    fill: primaryFill
  }));
};

export const TextHeader1Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/TextHeader1RegularIcon({}), 'TextHeader1Regular');

const TextHeader2FilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M3.5 4.5a.75.75 0 00-1.5 0v11a.75.75 0 001.5 0v-5h5v5a.75.75 0 001.5 0v-11a.75.75 0 00-1.5 0V9h-5V4.5zm11.25.75A2.3 2.3 0 0012.5 7.5a.75.75 0 01-1.5 0 3.8 3.8 0 013.75-3.75c1.4 0 2.48.8 2.97 1.91.5 1.11.41 2.5-.33 3.73a6.18 6.18 0 01-1.52 1.6l-.82.62-.07.04c-.3.22-.58.43-.85.65-.9.72-1.57 1.45-1.8 2.45h4.92a.75.75 0 010 1.5H11.5a.75.75 0 01-.75-.75c0-2.1 1.23-3.4 2.44-4.37l.9-.69.07-.04.78-.59c.53-.42.93-.8 1.17-1.2.5-.85.52-1.71.24-2.34a1.68 1.68 0 00-1.6-1.02z",
    fill: primaryFill
  }));
};

export const TextHeader2Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/TextHeader2FilledIcon({}), 'TextHeader2Filled');

const TextHeader2RegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M2.5 4c.28 0 .5.22.5.5V9h6V4.5a.5.5 0 011 0v11a.5.5 0 01-1 0V10H3v5.5a.5.5 0 01-1 0v-11c0-.28.22-.5.5-.5zm12 1A2.54 2.54 0 0012 7.5a.5.5 0 01-1 0C11 5.75 12.45 4 14.5 4c1.24 0 2.4.57 3.05 1.54.66 1 .71 2.33-.12 3.72-.42.7-1 1.24-1.62 1.71-.3.24-.62.46-.92.67l-.14.1c-.26.18-.52.35-.77.54-1.01.75-1.78 1.51-1.95 2.72h5.47a.5.5 0 010 1h-6a.5.5 0 01-.5-.5c0-2 1.17-3.13 2.4-4.03.25-.19.52-.38.79-.56l.13-.09c.3-.21.6-.42.88-.64.57-.43 1.04-.89 1.37-1.44.67-1.1.56-2.02.14-2.65A2.64 2.64 0 0014.5 5z",
    fill: primaryFill
  }));
};

export const TextHeader2Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/TextHeader2RegularIcon({}), 'TextHeader2Regular');

const TextHeader3FilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M3.5 4.5a.75.75 0 00-1.5 0v11a.75.75 0 001.5 0v-5h5v5a.75.75 0 001.5 0v-11a.75.75 0 00-1.5 0V9h-5V4.5zm8.97 1.96c.09-.3.22-.57.47-.79.24-.2.69-.42 1.56-.42.78 0 1.26.3 1.55.65.32.37.45.82.45 1.1 0 .36-.1.92-.45 1.38-.33.42-.96.87-2.3.87a.75.75 0 000 1.5c.45 0 1.2.11 1.81.42.6.3.94.71.94 1.33 0 .84-.26 1.39-.6 1.72-.33.34-.82.53-1.4.53-.68 0-1.15-.12-1.46-.3a1.17 1.17 0 01-.55-.85.75.75 0 10-1.48.3c.17.81.6 1.44 1.26 1.84.63.38 1.41.51 2.23.51.92 0 1.8-.3 2.47-.97A3.82 3.82 0 0018 12.5c0-1.23-.7-2.03-1.48-2.51.28-.2.52-.44.72-.7.63-.8.76-1.74.76-2.29 0-.63-.25-1.43-.8-2.08a3.43 3.43 0 00-2.7-1.17 3.8 3.8 0 00-2.53.78 3.02 3.02 0 00-.94 1.51.75.75 0 001.44.42z",
    fill: primaryFill
  }));
};

export const TextHeader3Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/TextHeader3FilledIcon({}), 'TextHeader3Filled');

const TextHeader3RegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M3 4.5a.5.5 0 00-1 0v11a.5.5 0 001 0V10h6v5.5a.5.5 0 001 0v-11a.5.5 0 00-1 0V9H3V4.5zm8.98 2.14c.09-.3.28-.7.66-1.04.38-.32.95-.6 1.86-.6C16.24 5 17 6.19 17 7c0 .5-.1 1.11-.5 1.6-.37.46-1.08.9-2.5.9a.5.5 0 000 1c.5 0 1.3.06 1.94.36.31.15.57.34.76.6.18.24.3.57.3 1.04 0 1-.33 1.6-.76 1.96a2.7 2.7 0 01-1.74.54c-.7 0-1.22-.12-1.61-.36-.38-.24-.7-.63-.92-1.3a.5.5 0 10-.94.32c.27.83.71 1.44 1.33 1.83.61.38 1.34.51 2.14.51.82 0 1.7-.2 2.38-.77.7-.58 1.12-1.48 1.12-2.73 0-.66-.18-1.2-.5-1.63-.3-.42-.7-.7-1.1-.9.36-.2.65-.46.88-.74.6-.74.72-1.63.72-2.23 0-1.39-1.24-3-3.5-3a3.7 3.7 0 00-2.51.85 3.22 3.22 0 00-.97 1.51.5.5 0 00.96.28z",
    fill: primaryFill
  }));
};

export const TextHeader3Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/TextHeader3RegularIcon({}), 'TextHeader3Regular');

const TextIndentDecreaseLtrFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M6 4.75c0-.41.34-.75.75-.75h7.5a.75.75 0 010 1.5h-7.5A.75.75 0 016 4.75zM6.75 9a.75.75 0 000 1.5h10.5a.75.75 0 000-1.5H6.75zm0 5a.75.75 0 000 1.5h5.5a.75.75 0 000-1.5h-5.5zm-3.28-2.22a.75.75 0 001.06-1.06l-.97-.97.97-.97a.75.75 0 00-1.06-1.06l-1.5 1.5c-.3.3-.3.77 0 1.06l1.5 1.5z",
    fill: primaryFill
  }));
};

export const TextIndentDecreaseLtrFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/TextIndentDecreaseLtrFilledIcon({}), 'TextIndentDecreaseLtrFilled');

const TextIndentDecreaseLtrRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M6 4.5c0-.28.22-.5.5-.5h8a.5.5 0 110 1h-8a.5.5 0 01-.5-.5zM3.56 7.73a.5.5 0 01.7.7L3.22 9.5l1.06 1.06a.5.5 0 11-.7.7l-1.42-1.4a.5.5 0 010-.71l1.41-1.42zM6.5 9a.5.5 0 000 1h11a.5.5 0 100-1h-11zM6 14.5c0-.28.22-.5.5-.5h6a.5.5 0 110 1h-6a.5.5 0 01-.5-.5z",
    fill: primaryFill
  }));
};

export const TextIndentDecreaseLtrRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/TextIndentDecreaseLtrRegularIcon({}), 'TextIndentDecreaseLtrRegular');

const TextIndentDecreaseRtlFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M13.25 4a.75.75 0 010 1.5h-7.5a.75.75 0 010-1.5h7.5zM14 9.75a.75.75 0 00-.75-.75H2.75a.75.75 0 000 1.5h10.5c.41 0 .75-.34.75-.75zm0 5a.75.75 0 00-.75-.75h-5.5a.75.75 0 000 1.5h5.5c.41 0 .75-.34.75-.75zm1.22-7.03c.3-.3.77-.3 1.06 0l1.5 1.5c.3.3.3.77 0 1.06l-1.5 1.5a.75.75 0 11-1.06-1.06l.97-.97-.97-.97a.75.75 0 010-1.06z",
    fill: primaryFill
  }));
};

export const TextIndentDecreaseRtlFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/TextIndentDecreaseRtlFilledIcon({}), 'TextIndentDecreaseRtlFilled');

const TextIndentDecreaseRtlRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M5.5 4a.5.5 0 000 1h8a.5.5 0 000-1h-8zm-3 5a.5.5 0 000 1h11a.5.5 0 000-1h-11zM7 14.5c0-.28.22-.5.5-.5h6a.5.5 0 010 1h-6a.5.5 0 01-.5-.5zm9.45-6.76a.5.5 0 10-.7.7L16.8 9.5l-1.06 1.06a.5.5 0 10.7.71l1.42-1.41a.5.5 0 000-.7l-1.42-1.42z",
    fill: primaryFill
  }));
};

export const TextIndentDecreaseRtlRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/TextIndentDecreaseRtlRegularIcon({}), 'TextIndentDecreaseRtlRegular');

const TextIndentIncreaseLtrFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M6 4.75c0-.41.34-.75.75-.75h7.5a.75.75 0 010 1.5h-7.5A.75.75 0 016 4.75zM6.75 9a.75.75 0 000 1.5h10.5a.75.75 0 000-1.5H6.75zm0 5a.75.75 0 000 1.5h5.5a.75.75 0 000-1.5h-5.5zM3.03 7.72a.75.75 0 00-1.06 1.06l.97.97-.97.97a.75.75 0 101.06 1.06l1.5-1.5c.3-.3.3-.77 0-1.06l-1.5-1.5z",
    fill: primaryFill
  }));
};

export const TextIndentIncreaseLtrFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/TextIndentIncreaseLtrFilledIcon({}), 'TextIndentIncreaseLtrFilled');

const TextIndentIncreaseLtrRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M6 4.5c0-.28.22-.5.5-.5h8a.5.5 0 010 1h-8a.5.5 0 01-.5-.5zm0 5c0-.28.22-.5.5-.5h11a.5.5 0 010 1h-11a.5.5 0 01-.5-.5zm.5 4.5a.5.5 0 000 1h6a.5.5 0 000-1h-6zM2.85 7.73a.5.5 0 10-.7.7L3.2 9.5l-1.06 1.06a.5.5 0 10.7.7l1.42-1.4a.5.5 0 000-.71L2.85 7.73z",
    fill: primaryFill
  }));
};

export const TextIndentIncreaseLtrRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/TextIndentIncreaseLtrRegularIcon({}), 'TextIndentIncreaseLtrRegular');

const TextIndentIncreaseRtlFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M14 4.75a.75.75 0 00-.75-.75h-7.5a.75.75 0 000 1.5h7.5c.41 0 .75-.34.75-.75zM13.25 9a.75.75 0 010 1.5H2.75a.75.75 0 010-1.5h10.5zm0 5a.75.75 0 010 1.5h-5.5a.75.75 0 010-1.5h5.5zm3.72-6.28a.75.75 0 111.06 1.06l-.97.97.97.97a.75.75 0 11-1.06 1.06l-1.5-1.5a.75.75 0 010-1.06l1.5-1.5z",
    fill: primaryFill
  }));
};

export const TextIndentIncreaseRtlFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/TextIndentIncreaseRtlFilledIcon({}), 'TextIndentIncreaseRtlFilled');

const TextIndentIncreaseRtlRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M5 4.5c0-.28.22-.5.5-.5h8a.5.5 0 010 1h-8a.5.5 0 01-.5-.5zm-3 5c0-.28.22-.5.5-.5h11a.5.5 0 010 1h-11a.5.5 0 01-.5-.5zM7.5 14a.5.5 0 000 1h6a.5.5 0 000-1h-6zm10.37-6.26a.5.5 0 00-.71 0l-1.41 1.41a.5.5 0 000 .7l1.41 1.42a.5.5 0 10.7-.7L16.82 9.5l1.06-1.06a.5.5 0 000-.7z",
    fill: primaryFill
  }));
};

export const TextIndentIncreaseRtlRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/TextIndentIncreaseRtlRegularIcon({}), 'TextIndentIncreaseRtlRegular');

const TextItalicFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M8 3.25c0-.41.34-.75.75-.75h7.5a.75.75 0 010 1.5h-3.23L8.59 15.5h2.66a.75.75 0 010 1.5h-7.5a.75.75 0 010-1.5h3.23L11.41 4H8.75A.75.75 0 018 3.25z",
    fill: primaryFill
  }));
};

export const TextItalicFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/TextItalicFilledIcon({}), 'TextItalicFilled');

const TextItalicRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M16 3a.5.5 0 010 1h-3.16L8.23 16h3.27a.5.5 0 010 1H4a.5.5 0 010-1h3.16l4.61-12H8.5a.5.5 0 010-1H16z",
    fill: primaryFill
  }));
};

export const TextItalicRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/TextItalicRegularIcon({}), 'TextItalicRegular');

const TextLineSpacingFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M17.78 4.22a.75.75 0 01-1.06 1.06L16 4.56v3.69a.75.75 0 01-1.5 0V4.56l-.72.72a.75.75 0 11-1.06-1.06l2-2c.3-.3.77-.3 1.06 0l2 2zM3 4.25c0-.41.34-.75.75-.75h5.5a.75.75 0 010 1.5h-5.5A.75.75 0 013 4.25zM15.25 11c.41 0 .75.34.75.75v3.69l.72-.72a.75.75 0 111.06 1.06l-2 2c-.3.3-.77.3-1.06 0l-2-2a.75.75 0 111.06-1.06l.72.72v-3.69c0-.41.34-.75.75-.75zM3 9.25c0-.41.34-.75.75-.75h7.5a.75.75 0 010 1.5h-7.5A.75.75 0 013 9.25zm.75 4.25a.75.75 0 000 1.5h5.5a.75.75 0 000-1.5h-5.5z",
    fill: primaryFill
  }));
};

export const TextLineSpacingFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/TextLineSpacingFilledIcon({}), 'TextLineSpacingFilled');

const TextLineSpacingRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M15 3.7v4.8a.5.5 0 001 0V3.7l1.15 1.15a.5.5 0 00.7-.7l-2-2a.5.5 0 00-.7 0l-2 2a.5.5 0 00.7.7L15 3.71zM2 4.5c0-.28.22-.5.5-.5h6a.5.5 0 010 1h-6a.5.5 0 01-.5-.5zm0 5c0-.28.22-.5.5-.5h9a.5.5 0 010 1h-9a.5.5 0 01-.5-.5zm.5 4.5a.5.5 0 000 1h6a.5.5 0 000-1h-6zM15 16.3v-4.8a.5.5 0 011 0v4.8l1.15-1.15a.5.5 0 01.7.7l-2 2a.5.5 0 01-.7 0l-2-2a.5.5 0 01.7-.7L15 16.29z",
    fill: primaryFill
  }));
};

export const TextLineSpacingRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/TextLineSpacingRegularIcon({}), 'TextLineSpacingRegular');

const TextMoreFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M8.25 2c.3 0 .58.18.7.47L14.04 15a2.24 2.24 0 00-1.69-.17l-.95-2.34H5.08l-1.64 4.03a.75.75 0 11-1.39-.56l5.5-13.5a.75.75 0 01.7-.47zM13 15.75c.63 0 1.15.46 1.24 1.07l.01.18A1.25 1.25 0 1113 15.75zM5.7 11h5.1L8.25 4.74 5.7 11zm4.55 6a1.25 1.25 0 11-2.5 0 1.25 1.25 0 012.5 0zM17 18.25a1.25 1.25 0 100-2.5 1.25 1.25 0 000 2.5z",
    fill: primaryFill
  }));
};

export const TextMoreFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/TextMoreFilledIcon({}), 'TextMoreFilled');

const TextMoreRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M8 2c.2 0 .39.12.46.31l5.1 12.51a2.26 2.26 0 00-1.08 0L11.33 12H4.67l-1.7 4.19a.5.5 0 11-.93-.38l5.5-13.5A.5.5 0 018 2zm5 13.75a1.25 1.25 0 110 2.5 1.25 1.25 0 110-2.5zm0 0zM5.08 11h5.84L8 3.83 5.08 11zm5.17 6a1.25 1.25 0 11-2.5 0 1.25 1.25 0 012.5 0zM17 18.25a1.25 1.25 0 100-2.5 1.25 1.25 0 000 2.5z",
    fill: primaryFill
  }));
};

export const TextMoreRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/TextMoreRegularIcon({}), 'TextMoreRegular');

const TextNumberFormatFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M16.97 2.98c.52.25.91.74 1.17 1.46a.75.75 0 01-1.4.51c-.18-.47-.35-.59-.44-.63-.12-.06-.27-.07-.58-.07a.69.69 0 00-.5.17c-.12.1-.22.27-.3.5a2.82 2.82 0 00-.17.88c0 .41 0 .9.16 1.3.08.18.17.32.3.42.11.1.3.2.6.23.08 0 .28 0 .48-.07a.8.8 0 00.46-.45.75.75 0 011.37.61c-.63 1.42-2.03 1.45-2.48 1.4a2.58 2.58 0 01-1.4-.56c-.35-.3-.58-.68-.72-1.04-.27-.68-.27-1.43-.27-1.8v-.08a3.36 3.36 0 01.03-.4c.03-.26.1-.61.23-.97.14-.36.35-.77.72-1.09.37-.34.87-.55 1.49-.55h.03c.28 0 .75 0 1.22.23zM4.7 2.75c.31 0 .59.2.7.5l1.77 5a.75.75 0 01-1.42.5l-.09-.25h-2.1l-.11.27a.75.75 0 11-1.4-.54l1.94-5c.1-.3.4-.48.7-.48zm-.04 2.9L4.14 7h1l-.48-1.34zm.64 5.1c.39.03.7.35.7.75v5a.75.75 0 01-1.5 0v-2.7l-.2.14a.75.75 0 11-.84-1.25c.56-.37.97-.96 1.05-1.35a.75.75 0 01.79-.59zm4.54 1.5c-.31 0-.59.29-.59.61a.75.75 0 11-1.5 0 2.12 2.12 0 013.88-1.17c.42.64.42 1.46-.04 2.24-.23.4-.55.69-.84.92l-.44.32-.06.05-.33.23c-.14.1-.25.2-.35.3h1.62a.75.75 0 010 1.5H8.55a.73.73 0 01-.05 0 .75.75 0 01-.75-.75c0-1.16.69-1.8 1.27-2.25L9.4 14l.06-.04.37-.28c.23-.18.38-.34.48-.5.21-.36.14-.57.08-.66a.64.64 0 00-.54-.26zm4.88.37a.49.49 0 01.14-.23c.07-.06.2-.14.49-.14.49 0 .6.3.6.39 0 .17-.04.31-.12.4-.04.06-.19.21-.7.21a.75.75 0 000 1.5c.2 0 .45.03.64.11.08.04.12.08.13.1.02.02.04.06.04.18 0 .33-.1.44-.15.49-.08.06-.22.12-.44.12-.26 0-.39-.05-.44-.08-.05-.03-.13-.1-.2-.31a.75.75 0 00-1.42.47 2 2 0 00.81 1.1c.4.25.83.32 1.25.32.45 0 .98-.11 1.4-.48.46-.38.7-.95.7-1.63a1.77 1.77 0 00-.43-1.18c.36-.47.42-1 .42-1.32 0-.93-.8-1.89-2.1-1.89-.62 0-1.11.2-1.47.52-.34.3-.51.66-.6.93a.75.75 0 101.45.42zM8 3.5v5a.75.75 0 00.87.74v.01h1.63c.24 0 .73-.04 1.2-.3.52-.3.92-.87.92-1.7 0-.43-.1-.8-.28-1.12a1.7 1.7 0 00-.29-.35c.15-.27.24-.62.24-1.02 0-.41-.08-.77-.25-1.08a1.69 1.69 0 00-.66-.67c-.46-.26-.95-.26-1.12-.26H8.75A.75.75 0 008 3.5zm2.5 4.25h-1v-1H10.44c.19 0 .38.01.51.08.05.02.08.05.1.08.03.04.07.13.07.33 0 .17-.04.26-.06.3a.3.3 0 01-.12.1.96.96 0 01-.44.11zm-.88-2.5H9.5v-1h.75c.16 0 .3.01.4.07a.2.2 0 01.08.08c.02.04.06.15.06.36 0 .18-.03.27-.06.3a.25.25 0 01-.1.1.76.76 0 01-.35.09h-.66z",
    fill: primaryFill
  }));
};

export const TextNumberFormatFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/TextNumberFormatFilledIcon({}), 'TextNumberFormatFilled');

const TextNumberFormatRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M4.94 3c.21 0 .4.14.47.33l1.77 5a.5.5 0 11-.94.34L6 8H3.73l-.26.68a.5.5 0 01-.94-.36l1.94-5A.5.5 0 014.94 3zm-.82 4h1.53l-.73-2.06L4.12 7zM8.5 3H10c.17 0 .6 0 1.01.23.22.12.42.3.56.57.15.26.22.58.22.96 0 .45-.12.8-.32 1.08.15.1.3.24.4.42.16.27.25.6.25.98 0 .75-.35 1.23-.8 1.49-.4.24-.85.27-1.07.27H8.5a.5.5 0 01-.5-.5v-5c0-.28.22-.5.5-.5zM10 4H9v1.5h1.02c.12 0 .33-.02.5-.12.12-.08.27-.22.27-.62 0-.25-.04-.4-.1-.48a.44.44 0 00-.17-.18c-.16-.09-.36-.1-.52-.1zM9 6.5V8h1.25c.14 0 .38-.03.57-.14.15-.08.3-.23.3-.62a1.11 1.11 0 00-.08-.41.47.47 0 00-.23-.23c-.2-.1-.44-.1-.62-.1H9zm8.4-1.97c-.24-.69-.6-1.1-1.05-1.33-.4-.2-.83-.2-1.1-.2h-.03c-.55 0-1 .19-1.33.49-.32.29-.52.65-.64.99A4.06 4.06 0 0013 5.77v.06c0 .38 0 1.08.25 1.72.13.33.33.67.66.93.32.27.74.45 1.25.5.42.05 1.67.02 2.23-1.24a.5.5 0 10-.9-.4c-.3.64-.94.68-1.22.65a1.34 1.34 0 01-.73-.28 1.26 1.26 0 01-.36-.52A3.89 3.89 0 0114 5.8V5.8a2.15 2.15 0 01.02-.28c.03-.2.07-.44.16-.68.1-.25.22-.45.38-.6a.94.94 0 01.66-.23c.3 0 .5 0 .7.1.15.08.36.25.55.77a.5.5 0 00.94-.34zm-3.2 7.67a.74.74 0 00-.22.35.5.5 0 01-.96-.28c.07-.23.22-.55.52-.82.3-.27.73-.45 1.3-.45 1.17 0 1.85.85 1.85 1.64a1.9 1.9 0 01-.52 1.33 1.53 1.53 0 01.25.27c.18.24.27.55.27.9 0 .63-.21 1.12-.6 1.44-.37.32-.83.42-1.24.42-.4 0-.78-.06-1.11-.28a1.75 1.75 0 01-.72-.97.5.5 0 01.95-.32c.05.14.1.23.15.3l.01.02a.7.7 0 00.04.04l.01.02.02.01a.52.52 0 00.2.12c.11.04.26.06.45.06.26 0 .46-.07.6-.18.12-.1.24-.29.24-.68a.53.53 0 00-.08-.32.58.58 0 00-.24-.18c-.23-.11-.53-.14-.75-.14a.5.5 0 110-1c.58 0 .8-.18.91-.3a.9.9 0 00.16-.56c0-.22-.22-.64-.84-.64-.35 0-.54.1-.65.2zm-5.2.66c0-.44.37-.86.84-.86.33 0 .6.16.75.37.12.19.18.5-.07.92-.13.21-.3.4-.55.58-.12.1-.24.19-.38.28l-.06.04-.36.26C8.61 14.88 8 15.46 8 16.5c0 .28.22.5.5.5h2.69a.5.5 0 100-1H9.1c.13-.28.36-.5.68-.75l.32-.23h.02l.06-.05.42-.31c.29-.23.58-.5.79-.86.41-.7.4-1.43.05-1.98A1.87 1.87 0 008 12.86a.5.5 0 101 0zm-4.58.87c.2-.13.4-.3.58-.47v3.24a.5.5 0 101 0v-5a.5.5 0 00-.98-.1 2.8 2.8 0 01-1.16 1.5.5.5 0 10.56.83z",
    fill: primaryFill
  }));
};

export const TextNumberFormatRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/TextNumberFormatRegularIcon({}), 'TextNumberFormatRegular');

const TextNumberListLtrFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M5 1.5a.5.5 0 00-.39-.49.5.5 0 00-.56.27l-.07.12a2.96 2.96 0 01-1.2 1.15.5.5 0 10.44.9c.3-.15.56-.34.78-.53V5.5a.5.5 0 001 0v-4zM8.75 4a.75.75 0 100 1.5h7.5a.75.75 0 000-1.5h-7.5zm0 5a.75.75 0 100 1.5h7.5a.75.75 0 000-1.5h-7.5zM8 14.75c0-.41.34-.75.75-.75h7.5a.75.75 0 010 1.5h-7.5a.75.75 0 01-.75-.75zm-5.35-7.1a.5.5 0 00.7.7l.05-.04.2-.12C3.76 8.09 4 8 4.3 8c.23 0 .41.06.53.15.1.07.16.17.16.35a.5.5 0 01-.21.44c-.15.12-.35.22-.62.35l-.14.08c-.32.15-.7.36-1 .7-.33.35-.53.81-.53 1.43 0 .28.22.5.5.5h2.5a.5.5 0 000-1H3.59c.04-.1.1-.2.17-.27.17-.18.4-.31.71-.47l.13-.06c.26-.13.58-.29.83-.5.33-.27.57-.65.57-1.2 0-.5-.22-.9-.57-1.15A1.92 1.92 0 004.33 7h-.01a2.5 2.5 0 00-1.66.63v.01h-.01zm.01-.02l-.01.02s.1-.1.01-.02zm1.09 7.87c0-.28.22-.5.5-.5.34 0 .53-.1.63-.18.1-.09.13-.2.13-.3-.01-.2-.19-.52-.76-.52-.41 0-.63.1-.72.17a.42.42 0 00-.1.07.5.5 0 01-.88-.46v-.01l.02-.02a.8.8 0 01.1-.15c.07-.08.17-.17.3-.27.28-.18.7-.33 1.28-.33 1.03 0 1.73.67 1.76 1.48.01.37-.12.74-.4 1.02.28.28.41.65.4 1.02-.03.8-.73 1.48-1.76 1.48-.59 0-1-.15-1.28-.33a1.4 1.4 0 01-.4-.42l-.01-.01v-.01a.5.5 0 01.87-.48l.1.08c.1.07.3.17.72.17.57 0 .75-.33.76-.52 0-.1-.04-.21-.13-.3-.1-.08-.29-.18-.63-.18a.5.5 0 01-.5-.5zm-.32-1.25l.02-.03v.01l-.01.01v.01z",
    fill: primaryFill
  }));
};

export const TextNumberListLtrFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/TextNumberListLtrFilledIcon({}), 'TextNumberListLtrFilled');